import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpRequest, HttpEventType, HttpResponse, HttpErrorResponse, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Inject, InjectionToken, NgModule, Optional, Directive, Input, Pipe, LOCALE_ID, forwardRef, Component, ViewEncapsulation, ViewChild, EventEmitter, Output, TemplateRef, ElementRef } from '@angular/core';
import { of, BehaviorSubject, timer, lastValueFrom, throwError, Observable, Subject } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import { of as of$1 } from 'rxjs/internal/observable/of';
import { map, mergeMap, catchError, takeWhile, share, delay } from 'rxjs/operators';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import queryString from 'query-string';
import * as uri from 'uri-js';
import { isDefined, IsEnum, IsDefined, IsString, IsOptional, IsEmail, IsBoolean, IsArray, IsDate, IsInt, IsInstance, IsMimeType, IsObject, IsLocale, IsPhoneNumber, IsUrl, Min, Max, IsNumber, IsMobilePhone } from 'class-validator';
import dot from 'dot-object';
import { BigNumber } from 'bignumber.js';
import * as i1 from '@ngx-pwa/local-storage';
import * as i4 from '@abacritt/angularx-social-login';
import { BaseLoginProvider, SocialUser, FacebookLoginProvider, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import jwtDecode from 'jwt-decode';
import * as base64 from 'base64-js';
import * as __md5 from 'md5';
import pluralize from 'pluralize';
import * as slugify from 'slugify';
import { __decorate } from 'tslib';
import { plainToInstance, Exclude, Expose, Type, instanceToPlain, TransformationType, Transform } from 'class-transformer';
import * as i4$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3 from '@angular/common';
import { CommonModule, CurrencyPipe } from '@angular/common';
import 'reflect-metadata';
import { parsePhoneNumber, ParseError } from 'libphonenumber-js/min';
import * as i1$2 from '@angular/platform-browser';
import * as i1$3 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as uuid from 'uuid';
import * as i2 from 'ng-zorro-antd/input-number';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import * as i5 from 'ngx-mask';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import * as i1$4 from 'ng-zorro-antd/checkbox';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import * as i4$2 from 'ng-zorro-antd/collapse';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import * as i2$1 from 'ng-zorro-antd/date-picker';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import * as i10 from 'ng-zorro-antd/button';
import { NzButtonModule } from 'ng-zorro-antd/button';
import * as i6 from 'ng-zorro-antd/form';
import { NzFormModule } from 'ng-zorro-antd/form';
import * as i2$2 from 'ng-zorro-antd/input';
import { NzInputModule } from 'ng-zorro-antd/input';
import * as i7 from 'ng-zorro-antd/modal';
import { NzModalModule } from 'ng-zorro-antd/modal';
import * as i2$3 from 'ng-zorro-antd/notification';
import { NzNotificationServiceModule, NzNotificationModule } from 'ng-zorro-antd/notification';
import * as i4$4 from 'ng-zorro-antd/spin';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import * as i4$3 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as i5$1 from 'ng-zorro-antd/grid';
import { NzGridModule } from 'ng-zorro-antd/grid';
import * as i11 from 'ng-zorro-antd/core/transition-patch';
import * as i12 from 'ng-zorro-antd/core/wave';
import * as i6$1 from 'ng-zorro-antd/divider';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import * as i2$4 from 'ng-zorro-antd/select';
import { NzSelectModule } from 'ng-zorro-antd/select';
import * as i2$5 from 'ng-zorro-antd/radio';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import dayjsTimezone from 'dayjs/plugin/timezone';
import * as i2$6 from 'ng-zorro-antd/switch';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import * as i2$7 from 'ng-zorro-antd/upload';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import * as i3$1 from 'ng-zorro-antd/card';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzMessageModule } from 'ng-zorro-antd/message';
import * as i4$5 from 'ng-zorro-antd/table';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzAlertModule } from 'ng-zorro-antd/alert';

dayjs.extend(utc);
var MintLogLevel;
(function (MintLogLevel) {
    MintLogLevel[MintLogLevel["OFF"] = -1] = "OFF";
    MintLogLevel[MintLogLevel["ERROR"] = 0] = "ERROR";
    MintLogLevel[MintLogLevel["WARN"] = 1] = "WARN";
    MintLogLevel[MintLogLevel["INFO"] = 2] = "INFO";
    MintLogLevel[MintLogLevel["VERBOSE"] = 3] = "VERBOSE";
    MintLogLevel[MintLogLevel["DEBUG"] = 4] = "DEBUG";
    MintLogLevel[MintLogLevel["SILLY"] = 5] = "SILLY";
    MintLogLevel[MintLogLevel["TRACE"] = 6] = "TRACE";
    MintLogLevel[MintLogLevel["ALL"] = 999] = "ALL";
})(MintLogLevel || (MintLogLevel = {}));
// TODO: add "package level" configuration
class MintLogger {
    static { this.LEVEL = MintLogLevel.ALL; }
    constructor(className) {
        this.className = className;
        // console.debug(`Created logger: className: ${className} level: ${this.level}`);
    }
    static setLevel(level) {
        if (typeof level === 'string') {
            level = level.toUpperCase();
            MintLogger.LEVEL = parseInt(MintLogLevel[level], 10);
        }
        else if (level) {
            MintLogger.LEVEL = level;
        }
        // tslint:disable-next-line:no-console
        console.log(`\nLogger level set to: ${level}\n`);
    }
    static getLogger(className) {
        return new MintLogger(className);
    }
    log(_context, message, ...optionalParams) {
        // if current LogLevel is set lower than requested level then return.
        // e.g. if LogLevel is set to ERROR and log is at DEBUG, then ignore log request.
        const level = _context[0];
        const context = _context[1];
        if (MintLogger.LEVEL < level) {
            return;
        }
        const timestamp = dayjs().utc().format('YYYY-MM-DD HH:mm:ss,SSS');
        const options = {
            context: context,
            timestamp: timestamp,
            level: MintLogLevel[level],
            message: message,
        };
        let params = optionalParams[0];
        if (typeof params === 'undefined' ||
            params === null ||
            params.length === 0) {
            params = null;
        }
        const print = (fn) => {
            const [meta, text] = this.formatter(options);
            // if (params) {
            //   fn(meta, text, ...params);
            // } else {
            //   fn(meta, text);
            // }
            const padding = '\n\n\n';
            if (params) {
                if (level === MintLogLevel.TRACE) {
                    fn(padding, meta, text, ...params, padding);
                }
                else {
                    fn(meta, text, ...params);
                }
            }
            else {
                if (level === MintLogLevel.TRACE) {
                    fn(padding, meta, text, padding);
                }
                else {
                    fn(meta, text);
                }
            }
        };
        switch (level) {
            case MintLogLevel.ERROR:
                print(console.error);
                break;
            case MintLogLevel.WARN:
                print(console.warn);
                break;
            case MintLogLevel.INFO:
                print(console.log);
                break;
            default:
                // tslint:disable-next-line:no-console
                print(console.log);
        }
    }
    error(message, ...meta) {
        this.log([MintLogLevel.ERROR], message, meta);
    }
    warn(message, ...meta) {
        this.log([MintLogLevel.WARN], message, meta);
    }
    info(message, ...meta) {
        this.log([MintLogLevel.INFO], message, meta);
    }
    verbose(message, ...meta) {
        this.log([MintLogLevel.VERBOSE], message, meta);
    }
    debug(message, ...meta) {
        this.log([MintLogLevel.DEBUG], message, meta);
    }
    silly(message, ...meta) {
        this.log([MintLogLevel.SILLY], message, meta);
    }
    trace(message, ...meta) {
        this.log([MintLogLevel.TRACE], message, meta);
    }
    // dummy method to ack unused params
    ack(...args) {
        args = null;
    }
    formatter(options) {
        let context = this.className ?? '';
        if (options.context) {
            context += context ? '|' + options.context : options.context;
        }
        const name = context ? ' [' + context + ']' : '';
        return [
            options.timestamp + name + ' [' + options.level.toUpperCase() + '] ',
            options.message ? options.message : '',
        ];
    }
}

const logger$2y = MintLogger.getLogger('MintUrlUtil');
function mintParseUrl(url) {
    const parsed = uri.parse(url);
    return {
        scheme: parsed.scheme,
        userInfo: parsed.userinfo,
        host: parsed.host,
        port: parsed.port,
        path: parsed.path,
        query: queryString.parse(parsed.query),
        fragment: parsed.fragment,
    };
}
function appendUrlParam(url, params) {
    const parsed = uri.parse(url);
    parsed.query = parsed.query ?? '';
    parsed.query += serializeQueryParams(params);
    return uri.serialize(parsed);
}
function serializeQueryParams(params) {
    let query = '';
    for (const key of Object.keys(params)) {
        let value = params[key];
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        if (query.length) {
            query += '&';
        }
        query += `${key}=${encodeURIComponent(value)}`;
    }
    return query;
}
function mintNormalizeUrl(url) {
    return uri.normalize(url);
}
function mintUrlEquals(url1, url2) {
    return uri.equal(url1, url2);
}
// @dynamic
class MintUrlUtil {
    static urlPathEquals(path, link) {
        const locationPath = MintUrlUtil.pathPartOfUrl(path);
        return link === locationPath;
    }
    static urlPathContains(path, link) {
        const locationPath = MintUrlUtil.pathPartOfUrl(path);
        const endOfUrlSegmentRegExp = /\/|^$/;
        return (locationPath.startsWith(link) &&
            locationPath
                .slice(link.length)
                .charAt(0)
                .search(endOfUrlSegmentRegExp) !== -1);
    }
    static pathPartOfUrl(url) {
        return url.match(/.*?(?=[?;#]|$)/)[0];
    }
    // given a path that contains a URL param start with a ':'
    // use the target path provided to match each of the params
    // with their positional values
    // e.g.    path  =>  /:uid/1234
    //       target  =>  /abc/9876
    //  return path  =>  /abc/1234
    static evalPathParams(path, target) {
        // if the loginRoute includes parameters then ASSUME they
        // map to the redirect URL positionally
        if (path.match(/:/)) {
            const pathParts = path.split('/');
            const targetParts = target.split('/');
            for (let i = 0; i < pathParts.length; i++) {
                const part = pathParts[i];
                if (part.startsWith(':')) {
                    pathParts[i] = targetParts[i] ?? '';
                }
            }
            path = pathParts.join('/');
        }
        return path;
    }
}

const toJSON = (obj, pretty = false, removeCircularRefs = false) => {
    if (!obj) {
        return obj;
    }
    const replacer = removeCircularRefs
        ? MintJsonUtil.circularReplacer()
        : undefined;
    if (pretty) {
        return JSON.stringify(obj, replacer, '  ');
    }
    return JSON.stringify(obj, replacer);
};
class MintJsonUtil {
    static toString(obj, pretty = false) {
        return toJSON(obj, pretty);
    }
    static parse(json) {
        if (typeof json !== 'string') {
            return json;
        }
        // undefined is not valid JSON so handle it separately
        if (json.toLowerCase() === 'undefined') {
            return undefined;
        }
        // JSON.parse can handle null and 'null', but will fail on 'NULL'
        if (json.toLowerCase() === 'null') {
            return null;
        }
        return JSON.parse(json);
    }
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
    static circularReplacer() {
        const seen = new WeakSet();
        return (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return;
                }
                seen.add(value);
            }
            return value;
        };
    }
}

function isMintError(err) {
    return err instanceof MintError;
}
// TODO: integrate Sentry ...
class MintError extends Error {
    static { this.consoleTrace = false; }
    #message;
    #code;
    #status;
    #data;
    #stackTrace;
    constructor(err, payload) {
        super(typeof err === 'string' ? err : err.message);
        this.name = 'MintError';
        this.#stackTrace = this.stack;
        if (typeof err === 'string') {
            this.#message = err;
            if (payload) {
                if (typeof payload === 'number') {
                    this.#status = payload;
                }
                else if (typeof payload === 'string') {
                    this.#code = payload;
                }
                else {
                    this.#status = payload.status;
                    this.#code = payload.code;
                    this.#data = payload.data;
                }
            }
        }
        else if (err instanceof Error) {
            this.#message = err.message;
            this.#stackTrace = err.stack;
        }
        else {
            this.#message = err.message;
            this.#status = err.status;
            this.#code = err.code;
            this.#data = err.data;
        }
        if (!this.#code &&
            this.#data?.code &&
            typeof this.#data.code === 'string') {
            this.#code = this.#data.code;
            // remove payload.code
            // delete this.#data['code'];
        }
        if (!this.#status &&
            this.#data?.status &&
            typeof this.#data.status === 'number') {
            this.#status = this.#data.status;
            // remove payload.code
            // delete this.#data['code'];
        }
        if (MintError.consoleTrace) {
            // tslint:disable-next-line:no-console
            console.trace(this.toJSON());
        }
    }
    get message() {
        const description = this.getCodeDescription(this.code);
        const s = [];
        if (this.#message) {
            s.push(this.#message);
        }
        if (this.code) {
            s.push('code: ' + this.code);
        }
        if (this.status) {
            s.push('status: ' + this.status);
        }
        if (description) {
            s.push('description: ' + description);
        }
        if (this.data) {
            s.push('data: ' + toJSON(this.data, true));
        }
        // s.push('stacktrace: ' + this.stack);
        return s.join('\n') + '\n';
    }
    get data() {
        return this.#data;
    }
    /** Application specific code */
    get code() {
        return this.#code;
    }
    /** HTTP Status code */
    get status() {
        return this.#status;
    }
    get stackTrace() {
        return this.#stackTrace;
    }
    toString() {
        const description = this.getCodeDescription(this.code);
        const s = [];
        if (this.name) {
            s.push(`name: ${this.name}`);
        }
        if (this.message) {
            s.push(`message: ${this.message}`);
        }
        if (this.code) {
            s.push(`code: ${this.code}`);
        }
        if (this.status) {
            s.push(`status: ${this.status}`);
        }
        if (description) {
            s.push(`description: ${description}`);
        }
        if (this.data) {
            s.push(`error: ${this.data}`);
        }
        if (this.stackTrace) {
            s.push('stacktrace: ' + this.stackTrace);
        }
        return s.join('\n') + '\n';
    }
    getCodeDescription(code) {
        return MintError.codeDictionary
            ? MintError.codeDictionary[this.code]
            : undefined;
    }
    toJSON(args) {
        args = !args || typeof args === 'string' ? {} : args;
        args.name = args.name ?? false;
        args.stacktrace = args.stacktrace ?? false;
        args.stringifyData = args.stringifyData ?? false;
        const description = this.getCodeDescription(this.code);
        const obj = {};
        if (args.name && this.name) {
            obj['name'] = this.name;
        }
        if (this.message) {
            obj['message'] = this.message;
        }
        if (this.code) {
            obj['code'] = this.code;
        }
        if (this.status) {
            obj['status'] = this.status;
        }
        if (description) {
            obj['description'] = description;
        }
        if (this.data) {
            obj['data'] =
                args.stringifyData && !(this.data instanceof Error)
                    ? toJSON(this.data, true)
                    : this.data;
        }
        if (args.stacktrace === true && this.stackTrace) {
            obj['stacktrace'] = this.stackTrace;
        }
        return obj;
    }
}

dayjs.extend(utc);
class MintDateUtil {
    static isDateObject(value) {
        if (value &&
            typeof value === 'object' &&
            Object.prototype.toString.call(value) === '[object Date]') {
            return true;
        }
        return false;
    }
    static isDateString(s) {
        return typeof s === 'string' && !!MintDateISOFormatRegex.exec(s);
    }
    static getMonthsDiff(startDate, endDate) {
        function getAbsoluteMonths(date) {
            const months = Number(dayjs(date).utc().format('MM'));
            const years = Number(dayjs(date).utc().format('YYYY'));
            return months + years * 12;
        }
        const startMonths = getAbsoluteMonths(startDate);
        const endMonths = getAbsoluteMonths(endDate);
        return endMonths - startMonths;
    }
    static getDaysDiff(startDate, endDate) {
        const start = dayjs(startDate).utc();
        const end = dayjs(endDate).utc();
        return end.diff(start, 'days');
    }
    static parseISODateString(value) {
        if (value && typeof value === 'string') {
            const match = MintDateISOFormatRegex.exec(value);
            if (match) {
                return new Date(value);
            }
        }
        throw new MintError('Not a valid ISO Date: ' + value);
    }
    // use MomentJS format strings;
    // e.g. YYYY-MM-DD
    static format(date, format) {
        if (!date) {
            return null;
        }
        return dayjs(date).format(format);
    }
    static getAge(date) {
        return Math.abs(dayjs().diff(dayjs(date), 'years'));
    }
    static asUTC(date, dateOnly = false) {
        if (!date) {
            return null;
        }
        if (!(date instanceof Date)) {
            throw new MintError('Invalid date-utc object: ' + JSON.stringify(date));
        }
        if (dateOnly) {
            date.setHours(0, 0, 0, 0);
        }
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
}

// Local copy of deepmerge module which uses is-mergeable-object
// https://github.com/TehShrike/is-mergeable-object
// https://github.com/KyleAMathews/deepmerge
const canUseSymbol = typeof Symbol === 'function' && Symbol.for;
const REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
const logger$2x = MintLogger.getLogger('MintDeepMerge');
class MintDeepMerge {
    static isMergeableObject(value, key) {
        return (MintDeepMerge.isNonNullObject(value) &&
            !MintDeepMerge.isSpecial(value, key));
    }
    static isNonNullObject(value) {
        return !!value && typeof value === 'object';
    }
    static isSpecial(value, key) {
        try {
            toJSON(value);
        }
        catch (err) {
            if (key) {
                logger$2x.debug(`Skipping non-serializable object: [${key}]: ` + typeof value);
            }
            return true;
        }
        const stringValue = Object.prototype.toString.call(value);
        return (stringValue === '[object RegExp]' ||
            stringValue === '[object Date]' ||
            MintDeepMerge.isReactElement(value));
    }
    static isReactElement(value) {
        return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    static emptyTarget(val) {
        return Array.isArray(val) ? [] : {};
    }
    static cloneUnlessOtherwiseSpecified(value, optionsArgument, key) {
        const clone = !optionsArgument || optionsArgument.clone !== false;
        return clone && MintDeepMerge.isMergeableObject(value, key)
            ? MintDeepMerge.merge(MintDeepMerge.emptyTarget(value), value, optionsArgument)
            : value;
    }
    static defaultArrayMerge(target, source, optionsArgument) {
        return target.concat(source).map((element) => {
            return MintDeepMerge.cloneUnlessOtherwiseSpecified(element, optionsArgument);
        });
    }
    static preferTargetArrayMerge(target, source, optionsArgument) {
        if (target.length) {
            return target.map((element) => {
                return MintDeepMerge.cloneUnlessOtherwiseSpecified(element, optionsArgument);
            });
        }
        else {
            return source.map((element) => {
                return MintDeepMerge.cloneUnlessOtherwiseSpecified(element, optionsArgument);
            });
        }
    }
    static preferSourceArrayMerge(target, source, optionsArgument) {
        if (source.length) {
            return source.map((element) => {
                return MintDeepMerge.cloneUnlessOtherwiseSpecified(element, optionsArgument);
            });
        }
        else {
            return target.map((element) => {
                return MintDeepMerge.cloneUnlessOtherwiseSpecified(element, optionsArgument);
            });
        }
    }
    static mergeObject(target, source, optionsArgument) {
        const destination = {};
        if (MintDeepMerge.isMergeableObject(target)) {
            Object.keys(target).forEach((key) => {
                destination[key] = MintDeepMerge.cloneUnlessOtherwiseSpecified(target[key], optionsArgument, key);
            });
        }
        Object.keys(source).forEach((key) => {
            if (!MintDeepMerge.isMergeableObject(source[key]) || !target[key]) {
                destination[key] = MintDeepMerge.cloneUnlessOtherwiseSpecified(source[key], optionsArgument, key);
            }
            else {
                destination[key] = MintDeepMerge.merge(target[key], source[key], optionsArgument);
            }
        });
        return destination;
    }
    //
    //  NOTE: Merging creates a new object, so that neither target or source is modified.
    //  If an element at the same key is present for both target and source, the value from source will appear in the result.
    //  Note: By default, arrays are merged by concatenating them.
    static merge(target, source, optionsArgument) {
        const sourceIsArray = Array.isArray(source);
        const targetIsArray = Array.isArray(target);
        const options = optionsArgument || {
            arrayMerge: MintDeepMerge.defaultArrayMerge,
        };
        const sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
        if (!sourceAndTargetTypesMatch) {
            return MintDeepMerge.cloneUnlessOtherwiseSpecified(source, optionsArgument);
        }
        else if (sourceIsArray) {
            const arrayMerge = options.arrayMerge || MintDeepMerge.defaultArrayMerge;
            return arrayMerge(target, source, optionsArgument);
        }
        else {
            return MintDeepMerge.mergeObject(target, source, optionsArgument);
        }
    }
    static mergeAll(array, optionsArgument) {
        if (!Array.isArray(array)) {
            throw new MintError('first argument should be an array');
        }
        return array.reduce((prev, next) => {
            return MintDeepMerge.merge(prev, next, optionsArgument);
        }, {});
    }
}

// =========
// Originally from humps
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Utilities
// Taken from Underscore.js
const logger$2w = MintLogger.getLogger('MintCamelizer');
const toString = Object.prototype.toString;
const _isFunction = (obj) => {
    return typeof obj === 'function';
};
const _isObject = (obj) => {
    return obj === Object(obj);
};
const _isArray = (obj) => {
    return toString.call(obj) === '[object Array]';
};
const _isDate = (obj) => {
    return toString.call(obj) === '[object Date]';
};
const _isRegExp = (obj) => {
    return toString.call(obj) === '[object RegExp]';
};
const _isBoolean = (obj) => {
    return toString.call(obj) === '[object Boolean]';
};
// Performant way to determine if obj coerces to a number
const _isNumerical = (obj) => {
    obj = obj - 0;
    return obj === obj;
};
class MintCamelizer {
    static separateWords(words, options) {
        options = options ?? {};
        const separator = options.separator || '_';
        const split = options.split || /(?=[A-Z])/;
        return words.split(split).join(separator);
    }
    // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback
    static processor(convert, options) {
        const callback = options && 'process' in options ? options.process : options;
        if (typeof callback !== 'function') {
            return convert;
        }
        return (_string, _options) => {
            return callback(_string, convert, _options);
        };
    }
    static processKeys(convert, obj, options) {
        if (!_isObject(obj) ||
            _isDate(obj) ||
            _isRegExp(obj) ||
            _isBoolean(obj) ||
            _isFunction(obj)) {
            return obj;
        }
        let output;
        let i = 0;
        let l = 0;
        if (_isArray(obj)) {
            output = [];
            for (l = obj.length; i < l; i++) {
                output.push(MintCamelizer.processKeys(convert, obj[i], options));
            }
        }
        else {
            output = {};
            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    const converted = convert(key, options);
                    output[converted] = MintCamelizer.processKeys(convert, obj[key], options);
                }
            }
        }
        return output;
    }
    static camelCase(_string, options) {
        return MintCamelizer.camelize(_string, options);
    }
    static camelize(_string, options = {}) {
        if (!_string) {
            return _string;
        }
        if (_isNumerical(_string)) {
            return _string;
        }
        options = options ?? {};
        options.ignoreDashed = options.ignoreDashed ?? true;
        options.ignoreFirstUnderscore = options.ignoreFirstUnderscore ?? true;
        options.ignoreFirstUpperCase = options.ignoreFirstUpperCase ?? false;
        // leave key alone if starts with capital letter
        if (options.ignoreFirstUpperCase && /^[A-Z]/.test(_string)) {
            return _string;
        }
        if (options.ignoreFirstUnderscore && _string.startsWith('_')) {
            return _string;
        }
        if (options.ignoreDashed && _string.includes('-')) {
            return _string;
        }
        _string = _string.replace(/[\-_\s]+(.)?/g, (match, chr) => {
            return chr ? chr.toUpperCase() : '';
        });
        // Ensure 1st char is always lowercase
        return _string.substr(0, 1).toLowerCase() + _string.substr(1);
    }
    static snakeCase(_string, options) {
        return MintCamelizer.decamelize(_string, options);
    }
    static decamelize(_string, options = {}) {
        if (!_string) {
            return _string;
        }
        // SJA: additional condition to ignore camel casing
        // leave key alone if starts with _ or already starts with capital letter
        options = options ?? {};
        options.ignoreDashed = options.ignoreDashed ?? true;
        options.ignoreFirstUnderscore = options.ignoreFirstUnderscore ?? true;
        options.ignoreFirstUpperCase = options.ignoreFirstUpperCase ?? false;
        if (options.ignoreFirstUnderscore && _string.startsWith('_')) {
            return _string;
        }
        if (options.ignoreFirstUpperCase && /^[A-Z]/.test(_string)) {
            return _string;
        }
        if (options.ignoreDashed && _string.includes('-')) {
            return _string;
        }
        return MintCamelizer.separateWords(_string, options).toLowerCase();
    }
    static pascalCase(_string, options) {
        return MintCamelizer.pascalize(_string, options);
    }
    static pascalize(_string, options) {
        const camelized = MintCamelizer.camelize(_string, options);
        // Ensure 1st char is always uppercase
        return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    }
    static depascalize(key, options) {
        return MintCamelizer.decamelize(key, options);
    }
    static camelCaseKeys(object, options) {
        return MintCamelizer.camelizeKeys(object, options);
    }
    static camelizeArray(list, options) {
        const result = [];
        for (const item of list) {
            result.push(MintCamelizer.camelize(item, options));
        }
        return result;
    }
    static pascalizeArray(list, options) {
        const result = [];
        for (const item of list) {
            result.push(MintCamelizer.pascalize(item, options));
        }
        return result;
    }
    static decamelizeArray(list, options) {
        const result = [];
        for (const item of list) {
            result.push(MintCamelizer.decamelize(item, options));
        }
        return result;
    }
    static depascalizeArray(list, options) {
        const result = [];
        for (const item of list) {
            result.push(MintCamelizer.depascalize(item, options));
        }
        return result;
    }
    static camelizeKeys(object, options) {
        return MintCamelizer.processKeys(MintCamelizer.processor(MintCamelizer.camelize, options), object, options);
    }
    static snakeCaseKeys(object, options) {
        return MintCamelizer.decamelizeKeys(object, options);
    }
    static decamelizeKeys(object, options) {
        return MintCamelizer.processKeys(MintCamelizer.processor(MintCamelizer.decamelize, options), object, options);
    }
    static pascalCaseKeys(object, options) {
        return MintCamelizer.pascalizeKeys(object, options);
    }
    static pascalizeKeys(object, options) {
        return MintCamelizer.processKeys(MintCamelizer.processor(MintCamelizer.pascalize, options), object, options);
    }
    static depascalizeKeys(object, options) {
        return MintCamelizer.decamelizeKeys(object, options);
    }
    static kebabCase(s, options) {
        const result = MintCamelizer.snakeCase(s, options);
        return result.replace(/_/g, '-');
    }
    static slug(s, options) {
        return MintCamelizer.kebabCase(s, options);
    }
    static kebabCaseKeys(obj, options) {
        if (Array.isArray(obj)) {
            const _result = [];
            for (const item of obj) {
                const _item = this.kebabCaseKeys(item, options);
                _result.push(_item);
            }
            return _result;
        }
        obj = MintCamelizer.snakeCaseKeys(obj, options);
        const result = {};
        for (const key of Object.keys(obj)) {
            const _key = key.replace(/_/g, '-');
            result[_key] = obj[key];
        }
        return result;
    }
}

const isUndefined = (value) => {
    return typeof value === 'undefined';
};
const isNullish = (value) => {
    return isUndefined(value) || value === null;
};
const isPromise = (obj) => {
    return (!!obj &&
        (typeof obj === 'object' || typeof obj === 'function') &&
        typeof obj.then === 'function');
};
function isValidNumberValue(value) {
    if (typeof value === 'number' || typeof value === 'bigint') {
        return Number.isNaN(value);
    }
    return !!value?.isNaN && typeof value.isNaN === 'function' && value.isNaN();
}
const isObject = (value) => !isNullish(value) && typeof value === 'object';
const isFunction = (val) => typeof val === 'function';
const isString = (val) => typeof val === 'string';
const isNumber = (val) => typeof val === 'number';
const isEmpty = (array) => !(array && array.length > 0);
const isSymbol = (val) => typeof val === 'symbol';
const isClass = (value) => !isNullish(value) &&
    typeof value === 'function' &&
    typeof value.constructor === 'function';
function prop(obj, key) {
    return obj[key];
}
class MintTypeUtil {
    // https://basarat.gitbooks.io/typescript/docs/types/literal-types.html
    static enum(o) {
        return o.reduce((res, key) => {
            res[key] = MintCamelizer.kebabCase(key);
            return res;
        }, Object.create(null));
    }
    // FIXME: this does not take into account different locales where ',' may
    // be the decimal separator
    static scrubNumber(value) {
        if (value) {
            value = value.trim().replace(/\s+/g, '').replace(/,/g, '');
        }
        return value;
    }
    static isNumeric(value) {
        if (isNullish(value)) {
            return false;
        }
        return (!isValidNumberValue(Number.parseFloat(value)) && Number.isFinite(value));
    }
    /**
     * Check if is Float
     */
    static isFloat(value) {
        return +value === value && (!Number.isFinite(value) || Boolean(value % 1));
    }
    static parseBoolean(value, defaultValue, silent = false) {
        defaultValue = defaultValue ?? null;
        if (isNullish(value)) {
            return defaultValue;
        }
        try {
            if (value === true) {
                return true;
            }
            if (value === false) {
                return false;
            }
            if (Number.isNaN(value)) {
                return false;
            }
            value = `${value}`.toLowerCase().trim();
            return (value === 'true' || value === '1' || value === 'y' || value === 'yes');
        }
        catch (err) {
            if (silent) {
                return defaultValue;
            }
            throw err;
        }
    }
    static parseFloat(value, defaultValue, silent = false) {
        defaultValue = defaultValue ?? null;
        if (isNullish(value)) {
            return defaultValue;
        }
        try {
            if (typeof value !== 'number' || Number.isSafeInteger(value)) {
                value = Number.parseFloat(this.scrubNumber(String(value)));
            }
            return value;
        }
        catch (err) {
            if (silent) {
                return defaultValue;
            }
            throw err;
        }
    }
    static parseInteger(value, defaultValue, silent = false) {
        defaultValue = defaultValue ?? null;
        if (isNullish(value)) {
            return defaultValue;
        }
        try {
            if (typeof value !== 'number' || !Number.isSafeInteger(value)) {
                value = Number.parseInt(this.scrubNumber(String(value)), 10);
            }
            return value;
        }
        catch (err) {
            if (silent) {
                return defaultValue;
            }
            throw err;
        }
    }
    static parseBigInt(value, defaultValue, silent = false) {
        defaultValue = defaultValue ?? null;
        if (isNullish(value)) {
            return defaultValue;
        }
        try {
            if (typeof value !== 'bigint') {
                value = BigInt(this.scrubNumber(String(value)));
            }
            return value;
        }
        catch (err) {
            if (silent) {
                return defaultValue;
            }
            throw err;
        }
    }
    static parseBigNumber(value, defaultValue, silent = false) {
        defaultValue = defaultValue ?? null;
        if (isNullish(value)) {
            return defaultValue;
        }
        try {
            if (!BigNumber.isBigNumber(value)) {
                if (typeof value === 'object') {
                    value = new BigNumber({ ...value, _isBigNumber: true });
                }
                else {
                    value = new BigNumber(this.scrubNumber(String(value)));
                }
            }
            return value;
        }
        catch (err) {
            if (silent) {
                return defaultValue;
            }
            throw err;
        }
    }
}

const logger$2v = MintLogger.getLogger('MintObjectUtil');
const MintDateISOFormatRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.{0,1}\d*))(?:Z|(\+|-)([\d|:]*))?$/;
function hasValue(item) {
    return typeof item !== 'undefined' && item !== null;
}
const hasOwnProperty = Object.prototype.hasOwnProperty;
const propIsEnumerable = Object.prototype.propertyIsEnumerable;
class MintObjectUtil {
    static getTypeProperty(obj, key) {
        return obj[key];
    }
    static isReadonlyProperty(obj, key) {
        const desc = Object.getOwnPropertyDescriptor(obj, key) || {};
        return !Boolean(desc.writable);
    }
    static toString(obj) {
        if (!obj) {
            return obj;
        }
        if (obj.toString) {
            return obj.toString();
        }
        return toJSON(obj);
    }
    static async transformObjectKeys(object, fn) {
        const keys = Object.keys(object);
        for (let key of keys) {
            const value = object[key];
            delete object[key];
            key = await fn(key);
            object[key] = value;
        }
    }
    static toObject(val) {
        if (val === null || typeof val === 'undefined') {
            throw new TypeError('MintObjectUtil.toObject cannot be called with null or undefined');
        }
        return Object(val);
    }
    // Merges sources into target and returns new object
    // target and sources are unaffected.
    static merge(target, ...sources) {
        if (!sources || !sources.length) {
            return target;
        }
        if (typeof target !== 'object') {
            throw new TypeError('Target must be an object type.');
        }
        for (const source of sources) {
            if (typeof source === 'undefined' || source === null) {
                continue;
            }
            target = MintDeepMerge.merge(target, source);
        }
        return target;
    }
    static clone(obj) {
        const target = Array.isArray(obj) ? [] : {};
        return MintObjectUtil.merge(target, obj);
    }
    // Merges sources into target.  Target is mutated.
    // Return the mutated target object.
    static assign(target, ...sources) {
        // NOTE: be sure to use the spread on sources here or the parameter
        // to merge will be taken to be a single value which is an array.
        const result = MintObjectUtil.merge({}, ...sources);
        return Object.assign(target, result);
    }
    static simpleAssign(target, source) {
        return Object.assign(target, source);
    }
    static objectAssign(target, ...source) {
        let from;
        const to = MintObjectUtil.toObject(target);
        let symbols;
        for (let s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (const key in from) {
                if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }
            if (Object.getOwnPropertySymbols) {
                symbols = Object.getOwnPropertySymbols(from);
                for (const symbol of symbols) {
                    if (propIsEnumerable.call(from, symbol)) {
                        to[symbol] = from[symbol];
                    }
                }
            }
        }
        return to;
    }
    //  (since ES2015) insertion order is preserved, except in the case of keys that parse
    // as integers (eg "7" or "99"), where behavior varies between browsers. For example,
    // Chrome/V8 does not respect insertion order when the keys are parse as numeric.
    static sortByKey(obj, comparator) {
        // const ordered = Object.create({});
        const ordered = {};
        const keys = Object.keys(obj).sort(comparator);
        for (const key of keys) {
            ordered[key] = obj[key];
        }
        return ordered;
    }
    static interpolate(obj, refMap) {
        const delimiter = /\$\{(.+?)\}/g;
        const getInterpolatedValue = (value, flatMap) => {
            if (value.match(delimiter)) {
                return value.replace(delimiter, (match, ...refKeys) => {
                    const refKey = refKeys[0]; // first item in array is the key
                    const refValue = flatMap[refKey];
                    if (!refValue) {
                        throw Error(`Reference value not found for key [${refKey}]:\n` + `${match}`);
                    }
                    return refValue;
                });
            }
            return value;
        };
        if (isNullish(obj)) {
            return obj;
        }
        if (typeof obj === 'string') {
            const flatMap = refMap ? MintObjectUtil.toDotObject(refMap) : {};
            return getInterpolatedValue(obj, flatMap);
        }
        if (Array.isArray(obj)) {
            return obj.map((item) => this.interpolate(item, refMap));
        }
        if (typeof obj === 'object') {
            const flatObj = MintObjectUtil.toDotObject(obj);
            for (const key of Object.keys(flatObj)) {
                const value = flatObj[key];
                flatObj[key] = this.interpolate(value, refMap ?? obj);
            }
            // return dot.object(flatObj) as unknown as T;
            return MintObjectUtil.fromDotObject(flatObj);
        }
        return obj;
    }
    static distinct(objects, property) {
        const map = new Map();
        if (!objects || !objects.length) {
            return [];
        }
        let key;
        for (const item of objects) {
            if (typeof property !== 'undefined' && typeof property !== null) {
                key = toJSON(item[property]);
            }
            else {
                key = toJSON(item);
            }
            map.set(key, item);
        }
        return Array.from(map.values());
    }
    // https://stackoverflow.com/questions/1173549/how-to-determine-if-an-object-is-an-object-literal-in-javascript
    static isObjectLiteral(_obj) {
        let _test = _obj;
        return typeof _obj !== 'object' || _obj === null
            ? false
            : (() => {
                while (true) {
                    if (Object.getPrototypeOf((_test = Object.getPrototypeOf(_test))) ===
                        null) {
                        break;
                    }
                }
                return Object.getPrototypeOf(_obj) === _test;
            })();
    }
    static isNullish(value) {
        return isNullish(value);
    }
    static sort(list, field, order = 'ASC') {
        if (!list || !list.length) {
            return [];
        }
        const items = [...list];
        const exampleItem = items.find((item) => !this.isNullish(item[field]));
        // all the field values are null so there's nothing to sort
        if (!exampleItem) {
            return items;
        }
        const value = exampleItem[field];
        switch (typeof value) {
            case 'string':
                if (order === 'ASC') {
                    return items.sort((a, b) => (a[field] ?? '').localeCompare(b[field] ?? ''));
                }
                else {
                    return items.sort((a, b) => (b[field] ?? '').localeCompare(a[field] ?? ''));
                }
            case 'number':
            case 'boolean':
            case 'bigint':
                if (order === 'ASC') {
                    return items.sort((a, b) => (a[field] ?? 0) - (b[field] ?? 0));
                }
                else {
                    return items.sort((a, b) => (b[field] ?? 0) - (a[field] ?? 0));
                }
            case 'object':
                if (value instanceof Date) {
                    if (order === 'ASC') {
                        return items.sort((a, b) => (a[field]?.getTime() ?? 0) - (b[field]?.getTime() ?? 0));
                    }
                    else {
                        return items.sort((a, b) => (b[field]?.getTime() ?? 0) - (a[field]?.getTime() ?? 0));
                    }
                }
                else if (value?.compare && typeof value.compare === 'function') {
                    if (order === 'ASC') {
                        return items.sort((a, b) => a[field].compare(b[field]));
                    }
                    else {
                        return items.sort((a, b) => b[field].compare(a[field]));
                    }
                }
                else {
                    throw new MintError('Cannot sort array.  Unknown value type: ' + typeof value);
                }
        }
        return items;
    }
    //
    // public static equals(obj1: any, obj2: any) {
    //   return isEqual(obj1, obj2);
    // }
    static equals(a, b, options = {}) {
        options.equalNull = options.equalNull ?? false;
        options.equalUndefined = options.equalUndefined ?? false;
        options.undefinedEqualsNull = options.undefinedEqualsNull ?? false;
        options.ignoreArrayOrder = options.ignoreArrayOrder ?? false;
        // if true and one of the object contains a key that is `undefined` and the other
        // object does not contain that key, then the objects will be considered
        // equal.  If set to false, then if one of the objects is missing a key
        // contained in the other object, then the objects will be considered not equal.
        // NOTE: if the missing key is not `undefined`, the objects will always
        // be not equal.
        options.ignoreMissingObjectKeys = options.ignoreMissingObjectKeys ?? false;
        const aType = typeof a;
        const bType = typeof b;
        if (options.undefinedEqualsNull) {
            if ((aType === 'undefined' && b === null) ||
                (bType === 'undefined' && a === null)) {
                return true;
            }
        }
        // all other checks assume a and b have the same type
        if (aType !== bType) {
            logger$2v.debug(`Type mismatch: `, {
                a: aType,
                b: bType,
            });
            return false;
        }
        if (aType === 'undefined') {
            return options.equalUndefined;
        }
        if (a === null && b === null) {
            return options.equalNull;
        }
        if ((a === null && b !== null) || (a !== null && b === null)) {
            logger$2v.debug(`Null mismatch: `, {
                aIsNull: a === null,
                bIsNull: b === null,
            });
            return false;
        }
        if (aType === 'string' ||
            aType === 'number' ||
            aType === 'boolean' ||
            aType === 'symbol' ||
            aType === 'bigint' ||
            aType === 'function') {
            return a === b;
        }
        if (Array.isArray(a)) {
            if (!Array.isArray(b)) {
                logger$2v.debug(`Array mismatch: `, {
                    aIsArray: true,
                    bIsArray: false,
                });
                return false;
            }
            if (a.length !== b?.length) {
                logger$2v.debug(`Array length mismatch: `, {
                    aLength: a.length,
                    bLength: b.length,
                });
                return false;
            }
            const _a = [...a];
            const _b = [...b];
            // TODO: what happens if the array values are objects
            if (options.ignoreArrayOrder) {
                _a.sort();
                _b.sort();
            }
            const matches = [];
            for (let i = 0; i < _a.length; i++) {
                matches.push(this.equals(_a[i], _b[i], options));
            }
            const equalArrays = matches.every((item) => item === true);
            if (!equalArrays) {
                logger$2v.debug(`Array value mismatch: `, {
                    a: _a,
                    b: _b,
                });
            }
            return equalArrays;
        }
        if ((a instanceof Date && !(b instanceof Date)) ||
            (b instanceof Date && !(a instanceof Date))) {
            logger$2v.debug(`Date type mismatch: `, {
                aIsDate: a instanceof Date,
                bIsDate: b instanceof Date,
            });
            return false;
        }
        if (a instanceof Date && b instanceof Date) {
            const equalTime = a.getTime() === b.getTime();
            if (!equalTime) {
                logger$2v.debug(`Date value mismatch: `, {
                    aTime: a.getTime(),
                    bTime: b.getTime(),
                });
            }
            return equalTime;
        }
        // NOTE: DO NOT USE lodash isEqual since it seems to require
        // object key order to be the same
        //
        // const result = isEqual(a, b);
        //
        // at this point we have an object
        // TODO: do we need to worry about circular refs?
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        const allKeys = [...new Set([...aKeys, ...bKeys])];
        if (aKeys.length !== bKeys.length && !options.ignoreMissingObjectKeys) {
            // object keys do not match
            logger$2v.debug(`Object key mismatch: `, {
                aKeys: aKeys,
                bKeys: bKeys,
            });
            return false;
        }
        for (const key of allKeys) {
            const aIsUndefined = typeof a[key] === 'undefined';
            const bIsUndefined = typeof b[key] === 'undefined';
            if (aIsUndefined &&
                bIsUndefined &&
                (options.ignoreMissingObjectKeys || options.equalUndefined)) {
                continue;
            }
            if (aIsUndefined || bIsUndefined) {
                // missing object key
                logger$2v.debug(`Object key mismatch: `, {
                    aHasKey: key,
                    bMissingKey: key,
                });
                return false;
            }
            if (!this.equals(a[key], b[key], options)) {
                // object values are not equal
                logger$2v.debug(`Object value mismatch: `, {
                    key: key,
                    aValue: a[key],
                    bValue: b[key],
                });
                return false;
            }
        }
        return true;
    }
    static flatDeep(arr, d = 1) {
        return d > 0
            ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? this.flatDeep(val, d - 1) : val), [])
            : arr.slice();
    }
    static removeCircular(obj, parseDates = true) {
        if (obj && typeof obj === 'object') {
            if (Array.isArray(obj)) {
                return obj.map((item) => this.removeCircular(item));
            }
            const json = JSON.stringify(obj, MintJsonUtil.circularReplacer());
            const parsed = MintJsonUtil.parse(json);
            return parseDates ? this.parseDates(parsed) : parsed;
        }
    }
    // NOTE: Needs more testing. Seems to work but is very slow.
    static removeCircularRefs(obj) {
        const seen = new WeakMap();
        const getAncestorKey = (parentKey, seenKeys) => {
            if (!parentKey || !seenKeys.length) {
                return null;
            }
            seenKeys.sort((a, b) => b.split('.').length - a.split('.').length);
            for (const seenKey of seenKeys) {
                if (parentKey.startsWith(seenKey)) {
                    return seenKey;
                }
            }
            return null;
        };
        const _deleteObject = (key) => {
            const parts = key.split('.');
            const propKey = parts.pop();
            let _value = obj;
            for (const part of parts) {
                if (_value) {
                    _value = _value[part];
                }
            }
            if (_value) {
                logger$2v.debug(`deleted:  property: [${propKey}]: from key: [${key}]`);
                _value[propKey] = undefined;
            }
        };
        const _removeCircular = (_obj, parentKeys) => {
            parentKeys = parentKeys ?? [];
            for (const key of Object.keys(_obj)) {
                const rootKeyPath = [...parentKeys, key].join('.');
                const value = _obj[key];
                if (typeof value === 'object' &&
                    value !== null &&
                    !(value instanceof Date)) {
                    // we care only about recursive references from the same root key
                    // if other keys reference the same object that should not be a
                    // problem. For example:
                    //    a -> User -> b -> User
                    // should result in:
                    //    a -> User -> b -> undefined
                    // This should be ok:
                    //    a -> User
                    //    b -> User
                    //    c -> User
                    const seenKeys = seen.get(value) ?? [];
                    // logger.test(
                    //   `checking: key [${key}] rootKeyPath:  [${rootKeyPath}]  seenKeys: [${seenKeys}]`,
                    // );
                    const ancestorKey = getAncestorKey(rootKeyPath, seenKeys);
                    if (ancestorKey) {
                        _deleteObject(rootKeyPath);
                    }
                    else {
                        seenKeys.push(rootKeyPath);
                        seen.set(value, seenKeys);
                        _removeCircular(value, [...parentKeys, key]);
                    }
                }
            }
        };
        _removeCircular(obj);
        return obj;
    }
    static parseDate(value) {
        if (isDefined(value) && MintDateISOFormatRegex.exec(value)) {
            return new Date(value);
        }
        return value;
    }
    static parseDates(obj, seen) {
        // used to check for circular refs
        if (!seen) {
            seen = new WeakSet();
        }
        if (!obj || typeof obj !== 'object') {
            return obj;
        }
        if (Array.isArray(obj)) {
            for (const item of obj) {
                this.parseDates(item);
            }
            return obj;
        }
        if (seen.has(obj)) {
            return obj;
        }
        for (const key of Object.keys(obj)) {
            if (MintObjectUtil.isReadonlyProperty(obj, key)) {
                continue;
            }
            const value = obj[key];
            if (!value) {
                continue;
            }
            if (typeof value === 'object' && !MintDateUtil.isDateObject(value)) {
                seen.add(value);
                this.parseDates(value, seen);
                continue;
            }
            if (typeof value === 'string' && MintDateISOFormatRegex.exec(value)) {
                obj[key] = new Date(value);
            }
        }
        return obj;
    }
    static sortKeys(obj, compareFn) {
        const keys = Object.keys(obj ?? {});
        if (!obj || !keys.length) {
            return obj;
        }
        const result = {};
        for (const key of keys.sort(compareFn)) {
            result[key] = obj[key];
        }
        return result;
    }
    static filterObjFields(obj, fields) {
        const dotObj = this.toDotObject(obj);
        const dotKeys = Object.keys(dotObj);
        for (const key of dotKeys) {
            if (!fields.map((field) => field.name).includes(key)) {
                delete dotObj[key];
            }
        }
        return this.fromDotObject(dotObj);
    }
    static toDotObject(obj, keepArray = true) {
        dot.keepArray = keepArray ?? true;
        const dotObject = dot.dot(obj);
        dot.keepArray = false;
        return dotObject;
    }
    static fromDotObject(obj, keepArray = true) {
        dot.keepArray = keepArray ?? true;
        const result = dot.object(obj);
        dot.keepArray = false;
        return result;
    }
}

const logger$2u = MintLogger.getLogger('MintStorageService');
var MintStorageType;
(function (MintStorageType) {
    MintStorageType["Local"] = "local";
    MintStorageType["Session"] = "session";
    MintStorageType["Memory"] = "memory";
})(MintStorageType || (MintStorageType = {}));
class MintStorageService {
    constructor(localStorage) {
        this.localStorage = localStorage;
        this.sessionStorage = window.sessionStorage;
        this.memoryStorage = {};
    }
    getData(key, payload, type) {
        if (!payload) {
            return undefined;
        }
        if (payload.expiresAt) {
            if (Date.now() - payload.expiresAt.getTime() > 0) {
                this.removeItem(key, type).subscribe(() => { });
                return undefined;
            }
        }
        // logger.debug('getItem: payload: ', payload);
        return payload.data;
    }
    /**
     * @returns value or `undefined` if key not set or value expired
     */
    getItem(key, type) {
        // logger.debug('getItem: key: ', key);
        if (type === MintStorageType.Local) {
            return this.localStorage.get(key).pipe(map((_payload) => {
                // logger.debug('payload: ', payload);
                return this.getData(key, _payload, type);
            }));
        }
        if (type === MintStorageType.Memory) {
            const _payload = this.memoryStorage[key];
            return of(this.getData(key, _payload, type));
        }
        let result;
        try {
            const value = this.sessionStorage.getItem(key);
            if (value) {
                const payload = JSON.parse(value);
                // NOTE: we need to parse dates since dates will be
                // serialized to a string with JSON.stringify()
                MintObjectUtil.parseDates(payload);
                result = this.getData(key, payload, type);
            }
        }
        catch (err) {
            logger$2u.error(err);
        }
        return of(result);
    }
    /**
     * Sets an item in local storage
     * @param key storage key
     * @param data The item's value, must NOT be undefined
     * @param type
     * @param expiresIn
     * @returns An RxJS Observable to wait the end of the operation
     */
    setItem(key, data, type, expiresIn) {
        if (typeof data === 'undefined') {
            throw new Error('Data value cannot be undefined. Set to null instead.');
        }
        let expiresAt;
        if (expiresIn) {
            expiresAt = dayjs().add(expiresIn, 'seconds').toDate();
        }
        const payload = {
            data: data,
            expiresAt: expiresAt,
            createdAt: new Date(),
        };
        if (type === MintStorageType.Local) {
            return this.localStorage.set(key, payload);
        }
        if (type === MintStorageType.Memory) {
            this.memoryStorage[key] = payload;
            return of(true);
        }
        this.sessionStorage.setItem(key, JSON.stringify(payload));
        return of(true);
    }
    /**
     * Deletes an item in local storage
     * @returns An RxJS Observable to wait the end of the operation
     */
    removeItem(key, type) {
        if (type === MintStorageType.Local) {
            return this.localStorage.delete(key);
        }
        if (type === MintStorageType.Memory) {
            delete this.memoryStorage[key];
            return of(true);
        }
        this.sessionStorage.removeItem(key);
        return of(true);
    }
    /**
     * Deletes all items from local storage
     * @returns An RxJS Observable to wait the end of the operation
     */
    clear(type) {
        if (type === MintStorageType.Local) {
            return this.localStorage.clear();
        }
        if (type === MintStorageType.Memory) {
            this.memoryStorage = {};
            return of(true);
        }
        this.sessionStorage.clear();
        return of(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintStorageService, deps: [{ token: i1.StorageMap }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintStorageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.StorageMap }] });

const logger$2t = MintLogger.getLogger('MintStringUtil');
const ANSI_REGEXP = /([\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><])/g;
// @dynamic
class MintStringUtil {
    static escapeRegEx(str) {
        const regexp = new RegExp(/[.*+?^${}()|[\]\\]/, 'g');
        return str.replace(regexp, '\\$&'); // $& means the whole matched string
    }
    static replaceAll(s, search, replacement) {
        search = MintStringUtil.escapeRegEx(search);
        return s.replace(new RegExp(search, 'g'), replacement);
    }
    // FIXME: this will convert _default to -default.
    static slug(val) {
        val = MintStringUtil.replaceAll(val, '_', '-');
        val = MintStringUtil.replaceAll(val, '.', '-');
        const slug = slugify.default(val, {
            replacement: '-',
            remove: new RegExp(/[!"#$%&'()*+,_./:;<=>?@[\]^`{|}~]/, 'g'),
            lower: true,
        });
        return slug;
    }
    static capitalizeFirst(word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    static titleCase(str) {
        return str
            .split(/\s+/)
            .map((word) => {
            // return word.replace(word[0], word[0].toUpperCase());
            return MintStringUtil.capitalizeFirst(word);
        })
            .join(' ');
    }
    // https://github.com/aslakhellesoy/express-uri-template
    static evalUriTemplate(template, params) {
        let result = template;
        for (const key of Object.keys(params)) {
            const param = params[key];
            result = result.replace(':' + key, encodeURIComponent(param));
        }
        if (result.match(new RegExp(/[\*:]/))) {
            logger$2t.error('evalUriTemplate: unexpanded parameters:\nstring: ', result, '\nparams:', params);
            throw new Error('There were unexpanded params: ' + result);
        }
        return result;
    }
    static getFullTextSearchValue(value) {
        if (typeof value === 'undefined' || value === null) {
            return null;
        }
        value = value.trim();
        if (value.length === 0) {
            return null;
        }
        if (value.length >= 1 && value.length < 3) {
            return false;
        }
        if (value.endsWith('-') ||
            value.endsWith('-*') ||
            value.endsWith('+') ||
            value.endsWith('+*') ||
            value.endsWith('>') ||
            value.endsWith('<') ||
            value.endsWith('@') ||
            value.endsWith('~') ||
            value.endsWith('(')) {
            return false;
        }
        return value;
    }
    static fromArrayBuffer(buffer) {
        return String.fromCharCode.apply(null, new Uint16Array(buffer));
    }
    static toArrayBuffer(value) {
        const buffer = new ArrayBuffer(value.length * 2); // 2 bytes for each char
        const bufferView = new Uint16Array(buffer);
        for (let i = 0, strLen = value.length; i < strLen; i++) {
            bufferView[i] = value.charCodeAt(i);
        }
        return buffer;
    }
    static toByteArray(value) {
        return new TextEncoder().encode(value);
    }
    static fromByteArray(value) {
        return new TextDecoder().decode(value);
    }
    static repeat(str, len) {
        if (!str || str.length === 0) {
            return str;
        }
        return new Array(len + 1).join(str);
    }
    static stripAnsi(str) {
        return str.replace(ANSI_REGEXP, '');
    }
    // credit: https://github.com/lahmatiy/fixed-width-string
    static fixedWidth(str, width = 0, options = {}) {
        str = String(str);
        const strWoAnsi = MintStringUtil.stripAnsi(str);
        // return empty string for bad width
        if (width <= 0) {
            return '';
        }
        // do nothing
        if (strWoAnsi.length === width) {
            return str;
        }
        // padding
        if (strWoAnsi.length <= width) {
            const paddingWidth = Math.max(width - strWoAnsi.length, 0);
            let paddingString = options.padding;
            if (typeof paddingString !== 'undefined') {
                if (paddingString.length > 0) {
                    paddingString = MintStringUtil.fixedWidth(options.padding, 1, {
                        ellipsis: '',
                    });
                }
            }
            else {
                paddingString = ' ';
            }
            const padding = MintStringUtil.repeat(paddingString, paddingWidth);
            if (options.align === 'right') {
                return padding + str;
            }
            else {
                return str + padding;
            }
        }
        // truncating
        // try to be intuitive
        // if align to right and truncate doesn't specify – truncate from left
        if (options.align === 'right' && 'truncate' in options === false) {
            options.truncate = 'left';
        }
        const parts = str.split(ANSI_REGEXP);
        const ellipsis = options.ellipsis || '\u2026'; // '…'
        const ellipsisWoAnsi = MintStringUtil.stripAnsi(ellipsis);
        let result = '';
        if (ellipsisWoAnsi.length >= width) {
            return MintStringUtil.fixedWidth(ellipsis, width, { ellipsis: '' });
        }
        width -= ellipsis.length;
        if (options.truncate === 'left') {
            // truncate left
            // 'very long str' -> '…str'
            for (let i = parts.length - 1, len = 0; i >= 0; i--) {
                const part = parts[i];
                // process non-ansi parts only
                if (i % 2 === 0) {
                    if (len + part.length >= width) {
                        result =
                            // ignore all other plain strings left
                            parts
                                .slice(0, i)
                                .filter((str1, idx) => {
                                return idx % 2 ? str1 : '';
                            })
                                .join('') +
                                ellipsis +
                                part.substr(part.length - (width - len)) +
                                result;
                        break;
                    }
                    len += part.length;
                }
                result = part + result;
            }
        }
        else {
            // truncate right
            // 'very long str' -> 'ver…'
            for (let i = 0, len = 0; i < parts.length; i++) {
                const part = parts[i];
                // process non-ansi parts only
                if (i % 2 === 0) {
                    if (len + part.length >= width) {
                        result =
                            result +
                                part.substr(0, width - len) +
                                ellipsis +
                                // ignore all other plain strings
                                parts
                                    .slice(i)
                                    .filter((str1, idx) => {
                                    return idx % 2 ? str1 : '';
                                })
                                    .join('');
                        break;
                    }
                    len += part.length;
                }
                result += part;
            }
        }
        return result;
    }
    static lowerFirst(s) {
        return s.charAt(0).toLowerCase() + s.slice(1);
    }
    static pluralize(s) {
        return pluralize(s);
    }
    static singularize(s) {
        return pluralize.singular(s);
    }
}

const md5 = __md5;
class MintCryptoUtil {
    static encode(type, data) {
        if (typeof data === 'string') {
            data = MintStringUtil.toByteArray(data);
        }
        switch (type) {
            case 'base64':
                return base64.fromByteArray(data);
        }
    }
    static decode(type, data) {
        switch (type) {
            case 'base64':
                return base64.toByteArray(data);
            // return btoa(data);
        }
    }
    static checksum(content, algorithm = 'sha256', encoding = 'hex') {
        switch (algorithm) {
            case 'md5':
                return md5(content);
            case 'sha1':
            case 'sha256':
                throw new Error('Algorithm not available: ' + algorithm);
        }
    }
    static randomString(length) {
        const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz+/';
        let result = '';
        while (length > 0) {
            const bytes = new Uint8Array(16);
            const random = window.crypto.getRandomValues(bytes);
            for (const value of random) {
                if (length === 0) {
                    break;
                }
                if (value < charset.length) {
                    result += charset[value];
                    length--;
                }
            }
            // random.forEach((c: number) => {
            //   if (length === 0) {
            //     return;
            //   }
            //
            //   if (c < charset.length) {
            //     result += charset[c];
            //     length--;
            //   }
            // });
        }
        return result;
    }
}

// @dynamic
class MintSystemUtil {
    static async sleep(sleepTime) {
        return new Promise((resolve) => setTimeout(resolve, sleepTime));
    }
}

const MINT_AUTH_DEFAULT_ACCESS_TOKEN_TIMEOUT = 60 * 60; // 1 hour
const MINT_AUTH_DEFAULT_REFRESH_TOKEN_TIMEOUT = 60 * 60 * 24 * 180; // 6 months
const MINT_AUTH_DEFAULT_SERVICE_TOKEN_TIMEOUT = 60 * 60 * 24 * 365 * 10; // 10 years
// duration of timeout in ms
const MINT_AUTH_FAILURE_TIMEOUT_DURATION = 1000 * 60 * 5;
// number of failed attempts to trigger timeout
const MINT_AUTH_FAILURE_TIMEOUT_ATTEMPTS = 3;
// number of failed attempts to trigger lockout
const MINT_AUTH_FAILURE_LOCKOUT_ATTEMPTS = 5;
var MintAuthPasswordStatus;
(function (MintAuthPasswordStatus) {
    MintAuthPasswordStatus["Exists"] = "exists";
    MintAuthPasswordStatus["NotFound"] = "not-found";
})(MintAuthPasswordStatus || (MintAuthPasswordStatus = {}));
var MintAuthChannel;
(function (MintAuthChannel) {
    MintAuthChannel["Email"] = "email";
    MintAuthChannel["Sms"] = "sms";
    MintAuthChannel["PushNotification"] = "push-notification";
    MintAuthChannel["PhoneCall"] = "phone-call";
    MintAuthChannel["Authenticator"] = "authenticator";
})(MintAuthChannel || (MintAuthChannel = {}));
var MintAuthType;
(function (MintAuthType) {
    MintAuthType["Login"] = "login";
    MintAuthType["Mfa"] = "mfa";
    MintAuthType["TokenValidation"] = "token-validation";
    MintAuthType["EmailVerification"] = "email-verification";
    MintAuthType["MobileVerification"] = "mobile-verification";
    MintAuthType["PhoneVerification"] = "phone-verification";
    MintAuthType["PasswordReset"] = "password-reset";
    // used to track failed auth code attempts and the exact type is not known
    MintAuthType["AuthCode"] = "auth-code";
    // general access
    MintAuthType["Access"] = "access";
})(MintAuthType || (MintAuthType = {}));
var MintAuthStatus;
(function (MintAuthStatus) {
    MintAuthStatus["Success"] = "success";
    MintAuthStatus["DeviceLocked"] = "device-locked";
    MintAuthStatus["DeviceUnlocked"] = "device-unlocked";
    MintAuthStatus["UserDisabled"] = "user-disabled";
    MintAuthStatus["InvalidAuthToken"] = "invalid-auth-token";
    MintAuthStatus["BadUsername"] = "bad-username";
    MintAuthStatus["BadPassword"] = "bad-password";
    MintAuthStatus["BadAuthCode"] = "bad-auth-code";
})(MintAuthStatus || (MintAuthStatus = {}));
var MintRegistrationType;
(function (MintRegistrationType) {
    // user self registers on site
    MintRegistrationType["SelfSignup"] = "self-signup";
    // an account has already been created on behalf of a user
    // and the user needs to activate it
    MintRegistrationType["AccountActivation"] = "account-activation";
    // a fully activated account is created by an admin on behalf of a user
    MintRegistrationType["AdminCreated"] = "admin-created";
})(MintRegistrationType || (MintRegistrationType = {}));
var MintAuthResource;
(function (MintAuthResource) {
    MintAuthResource["Root"] = "/auth";
    MintAuthResource["Login"] = "/auth/login";
    MintAuthResource["Password"] = "/auth/password";
    MintAuthResource["Passcode"] = "/auth/passcode";
    MintAuthResource["PasscodeVerification"] = "/auth/passcode/verification";
    MintAuthResource["Register"] = "/auth/register";
    MintAuthResource["RefreshToken"] = "/auth/token/refresh";
    MintAuthResource["VerificationCodes"] = "/auth/codes";
    MintAuthResource["UpdateUserEmail"] = "/auth/user/email";
    MintAuthResource["UpdateUserMobile"] = "/auth/user/mobile-number";
    MintAuthResource["EmailVerificationCode"] = "/auth/codes/email";
    MintAuthResource["MobileVerificationCode"] = "/auth/codes/mobile";
    MintAuthResource["MfaCode"] = "/auth/codes/mfa";
    MintAuthResource["Authenticator"] = "/auth/authenticator";
})(MintAuthResource || (MintAuthResource = {}));
var MintSessionScope;
(function (MintSessionScope) {
    MintSessionScope["Memory"] = "memory";
    MintSessionScope["Local"] = "local";
    MintSessionScope["Global"] = "global";
})(MintSessionScope || (MintSessionScope = {}));
var MintAuthSsoProvider;
(function (MintAuthSsoProvider) {
    MintAuthSsoProvider["Facebook"] = "facebook";
    MintAuthSsoProvider["Google"] = "google";
    MintAuthSsoProvider["Azure"] = "azure";
    MintAuthSsoProvider["Twitter"] = "twitter";
    MintAuthSsoProvider["LinkedIn"] = "linkedin";
})(MintAuthSsoProvider || (MintAuthSsoProvider = {}));

class MintSsoUserModel {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintSsoUserModel, model));
        }
    }
}
__decorate([
    IsEnum(MintAuthSsoProvider),
    IsDefined()
], MintSsoUserModel.prototype, "provider", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintSsoUserModel.prototype, "providerUserId", void 0);
__decorate([
    IsEmail(),
    IsOptional()
], MintSsoUserModel.prototype, "email", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], MintSsoUserModel.prototype, "emailVerified", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintSsoUserModel.prototype, "displayName", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintSsoUserModel.prototype, "photoUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintSsoUserModel.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintSsoUserModel.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintSsoUserModel.prototype, "locale", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintSsoUserModel.prototype, "domain", void 0);

const logger$2s = MintLogger.getLogger('MintAccess');
var MintAccessOperator;
(function (MintAccessOperator) {
    MintAccessOperator["Equals"] = "==";
    MintAccessOperator["NotEquals"] = "!=";
    MintAccessOperator["GreaterThan"] = ">";
    MintAccessOperator["LessThan"] = "<";
    MintAccessOperator["GreaterThanOrEquals"] = ">=";
    MintAccessOperator["LessThanOrEquals"] = "<=";
    MintAccessOperator["In"] = "in";
    MintAccessOperator["NotIn"] = "not-in";
    MintAccessOperator["Like"] = "like";
    MintAccessOperator["NotLike"] = "not-like";
    MintAccessOperator["Between"] = "between";
    MintAccessOperator["NotBetween"] = "not-between";
    MintAccessOperator["IsNull"] = "is-null";
    MintAccessOperator["IsNotNull"] = "not-null";
})(MintAccessOperator || (MintAccessOperator = {}));
var MintCoreResource;
(function (MintCoreResource) {
    MintCoreResource["Any"] = "/**";
    MintCoreResource["AnyAuth"] = "/auth/**";
    MintCoreResource["AnyUser"] = "/users/**";
    MintCoreResource["AnyMeta"] = "/**/_meta";
})(MintCoreResource || (MintCoreResource = {}));
var MintAccessEffect;
(function (MintAccessEffect) {
    MintAccessEffect["Allow"] = "allow";
    MintAccessEffect["Deny"] = "deny";
})(MintAccessEffect || (MintAccessEffect = {}));
// possible actions that can be performed by a user
var MintAccessAction;
(function (MintAccessAction) {
    MintAccessAction["Any"] = "any";
    MintAccessAction["Abort"] = "abort";
    MintAccessAction["Approve"] = "approve";
    MintAccessAction["Archive"] = "archive";
    MintAccessAction["Create"] = "create";
    MintAccessAction["Delete"] = "delete";
    MintAccessAction["Describe"] = "describe";
    MintAccessAction["Download"] = "download";
    MintAccessAction["Execute"] = "execute";
    MintAccessAction["Freeze"] = "freeze";
    MintAccessAction["Grant"] = "grant";
    MintAccessAction["Invite"] = "invite";
    MintAccessAction["List"] = "list";
    MintAccessAction["Lock"] = "lock";
    MintAccessAction["Publish"] = "publish";
    MintAccessAction["Refresh"] = "refresh";
    MintAccessAction["Request"] = "request";
    MintAccessAction["Revoke"] = "revoke";
    MintAccessAction["Send"] = "send";
    MintAccessAction["Share"] = "share";
    MintAccessAction["Transfer"] = "transfer";
    MintAccessAction["Unlock"] = "unlock";
    MintAccessAction["Unpublish"] = "unpublish";
    MintAccessAction["Update"] = "update";
    MintAccessAction["Upload"] = "upload";
    MintAccessAction["View"] = "view";
})(MintAccessAction || (MintAccessAction = {}));

/**
 * Function that returns a new decorator that applies all decorators provided by param
 *
 * Useful to build new decorators (or a decorator factory) encapsulating multiple decorators related with the same feature
 *
 * @param decorators one or more decorators (e.g., `ApplyGuard(...)`)
 */
// https://github.com/nestjs/nest/blob/master/packages/common/decorators/core/apply-decorators.ts
function mintApplyDecorators(...decorators) {
    // tslint:disable-next-line:ban-types
    return (target, propertyKey, descriptor) => {
        for (const decorator of decorators) {
            if (target instanceof Function && !descriptor) {
                decorator(target);
                continue;
            }
            decorator(target, propertyKey, descriptor);
        }
    };
}

const MINT_DECORATOR_RESOURCE_KEY = Symbol('mint-decorator-resource-key');
const MINT_DECORATOR_RESOURCE_CALLBACK_KEY = Symbol('mint-decorator-property-callback-key');
/**
 * Identify a Model as a Resource
 *
 * For example:
 *  \@MintResource('/users')
 *  MintUserModel {}
 */
function MintResource(basePath) {
    const decorator = (target) => {
        // FIXME: is this check sufficient to restrict to a class?
        if (target.constructor !== Function) {
            throw new MintError('Decorator can only be applied to a class');
        }
        // If basePath is not defined, we default to a root path of the
        // plural of the slug of the class name.
        //
        // Note `Mint` prefix is automatically removed as well
        // as `Model` and `Entity` suffixes
        //
        // e.g. if class is MintUserModel, the resource is: /users
        //
        if (basePath) {
            target._mintResourceName = basePath;
        }
        else {
            // target._mintResourceName will return a default resource name
            // based on the class name if it's not explicitly set
            basePath = target._mintResourceName;
        }
        // if (!basePath) {
        //   basePath = MintModel.toMintResourceName(target.name);
        // }
        Reflect.defineMetadata(MINT_DECORATOR_RESOURCE_KEY, basePath, target.prototype);
        const resourceCallbackFns = Reflect.getMetadata(MINT_DECORATOR_RESOURCE_CALLBACK_KEY, target.prototype);
        if (resourceCallbackFns) {
            resourceCallbackFns.map((fn) => fn());
        }
        return target;
    };
    return mintApplyDecorators(Exclude(), decorator);
}

const MINT_DECORATOR_PROPERTY_KEY = Symbol('mint-decorator-property-key');
/**
 * Expose a Model property
 *
 * For example:
 *  \@MintProperty({})
 *  uid: string;
 */
// export function MintExpose(
//   ...policy: Array<MintAccessPolicy | string>
// ): (object: any, propertyName: string) => void {
function MintProperty(...policy) {
    // const decorator = Reflect.metadata(MINT_DECORATOR_EXPOSE_KEY, policy);
    const decorator = (target, propertyKey) => {
        if (!policy?.length) {
            // Since class decorators are called after all property and method
            // decorators, we need to register a callback to get set the policy
            // https://stackoverflow.com/questions/48342656/how-to-access-class-metadata-from-method-decorator
            let resourceCallbackFns = Reflect.getMetadata(MINT_DECORATOR_RESOURCE_CALLBACK_KEY, target);
            if (!resourceCallbackFns) {
                Reflect.defineMetadata(MINT_DECORATOR_RESOURCE_CALLBACK_KEY, (resourceCallbackFns = []), target);
            }
            resourceCallbackFns.push(() => {
                const basePath = Reflect.getMetadata(MINT_DECORATOR_RESOURCE_KEY, target);
                const resourceName = basePath + '/:uid/' + propertyKey;
                policy = [
                    {
                        resource: resourceName,
                        action: MintAccessAction.View,
                    },
                ];
                Reflect.defineMetadata(MINT_DECORATOR_PROPERTY_KEY, policy, target, propertyKey);
            });
        }
        else {
            Reflect.defineMetadata(MINT_DECORATOR_PROPERTY_KEY, policy, target, propertyKey);
        }
    };
    return mintApplyDecorators(Expose(), decorator);
}

const logger$2r = MintLogger.getLogger('MintEntityMeta');
var MintEntityStatus;
(function (MintEntityStatus) {
    MintEntityStatus["Created"] = "created";
    MintEntityStatus["Updated"] = "updated";
    MintEntityStatus["Deleted"] = "deleted";
})(MintEntityStatus || (MintEntityStatus = {}));
class MintEntityUpdate {
    constructor(value) {
        if (value) {
            // https://bobbyhadz.com/blog/typescript-cannot-assign-to-read-only-property-of-object
            value.patch = MintObjectUtil.clone(value.patch);
            Object.assign(this, plainToInstance(MintEntityUpdate, value));
        }
    }
}
__decorate([
    IsArray(),
    IsDefined()
], MintEntityUpdate.prototype, "patch", void 0);
__decorate([
    IsDate(),
    IsDefined(),
    Type(() => Date)
], MintEntityUpdate.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintEntityUpdate.prototype, "updatedByUid", void 0);
class MintEntityMetaCache {
    get age() {
        return this.cachedAt ? Date.now() - this.cachedAt.getTime() : undefined;
    }
    constructor(value) {
        if (value) {
            Object.assign(this, plainToInstance(MintEntityMetaCache, value));
        }
    }
}
__decorate([
    IsDate(),
    IsDefined(),
    Type(() => Date)
], MintEntityMetaCache.prototype, "cachedAt", void 0);
__decorate([
    IsDate(),
    IsDefined(),
    Type(() => Date)
], MintEntityMetaCache.prototype, "fetchedAt", void 0);
class MintEntityMeta {
    constructor(value) {
        this.updates = [];
        if (value) {
            Object.assign(this, plainToInstance(MintEntityMeta, value));
        }
    }
}
__decorate([
    IsOptional(),
    Type(() => MintEntityMetaCache)
], MintEntityMeta.prototype, "cached", void 0);
__decorate([
    IsInt(),
    IsDefined()
], MintEntityMeta.prototype, "version", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintEntityMeta.prototype, "resource", void 0);
__decorate([
    IsEnum(MintEntityStatus),
    IsDefined()
], MintEntityMeta.prototype, "status", void 0);
__decorate([
    IsDate(),
    IsDefined(),
    Type(() => Date)
], MintEntityMeta.prototype, "createdAt", void 0);
__decorate([
    IsDate(),
    IsDefined(),
    Type(() => Date)
], MintEntityMeta.prototype, "lastUpdatedAt", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintEntityMeta.prototype, "createdByUid", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintEntityMeta.prototype, "lastUpdatedByUid", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date)
], MintEntityMeta.prototype, "deletedAt", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintEntityMeta.prototype, "deletedByUid", void 0);
__decorate([
    IsArray(),
    IsInstance(MintEntityUpdate),
    IsOptional(),
    Type(() => MintEntityUpdate)
], MintEntityMeta.prototype, "updates", void 0);

const logger$2q = MintLogger.getLogger('MintModel');
function isModel(model) {
    return (model instanceof MintModel ||
        (typeof model?.id === 'undefined' && typeof model?.uid === 'string'));
}
class MintModel {
    constructor(model, isEntity = false) {
        // logger.test('isMintModel: ', this.constructor instanceof MintModel);
        if (model) {
            if (typeof model === 'string') {
                model = { uid: model };
            }
            if (isEntity) {
                for (const key of Object.keys(model)) {
                    try {
                        this[key] = model[key];
                    }
                    catch (err) {
                        // ignore assignment error due to non-writeable properties
                    }
                }
            }
            else {
                const instance = plainToInstance(this.constructor, model, {
                    strategy: 'exposeAll',
                    excludeExtraneousValues: false,
                    enableCircularCheck: true,
                    enableImplicitConversion: false,
                    exposeDefaultValues: true,
                    exposeUnsetFields: true,
                });
                Object.assign(this, instance);
            }
            if (this._meta && !(this._meta instanceof MintEntityMeta)) {
                this._meta = new MintEntityMeta(this._meta);
            }
        }
    }
    static get _mintResourceName() {
        if (!this.__mintResourceName) {
            this.__mintResourceName = this.toMintResourceName(this.name);
        }
        return this.__mintResourceName;
    }
    static set _mintResourceName(resourceName) {
        this.__mintResourceName = resourceName;
    }
    get _mintResourceName() {
        return this.constructor._mintResourceName;
    }
    set _mintResourceName(resourceName) {
        this.constructor._mintResourceName = resourceName;
    }
    static from(model, isEntity = false) {
        if (!model) {
            return model;
        }
        if (typeof model === 'string') {
            return new this({ uid: model }, isEntity);
        }
        return new this(model, isEntity);
    }
    static toMintResourceName(className) {
        let resource = MintCamelizer.kebabCase(className).trim();
        if (resource.startsWith('mint-')) {
            resource = resource.replace(/^mint-/, '');
        }
        if (resource.endsWith('-entity')) {
            resource = resource.replace(/-entity$/, '');
        }
        if (resource.endsWith('-model')) {
            resource = resource.replace(/-model$/, '');
        }
        resource = '/' + MintStringUtil.pluralize(resource);
        return resource;
    }
    toString() {
        return JSON.stringify(instanceToPlain(this), null, '  ');
    }
}
__decorate([
    IsString()
], MintModel.prototype, "uid", void 0);
__decorate([
    Type(() => MintEntityMeta)
], MintModel.prototype, "_meta", void 0);
__decorate([
    Type(() => Date)
], MintModel.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date)
], MintModel.prototype, "updatedAt", void 0);

const logger$2p = MintLogger.getLogger('MintTag');
const mintTag = (value, key = 'name') => {
    return new MintTag(value, key);
};
const isMintTag = (tag) => {
    return (tag instanceof MintTag || (!isNullish(tag.key) && !isUndefined(tag.value)));
};
const mintTagModelTransformer = (params) => {
    switch (params.type) {
        case TransformationType.PLAIN_TO_CLASS:
            return MintTag.from(params.value);
        default:
            return params.value;
    }
};
class MintTag {
    constructor(value, key = 'name') {
        if (!isUndefined(value)) {
            if (typeof value === 'string' || Array.isArray(value)) {
                this.key = key;
                this.value = value;
            }
            else if (!isUndefined(value?.value)) {
                this.key = value.key ?? 'name';
                this.value = value.value;
            }
        }
    }
    static equals(tag, other) {
        return tag.key === other.key && tag.value === other.value;
    }
    // return a string or a flat array of all values associated with a key
    static get(tags, key) {
        const values = [];
        const _tags = tags.filter((tag) => tag.key === key);
        if (_tags.length === 1 && typeof _tags[0].value === 'string') {
            return _tags[0].value;
        }
        for (const _tag of _tags) {
            if (Array.isArray(_tag.value)) {
                values.push(..._tag.value);
            }
            else {
                values.push(_tag.value);
            }
        }
        return values;
    }
    static from(tags) {
        if (!tags) {
            return tags;
        }
        if (typeof tags === 'string') {
            return this.parse(tags);
        }
        if (!Array.isArray(tags)) {
            throw new MintError('value must be a string or an array');
        }
        if (!tags.length || isMintTag(tags[0])) {
            return tags;
        }
        if (typeof tags[0] === 'string') {
            return tags.map((value) => mintTag(value));
        }
        throw new MintError('Cannot convert tags: ', {
            data: tags,
        });
    }
    static parse(tags, defaultTags = []) {
        let _tags;
        logger$2p.debug('parseTags: parsing tags: ', tags);
        if (tags) {
            try {
                const parsed = MintJsonUtil.parse(tags);
                // if parsed value is a simple string, create a tag and return
                if (typeof parsed === 'string') {
                    return [mintTag(parsed)];
                }
                // if parsed value is an object with a property called 'value', create a tag and return
                if (!Array.isArray(parsed) && parsed.value) {
                    return [mintTag(parsed.value, parsed.key)];
                }
                if (Array.isArray(parsed)) {
                    _tags = [];
                    // tslint:disable-next-line:prefer-for-of
                    for (let i = 0; i < parsed.length; i++) {
                        let _tag = parsed[i];
                        if (typeof _tag === 'object' && _tag.key && _tag.value) {
                            _tag = mintTag(_tag.value, _tag.key);
                        }
                        else if (typeof _tag === 'string') {
                            _tag = mintTag(_tag);
                        }
                        else {
                            _tag = mintTag(String(_tag));
                        }
                        _tags.push(_tag);
                    }
                }
                else {
                    throw new MintError('Invalid tags value: ', parsed);
                }
            }
            catch (err) {
                if (err instanceof MintError) {
                    throw err;
                }
                // if parsing fails assume it's a simple string that may be comma or pipe delimited
                _tags = tags.split(/\s*[,|]\s*/).map((item) => mintTag(item));
            }
        }
        else {
            _tags = defaultTags;
        }
        logger$2p.debug('parseTags: parsed tags: ', _tags);
        return _tags;
    }
}
__decorate([
    Expose(),
    IsString()
], MintTag.prototype, "key", void 0);
__decorate([
    Expose()
], MintTag.prototype, "value", void 0);

// @dynamic
let MintAccessRoleModel = class MintAccessRoleModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAccessRoleModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAccessRoleModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintAccessRoleModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintAccessRoleModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessRoleModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessRoleModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAccessRoleModel.prototype, "_meta", void 0);
MintAccessRoleModel = __decorate([
    MintResource('/access-roles')
], MintAccessRoleModel);

// @dynamic
let MintAccountModel = class MintAccountModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAccountModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAccountModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintAccountModel.prototype, "app", void 0);
__decorate([
    MintProperty()
], MintAccountModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintAccountModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintAccountModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccountModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccountModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAccountModel.prototype, "_meta", void 0);
MintAccountModel = __decorate([
    MintResource('/accounts')
], MintAccountModel);

var MintFileStatus;
(function (MintFileStatus) {
    MintFileStatus["Enabled"] = "enabled";
    MintFileStatus["Disabled"] = "disabled";
    MintFileStatus["Deleted"] = "deleted";
})(MintFileStatus || (MintFileStatus = {}));
var MintFileType;
(function (MintFileType) {
    MintFileType["Thumbnail"] = "thumbnail";
    MintFileType["Image"] = "image";
    MintFileType["Audio"] = "audio";
    MintFileType["Video"] = "video";
    MintFileType["Document"] = "document";
    MintFileType["Archive"] = "archive";
    MintFileType["Executable"] = "executable";
    MintFileType["Other"] = "other";
})(MintFileType || (MintFileType = {}));

const logger$2o = MintLogger.getLogger('MintMediaTypeUtil');
class MintMediaTypeUtil {
    static { this.mimeTypeMap = new Map(); }
    static { this.DEFAULT_MIME_TYPE = 'text/plain'; }
    static { this.FORMAT_MIME_MAP = {
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        png: 'image/png',
        bmp: 'image/bmp',
        pcx: 'image/pcx',
        tiff: 'image/tiff',
        ras: 'image/ras',
        pbm: 'image/x-portable-bitmap',
        pgm: 'image/x-portable-graymap',
        ppm: 'image/x-portable-pixmap',
        psd: 'image/psd',
        swf: 'image/x-xcf',
        svg: 'image/svg+xml',
    }; }
    static { this.IMAGE_MIME_TYPES = [
        'image/jpeg',
        'image/pjpeg',
        'image/gif',
        'image/png',
        'image/bmp',
        'image/pcx',
        'image/tiff',
        'image/ras',
        'image/x-portable-bitmap',
        'image/x-portable-graymap',
        'image/x-portable-pixmap',
        'image/psd',
        'image/x-xcf',
        'image/svg+xml',
    ]; }
    static { this.AUDIO_MIME_TYPES = [
        'audio/amr',
        'audio/3gpp',
        'audio/3gpp2',
        'audio/basic',
        'audio/L24',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/vorbis',
        'audio/vnd.rn-realaudio',
        'audio/vnd.wav',
        'audio/wav',
        'audio/x-wav',
        'audio/webm',
        'audio/x-aac',
        'audio/x-caf',
    ]; }
    static { this.VIDEO_MIME_TYPES = [
        'video/mpeg',
        'video/mp4',
        'video/ogg',
        'video/quicktime',
        'video/webm',
        'video/x-matroska',
        'application/x-matroska',
        'video/x-ms-wmv',
        'video/x-flv',
    ]; }
    static { this.DOCUMENT_MIME_TYPES = [
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.presentation',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-xpsdocument',
        'application/pdf',
        'application/postscript',
        'application/x-latex',
        'text/css',
        'text/html',
        'text/plain',
        'text/csv',
        'text/xml',
        'text/vcard',
        'text/x-vcard',
        'application/javascript',
        'application/json',
    ]; }
    static { this.ARCHIVE_MIME_TYPES = [
        'application/x-7z-compressed',
        'application/x-rar-compressed',
        'application/x-tar',
        'application/zip',
        'application/gzip',
    ]; }
    static isArchive(contentType) {
        for (const s of MintMediaTypeUtil.ARCHIVE_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isAudio(contentType) {
        for (const s of MintMediaTypeUtil.AUDIO_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isDocument(contentType) {
        for (const s of MintMediaTypeUtil.DOCUMENT_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isImage(contentType) {
        for (const s of MintMediaTypeUtil.IMAGE_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isVideo(contentType) {
        for (const s of MintMediaTypeUtil.VIDEO_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isMedia(contentType) {
        return (MintMediaTypeUtil.isAudio(contentType) ||
            MintMediaTypeUtil.isVideo(contentType) ||
            MintMediaTypeUtil.isImage(contentType));
    }
    static getMediaTypeByFormat(format, isProgressive = false) {
        // if (format === 'jpeg' && isProgressive) {
        //   return 'image/pjpeg';
        // }
        return MintMediaTypeUtil.FORMAT_MIME_MAP[format];
    }
    static getExtension(contentType) {
        if (!contentType) {
            return null;
        }
        switch (contentType.toLowerCase()) {
            // images
            case 'image/jpeg':
            case 'image/pjpeg':
                return 'jpg';
            case 'image/gif':
                return 'gif';
            case 'image/png':
                return 'png';
            case 'image/bmp':
                return 'bmp';
            case 'image/pcx':
                return 'pcx';
            case 'image/tiff':
                return 'tif';
            case 'image/ras':
                return 'ras';
            case 'image/x-portable-bitmap':
            case 'image/x-portable-graymap':
            case 'image/x-portable-pixmap':
                return 'pbm';
            case 'image/psd':
                return 'pbm';
            case 'image/x-xcf':
                return 'xcf';
            // images
            case 'video/mpeg':
                return 'mpeg';
            case 'video/mp4':
                return 'mp4';
            case 'video/ogg':
                return 'ogg';
            case 'video/quicktime':
                return 'mov';
            case 'video/webm':
            case 'video/x-matroska':
            case 'application/x-matroska':
                return 'webm';
            case 'video/x-ms-wmv':
                return 'wmv';
            case 'video/x-flv':
                return 'flv';
            // images
            case 'audio/amr':
                return 'amr';
            case 'audio/3gpp':
            case 'audio/3gpp2':
                return '3gpp';
            case 'audio/basic':
                return 'basic';
            case 'audio/L24':
                return 'l24';
            case 'audio/mp4':
                return 'mp4';
            case 'audio/mpeg':
                return 'mpeg';
            case 'audio/ogg':
                return 'ogg';
            case 'audio/vorbis':
                return 'vorbis';
            case 'audio/vnd.rn-realaudio':
                return 'ra';
            case 'audio/vnd.wav':
            case 'audio/wav':
            case 'audio/x-wav':
                return 'wav';
            case 'audio/webm':
                return 'webm';
            case 'audio/x-aac':
                return 'aac';
            case 'audio/x-caf':
                return 'caf';
            // documents
            case 'text/plain':
                return 'txt';
            case 'text/html':
                return 'html';
            case 'application/pdf':
                return 'pdf';
            case 'text/vcard':
            case 'text/x-vcard':
                return 'vcf';
            case 'text/calendar':
                return 'ics';
            case 'text/vcalendar':
            case 'text/x-vcalendar':
                return 'vcs';
            case 'text/rtf':
            case 'application/rtf':
                return 'rtf';
            case 'text/richtext':
                return 'rtx';
            case 'application/json':
                return 'json';
            case 'application/javascript':
                return 'js';
            case 'text/css':
                return 'css';
            default:
                return null;
        }
    }
}

var MintImage_1;
/*
 * http://www.impulseadventure.com/photo/exif-orientation.html
 *

EXIF Orientation Value  Row #0 is:  Column #0 is:
1   Top Left side
2*  Top Right side
3   Bottom  Right side
4*  Bottom  Left side
5*  Left side   Top
6   Right side  Top
7*  Right side  Bottom
8   Left side   Bottom
NOTE: Values with "*" are uncommon since they represent "flipped" orientations.
*/
var MintImageOrientation;
(function (MintImageOrientation) {
    MintImageOrientation[MintImageOrientation["TopLeft"] = 1] = "TopLeft";
    MintImageOrientation[MintImageOrientation["TopRight"] = 2] = "TopRight";
    MintImageOrientation["TopRightFlipped"] = "2*";
    MintImageOrientation[MintImageOrientation["BottomRight"] = 3] = "BottomRight";
    MintImageOrientation[MintImageOrientation["BottomLeft"] = 4] = "BottomLeft";
    MintImageOrientation["BottomLeftFlipped"] = "4*";
    MintImageOrientation[MintImageOrientation["LeftTop"] = 5] = "LeftTop";
    MintImageOrientation["LeftTopFlipped"] = "5*";
    MintImageOrientation[MintImageOrientation["RightTop"] = 6] = "RightTop";
    MintImageOrientation[MintImageOrientation["RightBottom"] = 7] = "RightBottom";
    MintImageOrientation["RightBottomFlipped"] = "7*";
    MintImageOrientation[MintImageOrientation["LeftBottom"] = 8] = "LeftBottom";
})(MintImageOrientation || (MintImageOrientation = {}));
var MintImageColorSpace;
(function (MintImageColorSpace) {
    MintImageColorSpace["Multiband"] = "multiband";
    MintImageColorSpace["BlackWhite"] = "b-w";
    MintImageColorSpace["BlackWhite2"] = "bw";
    MintImageColorSpace["CMYK"] = "cmyk";
    MintImageColorSpace["SRGB"] = "srgb";
})(MintImageColorSpace || (MintImageColorSpace = {}));
var MintImageChannel;
(function (MintImageChannel) {
    MintImageChannel[MintImageChannel["SRGB"] = 3] = "SRGB";
    MintImageChannel[MintImageChannel["CMYK"] = 4] = "CMYK";
})(MintImageChannel || (MintImageChannel = {}));
let MintImage = MintImage_1 = class MintImage {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintImage_1, model));
            const buffers = ['buffer', 'exif', 'icc', 'iptc', 'xmp'];
            for (const buffer of buffers) {
                this[buffer] = model[buffer];
            }
        }
        this.bitsPerPixel = this.channels * 8;
        if (this.hasAlpha) {
            this.bitsPerPixel += 8;
        }
        if (this.format) {
            this.contentType = MintMediaTypeUtil.getMediaTypeByFormat(this.format, this.isProgressive);
        }
    }
    toJSON() {
        const model = {
            ...this,
        };
        const buffers = ['buffer', 'exif', 'icc', 'iptc', 'xmp'];
        for (const buffer of buffers) {
            delete model[buffer];
        }
        return model;
    }
};
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "bitsPerPixel", void 0);
__decorate([
    Expose(),
    IsMimeType()
], MintImage.prototype, "contentType", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "framesPerSecond", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "duration", void 0);
__decorate([
    Expose(),
    IsString()
], MintImage.prototype, "format", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "size", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "width", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "height", void 0);
__decorate([
    Expose(),
    IsEnum(MintImageColorSpace)
], MintImage.prototype, "space", void 0);
__decorate([
    Expose(),
    IsEnum(MintImageChannel)
], MintImage.prototype, "channels", void 0);
__decorate([
    Expose(),
    IsString()
], MintImage.prototype, "depth", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "density", void 0);
__decorate([
    Expose(),
    IsString()
], MintImage.prototype, "chromaSubsampling", void 0);
__decorate([
    Expose(),
    IsBoolean()
], MintImage.prototype, "isProgressive", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "pages", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "pageHeight", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "pagePrimary", void 0);
__decorate([
    Expose(),
    IsInt()
], MintImage.prototype, "loop", void 0);
__decorate([
    Expose(),
    IsArray()
], MintImage.prototype, "delay", void 0);
__decorate([
    Expose(),
    IsBoolean()
], MintImage.prototype, "hasProfile", void 0);
__decorate([
    Expose(),
    IsBoolean()
], MintImage.prototype, "hasAlpha", void 0);
__decorate([
    Expose(),
    IsEnum(MintImageOrientation)
], MintImage.prototype, "orientation", void 0);
MintImage = MintImage_1 = __decorate([
    Exclude()
], MintImage);

var MintMediaModel_1;
// @dynamic
let MintMediaModel = MintMediaModel_1 = class MintMediaModel {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintMediaModel_1, model));
        }
    }
};
__decorate([
    Expose(),
    IsString()
], MintMediaModel.prototype, "uid", void 0);
__decorate([
    Expose(),
    IsEnum(MintFileType)
], MintMediaModel.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString()
], MintMediaModel.prototype, "mediaUrl", void 0);
__decorate([
    Expose(),
    IsString()
], MintMediaModel.prototype, "thumbnailUrl", void 0);
__decorate([
    Expose(),
    IsMimeType()
], MintMediaModel.prototype, "contentType", void 0);
__decorate([
    Expose(),
    IsInt()
], MintMediaModel.prototype, "size", void 0);
__decorate([
    Expose(),
    IsString()
], MintMediaModel.prototype, "checksum", void 0);
__decorate([
    Expose(),
    IsString()
], MintMediaModel.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString()
], MintMediaModel.prototype, "description", void 0);
__decorate([
    Expose(),
    IsString()
], MintMediaModel.prototype, "extension", void 0);
__decorate([
    Expose(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintMediaModel.prototype, "tags", void 0);
__decorate([
    Expose(),
    IsObject()
], MintMediaModel.prototype, "context", void 0);
__decorate([
    Expose(),
    Type(() => MintImage)
], MintMediaModel.prototype, "image", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintMediaModel.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintMediaModel.prototype, "updatedAt", void 0);
MintMediaModel = MintMediaModel_1 = __decorate([
    Exclude()
], MintMediaModel);

// @dynamic
let MintAppModel = class MintAppModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAppModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAppModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintAppModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintAppModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintAppModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintAppModel.prototype, "serviceUser", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccessRoleModel)
], MintAppModel.prototype, "serviceRole", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintAppModel.prototype, "logo", void 0);
__decorate([
    MintProperty()
], MintAppModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintAppModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintAppModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintAppModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAppModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAppModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAppModel.prototype, "_meta", void 0);
MintAppModel = __decorate([
    MintResource('/apps')
], MintAppModel);

var MintVerificationStatus;
(function (MintVerificationStatus) {
    MintVerificationStatus["Verified"] = "verified";
    MintVerificationStatus["NotVerified"] = "not-verified";
    MintVerificationStatus["VerificationRequested"] = "verification-requested";
    MintVerificationStatus["VerificationRequestExpired"] = "verification-request-expired";
    MintVerificationStatus["NotFound"] = "not-found";
})(MintVerificationStatus || (MintVerificationStatus = {}));
var MintObjectAccess;
(function (MintObjectAccess) {
    MintObjectAccess["System"] = "system";
    MintObjectAccess["Owner"] = "owner";
    MintObjectAccess["Account"] = "account";
    MintObjectAccess["Friend"] = "friend";
    MintObjectAccess["App"] = "app";
    MintObjectAccess["Public"] = "public";
    MintObjectAccess["None"] = "none";
})(MintObjectAccess || (MintObjectAccess = {}));
var MintObjectOwnership;
(function (MintObjectOwnership) {
    MintObjectOwnership["System"] = "system";
    MintObjectOwnership["App"] = "app";
    MintObjectOwnership["Account"] = "account";
    MintObjectOwnership["User"] = "user";
})(MintObjectOwnership || (MintObjectOwnership = {}));
var MintPeriod;
(function (MintPeriod) {
    MintPeriod["EverySecond"] = "every-second";
    MintPeriod["EveryMinute"] = "every-minute";
    MintPeriod["Hourly"] = "hourly";
    MintPeriod["Daily"] = "daily";
    MintPeriod["Weekly"] = "weekly";
    MintPeriod["Monthly"] = "monthly";
    MintPeriod["Quarterly"] = "quarterly";
    MintPeriod["Annually"] = "annually";
    MintPeriod["Lifetime"] = "lifetime";
})(MintPeriod || (MintPeriod = {}));

let MintDeviceModel = class MintDeviceModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintDeviceModel.prototype, "parent", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "advertiserId", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "userAgent", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "isAdTrackingDisabled", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "osName", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "osVersion", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "bleMacAddress", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "lanMacAddress", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "pnpId", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "vendor", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "manufacturer", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "model", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "serialNumber", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "deviceUuid", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "fingerprint", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "fingerprintHash", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "hardwareVersion", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "firmwareVersion", void 0);
__decorate([
    MintProperty()
], MintDeviceModel.prototype, "capabilities", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintDeviceModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintDeviceModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintDeviceModel.prototype, "_meta", void 0);
MintDeviceModel = __decorate([
    MintResource('/devices')
], MintDeviceModel);

var MintProfilePresence;
(function (MintProfilePresence) {
    MintProfilePresence["Online"] = "online";
    MintProfilePresence["Away"] = "away";
    MintProfilePresence["Busy"] = "busy";
    MintProfilePresence["Invisible"] = "invisible";
    MintProfilePresence["Streaming"] = "streaming";
    MintProfilePresence["Offline"] = "offline";
})(MintProfilePresence || (MintProfilePresence = {}));
var MintProfileVisibility;
(function (MintProfileVisibility) {
    MintProfileVisibility["Public"] = "public";
    MintProfileVisibility["Private"] = "private";
    MintProfileVisibility["Account"] = "account";
    MintProfileVisibility["Friends"] = "friends";
})(MintProfileVisibility || (MintProfileVisibility = {}));
var MintProfileGender;
(function (MintProfileGender) {
    MintProfileGender["Male"] = "male";
    MintProfileGender["Female"] = "female";
    MintProfileGender["NonBinary"] = "non-binary";
    MintProfileGender["Transgender"] = "transgender";
    MintProfileGender["Intersex"] = "intersex";
    MintProfileGender["NonConforming"] = "non-conforming";
    MintProfileGender["Other"] = "other";
    MintProfileGender["Decline"] = "decline";
})(MintProfileGender || (MintProfileGender = {}));
var MintProfileMaritalStatus;
(function (MintProfileMaritalStatus) {
    MintProfileMaritalStatus["Single"] = "single";
    MintProfileMaritalStatus["Married"] = "married";
    MintProfileMaritalStatus["DomesticPartnership"] = "domestic-partnership";
    MintProfileMaritalStatus["Separated"] = "separated";
    MintProfileMaritalStatus["Divorced"] = "divorced";
    MintProfileMaritalStatus["Widowed"] = "widowed";
})(MintProfileMaritalStatus || (MintProfileMaritalStatus = {}));
var MintProfileRace;
(function (MintProfileRace) {
    MintProfileRace["NonHispanicWhite"] = "non-hispanic-white";
    MintProfileRace["NonHispanicBlack"] = "non-hispanic-black";
    MintProfileRace["Hispanic"] = "hispanic";
    MintProfileRace["Asian"] = "asian";
    MintProfileRace["NativeAmerican"] = "native-american";
    MintProfileRace["PacificIslander"] = "pacific-islander";
    MintProfileRace["MultipleRace"] = "multiple-race";
    MintProfileRace["Other"] = "other-race";
})(MintProfileRace || (MintProfileRace = {}));
var MintProfileEyeColor;
(function (MintProfileEyeColor) {
    MintProfileEyeColor["Amber"] = "amber";
    MintProfileEyeColor["Blue"] = "blue";
    MintProfileEyeColor["Brown"] = "brown";
    MintProfileEyeColor["Gray"] = "gray";
    MintProfileEyeColor["Green"] = "green";
    MintProfileEyeColor["Hazel"] = "hazel";
})(MintProfileEyeColor || (MintProfileEyeColor = {}));
var MintPhoneType;
(function (MintPhoneType) {
    MintPhoneType["Home"] = "home";
    MintPhoneType["Work"] = "work";
    MintPhoneType["Mobile"] = "mobile";
    MintPhoneType["Fax"] = "fax";
    MintPhoneType["Other"] = "other";
})(MintPhoneType || (MintPhoneType = {}));
var MintEmailType;
(function (MintEmailType) {
    MintEmailType["Personal"] = "personal";
    MintEmailType["Work"] = "work";
    MintEmailType["Other"] = "other";
})(MintEmailType || (MintEmailType = {}));
var MintUserStatus;
(function (MintUserStatus) {
    MintUserStatus["Enabled"] = "enabled";
    MintUserStatus["Disabled"] = "disabled";
    MintUserStatus["Deleted"] = "deleted";
})(MintUserStatus || (MintUserStatus = {}));
var MintUserType;
(function (MintUserType) {
    MintUserType["Service"] = "service";
    MintUserType["User"] = "user";
    // Non-registered user.  Use case is a user created by the system
    // to allow certain functionality for a non-registered user.
    // For example to allow temporary access for a third-party to download a file.
    //
    // FIXME: Allow for a guest user to be "upgraded" to a full user during
    //   registration process.
    MintUserType["Guest"] = "guest";
})(MintUserType || (MintUserType = {}));
// Define a well known UID for the system user
// Needed by MintService to track entity updates
const MINT_SYSTEM_USER_UID = '_system';
const MINT_SYSTEM_USER_USERNAME = 'system';
const MINT_SYSTEM_ACCOUNT_UID = '_system';
const MINT_SYSTEM_ACCOUNT_SLUG = 'system';
class MintUserDynamicSettings {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintUserDynamicSettings, model));
        }
    }
}
class MintUserMfaDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintUserMfaDto, model));
        }
    }
}
__decorate([
    IsOptional(),
    IsBoolean()
], MintUserMfaDto.prototype, "enabled", void 0);
__decorate([
    IsOptional(),
    IsEnum(MintAuthChannel)
], MintUserMfaDto.prototype, "defaultChannel", void 0);
class MintUserEmailVerifiedDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintUserEmailVerifiedDto, model));
        }
    }
}
__decorate([
    IsDefined(),
    IsString()
], MintUserEmailVerifiedDto.prototype, "email", void 0);
__decorate([
    IsDefined(),
    IsEnum(MintVerificationStatus)
], MintUserEmailVerifiedDto.prototype, "status", void 0);
class MintUserMobileNumberVerifiedDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintUserMobileNumberVerifiedDto, model));
        }
    }
}
__decorate([
    IsDefined(),
    IsString()
], MintUserMobileNumberVerifiedDto.prototype, "mobileNumber", void 0);
__decorate([
    IsDefined(),
    IsEnum(MintVerificationStatus)
], MintUserMobileNumberVerifiedDto.prototype, "status", void 0);
class MintUserLockedStatusDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintUserLockedStatusDto, model));
        }
    }
}
__decorate([
    IsDefined(),
    IsBoolean()
], MintUserLockedStatusDto.prototype, "locked", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    Type(() => MintDeviceModel)
], MintUserLockedStatusDto.prototype, "devices", void 0);

// @dynamic
let MintUserModel = class MintUserModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type((type) => MintAppModel)
], MintUserModel.prototype, "app", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    Type((type) => MintMediaModel)
], MintUserModel.prototype, "photo", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "prefix", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "firstName", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "middleName", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "maidenName", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "lastName", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "suffix", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "preferredName", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "username", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "email", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "mobileNumber", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserModel.prototype, "lastLoginAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserDynamicSettings)
], MintUserModel.prototype, "dynamicSettings", void 0);
__decorate([
    MintProperty()
], MintUserModel.prototype, "fullName", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserModel.prototype, "_meta", void 0);
MintUserModel = __decorate([
    MintResource('/users')
], MintUserModel);

const logger$2n = MintLogger.getLogger('MintAzureLoginProvider');
// Based on: https://github.com/abacritt/angularx-social-login/blob/master/projects/lib/src/providers/microsoft-login-provider.ts
/**
 * Protocol modes supported by MSAL.
 */
var MintAzureLoginProtocolMode;
(function (MintAzureLoginProtocolMode) {
    MintAzureLoginProtocolMode["AAD"] = "AAD";
    MintAzureLoginProtocolMode["OIDC"] = "OIDC";
})(MintAzureLoginProtocolMode || (MintAzureLoginProtocolMode = {}));
var MintAzureLoginPrompt;
(function (MintAzureLoginPrompt) {
    MintAzureLoginPrompt["None"] = "none";
    MintAzureLoginPrompt["Login"] = "login";
    MintAzureLoginPrompt["Consent"] = "consent";
    MintAzureLoginPrompt["SelectAccount"] = "select_account";
})(MintAzureLoginPrompt || (MintAzureLoginPrompt = {}));
var MintAzureLoginCacheLocation;
(function (MintAzureLoginCacheLocation) {
    MintAzureLoginCacheLocation["LocalStorage"] = "localStorage";
    MintAzureLoginCacheLocation["SessionStorage"] = "sessionStorage";
    MintAzureLoginCacheLocation["MemoryStorage"] = "memoryStorage";
})(MintAzureLoginCacheLocation || (MintAzureLoginCacheLocation = {}));
// const COMMON_AUTHORITY = 'https://login.microsoftonline.com/common/';
/**
 * Microsoft Authentication using MSAL v2: https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-browser
 */
class MintAzureLoginProvider extends BaseLoginProvider {
    static { this.PROVIDER_ID = 'MINT_AZURE'; }
    constructor(clientId, initOptions) {
        super();
        this.clientId = clientId;
        this.initOptions = {
            tenantId: 'common',
            // scopes: ['openid', 'email', 'profile', 'User.Read'],
            scopes: ['openid', 'email', 'profile', 'offline_access'],
            knownAuthorities: [],
            protocolMode: MintAzureLoginProtocolMode.AAD,
            clientCapabilities: [],
            cacheLocation: MintAzureLoginCacheLocation.SessionStorage,
        };
        this.initOptions = {
            ...this.initOptions,
            ...initOptions,
        };
        this.authority = `https://login.microsoftonline.com/${this.initOptions.tenantId}/`;
    }
    initialize() {
        return new Promise((resolve, reject) => {
            this.loadScript(MintAzureLoginProvider.PROVIDER_ID, 'https://alcdn.msauth.net/browser/2.13.1/js/msal-browser.min.js', () => {
                try {
                    const config = {
                        auth: {
                            clientId: this.clientId,
                            redirectUri: this.initOptions.redirect_uri ?? location.origin,
                            authority: this.authority,
                            knownAuthorities: this.initOptions.knownAuthorities,
                            protocolMode: this.initOptions.protocolMode,
                            clientCapabilities: this.initOptions.clientCapabilities,
                        },
                        cache: !this.initOptions.cacheLocation
                            ? null
                            : {
                                cacheLocation: this.initOptions.cacheLocation,
                            },
                    };
                    this._instance = new msal.PublicClientApplication(config);
                    resolve();
                }
                catch (e) {
                    reject(e);
                }
            });
        });
    }
    getSocialUser(loginResponse) {
        const user = new SocialUser();
        user.provider = MintAzureLoginProvider.PROVIDER_ID;
        user.id = loginResponse.uniqueId;
        user.idToken = loginResponse.idToken;
        user.authToken = loginResponse.accessToken;
        user.name = loginResponse.idTokenClaims.name;
        user.email = loginResponse.account.username;
        user.idToken = loginResponse.idToken;
        user.response = loginResponse;
        return new Promise((resolve, reject) => {
            // After login, use Microsoft Graph API to get user info
            const meRequest = new XMLHttpRequest();
            meRequest.onreadystatechange = () => {
                if (meRequest.readyState === 4) {
                    try {
                        if (meRequest.status === 200) {
                            const userInfo = JSON.parse(meRequest.responseText);
                            user.firstName = userInfo.givenName;
                            user.lastName = userInfo.surname;
                            resolve(user);
                        }
                        else {
                            logger$2n.warn(`Error retrieving user info: ${meRequest.status}`);
                            resolve(user);
                        }
                    }
                    catch (err) {
                        reject(err);
                    }
                }
            };
            // Microsoft Graph ME Endpoint: https://docs.microsoft.com/en-us/graph/api/user-get?view=graph-rest-1.0&tabs=http
            meRequest.open('GET', 'https://graph.microsoft.com/v1.0/me');
            meRequest.setRequestHeader('Authorization', `Bearer ${loginResponse.accessToken}`);
            try {
                meRequest.send();
            }
            catch (err) {
                logger$2n.warn(`Error sending user info request: `, err);
                resolve(user);
            }
        });
    }
    async getLoginStatus() {
        const accounts = this._instance.getAllAccounts();
        if (accounts?.length > 0) {
            const loginResponse = await this._instance.ssoSilent({
                scopes: this.initOptions.scopes,
                loginHint: accounts[0].username,
            });
            return await this.getSocialUser(loginResponse);
        }
        else {
            throw new Error(`No user is currently logged in with ${MintAzureLoginProvider.PROVIDER_ID}`);
        }
    }
    async signIn() {
        const loginResponse = await this._instance.loginPopup({
            scopes: this.initOptions.scopes,
            prompt: this.initOptions.prompt,
        });
        return await this.getSocialUser(loginResponse);
    }
    async signOut(revoke) {
        const accounts = this._instance.getAllAccounts();
        if (accounts?.length > 0) {
            await this._instance.logoutPopup({
                account: accounts[0],
                postLogoutRedirectUri: this.initOptions.logout_redirect_uri ??
                    this.initOptions.redirect_uri ??
                    location.href,
            });
        }
    }
}

class MintAuthLoginCredentialsDto {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintAuthLoginCredentialsDto.prototype, "username", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintAuthLoginCredentialsDto.prototype, "password", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], MintAuthLoginCredentialsDto.prototype, "logoutOtherSessions", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthLoginCredentialsDto.prototype, "context", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthLoginCredentialsDto.prototype, "nonce", void 0);

class MintAuthSsoDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintAuthSsoDto, model));
        }
        this.context = this.context ?? {};
    }
}
__decorate([
    IsEnum(MintAuthSsoProvider),
    IsDefined()
], MintAuthSsoDto.prototype, "provider", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthSsoDto.prototype, "providerAuthToken", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthSsoDto.prototype, "providerIdToken", void 0);
__decorate([
    IsOptional()
], MintAuthSsoDto.prototype, "providerResponse", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthSsoDto.prototype, "providerAuthorizationCode", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthSsoDto.prototype, "referredBy", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthSsoDto.prototype, "invitationCode", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthSsoDto.prototype, "promoCode", void 0);
__decorate([
    IsInt(),
    IsOptional()
], MintAuthSsoDto.prototype, "signupTime", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], MintAuthSsoDto.prototype, "logoutOtherSessions", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthSsoDto.prototype, "utm", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthSsoDto.prototype, "nonce", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthSsoDto.prototype, "context", void 0);
__decorate([
    IsOptional(),
    Type(() => MintSsoUserModel)
], MintAuthSsoDto.prototype, "ssoUser", void 0);

class MintAuthTokenRefreshDto {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintAuthTokenRefreshDto.prototype, "refreshToken", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthTokenRefreshDto.prototype, "nonce", void 0);

var MintAuthErrorType;
(function (MintAuthErrorType) {
    MintAuthErrorType["LoginRequired"] = "login-required";
    MintAuthErrorType["LoginDisabled"] = "login-disabled";
    MintAuthErrorType["InvalidToken"] = "invalid-token";
    MintAuthErrorType["InvalidUsername"] = "invalid-username";
    MintAuthErrorType["InvalidPassword"] = "invalid-password";
    MintAuthErrorType["InvalidEmail"] = "invalid-email";
    MintAuthErrorType["InvalidMobileNumber"] = "invalid-mobile-number";
    MintAuthErrorType["InvalidAuthCode"] = "invalid-auth-code";
    MintAuthErrorType["InvalidAuthenticatorToken"] = "invalid-authenticator-token";
    MintAuthErrorType["DuplicateUser"] = "duplicate-user";
    MintAuthErrorType["MaxLoginAttempts"] = "max-login-attempts";
    MintAuthErrorType["MaxSessionsExceeded"] = "max-sessions-exceeded";
    MintAuthErrorType["NotAuthorized"] = "not-authorized";
    MintAuthErrorType["NotVerified"] = "not-verified";
    MintAuthErrorType["EmailNotVerified"] = "email-not-verified";
    MintAuthErrorType["MobileNotVerified"] = "mobile-not-verified";
    MintAuthErrorType["UserNotEnabled"] = "user-not-enabled";
    MintAuthErrorType["UserNotFound"] = "user-not-found";
    MintAuthErrorType["InternalError"] = "internal-error";
    MintAuthErrorType["RecentPasswordMatch"] = "recent-password-match";
})(MintAuthErrorType || (MintAuthErrorType = {}));
class MintAuthException extends MintError {
    #type;
    constructor(message, type, error) {
        super(message, {
            code: error?.code ?? error.status,
            data: error,
        });
        this.#type = type;
    }
    get type() {
        return this.#type;
    }
}

var MintSessionToken_1;
// @dynamic
let MintSessionToken = MintSessionToken_1 = class MintSessionToken {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintSessionToken_1, model));
        }
    }
};
__decorate([
    Expose()
], MintSessionToken.prototype, "tokenType", void 0);
__decorate([
    Expose()
], MintSessionToken.prototype, "tokenUid", void 0);
__decorate([
    Expose()
], MintSessionToken.prototype, "accessToken", void 0);
__decorate([
    Expose()
], MintSessionToken.prototype, "refreshToken", void 0);
__decorate([
    Expose()
], MintSessionToken.prototype, "idToken", void 0);
__decorate([
    Expose()
], MintSessionToken.prototype, "expiresIn", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintSessionToken.prototype, "expiresAt", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintSessionToken.prototype, "refreshedAt", void 0);
__decorate([
    Expose()
], MintSessionToken.prototype, "refreshExpiresIn", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintSessionToken.prototype, "refreshExpiresAt", void 0);
__decorate([
    Expose()
], MintSessionToken.prototype, "accessPrivs", void 0);
MintSessionToken = MintSessionToken_1 = __decorate([
    Exclude()
], MintSessionToken);

var MintSession_1;
// @dynamic
let MintSession = MintSession_1 = class MintSession {
    constructor(obj) {
        if (obj) {
            Object.assign(this, plainToInstance(MintSession_1, obj));
        }
    }
};
__decorate([
    Expose(),
    Type(() => MintUserModel)
], MintSession.prototype, "user", void 0);
__decorate([
    Expose(),
    Type(() => MintSessionToken)
], MintSession.prototype, "token", void 0);
__decorate([
    Expose()
], MintSession.prototype, "mfa", void 0);
__decorate([
    Expose()
], MintSession.prototype, "verification", void 0);
MintSession = MintSession_1 = __decorate([
    Exclude()
], MintSession);

class MintEnumUtil {
    static isValidValue(obj, value) {
        if (Object.values(obj).includes(value)) {
            return true;
        }
        return false;
    }
    static toEnum(enumClass, value) {
        if (typeof value === 'undefined' || value === null) {
            return null;
        }
        if (!MintEnumUtil.isValidValue(enumClass, value)) {
            throw new Error('Invalid enum type: ' + value);
        }
        return value;
    }
}

const logger$2m = MintLogger.getLogger('MintConfigService');
class MintConfigService {
    #envConfig;
    #dotConfig;
    constructor(options) {
        this.env = options.env;
        let configs = options.configs;
        if (!Array.isArray(configs)) {
            configs = [configs];
        }
        let allDefaults = {};
        let allValues = {};
        for (const config of configs) {
            const defaults = config['_default'] || {};
            allDefaults = MintDeepMerge.merge(allDefaults, defaults);
        }
        for (const config of configs) {
            const values = config[this.env] || {};
            allValues = MintDeepMerge.merge(allValues, values);
        }
        this.#envConfig = MintDeepMerge.merge(allDefaults, allValues);
        this.#envConfig = MintObjectUtil.interpolate(this.#envConfig);
        this.#dotConfig = dot.dot(this.#envConfig);
        logger$2m.debug('ENVIRONMENT: ', this.env);
        logger$2m.debug('dotConfig: ', this.#dotConfig);
    }
    getEnv() {
        return this.env;
    }
    isProdution() {
        return this.env === 'production';
    }
    getConfig() {
        return this.#envConfig;
    }
    getDotConfig() {
        return this.#dotConfig;
    }
    get(key) {
        return this.#dotConfig[key];
    }
    getEnum(key, enumClass, defaultValue) {
        const value = this.getString(key);
        if (!value || typeof value === 'undefined') {
            return typeof defaultValue === 'undefined' ? null : defaultValue;
        }
        if (!MintEnumUtil.isValidValue(enumClass, value)) {
            throw new Error('Invalid enum type: ' + value);
        }
        return value;
    }
    getString(key, defaultValue) {
        let value = this.get(key);
        if (!value || typeof value === 'undefined') {
            return typeof defaultValue === 'undefined' ? null : defaultValue;
        }
        if (typeof value !== 'string') {
            value = String(value);
        }
        return value;
    }
    getBoolean(key, defaultValue) {
        const value = this.get(key);
        return MintTypeUtil.parseBoolean(value, defaultValue);
    }
    getInteger(key, defaultValue) {
        const value = this.get(key);
        return MintTypeUtil.parseInteger(value, defaultValue);
    }
    getFloat(key, defaultValue) {
        const value = this.get(key);
        return MintTypeUtil.parseFloat(value, defaultValue);
    }
    getObject(key, defaultValue) {
        let value = dot.pick(key, this.#envConfig);
        if (isNullish(value)) {
            value = defaultValue;
        }
        return value;
    }
    getList(key, defaultValue) {
        let value = this.getObject(key);
        if (isNullish(value)) {
            value = defaultValue;
        }
        if (!Array.isArray(value)) {
            throw new MintError(`getList: Value for key [${key}] is not an Array.`);
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintConfigService, deps: [{ token: 'MINT_CONFIG_OPTIONS' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintConfigService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['MINT_CONFIG_OPTIONS']
                }] }] });

//
// NOTE: when using ElasticBeanstalk set to ebs-production
// https://medium.com/engineering-on-the-incline/elastic-beanstalk-npm-production-installation-tips-1dccf1f468c4
//
var MintEnv;
(function (MintEnv) {
    MintEnv["Local"] = "local";
    MintEnv["Development"] = "development";
    MintEnv["Integration"] = "integration";
    MintEnv["QA"] = "qa";
    MintEnv["Staging"] = "staging";
    MintEnv["UAT"] = "uat";
    MintEnv["Beta"] = "beta";
    MintEnv["Production"] = "production";
    MintEnv["EbsProduction"] = "ebs-production";
    MintEnv["Test"] = "test";
})(MintEnv || (MintEnv = {}));
var MintPropertyNameCase;
(function (MintPropertyNameCase) {
    MintPropertyNameCase["Snake"] = "snake";
    MintPropertyNameCase["Camel"] = "camel";
})(MintPropertyNameCase || (MintPropertyNameCase = {}));

var MintHttpRequestHeaderName;
(function (MintHttpRequestHeaderName) {
    MintHttpRequestHeaderName["AppVersion"] = "mint-app-version";
    MintHttpRequestHeaderName["AppBuild"] = "mint-app-build";
    MintHttpRequestHeaderName["ApiVersion"] = "mint-api-version";
    MintHttpRequestHeaderName["ClientId"] = "mint-client-id";
    MintHttpRequestHeaderName["Latitude"] = "mint-latitude";
    MintHttpRequestHeaderName["Longitude"] = "mint-longitude";
    MintHttpRequestHeaderName["Altitude"] = "mint-altitude";
    MintHttpRequestHeaderName["DeviceId"] = "mint-device-id";
    MintHttpRequestHeaderName["Timestamp"] = "mint-timestamp";
    MintHttpRequestHeaderName["IdempotencyKey"] = "idempotency-key";
})(MintHttpRequestHeaderName || (MintHttpRequestHeaderName = {}));

const logger$2l = MintLogger.getLogger('MintHttpService');
// export enum MintPropertyNameCase {
//   Snake = 'snake',
//   Camel = 'camel',
// }
class MintHttpService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.token = null;
        this.withCredentials = true;
        this.baseUrl = null;
        this.cachedRequests = [];
        // logger.debug('this.config: ', this.config);
        this.config = this.configService.getConfig();
        this.propertyNameCase =
            this.config.api.propertyNameCase ?? MintPropertyNameCase.Snake;
        this.baseUrl = this.config.api.baseUrl;
        if (!this.baseUrl.endsWith('/')) {
            this.baseUrl += '/';
        }
    }
    // to be used with http interceptor
    // https://ryanchenkie.com/angular-authentication-using-the-http-client-and-http-interceptors
    collectFailedRequest(request) {
        // this.cachedRequests.push(request);
    }
    retryFailedRequests() {
        for (const req of this.cachedRequests) {
            // this.http.request(req);
        }
    }
    getDefaultHeaders(args) {
        const headers = args ?? {};
        const clientIdHeaderName = this.config.api.clientIdHeaderName ?? MintHttpRequestHeaderName.ClientId;
        const clientId = this.config.api.clientId;
        if (clientIdHeaderName && clientId) {
            headers[clientIdHeaderName] = clientId;
        }
        // common params
        headers[MintHttpRequestHeaderName.ApiVersion] =
            this.config.api.apiVersion ?? '1.0.0';
        headers[MintHttpRequestHeaderName.AppVersion] = this.config.app?.version;
        headers[MintHttpRequestHeaderName.AppBuild] = this.config.app?.build;
        headers[MintHttpRequestHeaderName.Timestamp] = `${Date.now()}`;
        if (this.token) {
            headers['Authorization'] = this.token;
        }
        return new HttpHeaders(headers);
    }
    getHttpRequestOptions(args = {}) {
        const headers = this.getDefaultHeaders(args.headers);
        // observe?: string; // 'body'|'response'|'events';
        // responseType?: 'json';  // 'json'|'text'|'arraybuffer'|'blob';
        const options = {
            observe: 'response',
            responseType: 'json',
            headers: headers,
            withCredentials: args.withCredentials ?? this.withCredentials,
        };
        if (args.queryParams) {
            let params = new HttpParams();
            for (const key of Object.keys(args.queryParams)) {
                let value = args.queryParams[key];
                if (typeof value !== 'string') {
                    value = JSON.stringify(value);
                }
                // params.set(key, value); // DOES NOT WORK
                params = params.append(key, value);
            }
            options.params = params;
        }
        // logger.debug('getHttpRequestOptions: options: ', options);
        return options;
    }
    async get(urlPath, args) {
        const options = this.getHttpRequestOptions(args);
        // logger.debug('get: options: ', toJSON(options, true));
        return new Promise((resolve, reject) => {
            this.http
                .get(this.url(urlPath), options)
                .pipe(map((resp) => {
                return MintCamelizer.camelizeKeys(resp.body);
            }))
                .subscribe({
                next: (result) => {
                    if (args?.subscribeFn) {
                        result = args.subscribeFn(result);
                    }
                    resolve(result);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
    createRequest(method, urlPath, body, options = {}) {
        options.headers = this.getDefaultHeaders();
        return new HttpRequest(method, this.url(urlPath), body, {
            withCredentials: this.withCredentials,
            ...(options || {}),
        });
    }
    url(urlPath) {
        if (urlPath.startsWith('http://') || urlPath.startsWith('https://')) {
            return urlPath;
        }
        if (urlPath.startsWith('/')) {
            urlPath = urlPath.substring(1);
        }
        return this.baseUrl + urlPath;
    }
    request(httpRequest, options = {}) {
        return this.http
            .request(httpRequest)
            .pipe()
            .subscribe({
            next: (event) => {
                // logger.debug('request: event: ', event);
                if (event.type === HttpEventType.UploadProgress ||
                    event.type === HttpEventType.DownloadProgress) {
                    if (event.total && event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    if (options.onProgress) {
                        options.onProgress(event);
                    }
                }
                else if (event instanceof HttpResponse) {
                    // logger.debug('event: response: ', event);
                    let result = event.body;
                    if (typeof event.body === 'object' &&
                        !(result instanceof Blob) &&
                        !(result instanceof ArrayBuffer) &&
                        !(result instanceof File)) {
                        result = MintCamelizer.camelizeKeys(event.body);
                    }
                    if (options.onSuccess) {
                        options.onSuccess(result);
                    }
                }
            },
            error: (err) => {
                logger$2l.error('request: error: ', httpRequest, err);
                if (options.onError) {
                    options.onError(err);
                }
            },
        });
    }
    async post(urlPath, data, args) {
        const options = this.getHttpRequestOptions(args);
        if (!options || !options.headers) {
            throw new Error('Invalid options: ' + options);
        }
        options.headers['Content-Type'] = 'application/json';
        // logger.debug('post: options: ', options);
        return new Promise((resolve, reject) => {
            if (data && typeof data !== 'string') {
                if (this.propertyNameCase === 'snake') {
                    data = MintCamelizer.decamelizeKeys(data);
                }
                // data = JSON.stringify(data);
            }
            this.http
                .post(this.url(urlPath), data, options)
                .pipe(map((resp) => {
                return MintCamelizer.camelizeKeys(resp.body);
            }))
                .subscribe({
                next: (result) => {
                    if (args?.subscribeFn) {
                        result = args.subscribeFn(result);
                    }
                    resolve(result);
                },
                error: (err) => {
                    // logger.error('post: subscribe: error: ', err);
                    reject(err);
                },
            });
        });
    }
    async put(urlPath, data, args) {
        const options = this.getHttpRequestOptions(args);
        if (!options || !options.headers) {
            throw new Error('Invalid options: ' + options);
        }
        options.headers['Content-Type'] = 'application/json';
        return new Promise((resolve, reject) => {
            if (data && typeof data !== 'string') {
                if (this.propertyNameCase === 'snake') {
                    data = MintCamelizer.decamelizeKeys(data);
                }
            }
            this.http
                .put(this.url(urlPath), data, options)
                .pipe(map((resp) => {
                return MintCamelizer.camelizeKeys(resp.body);
            }))
                .subscribe({
                next: (result) => {
                    if (args?.subscribeFn) {
                        result = args.subscribeFn(result);
                    }
                    resolve(result);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
    async patch(urlPath, data, args) {
        const options = this.getHttpRequestOptions(args);
        if (!options || !options.headers) {
            throw new Error('Invalid options: ' + options);
        }
        options.headers['Content-Type'] = 'application/json';
        return new Promise((resolve, reject) => {
            if (data && typeof data !== 'string') {
                if (this.propertyNameCase === 'snake') {
                    data = MintCamelizer.decamelizeKeys(data);
                }
            }
            this.http
                .patch(this.url(urlPath), data, options)
                .pipe(map((resp) => {
                return MintCamelizer.camelizeKeys(resp.body);
            }))
                .subscribe({
                next: (result) => {
                    if (args?.subscribeFn) {
                        result = args.subscribeFn(result);
                    }
                    resolve(result);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
    async delete(urlPath, data, args) {
        const options = this.getHttpRequestOptions(args);
        if (data) {
            if (typeof data !== 'string') {
                if (this.propertyNameCase === 'snake') {
                    data = MintCamelizer.decamelizeKeys(data);
                }
            }
            options['body'] = data;
        }
        return new Promise((resolve, reject) => {
            // https://github.com/angular/angular/issues/19438
            this.http
                .request('delete', this.url(urlPath), options)
                .pipe(map((resp) => {
                return MintCamelizer.camelizeKeys(resp.body);
            }))
                .subscribe({
                next: (result) => {
                    if (args?.subscribeFn) {
                        result = args.subscribeFn(result);
                    }
                    resolve(result);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
    uploadFile(urlPath, file, options = {}, formData = new FormData()) {
        const fData = new FormData();
        formData.forEach((value, key) => {
            fData.set(key, value);
        });
        fData.set('file', file);
        fData.set('name', file.name);
        const httpReq = this.createRequest('POST', urlPath, fData, {
            reportProgress: true,
        });
        return this.request(httpReq, options);
    }
    getArrayBuffer(urlPath) {
        const httpReq = this.createRequest('GET', urlPath, undefined, {
            reportProgress: true,
            responseType: 'arraybuffer',
        });
        return new Promise((resolve, reject) => {
            const result = this.request(httpReq, {
                onError: (err) => {
                    reject(err);
                },
                onSuccess: (resp) => {
                    resolve(resp.body);
                },
            });
        });
    }
    getBlob(urlPath) {
        const httpReq = this.createRequest('GET', urlPath, undefined, {
            reportProgress: true,
            responseType: 'blob',
        });
        // logger.debug('getBlob: httpReq: ', httpReq);
        return new Promise((resolve, reject) => {
            const result = this.request(httpReq, {
                onError: (err) => {
                    reject(err);
                },
                onSuccess: (blob) => {
                    // logger.debug('getBlob: typeof blob: ', typeof blob);
                    resolve(blob);
                },
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHttpService, deps: [{ token: i1$1.HttpClient }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHttpService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHttpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: MintConfigService }] });

const logger$2k = MintLogger.getLogger('MintSessionService');
const MINT_AUTH_SESSION_KEY = 'mint-auth-session';
class MintSessionService {
    #session;
    constructor(configService, storageService, httpService) {
        this.configService = configService;
        this.storageService = storageService;
        this.httpService = httpService;
        this.#session = undefined;
        this.tokenExpired$ = new BehaviorSubject(false);
        const sessionScope = this.configService.getConfig().auth?.session?.scope ??
            MintSessionScope.Local;
        this.setStorageType(this.toStorageType(sessionScope)).then(() => {
            logger$2k.debug(`MintSessionService: initialized:`, `\nsessionScope: ${sessionScope}`, `\nstorageType: ${this.storageType}`);
        });
    }
    isTokenExpired(token) {
        if (!token || Date.now() - token.expiresAt.getTime() >= 0) {
            logger$2k.debug('Session: expired');
            return true;
        }
        return false;
    }
    async isSessionExpired() {
        const session = await this.getSession();
        return this.isTokenExpired(session?.token);
    }
    scheduleTokenExpirationEvent() {
        if (!this.#session?.token) {
            return;
        }
        // unsub from any old timers
        if (this.tokenExpirationTimerSub) {
            this.tokenExpirationTimerSub.unsubscribe();
        }
        let expiresInTimer = this.#session.token.expiresAt.getTime() - Date.now();
        expiresInTimer = expiresInTimer < 0 ? 0 : expiresInTimer;
        logger$2k.debug(`scheduleTokenExpirationEvent()- expires in (ms):`, expiresInTimer);
        this.tokenExpirationTimerSub = timer(expiresInTimer).subscribe(async () => {
            // if the token has not expired, schedule another expiration event
            if (!this.isTokenExpired(this.#session?.token)) {
                this.scheduleTokenExpirationEvent();
                return;
            }
            else {
                try {
                    // If refresh token is successful, it will schedule
                    // a token expiration event when the new session is created
                    if (this.#session?.token.refreshToken &&
                        !!(await this._refreshToken())) {
                        return;
                    }
                }
                catch (err) {
                    logger$2k.error(err);
                }
            }
            // if we get here the token has expired or could not be refreshed
            this.tokenExpired$.next(true);
        });
    }
    async setStorageType(storageType) {
        this.storageType = storageType;
        // Only set withCredentials flag if using cookie based authentication
        if (this.storageType === MintStorageType.Memory) {
            this.httpService.withCredentials = true;
        }
        else {
            this.httpService.withCredentials = false;
        }
    }
    toStorageType(scope) {
        if (!scope) {
            return undefined;
        }
        switch (scope) {
            case MintSessionScope.Global:
                return MintStorageType.Local;
            // data in sessionStorage is cleared when the page session ends.
            case MintSessionScope.Local:
                return MintStorageType.Session;
            case MintSessionScope.Memory:
                return MintStorageType.Memory;
        }
    }
    async save(_session) {
        this.#session = new MintSession(_session);
        await lastValueFrom(this.storageService.setItem(MINT_AUTH_SESSION_KEY, this.#session, this.storageType));
        return this.#session;
    }
    async clear() {
        this.#session = null;
        this.setHttpAuthToken(null);
        await lastValueFrom(this.storageService.removeItem(MINT_AUTH_SESSION_KEY, this.storageType));
    }
    async getUser() {
        const session = await this.getSession();
        return session?.user ?? null;
    }
    async getToken() {
        const session = await this.getSession();
        return session?.token ?? null;
    }
    async create(data) {
        // first clear any existing data
        await this.clear();
        this.#session = plainToInstance(MintSession, data);
        await this.save(this.#session);
        // Don't send authorization header if using cookie authentication
        if (this.storageType !== MintStorageType.Memory) {
            this.setHttpAuthToken(data.token);
        }
        this.scheduleTokenExpirationEvent();
        return this.#session;
    }
    // called when refresh token used to update access token
    async updateToken(token) {
        if (!this.#session) {
            throw new MintError('Session not found');
        }
        return await this.create({
            ...this.#session,
            token: token,
        });
    }
    // called when user updates own account
    async updateUser(user) {
        if (!this.#session) {
            throw new MintError('Session not found');
        }
        return await this.create({
            ...this.#session,
            user: user,
        });
    }
    setHttpAuthToken(token) {
        if (token && token.accessToken) {
            this.httpService.token = `${token.tokenType} ${token.accessToken}`;
        }
        else {
            this.httpService.token = null;
        }
    }
    async getSession() {
        if (!this.#session) {
            const session = await lastValueFrom(this.storageService.getItem(MINT_AUTH_SESSION_KEY, this.storageType));
            if (session) {
                this.#session = new MintSession(session);
            }
        }
        if (this.#session?.token?.expiresIn) {
            const expiresAt = dayjs()
                .add(this.#session.token.expiresIn, 'seconds')
                .toDate();
            // if session is expired, and we don't have a refreshToken then invalidate session
            if (Date.now() - expiresAt.getTime() >= 0) {
                if (!this.#session.token.refreshToken) {
                    await this.clear();
                    return this.#session;
                }
            }
        }
        // Don't send authorization header if using cookie authentication
        if (this.storageType !== MintStorageType.Memory) {
            this.setHttpAuthToken(this.#session?.token ?? null);
        }
        return this.#session;
    }
    // FIXME: figure out a way to avoid circular dependency from auth service
    //  so this call does not have to be duplicated locally
    async _refreshToken() {
        let session = await this.getSession();
        // check if the refreshToken exists
        if (!session?.token.refreshToken) {
            throw new MintAuthException('Refresh token not found');
        }
        // check if the refreshToken has expired
        const expiresAt = session.token.refreshExpiresAt;
        if (expiresAt && Date.now() - expiresAt.getTime() >= 0) {
            throw new MintAuthException(`Refresh token expired at: ${expiresAt}`);
        }
        // fetch a new token
        const nonce = MintCryptoUtil.randomString(16);
        const dto = new MintAuthTokenRefreshDto({
            refreshToken: session.token.refreshToken,
            nonce: nonce,
        });
        try {
            const result = (await this.httpService.post('/auth/token/refresh', dto));
            session = new MintSession(result);
        }
        catch (err) {
            logger$2k.error(err);
            throw err;
        }
        const decodedToken = jwtDecode(session.token.accessToken);
        if (decodedToken.nonce !== nonce) {
            throw new MintAuthException('Invalid refresh token', MintAuthErrorType.InvalidToken, session);
        }
        return await this.create(session);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSessionService, deps: [{ token: MintConfigService }, { token: MintStorageService }, { token: MintHttpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSessionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSessionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintStorageService }, { type: MintHttpService }] });

const logger$2j = MintLogger.getLogger('MintAuthService');
const MINT_AUTH_USERNAME_KEY = 'mint-auth-username';
const MINT_AUTH_NONCE_KEY = 'mint-nonce';
class MintAuthService {
    constructor(configService, httpService, storageService, socialAuthService, sessionService) {
        this.configService = configService;
        this.httpService = httpService;
        this.storageService = storageService;
        this.socialAuthService = socialAuthService;
        this.sessionService = sessionService;
        this.me$ = new BehaviorSubject(null);
        this.authenticated$ = new BehaviorSubject(false);
        this.session$ = new BehaviorSubject(null);
        logger$2j.debug('Initializing ...');
        this.baseUrl = this.configService.getConfig().api?.service?.auth ?? 'auth';
        this.authenticated$.subscribe((_auth) => {
            logger$2j.debug('authenticated: ' + _auth);
        });
        this.me$.subscribe((_user) => {
            logger$2j.debug('user: ' + _user);
        });
    }
    urlPath(path) {
        let url = this.baseUrl;
        if (!url.endsWith('/')) {
            url += '/';
        }
        return url + path;
    }
    async authenticated() {
        if (typeof this._authenticated === 'undefined') {
            const session = await this.getSession();
            if (session?.user) {
                this._authenticated = true;
                this.session$.next(session);
                this.me$.next(session.user);
            }
            else {
                this._authenticated = false;
            }
        }
        this.authenticated$.next(this._authenticated);
        return this._authenticated;
    }
    async getUsername() {
        return await lastValueFrom(this.storageService.getItem(MINT_AUTH_USERNAME_KEY, MintStorageType.Local));
    }
    async saveUsername(username) {
        return await lastValueFrom(this.storageService.setItem(MINT_AUTH_USERNAME_KEY, username, MintStorageType.Local));
    }
    async clearUsername() {
        return await lastValueFrom(this.storageService.removeItem(MINT_AUTH_USERNAME_KEY, MintStorageType.Local));
    }
    async me(fields) {
        const session = await this.getSession(fields);
        let user;
        if (session) {
            user = session.user;
        }
        return user;
    }
    // Check if we have a valid refresh token and use it to get a new access token
    async refreshToken() {
        logger$2j.debug('refreshToken called ...');
        let session = await this.sessionService.getSession();
        // check if the refreshToken exists
        if (!session?.token.refreshToken) {
            throw new MintAuthException('Refresh token not found');
        }
        // check if the refreshToken has expired
        const expiresAt = session.token.refreshExpiresAt;
        if (expiresAt && Date.now() - expiresAt.getTime() >= 0) {
            throw new MintAuthException(`Refresh token expired at: ${expiresAt}`);
        }
        // fetch a new token
        const nonce = MintCryptoUtil.randomString(16);
        const dto = new MintAuthTokenRefreshDto({
            refreshToken: session.token.refreshToken,
            nonce: nonce,
        });
        try {
            const result = (await this.httpService.post(this.urlPath('token/refresh'), dto));
            session = new MintSession(result);
        }
        catch (err) {
            logger$2j.error(err);
            throw err;
        }
        const decodedToken = jwtDecode(session.token.accessToken);
        if (decodedToken.nonce !== nonce) {
            throw new MintAuthException('Invalid refresh token', MintAuthErrorType.InvalidToken, session);
        }
        return await this.sessionService.create(session);
    }
    // FIXME: potential issue of providers not being initialized
    // when this is called: https://github.com/abacritt/angularx-social-login/issues/280
    async checkSsoInitialized() {
        let initialized;
        const sleepTime = 100;
        const maxWaitTime = sleepTime * 10 * 10; // 10 seconds
        let currentWaitTime = 0;
        do {
            initialized = await lastValueFrom(this.socialAuthService.initState);
            if (!initialized) {
                if (currentWaitTime >= maxWaitTime) {
                    throw new MintError('ssoLogin: Error initializing providers.');
                }
                currentWaitTime += sleepTime;
                await MintSystemUtil.sleep(sleepTime);
            }
        } while (!initialized);
    }
    async ssoLogin(ssoRequest) {
        logger$2j.debug('ssoLogin called: loginRequest: ', ssoRequest);
        await this.checkSsoInitialized();
        try {
            let socialUser;
            switch (ssoRequest.provider) {
                case MintAuthSsoProvider.Google:
                    socialUser = await this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
                    break;
                case MintAuthSsoProvider.Facebook:
                    socialUser = await this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
                    break;
                case MintAuthSsoProvider.Azure:
                    socialUser = await this.socialAuthService.signIn(MintAzureLoginProvider.PROVIDER_ID);
                    break;
                default:
                    throw new MintError({
                        message: `Login provider not supported: ` + ssoRequest.provider,
                    });
            }
            this._ssoRequest = new MintAuthSsoDto({
                ...ssoRequest,
                providerIdToken: socialUser.idToken,
                providerAuthToken: socialUser.authToken,
                providerResponse: socialUser.response,
                providerAuthorizationCode: socialUser.authorizationCode,
                ssoUser: new MintSsoUserModel({
                    provider: ssoRequest.provider,
                    providerUserId: socialUser.id,
                    email: socialUser.email,
                    firstName: socialUser.firstName,
                    lastName: socialUser.lastName,
                    displayName: socialUser.name,
                    photoUrl: socialUser.photoUrl,
                }),
            });
            logger$2j.debug('ssoLogin: socialUser: ', socialUser, '\nssoRequest: ', ssoRequest);
            const data = (await this.httpService.post(this.urlPath('sso-login'), this._ssoRequest, {
            // withCredentials: false
            }));
            logger$2j.debug('ssoLogin: result: ', data);
            return await this.newSession({ ...data });
        }
        catch (err) {
            if (err && err.status) {
                if (err.status === 401 || err.status === 403) {
                    throw new MintAuthException(err.error?.message ?? 'Invalid credentials', MintAuthErrorType.NotAuthorized, err);
                }
            }
            logger$2j.error('ssoLogin: error: ', err);
            throw new MintAuthException('System Error', MintAuthErrorType.InternalError, err);
        }
    }
    async updateSessionUser(user) {
        logger$2j.debug('updateSessionUser: updating user: ', user);
        const session = await this.sessionService.updateUser(user);
        this.session$.next(session);
        this.me$.next(session.user);
        return session;
    }
    async generateNonce(clientId) {
        const nonce = MintCryptoUtil.randomString(16);
        clientId = clientId ?? this.configService.getConfig().api.clientId;
        const key = clientId
            ? `${MINT_AUTH_NONCE_KEY}-${clientId}`
            : MINT_AUTH_NONCE_KEY;
        await lastValueFrom(this.storageService.setItem(key, nonce, MintStorageType.Local));
        return nonce;
    }
    async getNonce(clientId) {
        clientId = clientId ?? this.configService.getConfig().api.clientId;
        const key = clientId
            ? `${MINT_AUTH_NONCE_KEY}-${clientId}`
            : MINT_AUTH_NONCE_KEY;
        return await lastValueFrom(await this.storageService.getItem(key, MintStorageType.Local));
    }
    async removeNonce(clientId) {
        clientId = clientId ?? this.configService.getConfig().api.clientId;
        const key = clientId
            ? `${MINT_AUTH_NONCE_KEY}-${clientId}`
            : MINT_AUTH_NONCE_KEY;
        return await lastValueFrom(await this.storageService.removeItem(key, MintStorageType.Local));
    }
    async login(loginRequest, rememberMe) {
        logger$2j.debug('login called: loginRequest: ', loginRequest);
        this._ssoRequest = undefined;
        if (rememberMe === true) {
            await this.saveUsername(loginRequest.username);
        }
        else {
            await this.clearUsername();
        }
        try {
            const nonce = await this.generateNonce();
            loginRequest = new MintAuthLoginCredentialsDto({
                ...loginRequest,
                nonce: nonce,
            });
            const data = (await this.httpService.post(this.urlPath('login'), loginRequest, {
            // withCredentials: false
            }));
            logger$2j.debug('login called: result: ', data);
            const decodedToken = jwtDecode(data.token.accessToken);
            logger$2j.debug('decodedToken: ', decodedToken);
            if (decodedToken?.nonce !== nonce) {
                throw new MintAuthException('Invalid token', MintAuthErrorType.InvalidToken);
            }
            return await this.newSession(data);
        }
        catch (err) {
            logger$2j.debug('login: exception: ', err);
            if (err?.status === 401 || err?.status === 403) {
                throw new MintAuthException(err.error?.message ?? 'Invalid credentials', MintAuthErrorType.NotAuthorized, err);
            }
            if (err?.type === MintAuthErrorType.InvalidToken) {
                throw err;
            }
            throw new MintAuthException('System Error', MintAuthErrorType.InternalError, err);
        }
    }
    async newSession(data) {
        if (!data.user) {
            throw new Error('Cannot create new session. Invalid data: ' + JSON.stringify(data));
        }
        const session = await this.sessionService.create(data);
        this._authenticated = true;
        logger$2j.debug('newSession: session: ', session);
        this.authenticated$.next(true);
        this.session$.next(session);
        this.me$.next(session.user);
        return session;
    }
    // fetch user. used for password resets
    async getUserByAuthCode(code) {
        code = encodeURIComponent(code);
        const apiPath = this.urlPath(`codes/${code}`);
        logger$2j.debug('getUserByAuthCode: apiPath: ', apiPath);
        const user = (await this.httpService.get(apiPath).catch((err) => {
            logger$2j.debug('getUserByAuthCode: error: ', err);
            if (!err || !err.status) {
                throw new MintAuthException('System Error', MintAuthErrorType.InternalError, err);
            }
            if (err.status >= 500) {
                throw new MintAuthException('Error confirming code', MintAuthErrorType.InternalError, err);
            }
            else {
                throw new MintAuthException('Invalid code', MintAuthErrorType.InvalidAuthCode, err);
            }
        }));
        return new MintUserModel(user);
    }
    // confirm code
    async confirmAuthCode(code) {
        code = encodeURIComponent(code);
        const apiPath = this.urlPath(`confirmations/${code}`);
        logger$2j.debug('confirmAuthCode: apiPath: ', apiPath);
        return this.httpService.get(apiPath).catch((err) => {
            logger$2j.debug('confirmAuthCode: error: ', err);
            if (!err || !err.status || err.status >= 500) {
                throw new MintAuthException('Error confirming code', MintAuthErrorType.InternalError, err);
            }
            throw new MintAuthException('Invalid code', MintAuthErrorType.InvalidAuthCode, err);
        });
    }
    async logout(clearStorage = false, skipSsoLogout = false) {
        logger$2j.debug('logout called ...');
        const user = await this.me;
        const savedUsername = await this.getUsername();
        const done = async () => {
            this._authenticated = false;
            await this.sessionService.clear();
            await this.removeNonce();
            if (clearStorage) {
                await lastValueFrom(this.storageService.clear(this.sessionService.storageType));
                // preserve `rememberMe` value if set
                if (savedUsername) {
                    await this.saveUsername(savedUsername);
                }
            }
            logger$2j.debug('--- USER LOGGED OUT ---');
            this.authenticated$.next(false);
        };
        try {
            if (!(await this.sessionService.isSessionExpired())) {
                await this.httpService.post(this.urlPath('logout'), {});
                if (this._ssoRequest && !skipSsoLogout) {
                    await this.socialAuthService.signOut();
                }
            }
        }
        catch (err) {
            logger$2j.error(err);
        }
        finally {
            await done();
        }
        return user;
    }
    async resetPasswordRequest(username) {
        // username can be username, uid, mobileNumber, or email
        const data = {
            username: username,
        };
        const apiPath = this.urlPath(`password/reset`);
        logger$2j.debug(`requestPasswordReset: apiPath: ${apiPath}`);
        try {
            await this.httpService.post(apiPath, data, {
                // withCredentials: false,
                subscribeFn: (result) => {
                    logger$2j.debug('requestPasswordResetEmail: result: ', result);
                },
            });
        }
        catch (err) {
            logger$2j.debug('requestPasswordReset: error: ', err);
            if (err && err.status && (err.status === 401 || err.status === 403)) {
                throw new MintAuthException('Invalid username', MintAuthErrorType.InvalidUsername, err);
            }
            else {
                throw new MintAuthException('System Error', MintAuthErrorType.InternalError, err);
            }
        }
    }
    async verifyAuthCode(authCodeVerificationReq) {
        const apiPath = this.urlPath(`codes`);
        logger$2j.debug(`verifyAuthCode: apiPath: ${apiPath}`);
        const data = (await this.httpService.patch(apiPath, authCodeVerificationReq));
        logger$2j.debug('verifyAuthCode called: result: ', data);
        if (!data.user) {
            throw new MintAuthException('Invalid session response.');
        }
        let session;
        if (authCodeVerificationReq.login ||
            authCodeVerificationReq.type === MintAuthType.PasswordReset) {
            if (!data.token) {
                throw new MintAuthException('Invalid session response.');
            }
            session = await this.newSession(data);
        }
        else {
            session = await this.updateSessionUser(data.user);
        }
        return session;
    }
    // This is an authenticated endpoint
    async resetPasswordChange(passwordReset) {
        const apiPath = this.urlPath(`password`);
        logger$2j.debug(`resetPassword: apiPath: ${apiPath}`);
        try {
            await this.httpService.post(apiPath, passwordReset);
        }
        catch (err) {
            logger$2j.debug('resetPassword: error: ', err);
            if (err && err.status && (err.status === 401 || err.status === 403)) {
                throw new MintAuthException('Invalid password', MintAuthErrorType.InvalidPassword, err);
            }
            else {
                throw new MintAuthException('System Error', MintAuthErrorType.InternalError, err);
            }
        }
    }
    // TODO: Should only be accessible by admin
    async changeUserPassword(user, password) {
        const data = {
            password: password,
        };
        const apiPath = `users/${user.uid}/password`;
        logger$2j.debug(`changeUserPassword: apiPath: ${apiPath}`);
        return this.httpService.patch(apiPath, data).catch((err) => {
            logger$2j.debug('changeUserPassword: error: ', err);
            if (!err || !err.status || err.status !== 401) {
                throw new MintAuthException('Error changing password', MintAuthErrorType.InternalError, err);
            }
            throw new MintAuthException('Current password is invalid', MintAuthErrorType.InvalidPassword, err);
        });
    }
    async updatePassword(data) {
        // Authenticated endpoint
        const apiPath = this.urlPath(`password`);
        logger$2j.debug(`updatePassword: apiPath: ${apiPath}`);
        try {
            const result = (await this.httpService.patch(apiPath, data));
            logger$2j.debug('updatePassword: result: ', result);
            return result;
        }
        catch (err) {
            logger$2j.debug('updatePassword: error: ', err);
            if (err.status === 401) {
                throw new MintAuthException('Current password is invalid', MintAuthErrorType.InvalidPassword, err);
            }
            if (err.type === MintAuthErrorType.RecentPasswordMatch) {
                throw new MintAuthException('Error updating password. Password must be different from recently used passwords.', MintAuthErrorType.RecentPasswordMatch, err);
            }
            throw new MintAuthException('Error updating password', MintAuthErrorType.InternalError, err);
        }
    }
    async setUserMobileNumber(request) {
        try {
            const apiPath = this.urlPath(`user/mobile-number`);
            const data = (await this.httpService.post(apiPath, request));
            return await this.newSession(data);
        }
        catch (err) {
            logger$2j.error(err);
            throw err;
        }
    }
    async setUserEmail(request) {
        try {
            const apiPath = this.urlPath(`user/email`);
            const data = (await this.httpService.post(apiPath, request));
            return await this.newSession(data);
        }
        catch (err) {
            logger$2j.error(err);
            throw err;
        }
    }
    async requestMobileAuthCode() {
        try {
            const apiPath = this.urlPath(`codes/mobile`);
            logger$2j.debug('requestMobileAuthCode: apiPath: ', apiPath);
            await this.httpService.post(apiPath, {});
        }
        catch (err) {
            logger$2j.error(err);
            throw err;
        }
    }
    async requestEmailAuthCode() {
        try {
            const apiPath = this.urlPath(`codes/email`);
            logger$2j.debug('requestEmailAuthCode: apiPath: ', apiPath);
            await this.httpService.post(apiPath, {});
        }
        catch (err) {
            logger$2j.error(err);
            throw err;
        }
    }
    async requestMfaCode(channel = MintAuthChannel.Sms) {
        try {
            const apiPath = this.urlPath(`codes/mfa`);
            const params = {
                channel: channel,
            };
            logger$2j.debug('requestMfaCode: apiPath: ', apiPath, '  channel: ', channel);
            await this.httpService.post(apiPath, {}, { queryParams: params });
        }
        catch (err) {
            logger$2j.error(err);
            throw err;
        }
    }
    async register(registrationRequest) {
        const apiPath = this.urlPath(`register`);
        logger$2j.debug('register: apiPath: ', apiPath);
        try {
            const data = await this.httpService.post(apiPath, registrationRequest, {
            // withCredentials: false,
            });
            logger$2j.debug('MintAuthService.register:', data);
            return await this.newSession(data);
        }
        catch (err) {
            logger$2j.debug('register: exception: ', err);
            if (err && err.status) {
                if (err.status === 401 || err.status === 403) {
                    throw new MintAuthException(err.error?.message ?? 'Invalid credentials', MintAuthErrorType.NotAuthorized, err);
                }
            }
            throw new MintAuthException('System Error', MintAuthErrorType.InternalError, err);
        }
    }
    async newSessionByTokenUid(tokenUid, requestingUserUid) {
        tokenUid = encodeURIComponent(tokenUid);
        const apiPath = this.urlPath(`sessions/tokens/${tokenUid}`);
        const data = (await this.httpService.get(apiPath, {
            queryParams: {
                _u: requestingUserUid,
            },
        }));
        return await this.newSession(data);
    }
    // Called by `loginAsUser` to create a user session which can be
    // used to log in as that user in another window or tab.
    async createUserSession(user, clientId, bypassMfa = false) {
        if (!user) {
            throw new MintError('User is not set');
        }
        const data = {
            userUid: typeof user === 'string' ? user : user.uid,
            clientId: clientId,
            bypassMfa: bypassMfa,
        };
        const apiPath = this.urlPath(`sessions`);
        const session = (await this.httpService.post(apiPath, data));
        return new MintSession(session);
    }
    async loginAsUser(user, appUrl, clientId) {
        const me = await this.me();
        if (!clientId) {
            throw new MintAuthException('loginAsUser: clientId must be defined');
        }
        const userSession = await this.createUserSession(user, clientId, true);
        if (!userSession?.token?.tokenUid) {
            const uid = typeof user === 'string' ? user : user.uid;
            throw new MintError('Invalid session token for user: ' + uid);
        }
        const url = appendUrlParam(appUrl, {
            _t: userSession.token.tokenUid,
            _u: me.uid,
        });
        // NOTE: the 'noopener' option is required to prevent  the new window
        // from accessing the session storage of the opener window.
        // https://www.chromestatus.com/feature/5679997870145536
        // https://mathiasbynens.github.io/rel-noopener/
        window.open(url, '_blank', 'noopener');
        return url;
    }
    async getCurrentSession(fields) {
        try {
            const queryParams = fields?.length ? { fields } : {};
            const apiPath = this.urlPath(`sessions/me`);
            const session = (await this.httpService.get(apiPath, {
                queryParams,
            }));
            return await this.newSession({ ...session });
        }
        catch (err) {
            // if we're not authorized then we don't have a session. return null
            if (err?.status === 401 || err?.status === 403) {
                return null;
            }
            logger$2j.debug('getCurrentSession: error: ', err);
            throw err;
        }
    }
    async getSession(fields) {
        let session = await this.sessionService.getSession();
        if (!session) {
            session = await this.getCurrentSession(fields);
        }
        return session;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintStorageService }, { token: i4.SocialAuthService }, { token: MintSessionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintStorageService }, { type: i4.SocialAuthService }, { type: MintSessionService }] });

const logger$2i = MintLogger.getLogger('MintAuthInterceptor');
class MintAuthInterceptor {
    constructor(authService, sessionService, configService, router) {
        this.authService = authService;
        this.sessionService = sessionService;
        this.configService = configService;
        this.router = router;
        const config = this.configService.getConfig();
        this.baseUrl = config.api.baseUrl;
        const authPath = config.api.service.auth ?? 'auth';
        this.authUrl = this.baseUrl + authPath;
        if (!this.authUrl.endsWith('/')) {
            this.authUrl += '/';
        }
        this.loginRoute = config.components.auth?.login?.route ?? 'auth/login';
    }
    // Explicitly set cache controls to avoid caching issues in IE
    // https://stackoverflow.com/questions/37755782/prevent-ie11-caching-get-call-in-angular-2
    clone(req, token) {
        let headers = req.headers ?? new HttpHeaders();
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Modified-Since
        headers = headers
            .set('Cache-Control', 'no-cache')
            .set('Pragma', 'no-cache')
            .set('If-Modified-Since', 'Sat, 01 Jan 2000 00:00:00 GMT')
            .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
        if (token && this.sessionService.storageType !== MintStorageType.Memory) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }
        return req.clone({
            headers: headers,
            withCredentials: this.sessionService.storageType === MintStorageType.Memory,
        });
    }
    protectedUrl(url) {
        if (!this.baseUrl || !url.startsWith(this.baseUrl)) {
            return false;
        }
        if (url.startsWith(this.authUrl)) {
            return false;
        }
        return true;
    }
    // General flow: a request comes in with a token that has expired (possibly in flight)
    // First the refreshSession is called to get the latest/freshest token.
    // if the original request fails, the new token is used to retry the request.
    // Before each call we check the session to make sure the
    // access token has not been refreshed.
    handleAuthError(req, next) {
        return from(this.authService.refreshToken()).pipe(
        // should contain fresh token
        mergeMap((session) => {
            if (session?.token?.accessToken) {
                const authReq = this.clone(req, session.token.accessToken);
                return next.handle(authReq);
            }
            return throwError(() => new MintError('Error refreshing token: session: ', {
                data: session,
            }));
        }), catchError((err) => {
            logger$2i.error('intercept: error: ', err);
            const routerState = this.router.routerState.snapshot;
            const loginRoute = MintUrlUtil.evalPathParams(this.loginRoute, routerState.url);
            if (err.status === 401) {
                this.router.navigate([loginRoute]).then();
                return of$1(err);
            }
            else {
                return throwError(() => err);
            }
        }));
    }
    intercept(req, next) {
        // logger.debug('intercept:  reqUrl: ', req.url);
        // pass through if url is not protected
        if (!this.protectedUrl(req.url)) {
            return next.handle(req);
        }
        return next.handle(req).pipe(catchError((err) => {
            if (err instanceof HttpErrorResponse && err.status === 401) {
                return this.handleAuthError(req, next);
            }
            return throwError(() => err);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthInterceptor, deps: [{ token: MintAuthService }, { token: MintSessionService }, { token: MintConfigService }, { token: i4$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthInterceptor, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthInterceptor, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintAuthService }, { type: MintSessionService }, { type: MintConfigService }, { type: i4$1.Router }] });

// https://stackoverflow.com/questions/45428842/angular-url-plus-sign-converting-to-space
class MintHttpParamsInterceptor {
    intercept(req, next) {
        const params = new HttpParams({
            encoder: new MintHttpCustomEncoder(),
            fromString: req.params.toString(),
        });
        return next.handle(req.clone({ params }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHttpParamsInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHttpParamsInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHttpParamsInterceptor, decorators: [{
            type: Injectable
        }] });
class MintHttpCustomEncoder {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}

class MintMathUtil {
    // assumes currentCount changes by 1 for each calculation
    // tslint:disable-next-line
    // http://stackoverflow.com/questions/12636613/how-to-calculate-moving-average-without-keeping-the-count-and-data-total
    static getRunningAverage(lastAverage, currentCount, currentValue) {
        if (!currentCount) {
            return lastAverage;
        }
        return lastAverage + (currentValue - lastAverage) / currentCount;
    }
    // NOTE: Math.random is inside [0,1)
    static randomInt(min = 1, max = 100) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    static round(val, precision = 1) {
        return +(Math.round(parseFloat(val + 'e+' + precision)) + 'e-' + precision);
    }
    static toPct100(val) {
        if (hasValue(val)) {
            val = val * 100;
        }
        return val;
    }
    static fromPct100(val) {
        if (hasValue(val)) {
            val = val / 100;
        }
        return val;
    }
    /**
     * Return a value that randomly fluctuates by `percentFluctuation` amount.
     *
     * @param value Base value
     * @param percentFluctuation Percent to fluctuate [0, 1]
     */
    static getFluctuatedValue(value, percentFluctuation) {
        let pct = this.randomInt(1, percentFluctuation * 100);
        pct = pct * (pct % 2 === 0 ? -1 : 1);
        pct = pct / 100;
        return value + value * pct;
    }
}

class MintCacheException extends Error {
    constructor(error) {
        super(error);
    }
}

class MintCacheStatsData {
    constructor() {
        this.hits = 0;
        this.misses = 0;
        this.keys = 0;
        this.keySize = 0;
        this.valueSize = 0;
    }
}
class MintCacheStats {
    constructor() {
        this.map = new Map();
        this.hits = 0;
        this.misses = 0;
        this.keys = 0;
        this.keySize = 0;
        this.valueSize = 0;
    }
    inc(namespace, value) {
        const stats = this.getStats(namespace);
        if (typeof value.hits !== 'undefined' && value.hits !== null) {
            stats.hits += value.hits;
            this.hits += value.hits;
        }
        if (typeof value.misses !== 'undefined' && value.hits !== null) {
            stats.misses += value.misses;
            this.misses += value.misses;
        }
        if (typeof value.keys !== 'undefined' && value.hits !== null) {
            stats.keys += value.keys;
            this.keys += value.keys;
        }
        if (typeof value.keySize !== 'undefined' && value.hits !== null) {
            stats.keySize += value.keySize;
            this.keySize += value.keySize;
        }
        if (typeof value.valueSize !== 'undefined' && value.hits !== null) {
            stats.valueSize += value.valueSize;
            this.valueSize += value.valueSize;
        }
    }
    // incHits(namespace: string, count = 1) {
    //     const stats = this.getStats(namespace);
    //     stats.hits += count;
    //     this.hits += count;
    // }
    // incMisses(namespace: string, count = 1) {
    //     const stats = this.getStats(namespace);
    //     stats.misses += count;
    //     this.misses += count;
    // }
    // incKeys(namespace: string, count = 1) {
    //     const stats = this.getStats(namespace);
    //     stats.keys += count;
    //     this.keys += count;
    // }
    // incKeySize(namespace: string, count = 1) {
    //     const stats = this.getStats(namespace);
    //     stats.keySize += count;
    //     this.keySize += count;
    // }
    // incValueSize(namespace: string, count = 1) {
    //     const stats = this.getStats(namespace);
    //     stats.keySize += count;
    //     this.keySize += count;
    // }
    reset(namespace) {
        const stats = this.map.get(namespace);
        if (stats) {
            this.decreaseTotal(stats);
            this.resetStats(stats);
        }
    }
    resetStats(stats) {
        stats.hits = 0;
        stats.misses = 0;
        stats.keys = 0;
        stats.keySize = 0;
        stats.valueSize = 0;
    }
    decreaseTotal(stats) {
        this.hits -= stats.hits;
        this.misses -= stats.misses;
        this.keys -= stats.keys;
        this.keySize -= stats.keySize;
        this.valueSize -= stats.valueSize;
    }
    getStats(namespace) {
        let stats = this.map.get(namespace);
        if (!stats) {
            stats = new MintCacheStatsData();
            this.map.set(namespace, stats);
        }
        return stats;
    }
}

const logger$2h = MintLogger.getLogger('MintCacheStorage');
const DEFAULT_TTL = 60;
const CHECK_INTERVAL = 1000 * 60;
/**
 * Abstract cache storage
 */
class MintCacheStorage {
    constructor(type) {
        this.type = type;
        this.stats = new MintCacheStats();
        setTimeout(() => this.checkData(), 1000);
    }
    async checkData() {
        await this.removeExpired();
        this.checkTimer = setTimeout(() => {
            this.checkData();
        }, CHECK_INTERVAL);
        if (this.checkTimer.unref) {
            this.checkTimer.unref();
        }
    }
    /**
     * Get item from storage
     */
    async getItem(namespace, key) {
        const hasKey = await this.hasKey(namespace, key);
        if (!hasKey) {
            this.stats.inc(namespace, {
                misses: 1,
            });
            return undefined;
        }
        const storageValue = await this._getItem(namespace, key);
        let value = null;
        if (storageValue) {
            if (this.validateStorageValue(storageValue)) {
                value = storageValue.value;
                this.stats.inc(namespace, {
                    hits: 1,
                });
            }
            else {
                this.stats.inc(namespace, {
                    misses: 1,
                });
                await this.removeItem(namespace, key);
            }
        }
        else {
            this.stats.inc(namespace, {
                misses: 1,
            });
        }
        return value;
    }
    /**
     * Set item to storage
     */
    async setItem(namespace, key, value, options) {
        const valid = await this.validateNamespace(namespace);
        // TODO: purge based on policy for namespace
        if (!valid) {
            logger$2h.error('setItem:  cache namespace not valid');
            return;
        }
        value = this.toStorageValue(value, options);
        await this._setItem(namespace, key, value);
        await this.addKey(namespace, key);
        this.stats.inc(namespace, {
            keys: 1,
            keySize: key.length,
            //            valueSize: (this.sizeOfObject(value)),
        });
    }
    /**
     * Remove item from storage
     */
    async removeItem(namespace, key) {
        const hasKey = await this.hasKey(namespace, key);
        if (!hasKey) {
            this.stats.inc(namespace, {
                misses: 1,
            });
            return undefined;
        }
        const value = await this._removeItem(namespace, key);
        await this.removeKey(namespace, key);
        this.stats.inc(namespace, {
            keys: -1,
            keySize: -key.length,
            //            valueSize: -(this.sizeOfObject(value)),
        });
        return value;
    }
    async removeAll(namespace) {
        const keys = await this.getKeys(namespace);
        for (const key of keys) {
            await this.removeItem(namespace, key);
        }
    }
    /**
     * Clear item in storage
     */
    async clear(namespace) {
        if (namespace) {
            this._clear(namespace);
            this.stats.reset(namespace);
            return;
        }
        const namespaces = await this.getNamespaces();
        for (const ns of namespaces) {
            this._clear(ns.name);
            this.stats.reset(ns.name);
        }
    }
    /**
     * Check if storage is enabled
     */
    async isEnabled(namespace) {
        try {
            const key = '__test';
            const value = key;
            await this._setItem(namespace, key, {
                value: value,
                createdAt: Date.now(),
                expiresAt: Date.now() + 1000,
            });
            await this._removeItem(namespace, key);
            return true;
        }
        catch (err) {
            logger$2h.error(err);
            throw new MintCacheException(err);
        }
    }
    async keys(namespace) {
        return this.getKeys(namespace);
    }
    async hasKey(namespace, key) {
        const keys = await this.getKeys(namespace);
        return keys.indexOf(key) > -1;
    }
    async addKey(namespace, key) {
        const keys = await this.getKeys(namespace);
        if (keys.indexOf(key) < 0) {
            keys.push(key);
        }
        this.saveKeys(namespace, keys);
    }
    async removeKey(namespace, key) {
        let keys = await this.getKeys(namespace);
        keys = keys.filter((item) => item !== key);
        this.saveKeys(namespace, keys);
    }
    async clearKeys(namespace) {
        this.saveKeys(namespace, []);
    }
    async getNamespace(namespace) {
        const namespaces = await this.getNamespaces();
        return namespaces.find((ns) => ns.name === namespace);
    }
    async removeExpired() {
        try {
            const namespaces = await this.getNamespaces();
            for (const namespace of namespaces) {
                const keys = await this.getKeys(namespace.name);
                for (const key of keys) {
                    // call _getItem to avoid
                    const item = await this._getItem(namespace.name, key);
                    if (!item || Date.now() >= item.expiresAt) {
                        // call removeItem to include stats
                        // logger.debug('removeExpired: removing key: ', key);
                        await this.removeItem(namespace.name, key);
                    }
                }
            }
        }
        catch (err) {
            logger$2h.error(err);
            throw new MintCacheException(err);
        }
    }
    sizeOfObject2(value) {
        if (typeof value === 'undefined') {
            return 0;
        }
        if (typeof value === 'number') {
            return 8;
        }
        if (typeof value === 'boolean') {
            return 4;
        }
        if (typeof value === 'string') {
            return value.length;
        }
        if (typeof value === 'function') {
            return 80;
        }
        if (Array.isArray(value)) {
            let size = 0;
            for (const item of value) {
                size += this.sizeOfObject(item);
            }
            return size;
        }
        if (typeof value === 'object') {
            let size = 0;
            let keys = [];
            try {
                keys = Object.keys(value);
            }
            catch (err) { }
            for (const key of keys) {
                size += key.length + this.sizeOfObject(value[key]);
            }
            if (size === 0) {
                size = 80;
            }
            return size;
        }
        return 0;
    }
    sizeOfObject(obj) {
        const objectList = [];
        const stack = [obj];
        let bytes = 0;
        while (stack.length) {
            const value = stack.pop();
            if (typeof obj === 'undefined') {
                return 0;
            }
            else if (typeof value === 'function') {
                bytes += 80;
            }
            else if (typeof value === 'boolean') {
                bytes += 4;
            }
            else if (typeof value === 'string') {
                bytes += value.length * 2;
            }
            else if (typeof value === 'number') {
                bytes += 8;
            }
            else if (Array.isArray(value)) {
                for (const item of value) {
                    stack.push(item);
                }
            }
            else if (typeof value === 'object' &&
                objectList.indexOf(value) === -1) {
                objectList.push(value);
                let keys = [];
                try {
                    keys = Object.keys(value);
                }
                catch (err) { }
                for (const key of keys) {
                    stack.push(value[key]);
                }
            }
        }
        return bytes;
    }
    async validateNamespace(namespace) {
        const ns = await this.getNamespace(namespace);
        if (ns.maxItemCount > 0) {
            const stats = this.stats.getStats(namespace);
            if (stats.keys >= ns.maxItemCount) {
                return false;
            }
        }
        return true;
    }
    validateStorageValue(value) {
        return !!value.expiresAt && value.expiresAt > Date.now();
    }
    /**
     * Prepare value to set to storage
     * @param options
     * returns {value: any, options: CacheOptions}
     */
    toStorageValue(value, options) {
        if (!options.ttl) {
            options.ttl = DEFAULT_TTL;
        }
        const now = Date.now();
        const expiresAt = now + options.ttl * 1000;
        return {
            value: value,
            expiresAt: expiresAt,
            createdAt: now,
        };
    }
}

const logger$2g = MintLogger.getLogger('MintMemoryCacheStorage');
/**
 * Service for storing data in local storage
 */
class MintMemoryCacheStorage extends MintCacheStorage {
    constructor() {
        super(2 /* MintCacheStorageType.MEMORY */);
        this._namespaces = new Map();
        this._cache = new Map();
    }
    async create(namespace) {
        const data = this._cache.get(namespace.name);
        if (data) {
            throw Error('Namespace already defined: ' + namespace);
        }
        this._cache.set(namespace.name, {});
        this._namespaces.set(namespace.name, namespace);
    }
    async getNamespaces() {
        return Array.from(this._namespaces.values());
    }
    getNamespaceData(namespace) {
        const data = this._cache.get(namespace);
        if (!data) {
            throw Error('Namespace not defined: ' + namespace);
        }
        return data;
    }
    async getKeys(namespace) {
        const data = this.getNamespaceData(namespace);
        return Object.keys(data);
    }
    async saveKeys(namespace, keys) {
        const data = this.getNamespaceData(namespace);
    }
    async _getItem(namespace, key) {
        const data = this.getNamespaceData(namespace);
        try {
            return data[key] ? data[key] : null;
        }
        catch (err) {
            logger$2g.error(err);
            throw new MintCacheException(err);
        }
    }
    async _setItem(namespace, key, value) {
        const data = this.getNamespaceData(namespace);
        try {
            data[key] = value;
        }
        catch (err) {
            logger$2g.error(err);
            throw new MintCacheException(err);
        }
    }
    async _removeItem(namespace, key) {
        const data = this.getNamespaceData(namespace);
        try {
            const value = data[key];
            delete data[key];
            return value;
        }
        catch (err) {
            logger$2g.error(err);
            throw new MintCacheException(err);
        }
    }
    async _clear(namespace) {
        try {
            this._cache.set(namespace, {});
        }
        catch (err) {
            logger$2g.error(err);
            throw new MintCacheException(err);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMemoryCacheStorage, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMemoryCacheStorage, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMemoryCacheStorage, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

const CACHE_NAMESPACE = 'DEFAULT_CACHE';
const CACHE_MAP = new Map();
const CACHE_TTL = 60;
const CACHE_JITTER = 0.1;
const logger$2f = MintLogger.getLogger('MintCacheService');
class MintCacheService {
    constructor(options) {
        this.options = options;
        this.namespace = CACHE_NAMESPACE;
        if (options.storage instanceof MintCacheStorage) {
            this.storage = options.storage;
        }
        else {
            switch (options.storage ? options.storage : 2 /* MintCacheStorageType.MEMORY */) {
                // case MintCacheStorageType.SESSION_STORAGE:
                //     this.storage = new SessionCacheStorage();
                //    break;
                // case MintCacheStorageType.LOCAL_STORAGE:
                //     this.storage = new LocalCacheStorage(storageService);
                //    break;
                default:
                    this.storage = new MintMemoryCacheStorage();
            }
        }
        if (!options.namespace) {
            options.namespace = {
                name: CACHE_NAMESPACE,
                maxItemCount: -1,
                maxSizeBytes: -1,
            };
        }
        if (!options.namespace.maxItemCount) {
            options.namespace.maxItemCount = -1;
        }
        if (!options.namespace.maxSizeBytes) {
            options.namespace.maxSizeBytes = -1;
        }
        this.namespace = options.namespace.name;
        this.init(options.namespace).then((_) => _);
    }
    async init(namespace) {
        await this.storage.create(namespace);
        await this.validateStorage(namespace.name);
        // logger.debug(
        //   `CacheService initialized: [${this.namespace}] storage: `,
        //   this.storage,
        //   `  namespace: `,
        //   namespace
        // );
    }
    // Return a ttl that jitter factor to prevent all items from
    // expiring at the same time.
    ttl(ttl, jitter = CACHE_JITTER) {
        if (!hasValue(ttl)) {
            ttl = CACHE_TTL;
        }
        if (!hasValue(jitter)) {
            jitter = CACHE_JITTER;
        }
        if (jitter < 0 || jitter > 1) {
            throw new MintCacheException('jitter value must be 0 and 1');
        }
        return MintMathUtil.round(MintMathUtil.getFluctuatedValue(ttl, jitter));
    }
    /**
     * Get data from cache
     * @returns any
     */
    async get(key) {
        // logger.debug('get: checking key: ', key);
        const value = await this.storage.getItem(this.namespace, key);
        // logger.debug(`get: key [${key}] value: `, value);
        return value;
    }
    /**
     * Set data to cache
     */
    async set(key, value, options) {
        // logger.debug('set: key: ', key,  '  value: ', value, ' options: ', options);
        if (!options) {
            options = {
                ttl: CACHE_TTL,
            };
        }
        await this.storage.setItem(this.namespace, key, value, {
            ttl: this.ttl(options.ttl, options.jitter),
        });
    }
    /**
     * Check if value exists
     * @returns boolean
     */
    async exists(key) {
        return this.storage.hasKey(this.namespace, key);
    }
    /**
     * Remove item from cache
     */
    async remove(key) {
        return this.storage.removeItem(this.namespace, key);
    }
    /**
     * Remove all from cache
     */
    async removeAll() {
        return this.storage.removeAll(this.namespace);
    }
    /**
     * Create a new instance of cache with needed storage
     * @param type
     * returns MintCacheService
     */
    getOrCreate(namespace) {
        let service = CACHE_MAP.get(namespace.name);
        if (!service) {
            // logger.debug('namespace not found in cache map: key: ', namespace);
            let storage = this.storage;
            if (this.storage.type === 2 /* MintCacheStorageType.MEMORY */) {
                storage = new MintMemoryCacheStorage();
            }
            service = new MintCacheService({
                storage: storage,
                namespace: namespace,
            });
            CACHE_MAP.set(namespace.name, service);
            // logger.debug('add cache to cache map: namespace: ', namespace);
        }
        else {
            // logger.debug('found cache in cache map: service: ', service, ' storage:  ', JSON.stringify(service.storage));
        }
        return service;
    }
    /**
     * Validate cache storage
     */
    async validateStorage(namespace) {
        const enabled = await this.storage.isEnabled(namespace);
        if (!enabled) {
            throw new MintCacheException('Cache storage is not enabled: ' +
                this.storage.type +
                '  namespace: ' +
                namespace);
        }
    }
    toStorageKey(key) {
        return this.namespace + key;
    }
    createCacheKey(item) {
        if (!item) {
            return '';
        }
        if (typeof item !== 'string') {
            item = JSON.stringify(item);
        }
        return MintCryptoUtil.checksum(item, 'md5', 'hex');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCacheService, deps: [{ token: 'MINT_CACHE_OPTIONS' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCacheService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCacheService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['MINT_CACHE_OPTIONS']
                }] }] });

const logger$2e = MintLogger.getLogger('MintCommonModule');
const MINT_CONFIG_OPTIONS = new InjectionToken('MINT_CONFIG_OPTIONS');
const MINT_CACHE_SERVICE_OPTIONS = new InjectionToken('MINT_CACHE_SERVICE_OPTIONS');
function configServiceFactory(options) {
    logger$2e.debug('configServiceFactory: ', options);
    const configService = new MintConfigService(options);
    const logLevel = configService.getString('logger.level');
    if (logLevel) {
        MintLogger.setLevel(logLevel);
    }
    logger$2e.debug('configServiceFactory: ', configService.getConfig());
    return configService;
}
function cacheServiceFactory(options) {
    return new MintCacheService(options);
}
class MintCommonModule {
    static forRoot(options) {
        // logger.debug('MintCommonModule for root called ...');
        return {
            ngModule: MintCommonModule,
            providers: [
                // MintHttpService,
                // MintStorageService,
                {
                    provide: MINT_CONFIG_OPTIONS,
                    useValue: options,
                },
                {
                    provide: MINT_CACHE_SERVICE_OPTIONS,
                    useValue: {
                        storage: options.cacheType
                            ? options.cacheType
                            : 2 /* MintCacheStorageType.MEMORY */,
                    },
                },
                {
                    provide: MintConfigService,
                    useFactory: configServiceFactory,
                    deps: [MINT_CONFIG_OPTIONS],
                },
                {
                    provide: MintCacheService,
                    useFactory: cacheServiceFactory,
                    deps: [MINT_CACHE_SERVICE_OPTIONS],
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: MintHttpParamsInterceptor,
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintCommonModule, imports: [CommonModule, HttpClientModule], exports: [CommonModule, HttpClientModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCommonModule, imports: [CommonModule, HttpClientModule, CommonModule, HttpClientModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, HttpClientModule],
                    exports: [CommonModule, HttpClientModule],
                }]
        }] });

const logger$2d = MintLogger.getLogger('MintDebouncer');
class MintDebouncer {
    constructor(wait) {
        this.wait = wait;
    }
    async debounce(callback) {
        this.callback = callback;
        return await this.schedule();
    }
    async schedule() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = 0;
        }
        if (this.wait <= 0) {
            return this.callback();
        }
        else {
            return new Promise((resolve) => {
                this.timer = window.setTimeout(async () => {
                    // logger.debug('AsyncDebouncer: this.callback: ', this.callback);
                    const result = await this.callback();
                    // logger.debug('MintDebouncer: schedule result: ', result);
                    resolve(result);
                }, this.wait);
            });
        }
    }
}

const logger$2c = MintLogger.getLogger('MintValidatorService');
class MintValidatorService {
    constructor(api) {
        this.api = api;
    }
    async username(username, userUid) {
        logger$2c.debug(`ValidationService: username called: username: ${username}  userUid: ${userUid}`);
        let params;
        if (userUid) {
            params = {
                uid: userUid,
            };
        }
        try {
            const urlPath = 'validations/username/' + encodeURIComponent(username);
            const result = await this.api.get(urlPath, params);
            logger$2c.debug('username: result: ', result);
            return result;
        }
        catch (err) {
            logger$2c.error(err);
            return false;
        }
    }
    async email(email, userUid) {
        logger$2c.debug(`ValidationService: email called: email: ${email}  userUid: ${userUid}`);
        let params;
        if (userUid) {
            params = {
                uid: userUid,
            };
        }
        try {
            const urlPath = 'validations/email/' + encodeURIComponent(email);
            const result = await this.api.get(urlPath, params);
            logger$2c.debug('email: result: ', result);
            return result;
        }
        catch (err) {
            logger$2c.error(err);
            return false;
        }
    }
    async mobileNumber(mobileNumber, country, userUid) {
        logger$2c.debug(`ValidationService: mobileNumber called: mobileNumber: ${mobileNumber}  country: ${country}  userUid: ${userUid}`);
        const params = {};
        if (country) {
            params.country = country;
        }
        if (userUid) {
            params.uid = userUid;
        }
        const urlPath = 'validations/mobile-number/' + encodeURIComponent(mobileNumber);
        try {
            const result = await this.api.get(urlPath, params);
            logger$2c.debug('mobileNumber: result: ', result);
            return result;
        }
        catch (err) {
            logger$2c.error(err);
            return false;
        }
    }
    // public async mobileNumberAutoRegistered(
    //   mobileNumber: string,
    // ): Promise<boolean> {
    //   // BUSINESS RULE: if mobile number matches username then user was auto registered so number is valid and available.
    //   const params: any = {
    //     match_username: true,
    //   };
    //
    //   try {
    //     const result = await this.api.get(
    //       'auth/validations/mobile-numbers/' + mobileNumber,
    //       params,
    //     );
    //     return result.registered || false;
    //   } catch (err) {
    //     logger.error(err);
    //     throw err;
    //   }
    // }
    async invitationHasStatus(code, status) {
        logger$2c.debug(`
      ValidationService: invitationHasStatus
      called: code: ${code}  status: ${status}
    `);
        const urlPath = 'validations/invitation/' +
            encodeURIComponent(code) +
            '/' +
            status.toLowerCase();
        try {
            const result = await this.api.get(urlPath);
            logger$2c.debug('invitationHasStatus: result: ', result);
            return result;
        }
        catch (err) {
            logger$2c.error(err);
            return false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintValidatorService, deps: [{ token: MintHttpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintValidatorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintValidatorService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }] });

const logger$2b = MintLogger.getLogger('MintPhoneNumberService');
class MintPhoneNumberService {
    formatNational(phoneNumber, countryCode) {
        return this.format(phoneNumber, countryCode, 'NATIONAL');
    }
    formatE164(phoneNumber, countryCode) {
        return this.format(phoneNumber, countryCode, 'E.164');
    }
    parse(phoneNumber, defaultCountryCode) {
        return parsePhoneNumber(phoneNumber, defaultCountryCode);
    }
    countryCode(phoneNumber, defaultCountryCode) {
        let countryCode;
        const parsed = this.parse(phoneNumber, defaultCountryCode);
        if (parsed) {
            countryCode = parsed.country;
        }
        return countryCode;
    }
    valid(phoneNumber, countryCode = 'US', format) {
        if (!phoneNumber) {
            return false;
        }
        if (!format) {
            format = 'E.164';
        }
        try {
            const parsed = parsePhoneNumber(phoneNumber + '', countryCode);
            return parsed.isValid();
        }
        catch (error) {
            if (error instanceof ParseError) {
                return false;
            }
            else {
                logger$2b.error(error);
                return false;
            }
        }
    }
    format(phoneNumber, countryCode = 'US', format) {
        if (!phoneNumber) {
            return null;
        }
        if (!format) {
            format = 'E.164';
        }
        try {
            // const parsedPhoneNumber: PhoneNumber = MintphoneUtil.parse(phoneNumber, country);
            const parsed = parsePhoneNumber(phoneNumber + '', countryCode);
            if (phoneNumber) {
                phoneNumber = parsed.format(format);
                // logger.debug(`format: ${parsed}  formatted: ${phoneNumber}`);
            }
        }
        catch (error) {
            if (error instanceof ParseError) {
                // Not a phone number, non-existent country, etc.
                logger$2b.debug(error);
            }
            else {
                throw error;
            }
        }
        return phoneNumber;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPhoneNumberService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPhoneNumberService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPhoneNumberService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const logger$2a = MintLogger.getLogger('MintMobileNumberValidator');
class MintMobileNumberValidator {
    constructor(validator, phoneNumberService) {
        this.validator = validator;
        this.phoneNumberService = phoneNumberService;
        this.debouncer = new MintDebouncer(700);
    }
    async isValid(phoneNumber, countryCode = 'US') {
        if (!phoneNumber) {
            return null;
        }
        return await this.debouncer.debounce(async () => {
            if (typeof phoneNumber !== 'string') {
                const value = phoneNumber.value;
                phoneNumber = value.phoneNumber;
                countryCode = value.countryCode ? value.countryCode : countryCode;
            }
            const valid = this.phoneNumberService.valid(phoneNumber, countryCode);
            if (!valid) {
                return {
                    format: true,
                };
            }
            return null;
        });
    }
    async isAvailable(phoneNumber, userUid, countryCode = 'US') {
        if (!phoneNumber) {
            return null;
        }
        return await this.debouncer.debounce(async () => {
            if (typeof phoneNumber !== 'string') {
                const value = phoneNumber.value;
                phoneNumber = value.phoneNumber;
                countryCode = value.countryCode ? value.countryCode : countryCode;
            }
            let valid = this.phoneNumberService.valid(phoneNumber, countryCode);
            if (!valid) {
                return {
                    format: true,
                };
            }
            const mobileNumber = this.phoneNumberService.formatE164(phoneNumber, countryCode);
            // logger.debug('isAvailable: mobileNumber: ', mobileNumber);
            //
            // if (!mobileNumber) {
            //   return {
            //     format: true,
            //   };
            // }
            valid = await this.validator.mobileNumber(mobileNumber, countryCode, userUid);
            if (!valid) {
                return {
                    available: true,
                };
            }
            return null;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMobileNumberValidator, deps: [{ token: MintValidatorService }, { token: MintPhoneNumberService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMobileNumberValidator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMobileNumberValidator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintValidatorService }, { type: MintPhoneNumberService }] });

const logger$29 = MintLogger.getLogger('MintUsernameValidator');
class MintUsernameValidator {
    constructor(validator) {
        this.validator = validator;
        this.debouncer = new MintDebouncer(700);
    }
    async isValid(control) {
        const username = control.value;
        return await this.debouncer.debounce(async () => {
            const valid = username && username.length >= 4;
            if (!valid) {
                return {
                    format: true,
                };
            }
            return null;
        });
    }
    async isAvailable(control, userUid) {
        const username = control.value;
        const result = await this.isValid(control);
        if (result) {
            return result;
        }
        return await this.debouncer.debounce(async () => {
            const valid = await this.validator.username(username, userUid);
            if (!valid) {
                return {
                    available: true,
                };
            }
            return null;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUsernameValidator, deps: [{ token: MintValidatorService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUsernameValidator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUsernameValidator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintValidatorService }] });

const logger$28 = MintLogger.getLogger('MintPasswordValidator');
// @dynamic
class MintPasswordValidator {
    static { this.EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i; }
    /*
          https://www.thepolyglotdeveloper.com/2015/05/use-regex-to-test-password-strength-in-javascript/
          RegEx	Description
          ^	The password string will start this way
          (?=.*[a-z])
              The string must contain at least 1 lowercase alphabetical character
  
          (?=.*[A-Z])
              The string must contain at least 1 uppercase alphabetical character
  
          (?=.*[0-9])
              The string must contain at least 1 numeric character
  
          (?=.*[!@#\$%\^&\*])
              The string must contain at least one special character,
              but we are escaping reserved RegEx characters to avoid conflict
  
          (?=.{8,})
              The string must be eight characters or longer
      */
    static { this.STRONG = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'); }
    /*
       5 or more characters   AND
       1 lowercase and 1 uppercase OR
          1 lowercase and 1 numeric OR
          1 uppercase and 1 numeric
       */
    static { this.MEDIUM = new RegExp('^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})'); }
    /*
      4 or more characters
      */
    static { this.WEAK = new RegExp('^.{8,}$'); }
    isStrong(password) {
        return MintPasswordValidator.STRONG.test(password);
    }
    isMedium(password) {
        return MintPasswordValidator.MEDIUM.test(password);
    }
    isValid(control) {
        const password = control.value;
        let valid = MintPasswordValidator.STRONG.test(password);
        if (valid) {
            logger$28.debug('Password is strong: ', password);
        }
        if (!valid) {
            valid = MintPasswordValidator.MEDIUM.test(password);
            if (valid) {
                logger$28.debug('Password is medium: ', password);
            }
        }
        if (!valid) {
            valid = MintPasswordValidator.WEAK.test(password);
            if (valid) {
                logger$28.debug('Password is weak: ', password);
            }
        }
        if (!valid) {
            return {
                format: true,
            };
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPasswordValidator, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPasswordValidator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPasswordValidator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

// http://stackoverflow.com/questions/39847862/min-max-validator-in-angular-2-final
class MintNumberValidator {
    isValid(params) {
        return (control) => {
            const val = control.value;
            if (typeof val === 'undefined' || val === null) {
                return null;
            }
            if (params && params.integer === true) {
                if (isNaN(val) || /\D/.test(val.toString())) {
                    return { number: true };
                }
            }
            if (params && !isNaN(params.min) && !isNaN(params.max)) {
                return val < params.min || val > params.max ? { number: true } : null;
            }
            else if (params && !isNaN(params.min)) {
                return val < params.min ? { number: true } : null;
            }
            else if (params && !isNaN(params.max)) {
                return val > params.max ? { number: true } : null;
            }
            else {
                return null;
            }
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNumberValidator, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNumberValidator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNumberValidator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const logger$27 = MintLogger.getLogger('DateValidator');
class MintDateValidator {
    minAge(age) {
        return (control) => {
            let result = null;
            const date = control.value;
            const _age = dayjs().diff(dayjs(date), 'years');
            if (_age < age) {
                result = {
                    minAge: {
                        requiredAge: age,
                        actualAge: _age,
                    },
                };
            }
            return result;
        };
    }
    maxAge(age) {
        return (control) => {
            let result = null;
            const date = control.value;
            const _age = dayjs().diff(dayjs(date), 'years');
            if (_age > age) {
                result = {
                    maxAge: {
                        requiredAge: age,
                        actualAge: _age,
                    },
                };
            }
            return result;
        };
    }
    isValid(params) {
        return (control) => {
            const val = control.value;
            if (!params || typeof val === 'undefined' || val === null) {
                return null;
            }
            logger$27.debug('val: ', val);
            const valTime = dayjs(val).valueOf();
            const minTime = params && params.min ? params.min.getTime() : null;
            const maxTime = params && params.max ? params.max.getTime() : null;
            const result = {};
            if (minTime && valTime < minTime) {
                result['minDate'] = true;
            }
            if (maxTime && valTime > maxTime) {
                result['maxDate'] = true;
            }
            if (!dayjs(val).isValid()) {
                result['invalidDate'] = true;
            }
            return Object.keys(result).length ? result : null;
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateValidator, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateValidator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateValidator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const logger$26 = MintLogger.getLogger('MintEmailValidator');
// @dynamic
class MintEmailValidator {
    static { this.EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i; }
    constructor(validator) {
        this.validator = validator;
        this.debouncer = new MintDebouncer(400);
    }
    async isValid(control) {
        let email = control;
        if (typeof control !== 'string') {
            email = control.value;
        }
        return await this.debouncer.debounce(async () => {
            const valid = MintEmailValidator.EMAIL_REGEXP.test(email);
            if (!valid) {
                return {
                    format: true,
                };
            }
            return null;
        });
    }
    async isAvailable(control, userUid) {
        let email = control;
        if (typeof control !== 'string') {
            email = control.value;
        }
        // logger.debug('isAvailable: userUid: ', userUid);
        const result = await this.isValid(control);
        if (result) {
            return result;
        }
        return await this.debouncer.debounce(async () => {
            const valid = await this.validator.email(email, userUid);
            if (!valid) {
                return {
                    available: true,
                };
            }
            return null;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintEmailValidator, deps: [{ token: MintValidatorService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintEmailValidator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintEmailValidator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintValidatorService }] });

// https://dev.to/stephencweiss/validating-social-security-numbers-47mo
class MintSsnValidator {
    static validSsn(value) {
        return (value &&
            /^(?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/.test(value));
    }
    isValid() {
        return (control) => {
            const val = control.value;
            if (typeof val === 'undefined' || val === null || !val.length) {
                return null;
            }
            if (MintSsnValidator.validSsn(val)) {
                return null;
            }
            return {
                ssn: true,
            };
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSsnValidator, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSsnValidator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSsnValidator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const logger$25 = MintLogger.getLogger('ModulePreloadingStrategyService');
class ModulePreloadingStrategyService {
    constructor() {
        this.preloadedModules = [];
    }
    preload(route, load) {
        if (route.data && route.data['preload']) {
            // add the route path to the preloaded module array
            this.preloadedModules.push(route.path);
            // log the route path to the console
            logger$25.debug('Preloaded Module: ' + route.path);
            return load();
        }
        else {
            return of(null);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: ModulePreloadingStrategyService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: ModulePreloadingStrategyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: ModulePreloadingStrategyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

function throwIfAlreadyLoaded(parentModule, moduleName) {
    if (parentModule) {
        throw new Error(`${moduleName} has already been loaded. Import '${moduleName}' in AppModule only.`);
    }
}

class MintValidationException extends MintError {
    constructor(err, payload) {
        super(err, {
            ...payload,
            status: 422 /* HttpStatusCode.UnprocessableEntity */,
        });
        this.name = 'MintValidationException';
    }
}

class MintRoleProvider {
}

class MintArrayWrapper {
    #values = [];
    *[Symbol.iterator]() {
        for (const item of this.#values) {
            yield item;
        }
    }
    get values() {
        return this.#values;
    }
    push(...values) {
        return this.#values.push(...values);
    }
    get length() {
        return this.#values.length;
    }
    set length(length) {
        this.#values.length = length;
    }
    find(predicate, thisArg) {
        return this.#values.find(predicate, thisArg);
    }
    filter(predicate, thisArg) {
        return this.#values.filter(predicate, thisArg);
    }
    map(callbackfn, thisArg) {
        return this.#values.map(callbackfn, thisArg);
    }
    sort(compareFn, sortInPlace = false) {
        if (sortInPlace) {
            return this.#values.sort(compareFn);
        }
        const _values = [...this.#values];
        return _values.sort(compareFn);
    }
    toJSON() {
        return instanceToPlain(this);
    }
    toString() {
        return JSON.stringify(this.toJSON(), null, '  ');
    }
}

const MINT_NULL = '__MINT_NULL__';
const MINT_DUPE = '__MINT_DUPE__';
const isJsonQueryOperator = (operator) => {
    return (operator === MintQueryOperator.JsonArraySubset ||
        operator === MintQueryOperator.JsonArrayEquals ||
        operator === MintQueryOperator.JsonArrayIncludes);
};
// NOTE: ORDER OF OPERATORS MATTER!
// Items must be listed in order of most specific to least specific
// if '>' precedes '>=' then it will match first if the key is '>=age';
var MintQueryOperator;
(function (MintQueryOperator) {
    MintQueryOperator["IgnoreCase"] = "*";
    MintQueryOperator["JsonPath"] = "@@";
    MintQueryOperator["JsonArraySubset"] = "@>";
    MintQueryOperator["JsonArraySubsetIgnoreCase"] = "@>*";
    MintQueryOperator["JsonArrayEquals"] = "@=";
    MintQueryOperator["JsonArrayEqualsIgnoreCase"] = "@=*";
    MintQueryOperator["JsonArrayIncludes"] = "?|";
    MintQueryOperator["JsonArrayIncludesIgnoreCase"] = "?|*";
    MintQueryOperator["Equals"] = "=";
    MintQueryOperator["EqualsIgnoreCase"] = "=*";
    MintQueryOperator["NotEquals"] = "!=";
    MintQueryOperator["NotEqualsIgnoreCase"] = "!=*";
    MintQueryOperator["NotEqualsIgnoreCaseAlt"] = "!*";
    MintQueryOperator["GreaterThan"] = ">";
    MintQueryOperator["GreaterThanOrEquals"] = ">=";
    MintQueryOperator["LessThan"] = "<";
    MintQueryOperator["LessThanOrEquals"] = "<=";
    MintQueryOperator["In"] = "|";
    MintQueryOperator["InIgnoreCase"] = "|*";
    MintQueryOperator["NotIn"] = "!|";
    MintQueryOperator["NotInIgnoreCase"] = "!|*";
    MintQueryOperator["Between"] = "&";
    MintQueryOperator["NotBetween"] = "!&";
    MintQueryOperator["Regex"] = "~";
    MintQueryOperator["RegexIgnoreCase"] = "~*";
    MintQueryOperator["NotRegex"] = "!~";
    MintQueryOperator["NotRegexIgnoreCase"] = "!~*";
    MintQueryOperator["Like"] = "%";
    MintQueryOperator["LikeIgnoreCase"] = "%*";
    MintQueryOperator["NotLike"] = "!%";
    MintQueryOperator["NotLikeIgnoreCase"] = "!%*";
    MintQueryOperator["FullTextSearch"] = "%%";
    MintQueryOperator["Not"] = "!";
    MintQueryOperator["None"] = "";
})(MintQueryOperator || (MintQueryOperator = {}));
function isQueryFilterType(filter) {
    return (isQueryExpression(filter) ||
        isQueryCondition(filter) ||
        isQueryFilter(filter) ||
        (Array.isArray(filter) &&
            (isQueryExpression(filter[0]) ||
                isQueryCondition(filter[0]) ||
                (Array.isArray(filter[0]) && isQueryExpression(filter[0][0])))));
}

function isQueryExpression(arg) {
    return (arg instanceof MintQueryExpression ||
        (isDefined(arg?.key) &&
            isDefined(arg?.operator) &&
            typeof arg?.value !== 'undefined') // value can be null
    );
}
class MintQueryExpression {
    constructor(value) {
        if (value) {
            Object.assign(this, plainToInstance(MintQueryExpression, value));
        }
    }
    static from(value) {
        const _value = MintJsonUtil.parse(value);
        return new MintQueryExpression(_value);
    }
    toString() {
        return JSON.stringify(instanceToPlain(this), null, '  ');
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintQueryExpression.prototype, "key", void 0);
__decorate([
    IsEnum(MintQueryOperator),
    IsDefined()
], MintQueryExpression.prototype, "operator", void 0);
__decorate([
    IsDefined()
], MintQueryExpression.prototype, "value", void 0);

var MintQueryCondition_1;
const logger$24 = MintLogger.getLogger('MintQueryCondition');
function isQueryCondition(arg) {
    return (arg instanceof MintQueryCondition ||
        arg?.and?.length === 0 ||
        isQueryExpression(arg?.and?.[0]));
}
// a condition is a logical 'and' of expressions
let MintQueryCondition = MintQueryCondition_1 = class MintQueryCondition extends MintArrayWrapper {
    get and() {
        return this.values;
    }
    set and(values) {
        this.setExpressions(values);
    }
    constructor(condition) {
        super();
        if (condition) {
            // logger.test('condition: ', condition);
            if (isQueryExpression(condition)) {
                this.setExpressions([condition]);
            }
            else if (Array.isArray(condition) && isQueryExpression(condition[0])) {
                this.setExpressions(condition);
            }
            else if (isQueryCondition(condition)) {
                this.setExpressions(condition.and);
            }
            else {
                throw new MintError('Invalid argument');
            }
            // logger.test('conditions: ', this.conditions);
        }
    }
    static from(value) {
        const _value = MintJsonUtil.parse(value);
        return new MintQueryCondition_1(_value);
    }
    static toCondition(model) {
        if (typeof model === 'string') {
            logger$24.trace('toQueryRule: model is a string: ', model);
            throw new MintError('toQueryRule: Invalid model: ', toJSON(model, true));
        }
        const dotObject = MintObjectUtil.toDotObject(model);
        const result = new MintQueryCondition_1();
        for (const key of Object.keys(dotObject)) {
            result.addExpression({
                key: key,
                operator: MintQueryOperator.Equals,
                value: dotObject[key],
            });
        }
        // logger.test('toCondition: ', {
        //   model: model,
        //   dotObject: dotObject,
        //   result: toJSON(result, true),
        // });
        return result;
    }
    setExpressions(values) {
        this.addExpression(...values);
    }
    // replace existing keys
    addExpression(...values) {
        if (isNullish(values)) {
            return this;
        }
        values = values.map((item) => MintQueryExpression.from(item));
        for (const expression of values) {
            // get array that does not include key
            const filtered = this.values.filter((item) => item.key !== expression.key);
            // add expression to array
            filtered.push(expression);
            // set instance values to this array
            this.values.length = 0;
            this.values.push(...filtered);
        }
        return this;
    }
};
__decorate([
    Expose(),
    Type(() => MintQueryExpression)
], MintQueryCondition.prototype, "and", null);
MintQueryCondition = MintQueryCondition_1 = __decorate([
    Exclude()
], MintQueryCondition);

var MintQueryFilter_1;
const logger$23 = MintLogger.getLogger('MintQueryFilter');
function isQueryFilter(arg) {
    return (arg instanceof MintQueryFilter ||
        arg?.or?.length === 0 ||
        isQueryCondition(arg?.or?.[0]));
}
// a filter is a logical 'or' of conditions
let MintQueryFilter = MintQueryFilter_1 = class MintQueryFilter extends MintArrayWrapper {
    get or() {
        return this.values;
    }
    set or(values) {
        this.setConditions(values);
    }
    constructor(filter) {
        super();
        if (filter) {
            if (isQueryExpression(filter)) {
                this.setConditions([MintQueryCondition.from(filter)]);
            }
            else if (Array.isArray(filter) && isQueryExpression(filter[0])) {
                this.setConditions([
                    MintQueryCondition.from(filter),
                ]);
            }
            else if (isQueryCondition(filter)) {
                this.setConditions([filter]);
            }
            else if (Array.isArray(filter) && isQueryCondition(filter[0])) {
                this.setConditions(filter);
            }
            else if (Array.isArray(filter) &&
                Array.isArray(filter[0]) &&
                isQueryExpression(filter[0][0])) {
                const conditions = filter.map((item) => MintQueryCondition.from(item));
                this.setConditions(conditions);
            }
            else if (isQueryFilter(filter)) {
                const conditions = filter.or.map((item) => MintQueryCondition.from(item));
                this.setConditions(conditions);
            }
            else {
                logger$23.error('Error: invalid filter: ', filter, typeof filter);
                throw new MintError('Invalid argument');
            }
        }
    }
    static from(value) {
        if (!value || (Array.isArray(value) && !value.length)) {
            return new MintQueryFilter_1();
        }
        const filter = MintJsonUtil.parse(value);
        if ((Array.isArray(filter) && typeof filter[0] === 'string') ||
            (Array.isArray(filter) &&
                Array.isArray(filter?.[0]) &&
                typeof filter[0][0] === 'string')) {
            logger$23.trace('from: value is a string: ', filter);
            throw new MintError({
                message: 'MintQueryFilter.from: Invalid filter: ',
                data: filter,
            });
        }
        if (isQueryFilter(filter) && filter instanceof MintQueryFilter_1) {
            return filter;
        }
        if (isQueryFilterType(filter)) {
            return new MintQueryFilter_1(filter);
        }
        const result = new MintQueryFilter_1();
        const _filter = Array.isArray(filter) ? filter : [filter];
        for (const _model of _filter) {
            result.addCondition(MintQueryCondition.toCondition(_model));
        }
        return result;
    }
    setConditions(values) {
        this.length = 0;
        if (values?.length) {
            this.addCondition(...values);
        }
    }
    addCondition(...values) {
        const _values = values.map((item) => MintQueryCondition.from(item));
        super.push(..._values);
        return this;
    }
    // Add expression to each condition defined
    // existing keys will be replaced
    addExpression(...values) {
        if (!this.values.length) {
            this.addCondition(new MintQueryCondition());
        }
        for (const expression of values) {
            for (const condition of this.values) {
                condition.addExpression(expression);
            }
        }
        return this;
    }
};
__decorate([
    Expose(),
    Type(() => MintQueryCondition)
], MintQueryFilter.prototype, "or", null);
MintQueryFilter = MintQueryFilter_1 = __decorate([
    Exclude()
], MintQueryFilter);

const logger$22 = MintLogger.getLogger('MintClass');
class MintClassUtil {
    static ownKeys(obj) {
        return Object.keys(obj);
    }
    static instance(c, data = {}, transformGroups) {
        const options = {
            strategy: 'exposeAll',
            // not working
            // https://github.com/typestack/class-transformer/issues/152
            ignoreDecorators: false,
            // excludeExtraneousValues: true,
            // DO NOT ENABLE until fully tested especially with ENTITIES
            // that contain JSONB objects that are converted to MODELS
            // enableImplicitConversion: true,
            groups: transformGroups?.length ? transformGroups : undefined,
        };
        if (!data) {
            data = {};
        }
        return plainToInstance(c, data, options);
    }
    static toObject(c, data = {}, transformGroups) {
        const options = {
            strategy: 'exposeAll',
            ignoreDecorators: false,
            groups: transformGroups?.length ? transformGroups : undefined,
        };
        const instance = this.instance(c, data, transformGroups);
        return instanceToPlain(instance, options);
    }
    static fields(c, columns) {
        const obj = plainToInstance(c, instanceToPlain(new c()), {
            strategy: 'exposeAll',
            ignoreDecorators: true,
        });
        if (!columns || columns.length === 0) {
            columns = Object.getOwnPropertyNames(obj);
        }
        // make sure all column values are valid
        const props = Object.getOwnPropertyNames(obj);
        // use a tmp object to mark the fields that we want in the final output.
        const example = {};
        for (const column of columns) {
            if (!props.includes(column)) {
                throw new MintError('Location: fields(): Invalid column: ' + column);
            }
            // set value to 'null' to distinguish from 'undefined' which plainToInstance sets
            example[column] = null;
        }
        const plain = instanceToPlain(new c(example), {
            strategy: 'exposeAll',
            ignoreDecorators: false,
        });
        // instanceToPlain will return all the model properties.
        // remove any not specified in columns array
        for (const key of Object.keys(plain)) {
            if (typeof plain[key] === 'undefined') {
                delete plain[key];
            }
        }
        return Object.getOwnPropertyNames(plain);
    }
    static pick(obj, ...keys) {
        return MintClassUtil._pick(obj, ...keys);
    }
    // From T pick a set of properties K
    static _pick(obj, ...keys) {
        const copy = {};
        keys.forEach((key) => (copy[key] = obj[key]));
        return copy;
    }
    static propertyValue(obj, key) {
        return obj[key];
    }
}

class MintBaseService {
    constructor(_baseCacheService, _baseCacheGroupName = null) {
        this._baseCacheService = _baseCacheService;
        this._baseCacheGroupName = _baseCacheGroupName;
        this._logger = MintLogger.getLogger(this.constructor.name);
        if (!this._baseCacheGroupName) {
            this._baseCacheGroupName = this.constructor.name;
        }
        this._baseCacheGroupName = MintStringUtil.slug(this._baseCacheGroupName);
        // app specific cache
        this.cache = this._baseCacheService.getOrCreate({
            name: this._baseCacheGroupName,
            maxItemCount: -1,
            maxSizeBytes: -1,
        });
    }
    cacheKey(key, ...items) {
        if (items) {
            items = this._baseCacheService.createCacheKey(items);
            key = key + ':' + items;
        }
        return key;
    }
    async clearCache() {
        try {
            if (this.cache) {
                await this.cache.removeAll();
            }
        }
        catch (err) {
            this._logger.error(err);
        }
    }
}

var MintQueryAggregate;
(function (MintQueryAggregate) {
    MintQueryAggregate["Count"] = "count";
    MintQueryAggregate["Min"] = "min";
    MintQueryAggregate["Max"] = "max";
    MintQueryAggregate["Sum"] = "sum";
    MintQueryAggregate["Avg"] = "avg";
})(MintQueryAggregate || (MintQueryAggregate = {}));
function isMintResultSet(obj) {
    if (!obj) {
        return false;
    }
    if (obj instanceof MintResultSet) {
        return true;
    }
    const fields = [
        'totalSize',
        'startIndex',
        'endIndex',
        'pageSize',
        'totalPages',
        'data',
    ];
    for (const field of fields) {
        if (isUndefined(obj[field])) {
            return false;
        }
        if (field === 'data' && !Array.isArray(obj[field])) {
            return false;
        }
    }
    return true;
}
let MintResultSet = class MintResultSet {
    get endIndex() {
        if (this.startIndex === null) {
            return null;
        }
        if (this.pageSize === null) {
            return null;
        }
        let endIndex = this.startIndex + this.pageSize;
        if (endIndex > this.totalSize) {
            endIndex = this.totalSize;
        }
        return endIndex;
    }
    get totalPages() {
        if (this.totalSize === null) {
            return null;
        }
        if (this.totalSize === 0) {
            return 0;
        }
        if (this.pageSize === null) {
            return 1;
        }
        let result = Math.floor(this.totalSize / this.pageSize);
        if (this.totalSize % this.pageSize > 0) {
            result += 1;
        }
        return result;
    }
    // NOTE: first page starts at 1 (not 0)
    get currentPage() {
        if (this.startIndex === null) {
            return null;
        }
        if (this.totalSize === 0) {
            return 0;
        }
        const result = Math.floor(this.startIndex / this.pageSize);
        return result + 1;
    }
    constructor(options) {
        this.totalSize = 0;
        this.startIndex = 0;
        this.pageSize = 0;
        this.data = options.data ?? [];
        this.startIndex = options.startIndex ?? 0;
        this.pageSize = options.pageSize ?? options.data.length;
        this.totalSize = options.totalSize ?? options.data.length;
    }
};
__decorate([
    Expose()
], MintResultSet.prototype, "totalSize", void 0);
__decorate([
    Expose()
], MintResultSet.prototype, "startIndex", void 0);
__decorate([
    Expose()
], MintResultSet.prototype, "endIndex", null);
__decorate([
    Expose()
], MintResultSet.prototype, "pageSize", void 0);
__decorate([
    Expose()
], MintResultSet.prototype, "totalPages", null);
__decorate([
    Expose()
], MintResultSet.prototype, "currentPage", null);
__decorate([
    Expose()
], MintResultSet.prototype, "data", void 0);
MintResultSet = __decorate([
    Exclude()
], MintResultSet);

const logger$21 = MintLogger.getLogger('MintService');
const MINT_DEFAULT_CACHE_TTL = 60; // 60 seconds
class MintService extends MintBaseService {
    constructor(_httpService, _cacheService, _clazz, urlPath) {
        super(_cacheService, urlPath);
        this._httpService = _httpService;
        this._cacheService = _cacheService;
        this._clazz = _clazz;
        this.urlPath = urlPath;
    }
    apiPath(modelOrPath, pathOrQuery, query) {
        let url = this.urlPath;
        if (!url.endsWith('/')) {
            url += '/';
        }
        let path = '';
        if (typeof modelOrPath === 'string') {
            if (modelOrPath.startsWith('/')) {
                modelOrPath = modelOrPath.substring(1);
            }
            path += encodeURIComponent(modelOrPath);
        }
        else {
            path += encodeURIComponent(modelOrPath.uid);
        }
        let _query = query;
        if (typeof pathOrQuery === 'string') {
            path += `/${encodeURIComponent(pathOrQuery)}`;
        }
        else {
            _query = pathOrQuery;
        }
        if (Object.keys(_query ?? {}).length) {
            path += '?' + serializeQueryParams(_query);
        }
        return url + path;
    }
    // protected override cacheKey(key: string, ...item: string | any) {
    //   key = super.cacheKey(key, item);
    //   return this.constructor.name + ':' + key;
    // }
    toModel(item, cacheItem = true) {
        if (!item) {
            return null;
        }
        // const suffixes = ['Ts', 'Dt', 'At', 'Date'];
        // item = MintDateUtil.parseObject(item, suffixes, true);
        item = MintObjectUtil.parseDates(item);
        const instance = MintClassUtil.instance(this._clazz, item);
        // logger.debug('toModel: parsedInstance: ', instance);
        if (cacheItem && this.cache) {
            if (instance.uid) {
                this.cache.set(`uid|${instance.uid}`, instance, {
                    ttl: MINT_DEFAULT_CACHE_TTL,
                });
            }
        }
        return instance;
    }
    toModelArray(items, cacheItems = true, cacheMax = 10000) {
        const modelArray = [];
        for (let i = 0; i < items.length; i++) {
            const model = this.toModel(items[i], cacheItems && i < cacheMax);
            modelArray.push(model);
        }
        return modelArray;
    }
    toResultSet(resultSet, cacheItems = true, cacheMax = 10000) {
        const data = this.toModelArray(resultSet.data ?? [], cacheItems, cacheMax);
        return new MintResultSet({
            ...resultSet,
            data: data,
        });
    }
    // transform object before saving to server
    // protected transformModelObjects(model: Partial<T>, keys: string[]) {
    //     const _model = <any>model;
    //     for (const key of keys) {
    //         if (typeof _model[key] === 'undefined') {
    //             _model[key] = null;
    //         }
    //         const keyUid = key + 'Uid';
    //         _model[keyUid] = _model[key] ? _model[key].uid : null;
    //         delete _model[key];
    //     }
    //     return _model;
    // }
    async findAll(filter, urlPathVars, fields) {
        const result = await this.find({
            filter: filter,
            fields: fields,
            url: {
                params: urlPathVars,
            },
        });
        if (!result) {
            return null;
        }
        return result.data;
    }
    async findByExample(example, options) {
        const filter = MintQueryFilter.from(options.filter);
        for (const key of Object.keys(example)) {
            const value = example[key];
            if (!isUndefined(value)) {
                filter.addCondition({
                    key: key,
                    operator: MintQueryOperator.Equals,
                    value: value,
                });
            }
        }
        return this.find({
            ...options,
            filter: filter,
        });
    }
    toQueryParams(options) {
        const params = {};
        if (!isNullish(options.tokenUid)) {
            params['_t'] = options.tokenUid;
        }
        if (!isNullish(options.filter)) {
            // const filter = this.convertCase(options.filter);
            params['filter'] = JSON.stringify(options.filter);
        }
        if (!isNullish(options.fields)) {
            const fields = Array.isArray(options.fields)
                ? options.fields
                : [options.fields];
            // fields = this.convertCase(fields);
            params['fields'] = JSON.stringify(fields);
        }
        if (!isNullish(options.limit)) {
            params['limit'] = options.limit;
        }
        if (!isNullish(options.offset)) {
            params['offset'] = options.offset;
        }
        if (!isNullish(options.groupBy)) {
            let groupBy = Array.isArray(options.groupBy)
                ? options.groupBy
                : [options.groupBy];
            groupBy = this.convertCase(groupBy);
            params['groupBy'] = JSON.stringify(groupBy);
        }
        if (!isNullish(options.sort)) {
            const sort = Array.isArray(options.sort) ? options.sort : [options.sort];
            // sort = this.convertCase(sort);
            params['sort'] = JSON.stringify(sort);
        }
        if (!isNullish(options.countOnly)) {
            params['countOnly'] = options.countOnly;
        }
        if (!isNullish(options.distinct)) {
            params['distinct'] = options.distinct;
        }
        return params;
    }
    convertCase(value) {
        const propertyNameCase = this._httpService.propertyNameCase || 'snake';
        if (propertyNameCase === 'snake') {
            value = MintCamelizer.decamelizeKeys(value);
        }
        else {
            value = MintCamelizer.camelizeKeys(value);
        }
        return value;
    }
    async count(options = {}) {
        if (!options) {
            options = {};
        }
        options.countOnly = true;
        const result = await this.find(options);
        return result.totalSize;
    }
    async aggregate(options = {}) {
        if (!options) {
            options = {};
        }
        if (!options.fields?.length) {
            throw new Error('Aggregate fields must be specified.');
        }
        if (!options.groupBy?.length) {
            throw new Error('Aggregate groupBy must be specified.');
        }
        const cacheKey = `aggregate|${JSON.stringify(options)}`;
        let result = await this.cache.get(cacheKey);
        if (typeof result !== 'undefined' && result !== null) {
            return result;
        }
        const params = this.toQueryParams(options);
        let urlPath = options.url?.path ?? this.urlPath;
        if (options.url?.params) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, options.url.params);
        }
        result = await this._httpService.get(urlPath, { queryParams: params });
        await this.cache.set(cacheKey, result, { ttl: MINT_DEFAULT_CACHE_TTL });
        return result;
    }
    async find(options = {}) {
        const cacheKey = `find|${JSON.stringify(options)}`;
        let result = await this.cache.get(cacheKey);
        // logger.debug('find: cached result: ', result);
        if (result) {
            return result;
        }
        const params = this.toQueryParams(options);
        let cacheItems = true;
        if (options.cache === false) {
            cacheItems = false;
        }
        let urlPath = options.url?.path ?? this.urlPath;
        if (options.url?.params) {
            // logger.debug('have urlPathVars: ', options.urlPathVars);
            urlPath = MintStringUtil.evalUriTemplate(urlPath, options.url.params);
            // logger.debug('urlPath: ', urlPath);
        }
        result = await this._httpService.get(urlPath, {
            queryParams: params,
        });
        result = this.toResultSet(result, cacheItems);
        await this.cache.set(cacheKey, result, { ttl: MINT_DEFAULT_CACHE_TTL });
        // logger.debug('find: result: ', result);
        return result;
    }
    async findObject(filter, urlPathVars) {
        let item;
        const params = {};
        if (filter) {
            if (Array.isArray(filter)) {
                for (const obj of filter) {
                    params[obj.name] = obj.value;
                }
            }
            else {
                params['filter'] = JSON.stringify(filter);
            }
        }
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        try {
            const tmp = await this._httpService.get(urlPath, {
                queryParams: params,
            });
            item = this.toModel(tmp);
            // logger.debug('findObject: result: ', item);
        }
        catch (err) {
            if (err && err.status && err.status !== 404) {
                throw err;
            }
        }
        return item;
    }
    async findOne(filter, urlPathVars, fields) {
        let item = null;
        const result = await this.find({
            filter: filter,
            fields: fields,
            url: {
                params: urlPathVars,
            },
        });
        if (result.totalSize > 1) {
            throw new MintError(`findOne: expected 0 or 1 result but got [${result.totalSize}] for filter: ${JSON.stringify(filter)}`);
        }
        // if we got a result, capture it
        if (result.totalSize === 1) {
            item = result.data[0];
        }
        return item;
    }
    async findBySlug(slug, urlPathVars, fields) {
        let result = (await this.cache.get(`slug|${slug}:${urlPathVars}`));
        if (!result) {
            result = await this.findOne(MintQueryFilter.from({
                key: 'slug',
                operator: MintQueryOperator.Equals,
                value: slug,
            }), urlPathVars, fields);
        }
        return result;
    }
    async findByUid(uid, urlPathVars, fields) {
        // logger.debug(`findByUid: called uid: ${uid}   urlPathVars: ${urlPathVars}`);
        let obj = (await this.cache.get(`uid|${uid}:${urlPathVars}`));
        if (obj) {
            return new Promise((resolve) => {
                // logger.debug('findByUid: returning cached object: ', obj);
                resolve(obj);
            });
        }
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        const params = this.toQueryParams({ fields });
        try {
            const tmp = await this._httpService.get(urlPath + '/' + uid, {
                queryParams: params,
            });
            obj = this.toModel(tmp);
        }
        catch (err) {
            if (err && err.status && err.status !== 404) {
                throw err;
            }
        }
        return obj;
    }
    async findOneByProperty(name, value, urlPathVars) {
        const cacheKey = this.cacheKey(`findOneByProperty:${name}`, value, urlPathVars);
        let item = await this.cache.get(cacheKey);
        if (!item) {
            item = await this.findOne(MintQueryFilter.from({
                key: name,
                operator: MintQueryOperator.Equals,
                value: value,
            }), urlPathVars);
            await this.cache.set(cacheKey, item, { ttl: MINT_DEFAULT_CACHE_TTL });
        }
        return item;
    }
    async findAllByProperty(name, value, urlPathVars) {
        const cacheKey = this.cacheKey(`findAllByProperty:${name}`, value, urlPathVars);
        let items = await this.cache.get(cacheKey);
        if (!items || !items.length) {
            items = await this.findAll(MintQueryFilter.from({
                key: name,
                operator: MintQueryOperator.Equals,
                value: value,
            }), urlPathVars);
            await this.cache.set(cacheKey, items, { ttl: MINT_DEFAULT_CACHE_TTL });
        }
        return items;
    }
    async create(obj, urlPathVars, params) {
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        params = this.scrubParams(params);
        const _obj = instanceToPlain(obj);
        const tmp = await this._httpService.post(urlPath, _obj, {
            queryParams: params,
        });
        await this.clearCache();
        return this.toModel(tmp);
    }
    async update(obj, urlPathVars, params) {
        if (!obj.uid) {
            throw new MintError('Model uid must be defined');
        }
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        params = this.scrubParams(params);
        urlPath += '/' + obj.uid;
        await this.clearCache();
        const _obj = instanceToPlain(obj);
        const tmp = await this._httpService.patch(urlPath, _obj, {
            queryParams: params,
        });
        return this.toModel(tmp);
    }
    async patch(propertyPath, obj, urlPathVars, params) {
        if (!obj.uid) {
            throw new MintError('Model uid must be defined');
        }
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        params = this.scrubParams(params);
        urlPath += '/' + obj.uid + '/' + propertyPath;
        await this.clearCache();
        const _obj = instanceToPlain(obj);
        const tmp = await this._httpService.patch(urlPath, _obj, {
            queryParams: params,
        });
        return this.toModel(tmp);
    }
    async save(obj, urlPathVars, params) {
        if (obj && obj.uid) {
            return this.update(obj, urlPathVars, params);
        }
        return this.create(obj, urlPathVars, params);
    }
    async removeByUid(uid, urlPathVars, params) {
        const result = await this.findByUid(uid);
        if (!result) {
            throw Error('MintModel not found for uid: ' + uid);
        }
        return this.remove(result, urlPathVars, params);
    }
    async remove(obj, urlPathVars, params) {
        // logger.debug('remove called');
        if (!obj.uid) {
            throw new MintError('Model uid must be defined');
        }
        await this.clearCache();
        params = this.scrubParams(params);
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        const tmp = await this._httpService.delete(urlPath + '/' + obj.uid, obj, { queryParams: params });
        return this.toModel(tmp);
    }
    async softRemove(obj, urlPathVars, params) {
        // logger.debug('remove called');
        if (!obj.uid) {
            throw new MintError('Model uid must be defined');
        }
        await this.clearCache();
        params = this.scrubParams(params);
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        const tmp = await this._httpService.delete(urlPath + '/' + obj.uid + '/soft', obj, { queryParams: params });
        return this.toModel(tmp);
    }
    async restore(obj, urlPathVars, params) {
        // logger.debug('remove called');
        if (!obj.uid) {
            throw new MintError('Model uid must be defined');
        }
        await this.clearCache();
        params = this.scrubParams(params);
        let urlPath = this.urlPath;
        if (urlPathVars) {
            urlPath = MintStringUtil.evalUriTemplate(urlPath, urlPathVars);
        }
        const tmp = await this._httpService.put(urlPath + '/' + obj.uid + '/restore', obj, { queryParams: params });
        return this.toModel(tmp);
    }
    scrubParams(params) {
        const propertyNameCase = this._httpService.propertyNameCase || 'snake';
        if (params) {
            // if the value of a key is undefined, drop it
            for (const key of Object.keys(params)) {
                if (typeof params[key] === 'undefined') {
                    delete params[key];
                }
            }
            if (propertyNameCase === 'snake') {
                params = MintCamelizer.decamelizeKeys(params);
            }
            else {
                params = MintCamelizer.camelizeKeys(params);
            }
        }
        return params;
    }
}

// @dynamic
let MintUserRoleModel = class MintUserRoleModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserRoleModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserRoleModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccessRoleModel)
], MintUserRoleModel.prototype, "role", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserRoleModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserRoleModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserRoleModel.prototype, "_meta", void 0);
MintUserRoleModel = __decorate([
    MintResource('/user-roles')
], MintUserRoleModel);

const logger$20 = MintLogger.getLogger('MintUserRoleService');
class MintUserRoleService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintUserRoleModel, configService.getConfig().api.service?.userRole ??
            MintUserRoleModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByUser(user) {
        const uid = typeof user === 'string' ? user : user.uid;
        return await this.findAll(MintQueryFilter.from({
            key: 'user.uid',
            operator: MintQueryOperator.Equals,
            value: uid,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserRoleService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserRoleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserRoleService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$1$ = MintLogger.getLogger('MintRoleService');
class MintRoleService extends MintRoleProvider {
    constructor(authService, userRoleService) {
        super();
        this.authService = authService;
        this.userRoleService = userRoleService;
    }
    getRole() {
        return this.authService.session$.pipe(map((session) => {
            const role = 'guest';
            // if (session && session.user && session.user.roles) {
            //   role = session.user.roles.map((item) => item.toLowerCase());
            // }
            logger$1$.debug('getRole: role: ', role);
            return role;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoleService, deps: [{ token: MintAuthService }, { token: MintUserRoleService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoleService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintAuthService }, { type: MintUserRoleService }] });

const shallowObjectClone = (o) => Object.assign({}, o);
const shallowArrayClone = (a) => Object.assign([], a);
const popParent = (abilities) => {
    const parent = abilities['parent'];
    delete abilities['parent'];
    return parent;
};
const MINT_ACL_SERVICE_OPTIONS = new InjectionToken('MINT_ACL_SERVICE_OPTIONS');
/**
 * Common acl service.
 */
class MintAclService {
    static { this.ANY_RESOURCE = '*'; }
    constructor(settings = {}) {
        this.settings = settings;
        this.state = {};
        if (settings.accessControl) {
            this.setAccessControl(settings.accessControl);
        }
    }
    /**
     * Set/Reset ACL list
     */
    setAccessControl(list) {
        for (const [role, value] of Object.entries(list)) {
            const abilities = shallowObjectClone(value);
            const parent = popParent(abilities);
            this.register(role, parent, abilities);
        }
    }
    /**
     * Register a new role with a list of abilities (permission/resources combinations)
     */
    register(role, parent = null, abilities = {}) {
        this.validateRole(role);
        this.state[role] = {
            parent: parent,
        };
        for (const [permission, value] of Object.entries(abilities)) {
            const resources = typeof value === 'string' ? [value] : value;
            this.allow(role, permission, shallowArrayClone(resources));
        }
    }
    /**
     * Allow a permission for specific resources to a role
     */
    allow(role, permission, resource) {
        this.validateRole(role);
        if (!this.getRole(role)) {
            this.register(role, null, {});
        }
        resource = typeof resource === 'string' ? [resource] : resource;
        let resources = shallowArrayClone(this.getRoleResources(role, permission));
        resources = resources.concat(resource);
        this.state[role][permission] = resources.filter((item, pos) => resources.indexOf(item) === pos);
    }
    /**
     * Check whether the role has a permission to a resource
     */
    can(role, permission, resource) {
        this.validateResource(resource);
        const parentRole = this.getRoleParent(role);
        const parentCan = parentRole && this.can(this.getRoleParent(role), permission, resource);
        return parentCan || this.exactCan(role, permission, resource);
    }
    getRole(role) {
        return this.state[role];
    }
    validateRole(role) {
        if (!role) {
            throw new Error('MintAclService: role name cannot be empty');
        }
    }
    validateResource(resource) {
        if (!resource || [MintAclService.ANY_RESOURCE].includes(resource)) {
            throw new Error(`AclService: cannot use empty or bulk '*' resource placeholder with 'can' method`);
        }
    }
    exactCan(role, permission, resource) {
        const resources = this.getRoleResources(role, permission);
        return (resources.includes(resource) ||
            resources.includes(MintAclService.ANY_RESOURCE));
    }
    getRoleResources(role, permission) {
        return this.getRoleAbilities(role)[permission] || [];
    }
    getRoleAbilities(role) {
        const abilities = shallowObjectClone(this.state[role] || {});
        popParent(shallowObjectClone(this.state[role] || {}));
        return abilities;
    }
    getRoleParent(role) {
        return this.state[role] ? this.state[role]['parent'] : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclService, deps: [{ token: MINT_ACL_SERVICE_OPTIONS, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MINT_ACL_SERVICE_OPTIONS]
                }] }] });

/**
 * Access checker service.
 *
 * Injects `MintRoleProvider` to determine current user role, and checks access permissions using `MintAclService`
 */
class MintAclAccessChecker {
    constructor(roleService, acl) {
        this.roleService = roleService;
        this.acl = acl;
    }
    /**
     * Checks whether access is granted or not
     */
    isGranted(permission, resource) {
        return this.roleService.getRole().pipe(map((role) => (Array.isArray(role) ? role : [role])), map((roles) => {
            return roles.some((role) => this.acl.can(role, permission, resource));
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclAccessChecker, deps: [{ token: MintRoleService }, { token: MintAclService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclAccessChecker, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclAccessChecker, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintRoleService }, { type: MintAclService }] });

// tslint:disable-next-line:directive-selector
class MintAclDirective {
    constructor(templateRef, viewContainer, accessChecker) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.accessChecker = accessChecker;
        this.alive = true;
        this.hasView = false;
    }
    set acl([permission, resource]) {
        this.accessChecker
            .isGranted(permission, resource)
            .pipe(takeWhile(() => this.alive))
            .subscribe((can) => {
            if (can && !this.hasView) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasView = true;
            }
            else if (!can && this.hasView) {
                this.viewContainer.clear();
                this.hasView = false;
            }
        });
    }
    ngOnDestroy() {
        this.alive = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: MintAclAccessChecker }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.0.8", type: MintAclDirective, selector: "[acl]", inputs: { acl: "acl" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAclDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[acl]' }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: MintAclAccessChecker }], propDecorators: { acl: [{
                type: Input
            }] } });

const logger$1_ = MintLogger.getLogger('MintUserGuard');
class MintUserGuard {
    constructor(authService, configService, router) {
        this.authService = authService;
        this.configService = configService;
        this.router = router;
    }
    async canActivate(route, state) {
        const parts = mintParseUrl(state.url);
        let query = parts.query;
        // account for url that contains as hash fragment
        if (!parts.query && parts.fragment) {
            const fragmentParts = mintParseUrl(parts.fragment);
            if (fragmentParts) {
                query = fragmentParts.query;
            }
        }
        let authenticated;
        // check first if we're logging in using a predefined token (loginAsUser)
        if (query && query['_t'] && query['_u']) {
            const tokenUid = query['_t'];
            const requestingUserUid = query['_u'];
            const session = await this.authService.newSessionByTokenUid(tokenUid, requestingUserUid);
            authenticated = await this.authService.authenticated();
            logger$1_.debug('canActivate: session: ', session, '\nauthenticated: ', authenticated);
        }
        else {
            // if not, then check if we're already authenticated
            authenticated = await this.authService.authenticated();
        }
        if (!authenticated) {
            const config = this.configService.getConfig();
            let loginRoute = config.components?.auth?.login?.route ?? 'auth/login';
            // if the loginRoute includes parameters then ASSUME they
            // map to the redirect URL positionally
            loginRoute = MintUrlUtil.evalPathParams(loginRoute, state.url);
            await this.router.navigate([loginRoute], {
                queryParams: {
                    redirect: state.url,
                },
            });
        }
        return authenticated;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserGuard, deps: [{ token: MintAuthService }, { token: MintConfigService }, { token: i4$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintAuthService }, { type: MintConfigService }, { type: i4$1.Router }] });

const logger$1Z = MintLogger.getLogger('MintMediaUtil');
// @dynamic
class MintMediaUtil {
    static { this.FORMAT_MIME_MAP = {
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        png: 'image/png',
        bmp: 'image/bmp',
        pcx: 'image/pcx',
        tiff: 'image/tiff',
        ras: 'image/ras',
        pbm: 'image/x-portable-bitmap',
        pgm: 'image/x-portable-graymap',
        ppm: 'image/x-portable-pixmap',
        psd: 'image/psd',
        swf: 'image/x-xcf',
        svg: 'image/svg+xml',
    }; }
    static { this.IMAGE_MIME_TYPES = [
        'image/jpeg',
        'image/pjpeg',
        'image/gif',
        'image/png',
        'image/bmp',
        'image/pcx',
        'image/tiff',
        'image/ras',
        'image/x-portable-bitmap',
        'image/x-portable-graymap',
        'image/x-portable-pixmap',
        'image/psd',
        'image/x-xcf',
        'image/svg+xml',
    ]; }
    static { this.AUDIO_MIME_TYPES = [
        'audio/amr',
        'audio/3gpp',
        'audio/3gpp2',
        'audio/basic',
        'audio/L24',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/vorbis',
        'audio/vnd.rn-realaudio',
        'audio/vnd.wav',
        'audio/wav',
        'audio/x-wav',
        'audio/webm',
        'audio/x-aac',
        'audio/x-caf',
    ]; }
    static { this.VIDEO_MIME_TYPES = [
        'video/mpeg',
        'video/mp4',
        'video/ogg',
        'video/quicktime',
        'video/webm',
        'video/x-matroska',
        'application/x-matroska',
        'video/x-ms-wmv',
        'video/x-flv',
    ]; }
    static { this.DOCUMENT_MIME_TYPES = [
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.presentation',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-xpsdocument',
        'application/pdf',
        'application/postscript',
        'application/x-latex',
        'text/css',
        'text/safe-html',
        'text/plain',
        'text/xml',
        'text/vcard',
        'text/x-vcard',
        'application/javascript',
        'application/json',
    ]; }
    static { this.ARCHIVE_MIME_TYPES = [
        'application/x-7z-compressed',
        'application/x-rar-compressed',
        'application/x-tar',
        'application/zip',
        'application/gzip',
    ]; }
    static isArchive(contentType) {
        for (const s of MintMediaUtil.ARCHIVE_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isAudio(contentType) {
        for (const s of MintMediaUtil.AUDIO_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isDocument(contentType) {
        for (const s of MintMediaUtil.DOCUMENT_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isImage(contentType) {
        for (const s of MintMediaUtil.IMAGE_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isVideo(contentType) {
        for (const s of MintMediaUtil.VIDEO_MIME_TYPES) {
            if (contentType.toLowerCase() === s.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    static isMedia(contentType) {
        return (MintMediaUtil.isAudio(contentType) ||
            MintMediaUtil.isVideo(contentType) ||
            MintMediaUtil.isImage(contentType));
    }
    // static getMediaType(buffer: Buffer): MintMediaUtil {
    //   logger.debug('getMediaType: buffer: ', buffer);
    //   const result = fileType(buffer);
    //
    //   logger.debug('getMediaType: result: ', result);
    //
    //   return result
    //     ? {
    //         extension: result.ext,
    //         contentType: result.mime,
    //       }
    //     : null;
    // }
    static getMediaTypeByFormat(format, isProgressive = false) {
        // if (format === 'jpeg' && isProgressive) {
        //   return 'image/pjpeg';
        // }
        return MintMediaUtil.FORMAT_MIME_MAP[format];
    }
    static getExtension(contentType) {
        if (!contentType) {
            return null;
        }
        switch (contentType.toLowerCase()) {
            // images
            case 'image/jpeg':
            case 'image/pjpeg':
                return 'jpg';
            case 'image/gif':
                return 'gif';
            case 'image/png':
                return 'png';
            case 'image/bmp':
                return 'bmp';
            case 'image/pcx':
                return 'pcx';
            case 'image/tiff':
                return 'tif';
            case 'image/ras':
                return 'ras';
            case 'image/x-portable-bitmap':
            case 'image/x-portable-graymap':
            case 'image/x-portable-pixmap':
                return 'pbm';
            case 'image/psd':
                return 'pbm';
            case 'image/x-xcf':
                return 'xcf';
            // images
            case 'video/mpeg':
                return 'mpeg';
            case 'video/mp4':
                return 'mp4';
            case 'video/ogg':
                return 'ogg';
            case 'video/quicktime':
                return 'mov';
            case 'video/webm':
            case 'video/x-matroska':
            case 'application/x-matroska':
                return 'webm';
            case 'video/x-ms-wmv':
                return 'wmv';
            case 'video/x-flv':
                return 'flv';
            // images
            case 'audio/amr':
                return 'amr';
            case 'audio/3gpp':
            case 'audio/3gpp2':
                return '3gpp';
            case 'audio/basic':
                return 'basic';
            case 'audio/L24':
                return 'l24';
            case 'audio/mp4':
                return 'mp4';
            case 'audio/mpeg':
                return 'mpeg';
            case 'audio/ogg':
                return 'ogg';
            case 'audio/vorbis':
                return 'vorbis';
            case 'audio/vnd.rn-realaudio':
                return 'ra';
            case 'audio/vnd.wav':
            case 'audio/wav':
            case 'audio/x-wav':
                return 'wav';
            case 'audio/webm':
                return 'webm';
            case 'audio/x-aac':
                return 'aac';
            case 'audio/x-caf':
                return 'caf';
            // documents
            case 'text/plain':
                return 'txt';
            case 'text/safe-html':
                return 'html';
            case 'application/pdf':
                return 'pdf';
            case 'text/vcard':
            case 'text/x-vcard':
                return 'vcf';
            case 'text/calendar':
                return 'ics';
            case 'text/vcalendar':
            case 'text/x-vcalendar':
                return 'vcs';
            case 'text/rtf':
            case 'application/rtf':
                return 'rtf';
            case 'text/richtext':
                return 'rtx';
            case 'application/json':
                return 'json';
            case 'application/javascript':
                return 'js';
            case 'text/css':
                return 'css';
            default:
                return null;
        }
    }
    static getImageDimensions(blob) {
        return new Promise((resolve) => {
            const img = new Image(); // create image
            img.src = window.URL.createObjectURL(blob);
            img.onload = () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                window.URL.revokeObjectURL(img.src);
                resolve({
                    width: width,
                    height: height,
                });
            };
        });
    }
}

// TODO: create handler arrays for each of the event handler functions
// so multiple handlers can be executed for each event.
// e.g. onUploadSuccessHandlers[]
// for (const handler of onUploadSuccessHandlers) {
//  handler();
// }
class MintUpload {
    constructor(model) {
        this.uploadType = 'select';
        this.uploadListType = 'picture-card';
        this.dragUploadTypeText = 'Click or drag to upload.';
        this.multiple = false; // allow multiple files to be selected in file dialog
        this.multipleLimit = 1; // number of files that can be selected when multiple is enabled
        this.maxUploadCount = 1; // max number of allowed uploaded files
        // filter?: UploadFilter[];
        this.showUploadList = {
            showPreviewIcon: true,
            showRemoveIcon: true,
            hidePreviewIconInNonImage: true,
        };
        // NOTE: to trigger change detection make sure to set fileList to a new array
        // this.fileList = [...this.fileList, newItem]
        this.fileList = [];
        this.disabled = false;
        this.visible = true;
        this.includeContentTypes = [];
        this.excludeContentTypes = [];
        this.media = [];
        if (model) {
            Object.assign(this, model);
        }
        if (typeof this.valid !== 'function') {
            let _dimensions;
            const dimensions = async (file) => {
                if (!_dimensions) {
                    _dimensions = await MintMediaUtil.getImageDimensions(file.originFileObj);
                }
                return _dimensions;
            };
            this.valid = async (file) => {
                if (this.minWidth) {
                    const dims = await dimensions(file);
                    if (this.minWidth && dims.width < this.minWidth) {
                        return false;
                    }
                }
                if (this.minHeight) {
                    const dims = await dimensions(file);
                    if (this.minHeight && dims.height < this.minHeight) {
                        return false;
                    }
                }
                if (this.maxWidth) {
                    const dims = await dimensions(file);
                    if (this.maxWidth && dims.width > this.maxWidth) {
                        return false;
                    }
                }
                if (this.maxHeight) {
                    const dims = await dimensions(file);
                    if (this.maxHeight && dims.height > this.maxHeight) {
                        return false;
                    }
                }
                if (this.maxSize && file.size > this.maxSize) {
                    return false;
                }
                if (this.includeContentTypes.length &&
                    !this.includeContentTypes.includes(file.type)) {
                    return false;
                }
                if (this.excludeContentTypes.length &&
                    this.excludeContentTypes.includes(file.type)) {
                    return false;
                }
                return true;
            };
        }
    }
    async checkImageDimensions(uploadedFile) {
        const dimensions = await MintMediaUtil.getImageDimensions(uploadedFile);
        return true;
    }
}

// export class MintUserAuthStatusDto {
//   readonly type: MintUserType;
//   readonly enabled: boolean;
//   readonly locked: boolean;
//   readonly passwordExists: boolean;
//   readonly mfaEnabled: boolean;
//   readonly email: MintVerificationStatus;
//   readonly mobile: MintVerificationStatus;
//
//   constructor(model?: Partial<MintUserAuthStatusDto>) {
//     if (model) {
//       Object.assign(this, model);
//     }
//   }
// }
class MintUserAuthStatus {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintUserAuthStatus, model));
        }
    }
}
__decorate([
    Expose(),
    IsObject()
], MintUserAuthStatus.prototype, "user", void 0);
__decorate([
    Expose(),
    IsArray()
], MintUserAuthStatus.prototype, "devices", void 0);
__decorate([
    Expose(),
    IsObject()
], MintUserAuthStatus.prototype, "mfa", void 0);
__decorate([
    Expose(),
    IsObject()
], MintUserAuthStatus.prototype, "email", void 0);
__decorate([
    Expose(),
    IsObject()
], MintUserAuthStatus.prototype, "mobileNumber", void 0);
__decorate([
    Expose(),
    IsObject()
], MintUserAuthStatus.prototype, "password", void 0);

const logger$1Y = MintLogger.getLogger('MintMediaService');
class MintMediaService {
    constructor(httpService, domSanitizer) {
        this.httpService = httpService;
        this.domSanitizer = domSanitizer;
    }
    async fetchAsDataUrl(url) {
        if (!url) {
            return null;
        }
        logger$1Y.debug('fetchAsDataUrl: fetching url: ', url);
        const blob = await this.httpService.getBlob(url);
        logger$1Y.debug('fetchAsDataUrl: fetched blob: ', blob);
        if (!blob) {
            return null;
        }
        const dataUrl = window.URL.createObjectURL(blob);
        return this.domSanitizer.bypassSecurityTrustUrl(dataUrl);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMediaService, deps: [{ token: MintHttpService }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMediaService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMediaService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: i1$2.DomSanitizer }] });

const logger$1X = MintLogger.getLogger('MintAccountService');
class MintAccountService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintAccountModel, configService.getConfig().api.service?.account ??
            MintAccountModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccountService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccountService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccountService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

const logger$1W = MintLogger.getLogger('MintUserService');
class MintUserService extends MintService {
    constructor(httpService, cacheService, domSanitizer, mediaService, configService, userRoleService, authService, accountService) {
        super(httpService, cacheService, MintUserModel, configService.getConfig().api.service?.user ??
            MintUserModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.domSanitizer = domSanitizer;
        this.mediaService = mediaService;
        this.configService = configService;
        this.userRoleService = userRoleService;
        this.authService = authService;
        this.accountService = accountService;
    }
    async updateSessionUser(user) {
        const me = await this.authService.me();
        if (me.uid === user?.uid) {
            await this.authService.updateSessionUser(user);
        }
    }
    async registerUser(user, registrationOptions) {
        const params = registrationOptions
            ? {
                registration: registrationOptions,
            }
            : undefined;
        return await this.save(user, null, params);
    }
    async refreshUser(user) {
        await this.clearCache();
        user = await this.findByUid(user.uid);
        await this.updateSessionUser(user);
        return user;
    }
    async findByEmail(email) {
        return this.findOneByProperty('email', email);
    }
    async getPhoto(user) {
        const urlPath = `${this.urlPath}/${user.uid}/photo`;
        return await this.mediaService.fetchAsDataUrl(urlPath);
    }
    addPhoto(user) {
        const urlPath = `${this.urlPath}/${user.uid}/photo`;
        return new MintUpload({
            urlPath: urlPath,
            onUploadSuccess: async (media, file) => {
                logger$1W.debug('onUploadSuccess: media: ', media, '\n\nfile: ', file);
                await this.clearCache();
                user = this.toModel(media.context?.['user']);
                await this.updateSessionUser(user);
            },
        });
    }
    async removePhoto(user) {
        await this.clearCache();
        const urlPath = `${this.urlPath}/${user.uid}/photo`;
        const tmp = await this.httpService.delete(urlPath);
        user = this.toModel(tmp);
        await this.updateSessionUser(user);
        return user;
    }
    async save(user, urlPathVars, params) {
        user = await super.save(user, urlPathVars, params);
        await this.updateSessionUser(user);
        return user;
    }
    async updatePassword(user, password) {
        const urlPath = `${this.urlPath}/${user.uid}/password`;
        const data = {
            newPassword: password,
        };
        try {
            return await this.httpService.patch(urlPath, data);
        }
        catch (err) {
            logger$1W.debug('updatePassword: error: ', err);
            if (err?.status === 401) {
                throw new MintAuthException('Current password is invalid', MintAuthErrorType.InvalidPassword, err);
            }
            throw new MintAuthException('Error updating password', MintAuthErrorType.InternalError, err);
        }
    }
    async updateEmail(user, email, tokenUid) {
        await this.clearCache();
        const data = {
            email: email,
        };
        let urlPath = `${this.urlPath}/${user.uid}/email`;
        if (tokenUid) {
            urlPath = urlPath + '?_t=' + encodeURIComponent(tokenUid);
        }
        user = await this.httpService.patch(urlPath, data);
        user = this.toModel(user);
        await this.updateSessionUser(user);
        return user;
    }
    async updateEmailVerified(user, email, status, tokenUid) {
        await this.clearCache();
        const data = new MintUserEmailVerifiedDto({
            email: email,
            status: status,
        });
        let urlPath = `${this.urlPath}/${user.uid}/email/verified`;
        if (tokenUid) {
            urlPath = urlPath + '?_t=' + encodeURIComponent(tokenUid);
        }
        user = await this.httpService.patch(urlPath, data);
        user = this.toModel(user);
        await this.updateSessionUser(user);
        return user;
    }
    async updateUsername(user, username, tokenUid) {
        await this.clearCache();
        const data = {
            username: username,
        };
        let urlPath = `${this.urlPath}/${user.uid}/username`;
        if (tokenUid) {
            urlPath = urlPath + '?_t=' + encodeURIComponent(tokenUid);
        }
        user = await this.httpService.patch(urlPath, data);
        user = this.toModel(user);
        await this.updateSessionUser(user);
        return user;
    }
    async updateMobileNumber(user, mobileNumber, tokenUid) {
        await this.clearCache();
        const data = {
            mobileNumber: mobileNumber,
        };
        let urlPath = `${this.urlPath}/${user.uid}/mobile-number`;
        if (tokenUid) {
            urlPath = urlPath + '?_t=' + encodeURIComponent(tokenUid);
        }
        user = await this.httpService.patch(urlPath, data);
        user = this.toModel(user);
        await this.updateSessionUser(user);
        return user;
    }
    async updateMobileNumberVerified(user, mobileNumber, status, tokenUid) {
        await this.clearCache();
        const data = new MintUserMobileNumberVerifiedDto({
            mobileNumber: mobileNumber,
            status: status,
        });
        let urlPath = `${this.urlPath}/${user.uid}/mobile-number/verified`;
        if (tokenUid) {
            urlPath = urlPath + '?_t=' + encodeURIComponent(tokenUid);
        }
        user = await this.httpService.patch(urlPath, data);
        user = this.toModel(user);
        await this.updateSessionUser(user);
        return user;
    }
    async getMobileVerificationStatus() {
        try {
            const urlPath = this.urlPath + '/mobile-verification-status';
            return this.httpService.get(urlPath);
        }
        catch (err) {
            logger$1W.debug('getMobileVerificationStatus: error: ', err);
            throw new MintAuthException('Error fetching user mobile verification status', MintAuthErrorType.InternalError, err);
        }
    }
    async getAccounts(user) {
        const urlPath = `${this.urlPath}/${user.uid}/accounts`;
        try {
            const result = await this.httpService.get(urlPath);
            return result.map((item) => {
                return {
                    ...item,
                    account: this.accountService.toModel(item.account),
                };
            });
        }
        catch (err) {
            logger$1W.debug('getAccounts: error: ', err);
            throw new MintAuthException('Error fetching user accounts', MintAuthErrorType.InternalError, err);
        }
    }
    async getDefaultAccount(user) {
        const userAccounts = await this.getAccounts(user);
        return userAccounts.find((item) => item.isDefault)?.account;
    }
    async getAuthStatus(user) {
        const urlPath = `${this.urlPath}/${user.uid}/auth-status`;
        try {
            const result = await this.httpService.get(urlPath);
            return plainToInstance(MintUserAuthStatus, result);
        }
        catch (err) {
            logger$1W.debug('getAuthStatus: error: ', err);
            throw new MintAuthException('Error fetching user auth status', MintAuthErrorType.InternalError, err);
        }
    }
    async hasRole(user, role) {
        const roles = await this.userRoleService.findByUser(user);
        const _roles = roles.map((item) => item.role.slug);
        if (!user || !roles.length || !role) {
            return false;
        }
        for (const r of _roles) {
            if (r.toLowerCase() === role.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    async getSettings(user, account) {
        let urlPath = `${this.urlPath}/${user.uid}/settings`;
        if (account) {
            const accountUid = typeof account === 'string' ? account : account.uid;
            urlPath += `?account=${accountUid}`;
        }
        try {
            return await this.httpService.get(urlPath);
        }
        catch (err) {
            logger$1W.debug('getSettings: error: ', err);
            throw new MintAuthException('Error fetching user settings', MintAuthErrorType.InternalError, err);
        }
    }
    async updateSettings(user, account, settings) {
        let urlPath = `${this.urlPath}/${user.uid}/settings`;
        if (account) {
            const accountUid = typeof account === 'string' ? account : account.uid;
            urlPath += `?account=${accountUid}`;
        }
        try {
            return await this.httpService.patch(urlPath, settings);
        }
        catch (err) {
            logger$1W.debug('updateSettings: error: ', err);
            throw new MintAuthException('Error updating user settings', MintAuthErrorType.InternalError, err);
        }
    }
    async updateMfaSettings(user, account, mfaRequest) {
        let urlPath = `${this.urlPath}/${user.uid}/settings/mfa`;
        if (account) {
            const accountUid = typeof account === 'string' ? account : account.uid;
            urlPath += `?account=${accountUid}`;
        }
        try {
            return await this.httpService.patch(urlPath, mfaRequest);
        }
        catch (err) {
            logger$1W.debug('updateMfaSettings: error: ', err);
            throw new MintAuthException('Error updating user MFA settings', MintAuthErrorType.InternalError, err);
        }
    }
    async setUserLocked(user, locked, devices) {
        await this.clearCache();
        const data = new MintUserLockedStatusDto({
            locked,
            devices,
        });
        let urlPath = `${this.urlPath}/${user.uid}/locked-status`;
        user = await this.httpService.patch(urlPath, data);
        user = this.toModel(user);
        await this.updateSessionUser(user);
        return user;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: i1$2.DomSanitizer }, { token: MintMediaService }, { token: MintConfigService }, { token: MintUserRoleService }, { token: MintAuthService }, { token: MintAccountService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: i1$2.DomSanitizer }, { type: MintMediaService }, { type: MintConfigService }, { type: MintUserRoleService }, { type: MintAuthService }, { type: MintAccountService }] });

const logger$1V = MintLogger.getLogger('MintAdminGuard');
class MintAdminGuard {
    constructor(authService, userService, configService, router) {
        this.authService = authService;
        this.userService = userService;
        this.configService = configService;
        this.router = router;
    }
    async canActivate(route, state) {
        const user = await this.authService.me();
        let canAccess = false;
        logger$1V.debug('canActivate: user: ', user);
        if (user) {
            canAccess = await this.userService.hasRole(user, 'admin');
        }
        if (!canAccess) {
            const config = this.configService.getConfig().components;
            const forbiddenRoute = config?.error?.forbidden?.route ?? 'error/forbidden';
            await this.router.navigate([forbiddenRoute]);
        }
        return canAccess;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAdminGuard, deps: [{ token: MintAuthService }, { token: MintUserService }, { token: MintConfigService }, { token: i4$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAdminGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAdminGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintAuthService }, { type: MintUserService }, { type: MintConfigService }, { type: i4$1.Router }] });

class MintQueryField {
    constructor(value) {
        if (value) {
            Object.assign(this, plainToInstance(MintQueryField, value));
        }
    }
    static from(value) {
        const _value = MintJsonUtil.parse(value);
        return new MintQueryField(_value);
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintQueryField.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintQueryField.prototype, "alias", void 0);
__decorate([
    IsOptional(),
    IsEnum(MintQueryAggregate)
], MintQueryField.prototype, "aggregate", void 0);

var MintQuerySortOrder;
(function (MintQuerySortOrder) {
    MintQuerySortOrder["Asc"] = "ASC";
    MintQuerySortOrder["Desc"] = "DESC";
})(MintQuerySortOrder || (MintQuerySortOrder = {}));
class MintQuerySort {
    constructor(value) {
        if (value) {
            Object.assign(this, plainToInstance(MintQueryField, value));
        }
    }
    static from(value) {
        const _value = MintJsonUtil.parse(value);
        if (Array.isArray(_value)) {
            const results = [];
            for (const item of _value) {
                results.push(new MintQuerySort(item));
            }
            return results;
        }
        return new MintQuerySort(_value);
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintQuerySort.prototype, "field", void 0);
__decorate([
    IsEnum(MintQuerySortOrder),
    IsOptional()
], MintQuerySort.prototype, "order", void 0);

const logger$1U = MintLogger.getLogger('MintQueryOptions');
class MintQueryOptions {
    constructor(options) {
        if (options) {
            Object.assign(this, plainToInstance(MintQueryOptions, options));
        }
    }
    static from(value) {
        const _value = MintJsonUtil.parse(value);
        return new MintQueryOptions(_value);
    }
    toString() {
        return JSON.stringify(instanceToPlain(this), null, '  ');
    }
}
__decorate([
    IsOptional(),
    IsObject(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
], MintQueryOptions.prototype, "url", void 0);
__decorate([
    IsOptional()
], MintQueryOptions.prototype, "tokenUid", void 0);
__decorate([
    IsOptional(),
    Transform(({ value }) => (value ? MintQueryFilter.from(value) : null))
], MintQueryOptions.prototype, "filter", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Transform(({ value }) => value
        ? MintJsonUtil.parse(value).map((v) => MintQueryField.from(v))
        : null)
], MintQueryOptions.prototype, "fields", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
], MintQueryOptions.prototype, "groupBy", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
], MintQueryOptions.prototype, "limit", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
], MintQueryOptions.prototype, "offset", void 0);
__decorate([
    IsOptional(),
    Transform(({ value }) => (value ? MintQuerySort.from(value) : null))
    // NOTE: sorting must be done on Entity fields.  Nested model
    // fields cannot be sorted unless join relations are established.
], MintQueryOptions.prototype, "sort", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
], MintQueryOptions.prototype, "distinct", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
], MintQueryOptions.prototype, "countOnly", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
], MintQueryOptions.prototype, "cache", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Transform(({ value }) => (value ? MintJsonUtil.parse(value) : null))
    // arbitrary user-defined data to be passed along to the controller
], MintQueryOptions.prototype, "context", void 0);

const logger$1T = MintLogger.getLogger('MintQueryUtil');
class MintQueryUtil {
    static isQueryOptions(query) {
        // return false for an empty object
        if (!Object.keys(query).length) {
            return false;
        }
        const fields = [
            'filter',
            'fields',
            'groupBy',
            'limit',
            'offset',
            'sort',
            'distinct',
            'countOnly',
            'cache',
            'context',
        ];
        for (const field of fields) {
            if (typeof query[field] === 'undefined' ||
                typeof query[field] === 'string') {
                return false;
            }
        }
        return query instanceof MintQueryOptions;
    }
    /**
     * Merge query rules into a new object and return it.
     * If a query condition key already exists, it will be overwritten
     * with the last definition of that query condition.
     * @param conditions one or more query rules that will be merged into a new object
     * @return MintQueryCondition
     */
    static mergeConditions(...conditions) {
        const result = new MintQueryCondition();
        for (const condition of conditions) {
            for (const expression of condition) {
                const found = result.find((item) => item.key === expression.key);
                if (!found) {
                    result.addExpression(expression);
                }
            }
        }
        return result;
    }
}

const logger$1S = MintLogger.getLogger('MintHttpException');
// https://github.com/nestjs/nest/blob/master/packages/common/exceptions/http.exception.ts
class MintHttpException extends Error {
    /**
     * Instantiate a plain HTTP Exception.
     *
     * @example
     * `throw new HttpException()`
     *
     * @usageNotes
     * The constructor arguments define the response and the HTTP response status code.
     * - The `response` argument (required) defines the JSON response body.
     * - The `status` argument (required) defines the HTTP Status Code.
     *
     * By default, the JSON response body contains two properties:
     * - `statusCode`: the Http Status Code.
     * - `message`: a short description of the HTTP error by default; override this
     * by supplying a string in the `response` parameter.
     *
     * To override the entire JSON response body, pass an object to the `createBody`
     * method. Nest will serialize the object and return it as the JSON response body.
     *
     * The `status` argument is required, and should be a valid HTTP status code.
     * Best practice is to use the `HttpStatus` enum imported from `nestjs/common`.
     *
     * @param response string or object describing the error condition.
     * @param status HTTP response status code.
     */
    constructor(response, status) {
        super();
        this.response = response;
        this.status = status;
        this.initMessage();
        this.initName();
    }
    static createBody(objectOrError, description, statusCode) {
        if (!objectOrError) {
            return { statusCode, message: description };
        }
        return isObject(objectOrError) && !Array.isArray(objectOrError)
            ? objectOrError
            : { statusCode, message: objectOrError, error: description };
    }
    initMessage() {
        if (isString(this.response)) {
            this.message = this.response;
        }
        else if (isObject(this.response) &&
            isString(this.response['message'])) {
            this.message = this.response['message'];
        }
        else if (this.constructor) {
            this.message = this.constructor.name
                .match(/[A-Z][a-z]+|[0-9]+/g)
                .join(' ');
        }
    }
    initName() {
        this.name = this.constructor.name;
    }
    getResponse() {
        return this.response;
    }
    getStatus() {
        return this.status;
    }
}

const logger$1R = MintLogger.getLogger('MintModel');
// export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const mintIntegerModelTransformer = (args) => {
    const { type, value } = args;
    switch (type) {
        case TransformationType.CLASS_TO_CLASS:
            return value;
        case TransformationType.CLASS_TO_PLAIN:
            return isNullish(value) ? null : value.toString();
        case TransformationType.PLAIN_TO_CLASS:
            return isNullish(value) ? null : MintTypeUtil.parseInteger(value);
    }
};
const mintFloatModelTransformer = (args) => {
    const { type, value } = args;
    switch (type) {
        case TransformationType.CLASS_TO_CLASS:
            return value;
        case TransformationType.CLASS_TO_PLAIN:
            return isNullish(value) ? null : value.toString();
        case TransformationType.PLAIN_TO_CLASS:
            return isNullish(value) ? null : MintTypeUtil.parseFloat(value);
    }
};
const mintBigNumberModelTransformer = (args) => {
    const { type, value } = args;
    switch (type) {
        case TransformationType.CLASS_TO_CLASS:
            return value;
        case TransformationType.CLASS_TO_PLAIN:
            return isNullish(value) ||
                (value.isNaN && typeof value.isNaN === 'function' && value.isNaN())
                ? null
                : value.toString();
        case TransformationType.PLAIN_TO_CLASS:
            return isNullish(value)
                ? null
                : typeof value === 'object'
                    ? new BigNumber({ ...value, _isBigNumber: true })
                    : new BigNumber(value);
    }
};
const mintBigIntModelTransformer = (args) => {
    const { type, value } = args;
    switch (type) {
        case TransformationType.CLASS_TO_CLASS:
            return value;
        case TransformationType.CLASS_TO_PLAIN:
            return isNullish(value) ||
                (value.isNaN && typeof value.isNaN === 'function' && value.isNaN())
                ? null
                : value.toString();
        case TransformationType.PLAIN_TO_CLASS:
            return isNullish(value) ? null : BigInt(value);
    }
};

class MintSafeResourceUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        // return this.sanitizer.bypassSecurityTrustHtml(style);
        // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSafeResourceUrlPipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintSafeResourceUrlPipe, name: "mintSafeResourceUrl" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSafeResourceUrlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintSafeResourceUrl' }]
        }], ctorParameters: () => [{ type: i1$2.DomSanitizer }] });

/**
 * An extension of Angular CurrencyPipe to handle BigNumber values.
 */
class MintCurrencyPipe {
    constructor(locale) {
        this.locale = locale;
        this._currencyPipe = new CurrencyPipe(locale);
    }
    transform(value, currencyCode, display, digitsInfo, locale) {
        const _value = BigNumber.isBigNumber(value) ? value.toString() : value;
        return this._currencyPipe.transform(_value, currencyCode, display, digitsInfo, locale);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCurrencyPipe, deps: [{ token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintCurrencyPipe, name: "mintCurrency" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintCurrency' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }] });

class MintSafeUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        // return this.sanitizer.bypassSecurityTrustHtml(style);
        // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSafeUrlPipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintSafeUrlPipe, name: "mintSafeUrl" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSafeUrlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintSafeUrl' }]
        }], ctorParameters: () => [{ type: i1$2.DomSanitizer }] });

class MintTimingPipe {
    transform(time) {
        if (time) {
            const minutes = Math.floor(time / 60);
            const seconds = Math.floor(time % 60);
            return `${this.initZero(minutes)}${minutes}:${this.initZero(seconds)}${seconds}`;
        }
        return '00:00';
    }
    initZero(time) {
        return time < 10 ? '0' : '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintTimingPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintTimingPipe, name: "mintTiming" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintTimingPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintTiming' }]
        }] });

class MintCapitalizePipe {
    transform(input) {
        return input && input.length
            ? input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()
            : input;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCapitalizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintCapitalizePipe, name: "mintCapitalize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCapitalizePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintCapitalize' }]
        }] });

class MintSafeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(html) {
        // return this.sanitizer.bypassSecurityTrustHtml(style);
        // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSafeHtmlPipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintSafeHtmlPipe, name: "mintSafeHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSafeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintSafeHtml' }]
        }], ctorParameters: () => [{ type: i1$2.DomSanitizer }] });

/*
 * Format a phone number.
 * Takes a countryCode argument that defaults to 'US' and format argument
 * that defaults to 'NATIONAL'.
 * Possible formats are: NATIONAL | INTERNATIONAL | E.164
 *
 * Usage:
 *   value | phoneFormat:countryCode:format
 *
 * Example:
 *   {{ 212-555-1212 | phoneFormat:'US':'NATIONAL' }}
 *   formats to: (212) 555-1212
 */
class MintPhoneFormatPipe {
    constructor(phoneNumberService) {
        this.phoneNumberService = phoneNumberService;
    }
    transform(phoneValue, countryCode, format, mask = false) {
        if (!countryCode) {
            countryCode = 'US';
        }
        if (!format) {
            format = 'NATIONAL';
        }
        const formatted = this.phoneNumberService.format(phoneValue, countryCode, format);
        if (mask) {
            return (formatted[0] +
                formatted[1] +
                formatted[2] +
                '*'.repeat(formatted.length - 6) +
                formatted.slice(-3));
        }
        return formatted;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPhoneFormatPipe, deps: [{ token: MintPhoneNumberService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintPhoneFormatPipe, name: "mintPhoneFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPhoneFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'mintPhoneFormat',
                }]
        }], ctorParameters: () => [{ type: MintPhoneNumberService }] });

class MintEmailMaskPipe {
    transform(email) {
        if (!email) {
            return '';
        }
        const maskedEmail = email.replace(/([^@\.])/g, '*').split('');
        let previous = '';
        for (let i = 0; i < maskedEmail.length; i++) {
            if (i <= 1 || previous === '.' || previous === '@') {
                maskedEmail[i] = email[i];
            }
            previous = email[i];
        }
        return maskedEmail.join('');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintEmailMaskPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintEmailMaskPipe, name: "mintEmailMask" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintEmailMaskPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'mintEmailMask',
                }]
        }] });

class MintPluralPipe {
    transform(input, label, pluralLabel = '') {
        input = input || 0;
        return input === 1
            ? `${input} ${label}`
            : pluralLabel
                ? `${input} ${pluralLabel}`
                : `${input} ${label}s`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPluralPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintPluralPipe, name: "mintPlural" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPluralPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintPlural' }]
        }] });

class MintNumberFormatPipe {
    transform(input) {
        return new Intl.NumberFormat().format(input);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNumberFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintNumberFormatPipe, name: "mintNumberFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNumberFormatPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintNumberFormat' }]
        }] });

class MintRoundPipe {
    transform(input) {
        return MintMathUtil.round(input);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoundPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintRoundPipe, name: "mintRound" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoundPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintRound' }]
        }] });

dayjs.extend(utc);
class MintDateUtcPipe {
    transform(date, format = 'YYYY-MM-DD') {
        if (date) {
            return dayjs.utc(date).format(format);
        }
        else {
            return '';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateUtcPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintDateUtcPipe, name: "mintDateUTC" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateUtcPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'mintDateUTC',
                }]
        }] });

/**
 * Pipe to download authenticated files from the
 * application's file server.
 */
class MintMediaUrlPipe {
    constructor(mediaService) {
        this.mediaService = mediaService;
    }
    transform(url) {
        return this.mediaService.fetchAsDataUrl(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMediaUrlPipe, deps: [{ token: MintMediaService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintMediaUrlPipe, name: "mintMediaUrl" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMediaUrlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintMediaUrl' }]
        }], ctorParameters: () => [{ type: MintMediaService }] });

class MintSsnPipe {
    transform(ssn, mask) {
        if (!ssn) {
            return '';
        }
        // const value = ssn.toString().trim().replace(/^\+/, '');
        const value = ssn
            .toString()
            .trim()
            .replace(/[^0-9]/g, '');
        if (value.match(/[^0-9]/)) {
            return ssn;
        }
        if (mask) {
            return '***-**-' + ssn.substring(5);
        }
        const three = value.slice(0, 3);
        let six = value.slice(3);
        if (six) {
            if (six.length > 2) {
                six = six.slice(0, 2) + '-' + six.slice(2, 6);
            }
            return (three + '-' + six).trim();
        }
        else {
            return three;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSsnPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintSsnPipe, name: "mintSsn" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSsnPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'mintSsn',
                }]
        }] });

const logger$1Q = MintLogger.getLogger('MintPipesModule');
const PIPES$1 = [
    MintCapitalizePipe,
    MintCurrencyPipe,
    MintDateUtcPipe,
    MintEmailMaskPipe,
    MintMediaUrlPipe,
    MintPhoneFormatPipe,
    MintPluralPipe,
    MintRoundPipe,
    MintSsnPipe,
    MintNumberFormatPipe,
    MintSafeHtmlPipe,
    MintSafeUrlPipe,
    MintSafeResourceUrlPipe,
    MintTimingPipe,
];
class MintPipesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintPipesModule, declarations: [MintCapitalizePipe,
            MintCurrencyPipe,
            MintDateUtcPipe,
            MintEmailMaskPipe,
            MintMediaUrlPipe,
            MintPhoneFormatPipe,
            MintPluralPipe,
            MintRoundPipe,
            MintSsnPipe,
            MintNumberFormatPipe,
            MintSafeHtmlPipe,
            MintSafeUrlPipe,
            MintSafeResourceUrlPipe,
            MintTimingPipe], imports: [CommonModule], exports: [MintCapitalizePipe,
            MintCurrencyPipe,
            MintDateUtcPipe,
            MintEmailMaskPipe,
            MintMediaUrlPipe,
            MintPhoneFormatPipe,
            MintPluralPipe,
            MintRoundPipe,
            MintSsnPipe,
            MintNumberFormatPipe,
            MintSafeHtmlPipe,
            MintSafeUrlPipe,
            MintSafeResourceUrlPipe,
            MintTimingPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPipesModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPipesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [...PIPES$1],
                    exports: [...PIPES$1],
                }]
        }] });

const logger$1P = MintLogger.getLogger('FormController');
class MintFormController extends UntypedFormGroup {
    constructor(fields) {
        super(fields.reduce((map, field) => {
            map[field.name] = field.control;
            return map;
        }, {}));
        // flag to track submission state of the form
        this.submitted = false;
        // for (const field of fields) {
        //   field.valueChanges.subscribe((value) => {
        //     logger.debug('field value changed: value: ', value);
        //   });
        // }
        this.fields = fields;
        // logger.debug('init: initialized: ', this);
    }
    get valueChanged() {
        for (const field of this.fields) {
            if (field.valueChanged) {
                return true;
            }
        }
        return false;
    }
    formValues() {
        const keys = Object.keys(this.controls);
        const result = {};
        for (const key of keys) {
            result[key] = this.fieldValue(key);
        }
        return result;
    }
    fieldControl(field) {
        if (typeof field === 'string') {
            return this.controls[field];
        }
        return field;
    }
    fieldValue(field) {
        let value;
        const control = this.fieldControl(field);
        if (control) {
            value = control.value;
            if (typeof value === 'undefined') {
                return null;
            }
            if (typeof value === 'string' && value.trim().length === 0) {
                return null;
            }
        }
        return value;
    }
    resetForm(values = {}) {
        this.submitted = false;
        for (const field of this.fields) {
            if (!values.hasOwnProperty(field.name)) {
                values[field.name] = field.defaultValue;
            }
            field.reset(values[field.name]);
        }
        this.reset(values);
        // logger.debug('resetForm:\nvalues: ', values, '\nfields: ', this.fields);
    }
    async triggerFormValidation() {
        for (const field of this.fields) {
            await field.triggerValidation();
        }
    }
    submit() {
        if (!this.form) {
            throw new Error('Controller not associated with MintFormController');
        }
        return this.form.submit();
    }
    /**
     * Ready to be submitted: used for disabling form submission button
     */
    get ready() {
        return !this.submitted && this.valid && this.valueChanged;
    }
    field(fieldName) {
        if (!fieldName) {
            throw new Error('getFormField: fieldName is not defined');
        }
        // logger.debug('getFormField: ', fieldName);
        let _fieldName;
        if (typeof fieldName === 'string') {
            _fieldName = fieldName;
        }
        else {
            const keys = Object.keys(this.controls);
            // logger.debug('keys: ', keys);
            for (const key of keys) {
                const obj = this.controls[key];
                // logger.debug('obj: ', obj);
                if (obj === fieldName) {
                    _fieldName = key;
                    break;
                }
            }
        }
        // logger.debug('getFormField: fields:', this.fields);
        if (!_fieldName) {
            throw new Error('Invalid field name');
        }
        let field;
        for (const f of this.fields) {
            if (f.name === _fieldName) {
                field = f;
                break;
            }
        }
        return field;
    }
}

var MintInputLayoutClassNames;
(function (MintInputLayoutClassNames) {
    MintInputLayoutClassNames["StandardLateral"] = "mint-input-std-lat";
    MintInputLayoutClassNames["StandardVertical"] = "mint-input-std-vert";
})(MintInputLayoutClassNames || (MintInputLayoutClassNames = {}));
var MintInputLayout;
(function (MintInputLayout) {
    MintInputLayout["StandardLateral"] = "standard-lateral";
    MintInputLayout["StandardVertical"] = "standard-vertical";
})(MintInputLayout || (MintInputLayout = {}));
var MintInputBefore;
(function (MintInputBefore) {
    MintInputBefore["Dollar"] = "$";
})(MintInputBefore || (MintInputBefore = {}));
var MintInputAfter;
(function (MintInputAfter) {
    MintInputAfter["Percent"] = "%";
})(MintInputAfter || (MintInputAfter = {}));
var MintFormValidationTrigger;
(function (MintFormValidationTrigger) {
    MintFormValidationTrigger["Change"] = "change";
    MintFormValidationTrigger["Blur"] = "blur";
    MintFormValidationTrigger["Submit"] = "submit";
})(MintFormValidationTrigger || (MintFormValidationTrigger = {}));
var MintFormFieldAutocomplete;
(function (MintFormFieldAutocomplete) {
    MintFormFieldAutocomplete["On"] = "on";
    MintFormFieldAutocomplete["Off"] = "off";
    MintFormFieldAutocomplete["NewPassword"] = "new-password";
    MintFormFieldAutocomplete["Username"] = "username";
})(MintFormFieldAutocomplete || (MintFormFieldAutocomplete = {}));

const logger$1O = MintLogger.getLogger('MintUidUtil');
class MintUidUtil {
    static uuid() {
        return uuid.v4();
    }
    static uid() {
        const _uuid = MintUidUtil.uuid();
        const _uid = _uuid.replace(/-/g, '');
        // logger.debug('uid: generated: ', _uid);
        return _uid;
    }
}

const logger$1N = MintLogger.getLogger('MintFormFieldComponent');
class MintFormFieldComponent {
    constructor() {
        this.uid = MintUidUtil.uid();
        this.layoutClassName = MintInputLayoutClassNames.StandardVertical;
    }
    init(_field, _controlElement) {
        this.field = _field;
        this._controlElement = _controlElement;
        this.setLayout();
    }
    setLayout() {
        const STANDARD_LATERAL = 'standard-lateral';
        const STANDARD_VERTICAL = 'standard-vertical';
        if (this.field.layout === STANDARD_LATERAL) {
            this.layoutClassName = MintInputLayoutClassNames.StandardLateral;
        }
        else if (this.field.layout === STANDARD_VERTICAL) {
            this.layoutClassName = MintInputLayoutClassNames.StandardVertical;
        }
    }
    // async ngOnChanges(changes: SimpleChanges) {
    //   const _field: SimpleChange = changes.field;
    //
    //   if (_field && !_field.firstChange) {
    //     this.field = _field.currentValue;
    //     this.ngOnInit();
    //   }
    // }
    isDisabled() {
        return this.field.control.disabled;
    }
    isValid(strict = false) {
        if (typeof strict === 'undefined' || strict === null) {
            strict = false;
        }
        let invalid = true;
        const control = this.field.control;
        // if strict is not set then if the control is
        // disabled simply return true.
        if (!strict && control.disabled) {
            return true;
        }
        // NOTE: control has both valid and invalid flags
        // - a control can have both valid AND invalid = false
        //   if the control is disabled
        if (control) {
            // use 'touched' instead of 'dirty' if you want to trigger an error after 'tabbing' to a required field
            // invalid = !control.valid && control.touched && !control.pending;
            // invalid = !control.valid && control.dirty && !control.pending;
            invalid =
                !control.valid && control.invalid && control.dirty && !control.pending;
        }
        return !invalid;
    }
    getErrors() {
        const messages = [];
        const control = this.field.control;
        const errors = control.errors;
        if (errors) {
            const keys = Object.keys(errors);
            for (const key of keys) {
                let message;
                if (this.field.onValidationError) {
                    message = this.field.onValidationError(key, errors[key]);
                }
                if (!message) {
                    message = 'Please enter a valid value';
                }
                messages.push(message);
            }
        }
        if (!messages.length) {
            return null;
        }
        return messages;
    }
    onChange($event, fieldOption) {
        if (this.field.disabled) {
            return;
        }
        // propagate value into form control using control value accessor interface
        if (this.propagateChange) {
            // this.propagateChange(this.trim(this.field.value));
            this.propagateChange(this.field.value);
        }
    }
    // private trim(value: any) {
    //   if (typeof value === 'string' && this.field.trim) {
    //     value = value.trim();
    //   }
    //
    //   return value;
    // }
    get value() {
        return this.field.value;
    }
    set value(_value) {
        this.field.value = _value;
    }
    // register onTouched event
    onFocus($event) {
        if (this.onTouchedFn) {
            this.onTouchedFn($event);
        }
        if (this.field.onFocus) {
            this.field.onFocus(this.field.control, $event);
        }
    }
    onBlur($event) {
        if (this.onTouchedFn) {
            this.onTouchedFn($event);
        }
        if (this.field.formatValue) {
            this.field.formatValue(this.field.control);
        }
        if (this.field.onBlur) {
            this.field.onBlur(this.field.control, $event);
        }
    }
    // From ControlValueAccessor interface
    // Writes a new value to the view element.
    writeValue(_value) {
        this.field.value = _value;
    }
    // From ControlValueAccessor interface
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // From ControlValueAccessor interface
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        if (!this._controlElement) {
            return;
        }
        if (this._controlElement.hasOwnProperty('disabled')) {
            this._controlElement.disabled = isDisabled;
        }
        if (this._controlElement.hasOwnProperty('isReadOnly')) {
            this._controlElement.isReadOnly = isDisabled;
        }
    }
}

class MintFormUtil {
    static isTextField(field) {
        return (field.controlType === 'text' ||
            field.controlType === 'password' ||
            field.controlType === 'email' ||
            field.controlType === 'search' ||
            field.controlType === 'url');
    }
    static isPhoneField(field) {
        return field.controlType === 'tel';
    }
    static isNumberField(field) {
        return field.controlType === 'number';
    }
    static isSelectField(field) {
        return field.controlType === 'select';
    }
    static isToggleField(field) {
        return field.controlType === 'toggle';
    }
    static isDateField(field) {
        return field.controlType === 'date';
    }
    static isDateRangeField(field) {
        return field.controlType === 'daterange';
    }
    static isDatePickerField(field) {
        return field.controlType === 'datepicker';
    }
    static isRadioGroup(field) {
        return field.controlType === 'radio-group';
    }
    static isCheckboxGroup(field) {
        return field.controlType === 'checkbox-group';
    }
    static isTextArea(field) {
        return field.controlType === 'textarea';
    }
    static isNotes(field) {
        return field.controlType === 'notes';
    }
    static isAddressField(field) {
        return field.controlType === 'address';
    }
}

/**
 * FormService must be provided directly in each Component
 * that uses it so it can pick up that component's
 * ChangeDetectorRef.
 *
 * For example:
 * ```
 * @Component({
 * selector: 'mint-auth-login',
 * templateUrl: './login.component.safe-html',
 * service: [MintFormService],
 * })
 * ```
 */
class MintFormService {
    constructor(cd) {
        this.cd = cd;
    }
    build(name, fields) {
        let formName = name;
        if (typeof name !== 'string') {
            formName = MintUidUtil.uid();
            fields = name;
        }
        // return MintFormController.build(this.cd, formName, fields);
        return new MintFormController(fields);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormService, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }] });

const logger$1M = MintLogger.getLogger('MintFormField');
// export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
class MintFormField {
    get status() {
        return this._status;
    }
    // field's current value
    get value() {
        return this._value;
    }
    set value(_value) {
        if (typeof _value !== 'string') {
            _value = this.scrub(_value);
        }
        this._value = _value;
        this._valueChanged = true;
        this._valueChanges.next(_value);
        // // logger.debug(
        // //   `[${this.name}]: value setter: `,
        // //   '\ncurrent value: ',
        // //   this._value,
        // //   '\nnew value:',
        // //   _value
        // // );
        //
        // if (!this.equals(this._value, _value)) {
        //   // logger.debug(`[${this.name}]: value setter: NOT EQUAL`);
        //   this._value = _value;
        //   this._valueChanged = true;
        //   this._valueChanges.next(_value);
        // }
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(_disabled) {
        this._disabled = _disabled;
        if (this._control) {
            if (this._disabled) {
                this._control.disable();
            }
            else {
                this._control.enable();
            }
        }
    }
    get controlType() {
        return this._controlType;
    }
    set controlType(_controlType) {
        this._controlType = _controlType;
    }
    get control() {
        return this._control;
    }
    get valueChanged() {
        return this._valueChanged;
    }
    get valueChanges() {
        return this._valueChanges;
    }
    get controlValue() {
        return this.scrub(this.control?.value);
    }
    set controlValue(value) {
        if (this.control) {
            this.control.setValue(this.scrub(value));
        }
    }
    constructor(field) {
        this._valueChanges = new BehaviorSubject(null);
        this._validationInProgress = false;
        if (field) {
            Object.assign(this, field);
            this.setDefaultValue();
        }
        if (typeof this.visible !== 'function') {
            this.visible = () => {
                return true;
            };
        }
        if (typeof this.compareWith === 'undefined') {
            this.compareWith = (o1, o2) => {
                if (MintObjectUtil.isNullish(o1) || MintObjectUtil.isNullish(o2)) {
                    return false;
                }
                if (typeof o1.id !== 'undefined' && typeof o2.id !== 'undefined') {
                    return o1.id === o2.id;
                }
                else if (typeof o1.uid !== 'undefined' &&
                    typeof o2.uid !== 'undefined') {
                    return o1.uid === o2.uid;
                }
                else {
                    return this.equals(o1, o2);
                }
            };
        }
        this.trim = this.trim ?? true;
        if (!this.onValidationError) {
            this.onValidationError = (key, errors) => {
                logger$1M.ack(key, errors);
                return 'Please enter a valid value';
            };
        }
        this.updateControl();
    }
    _debounce(callback) {
        if (!this._debouncer) {
            this.debounce = this.debounce ?? 200;
            this._debouncer = new MintDebouncer(this.debounce);
        }
        return this._debouncer.debounce(callback);
    }
    updateControl() {
        const defaultValue = typeof this.defaultValue === 'function'
            ? this.defaultValue()
            : this.defaultValue;
        this._control = new UntypedFormControl({
            value: defaultValue,
            disabled: this.disabled,
        }, {
            validators: this.validator,
            asyncValidators: this.asyncValidator,
            updateOn: this.validationTrigger ?? MintFormValidationTrigger.Change,
        });
        this._valueChanged = false;
        this._control.statusChanges.subscribe((_status) => {
            this._status = _status;
            this._disabled = _status === 'DISABLED';
        });
        this._control.valueChanges.subscribe(async (_value) => {
            // logger.debug(`[${this.name}]: control value changed: `, _value);
            // shouldn't be necessary but included for possible edge cases
            this.value = _value;
            // don't trigger change events when validation is manually triggered
            if (this.onChange && !this._validationInProgress) {
                await this._debounce(() => {
                    this.onChange(this._control, this._value);
                });
            }
        });
    }
    reset(defaultValue) {
        if (typeof defaultValue !== 'undefined') {
            this.defaultValue = defaultValue;
        }
        this.setDefaultValue();
        // this.updateControl();
    }
    async triggerValidation() {
        return new Promise((resolve, reject) => {
            const control = this.control;
            this._validationInProgress = true;
            const subscription = control.statusChanges.subscribe((_status) => {
                // logger.debug('triggerValidation: got _status: ', _status);
                if (_status !== 'PENDING') {
                    this._validationInProgress = false;
                    subscription.unsubscribe();
                    resolve(_status);
                }
            });
            control.markAsTouched();
            control.markAsDirty();
            control.updateValueAndValidity();
        });
    }
    addValidator(validatorFn) {
        const validators = [];
        const self = this;
        if (!this.validator) {
            validators.push(validatorFn);
        }
        else {
            validators.push(self.validator, validatorFn);
        }
        this.validator = Validators.compose(validators);
        this.updateControl();
        // logger.debug('this.addValidator called: ', validators);
    }
    addAsyncValidator(validatorFn) {
        const validators = [];
        const self = this;
        if (!this.asyncValidator) {
            validators.push(validatorFn);
        }
        else {
            validators.push(self.validator, validatorFn);
        }
        this.asyncValidator = Validators.composeAsync(validators);
        this.updateControl();
        // logger.debug('this.addAsyncValidator called: ', validators);
    }
    isEmptyString(value) {
        if (typeof value !== 'string') {
            return false;
        }
        return value.length === 0;
    }
    scrub(_value) {
        if (typeof _value === 'string') {
            if (_value && this.trim) {
                _value = _value.trim();
            }
        }
        if (typeof _value === 'undefined' ||
            _value === null ||
            this.isEmptyString(_value)) {
            _value = null;
        }
        return _value;
    }
    equals(value1, value2) {
        return MintObjectUtil.equals(value1, value2, {
            equalUndefined: true,
            equalNull: true,
            undefinedEqualsNull: true,
        });
    }
    setDefaultValue() {
        let defaultValue = typeof this.defaultValue === 'function'
            ? this.defaultValue()
            : this.defaultValue;
        defaultValue = this.scrub(defaultValue);
        this._value = defaultValue;
        this._valueChanged = false;
    }
}

const logger$1L = MintLogger.getLogger('MintInputNumber');
// NOTE: ngx-mask directive does not appear to work
// with MintInputNumber since there's a conflict.
// Need to investigate further.
// If mask is needed use MintInputText with type='number'
class MintInputNumber extends MintFormField {
    constructor(model) {
        super(model);
        this._controlType = 'number';
        if (typeof this.size === 'undefined') {
            this.size = 'default';
        }
        if (typeof this.step === 'undefined') {
            this.step = 1;
        }
        if (typeof this.minValue === 'undefined') {
            this.minValue = -Infinity;
        }
        if (typeof this.maxValue === 'undefined') {
            this.maxValue = Infinity;
        }
        if (typeof this.parser === 'undefined') {
            this.parser = (value) => {
                const parsed = MintTypeUtil.parseFloat(value);
                return value && this.isNumeric(parsed) ? parsed.toString() : '';
            };
        }
        if (typeof this.formatter === 'undefined') {
            this.formatter = (value) => (value || value === 0) && this.isNumeric(value) ? `${value}` : '';
        }
    }
    isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
}

const logger$1K = MintLogger.getLogger('MintInputNumberComponent');
const MINT_INPUT_NUMBER_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintInputNumberComponent),
    multi: true,
};
class MintInputNumberComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
    }
    isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
    onChange($event, fieldOption) {
        if (this.field.disabled) {
            return;
        }
        logger$1K.debug('onChange: value: ', $event);
        if (this.isNumeric($event)) {
            this.field.value = $event;
        }
        else {
            this.field.value = null;
        }
        // logger.debug('onChange: field.value: ', this.field.value);
        // propagate value into form control using control value accessor interface
        if (this.propagateChange) {
            this.propagateChange(this.field.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputNumberComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintInputNumberComponent, selector: "mint-input-number", inputs: { field: "field" }, providers: [MINT_INPUT_NUMBER_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'number'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-input-number\n        #control\n        id=\"input-{{ uid }}\"\n        [ngStyle]=\"{ width: '100%' }\"\n        [nzSize]=\"field.size\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (ngModelChange)=\"onChange($event)\"\n        [ngModel]=\"field.value\"\n        [nzPlaceHolder]=\"field.placeholder ? field.placeholder : ''\"\n        [nzMin]=\"field.minValue\"\n        [nzMax]=\"field.maxValue\"\n        [nzStep]=\"field.step\"\n        [nzPrecision]=\"field.precision\"\n        [nzFormatter]=\"field.formatter\"\n        [nzParser]=\"field.parser\"\n        [attr.aria-invalid]=\"!isValid()\"\n        [nzDisabled]=\"field.disabled\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n      >\n      </nz-input-number>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2.NzInputNumberComponent, selector: "nz-input-number", inputs: ["nzSize", "nzMin", "nzMax", "nzParser", "nzPrecision", "nzPrecisionMode", "nzPlaceHolder", "nzStatus", "nzStep", "nzInputMode", "nzId", "nzDisabled", "nzReadOnly", "nzAutoFocus", "nzBorderless", "nzFormatter"], outputs: ["nzBlur", "nzFocus"], exportAs: ["nzInputNumber"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputNumberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-input-number', encapsulation: ViewEncapsulation.None, providers: [MINT_INPUT_NUMBER_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'number'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-input-number\n        #control\n        id=\"input-{{ uid }}\"\n        [ngStyle]=\"{ width: '100%' }\"\n        [nzSize]=\"field.size\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (ngModelChange)=\"onChange($event)\"\n        [ngModel]=\"field.value\"\n        [nzPlaceHolder]=\"field.placeholder ? field.placeholder : ''\"\n        [nzMin]=\"field.minValue\"\n        [nzMax]=\"field.maxValue\"\n        [nzStep]=\"field.step\"\n        [nzPrecision]=\"field.precision\"\n        [nzFormatter]=\"field.formatter\"\n        [nzParser]=\"field.parser\"\n        [attr.aria-invalid]=\"!isValid()\"\n        [nzDisabled]=\"field.disabled\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n      >\n      </nz-input-number>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

const logger$1J = MintLogger.getLogger('MintFormComponent');
class MintFormComponent {
    constructor() {
        this.onSubmit = new EventEmitter();
        this.submitted = false;
        this.maxResubmitCount = 5;
    }
    ngOnChanges() {
        this.controller.form = this;
    }
    ngOnInit() {
        this.controller.form = this;
    }
    async submit(resubmitCount = 0) {
        this.submitted = true;
        if (!this.controller) {
            logger$1J.error('submit: form controller is not defined. exiting.');
            this.submitted = false;
            return;
        }
        // force change detection
        await this.controller.triggerFormValidation();
        // this shouldn't happen so set to warn to highlight issue.
        if (this.controller.pending) {
            logger$1J.warn('submit: form is pending.  waiting.');
            if (resubmitCount < this.maxResubmitCount) {
                await MintSystemUtil.sleep(100);
                return await this.submit(resubmitCount++);
            }
            throw new Error('MintFormComponent: form pending timeout.');
        }
        if (!this.controller.valid) {
            logger$1J.info('submit: form is not valid. exiting.');
            this.submitted = false;
            return;
        }
        this.onSubmit.emit(this.controller);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintFormComponent, selector: "mint-form", inputs: { controller: ["formGroup", "controller"] }, outputs: { onSubmit: "onSubmit" }, viewQueries: [{ propertyName: "form", first: true, predicate: ["form"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<form #form=\"ngForm\" class=\"mint-form\">\n  <ng-content></ng-content>\n</form>\n", styles: [":host{display:block}.label{display:block;margin-bottom:.5rem}.form-control-group{margin-bottom:2rem}.form-control-group.option-group{display:flex;justify-content:space-between;margin:2rem 0}.mint-form-label-invalid{color:#dc143c}.mint-form-field-invalid{border:crimson}.mint-form-field-help{background-color:#e6f7ff;border:1px solid #91d5ff;padding:5px 5px 5px 10px;border-radius:4px;line-height:1.5;margin-top:10px}.mint-form-field-help p{white-space:normal;margin:0}.mint-form-field-description{line-height:1.5}.mint-form-field-description p{white-space:normal;margin:0;font-size:.8rem}\n"], dependencies: [{ kind: "directive", type: i1$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-form', encapsulation: ViewEncapsulation.None, template: "<form #form=\"ngForm\" class=\"mint-form\">\n  <ng-content></ng-content>\n</form>\n", styles: [":host{display:block}.label{display:block;margin-bottom:.5rem}.form-control-group{margin-bottom:2rem}.form-control-group.option-group{display:flex;justify-content:space-between;margin:2rem 0}.mint-form-label-invalid{color:#dc143c}.mint-form-field-invalid{border:crimson}.mint-form-field-help{background-color:#e6f7ff;border:1px solid #91d5ff;padding:5px 5px 5px 10px;border-radius:4px;line-height:1.5;margin-top:10px}.mint-form-field-help p{white-space:normal;margin:0}.mint-form-field-description{line-height:1.5}.mint-form-field-description p{white-space:normal;margin:0;font-size:.8rem}\n"] }]
        }], propDecorators: { controller: [{
                type: Input,
                args: ['formGroup']
            }], onSubmit: [{
                type: Output
            }], form: [{
                type: ViewChild,
                args: ['form', { static: true }]
            }] } });

const MODULES$6 = [
    MintCommonModule,
    MintPipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
];
const COMPONENTS$6 = [MintFormComponent];
class MintFormModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintFormModule, declarations: [MintFormComponent], imports: [MintCommonModule,
            MintPipesModule,
            FormsModule,
            ReactiveFormsModule,
            NgxMaskDirective,
            NgxMaskPipe], exports: [MintCommonModule,
            MintPipesModule,
            FormsModule,
            ReactiveFormsModule,
            NgxMaskDirective,
            NgxMaskPipe, MintFormComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormModule, providers: [provideNgxMask()], imports: [MintCommonModule,
            MintPipesModule,
            FormsModule,
            ReactiveFormsModule,
            MintCommonModule,
            MintPipesModule,
            FormsModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$6],
                    declarations: [...COMPONENTS$6],
                    providers: [provideNgxMask()],
                    exports: [...MODULES$6, ...COMPONENTS$6],
                }]
        }] });

class MintInputNumberModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputNumberModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintInputNumberModule, declarations: [MintInputNumberComponent], imports: [FormsModule, NzInputNumberModule, CommonModule, MintFormModule], exports: [MintInputNumberComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputNumberModule, providers: [provideNgxMask()], imports: [FormsModule, NzInputNumberModule, CommonModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputNumberModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, NzInputNumberModule, CommonModule, MintFormModule],
                    declarations: [MintInputNumberComponent],
                    providers: [provideNgxMask()],
                    exports: [MintInputNumberComponent],
                }]
        }] });

const logger$1I = MintLogger.getLogger('MintCheckboxGroupComponent');
const MINT_CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintCheckboxGroupComponent),
    multi: true,
};
class MintCheckboxGroupComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
    }
    isNullish(item) {
        return typeof item === 'undefined' || item === null;
    }
    isChecked(fieldOption) {
        if (this.isNullish(this.field.value) || this.field.value.length === 0) {
            return false;
        }
        // logger.debug('isChecked: field value: ', this.field.value);
        // logger.debug('isChecked: fieldOption: ', fieldOption);
        if (!Array.isArray(this.field.value)) {
            logger$1I.warn('isChecked: field.value is not an array');
            return false;
        }
        if (this.field.value.length === 0) {
            return false;
        }
        const result = this.field.value.find((item) => item === fieldOption.value);
        // logger.debug('isChecked: result: ', result);
        if (typeof result !== 'undefined') {
            return true;
        }
        return false;
    }
    onChange($event, fieldOption) {
        if (this.field.disabled) {
            return;
        }
        // logger.trace('onChange: event: ', $event);
        // logger.trace('onChange: fieldOption: ', fieldOption);
        this.field.value = this.field.value ?? [];
        // logger.trace('onChange: field.value 1: ', this.field.value);
        if ($event === true || $event.value === true || $event.returnValue) {
            // checkbox item was checked; add it
            this.field.value.push(fieldOption.value);
        }
        else {
            // checkbox item was unchecked; remove it
            this.field.value = this.field.value.filter((item) => item !== fieldOption.value);
        }
        if (this.field.value.length === 0) {
            this.field.value = null;
        }
        // logger.trace('onChange: field.value 2: ', this.field.value);
        // propagate value into form control using control value accessor interface
        if (this.propagateChange) {
            this.propagateChange(this.field.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCheckboxGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintCheckboxGroupComponent, selector: "mint-checkbox-group", inputs: { field: "field" }, providers: [MINT_CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div\n    *ngIf=\"field && field.controlType === 'checkbox-group'\"\n    #control\n    [class.mint-form-label-invalid]=\"!isValid()\"\n    [ngClass]=\"{ 'vertical-layout': field.layout === 'standard-vertical' }\"\n  >\n    <ng-container *ngIf=\"!field.isOptionCollapsible\">\n      <ng-container *ngFor=\"let option of field.options\">\n        <label\n          nz-checkbox\n          [nzDisabled]=\"field.disabled\"\n          [nzValue]=\"option.value\"\n          (focus)=\"onFocus($event)\"\n          (blur)=\"onBlur($event)\"\n          (ngModelChange)=\"onChange($event, option)\"\n          [ngModel]=\"isChecked(option)\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n          [attr.data-testid]=\"option.dataTestId\"\n        >\n          {{ option.name }}\n        </label>\n        <ng-container\n          *ngIf=\"field.optionContentTemplate\"\n          [ngTemplateOutlet]=\"field.optionContentTemplate\"\n          [ngTemplateOutletContext]=\"{ option: option }\"\n        >\n        </ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"field.isOptionCollapsible\">\n      <nz-collapse\n        [nzGhost]=\"true\"\n        *ngFor=\"let option of field.options\"\n        class=\"option-collapse\"\n      >\n        <nz-collapse-panel\n          [nzActive]=\"field.areOptionsActive\"\n          [nzHeader]=\"option.name\"\n          class=\"option-collapse-panel\"\n        >\n          <label\n            nz-checkbox\n            [nzDisabled]=\"field.disabled\"\n            [nzValue]=\"option.value\"\n            (focus)=\"onFocus($event)\"\n            (blur)=\"onBlur($event)\"\n            (ngModelChange)=\"onChange($event, option)\"\n            [ngModel]=\"isChecked(option)\"\n            [class.mint-form-field-invalid]=\"!isValid()\"\n            class=\"collapse-checkbox\"\n            [attr.data-testid]=\"option.dataTestId\"\n          >\n          </label>\n          <ng-container\n            *ngIf=\"field.optionContentTemplate\"\n            [ngTemplateOutlet]=\"field.optionContentTemplate\"\n            [ngTemplateOutletContext]=\"{ option: option }\"\n          >\n          </ng-container>\n        </nz-collapse-panel>\n      </nz-collapse>\n    </ng-container>\n  </div>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n", styles: [":host{display:block}.option-collapse{padding:0 22px}.option-collapse-panel{position:relative}.option-collapse-panel .ant-collapse-content-box{margin-top:-8px}.collapse-checkbox{position:absolute;left:-10px;top:13px}.vertical-layout{display:flex;flex-direction:column;gap:15px}.vertical-layout .ant-checkbox-wrapper+.ant-checkbox-wrapper{margin-left:0}\n"], dependencies: [{ kind: "component", type: i1$4.NzCheckboxComponent, selector: "[nz-checkbox]", inputs: ["nzValue", "nzAutoFocus", "nzDisabled", "nzIndeterminate", "nzChecked", "nzId"], outputs: ["nzCheckedChange"], exportAs: ["nzCheckbox"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i4$2.NzCollapsePanelComponent, selector: "nz-collapse-panel", inputs: ["nzActive", "nzDisabled", "nzShowArrow", "nzExtra", "nzHeader", "nzExpandedIcon"], outputs: ["nzActiveChange"], exportAs: ["nzCollapsePanel"] }, { kind: "component", type: i4$2.NzCollapseComponent, selector: "nz-collapse", inputs: ["nzAccordion", "nzBordered", "nzGhost", "nzExpandIconPosition"], exportAs: ["nzCollapse"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-checkbox-group', encapsulation: ViewEncapsulation.None, providers: [MINT_CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div\n    *ngIf=\"field && field.controlType === 'checkbox-group'\"\n    #control\n    [class.mint-form-label-invalid]=\"!isValid()\"\n    [ngClass]=\"{ 'vertical-layout': field.layout === 'standard-vertical' }\"\n  >\n    <ng-container *ngIf=\"!field.isOptionCollapsible\">\n      <ng-container *ngFor=\"let option of field.options\">\n        <label\n          nz-checkbox\n          [nzDisabled]=\"field.disabled\"\n          [nzValue]=\"option.value\"\n          (focus)=\"onFocus($event)\"\n          (blur)=\"onBlur($event)\"\n          (ngModelChange)=\"onChange($event, option)\"\n          [ngModel]=\"isChecked(option)\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n          [attr.data-testid]=\"option.dataTestId\"\n        >\n          {{ option.name }}\n        </label>\n        <ng-container\n          *ngIf=\"field.optionContentTemplate\"\n          [ngTemplateOutlet]=\"field.optionContentTemplate\"\n          [ngTemplateOutletContext]=\"{ option: option }\"\n        >\n        </ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"field.isOptionCollapsible\">\n      <nz-collapse\n        [nzGhost]=\"true\"\n        *ngFor=\"let option of field.options\"\n        class=\"option-collapse\"\n      >\n        <nz-collapse-panel\n          [nzActive]=\"field.areOptionsActive\"\n          [nzHeader]=\"option.name\"\n          class=\"option-collapse-panel\"\n        >\n          <label\n            nz-checkbox\n            [nzDisabled]=\"field.disabled\"\n            [nzValue]=\"option.value\"\n            (focus)=\"onFocus($event)\"\n            (blur)=\"onBlur($event)\"\n            (ngModelChange)=\"onChange($event, option)\"\n            [ngModel]=\"isChecked(option)\"\n            [class.mint-form-field-invalid]=\"!isValid()\"\n            class=\"collapse-checkbox\"\n            [attr.data-testid]=\"option.dataTestId\"\n          >\n          </label>\n          <ng-container\n            *ngIf=\"field.optionContentTemplate\"\n            [ngTemplateOutlet]=\"field.optionContentTemplate\"\n            [ngTemplateOutletContext]=\"{ option: option }\"\n          >\n          </ng-container>\n        </nz-collapse-panel>\n      </nz-collapse>\n    </ng-container>\n  </div>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n", styles: [":host{display:block}.option-collapse{padding:0 22px}.option-collapse-panel{position:relative}.option-collapse-panel .ant-collapse-content-box{margin-top:-8px}.collapse-checkbox{position:absolute;left:-10px;top:13px}.vertical-layout{display:flex;flex-direction:column;gap:15px}.vertical-layout .ant-checkbox-wrapper+.ant-checkbox-wrapper{margin-left:0}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintCheckboxGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCheckboxGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintCheckboxGroupModule, declarations: [MintCheckboxGroupComponent], imports: [NzCheckboxModule,
            CommonModule,
            FormsModule,
            MintFormModule,
            NzCollapseModule], exports: [MintCheckboxGroupComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCheckboxGroupModule, imports: [NzCheckboxModule,
            CommonModule,
            FormsModule,
            MintFormModule,
            NzCollapseModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCheckboxGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        NzCheckboxModule,
                        CommonModule,
                        FormsModule,
                        MintFormModule,
                        NzCollapseModule,
                    ],
                    declarations: [MintCheckboxGroupComponent],
                    exports: [MintCheckboxGroupComponent, MintFormModule],
                }]
        }] });

const logger$1H = MintLogger.getLogger('MintDateRangeComponent');
const MINT_DATE_RANGE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintDateRangeComponent),
    multi: true,
};
class MintDateRangeComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateRangeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintDateRangeComponent, selector: "mint-date-range", inputs: { field: "field" }, providers: [MINT_DATE_RANGE_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'daterange'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-range-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (nzOnOk)=\"field.onOk($event)\"\n        [nzRanges]=\"field.ranges\"\n        [nzMode]=\"field.mode\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzShowTime]=\"field.showTime\"\n        [nzShowToday]=\"field.showToday\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.value\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-range-picker>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$1.NzDatePickerComponent, selector: "nz-date-picker,nz-week-picker,nz-month-picker,nz-year-picker,nz-range-picker", inputs: ["nzAllowClear", "nzAutoFocus", "nzDisabled", "nzBorderless", "nzInputReadOnly", "nzInline", "nzOpen", "nzDisabledDate", "nzLocale", "nzPlaceHolder", "nzPopupStyle", "nzDropdownClassName", "nzSize", "nzStatus", "nzFormat", "nzDateRender", "nzDisabledTime", "nzRenderExtraFooter", "nzShowToday", "nzMode", "nzShowNow", "nzRanges", "nzDefaultPickerValue", "nzSeparator", "nzSuffixIcon", "nzBackdrop", "nzId", "nzPlacement", "nzShowWeekNumber", "nzShowTime"], outputs: ["nzOnPanelChange", "nzOnCalendarChange", "nzOnOk", "nzOnOpenChange"], exportAs: ["nzDatePicker"] }, { kind: "directive", type: i2$1.NzRangePickerComponent, selector: "nz-range-picker", exportAs: ["nzRangePicker"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateRangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-date-range', encapsulation: ViewEncapsulation.None, providers: [MINT_DATE_RANGE_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'daterange'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-range-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (nzOnOk)=\"field.onOk($event)\"\n        [nzRanges]=\"field.ranges\"\n        [nzMode]=\"field.mode\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzShowTime]=\"field.showTime\"\n        [nzShowToday]=\"field.showToday\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.value\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-range-picker>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintDateRangeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateRangeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintDateRangeModule, declarations: [MintDateRangeComponent], imports: [FormsModule, NzDatePickerModule, CommonModule, MintFormModule], exports: [MintDateRangeComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateRangeModule, imports: [FormsModule, NzDatePickerModule, CommonModule, MintFormModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateRangeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, NzDatePickerModule, CommonModule, MintFormModule],
                    declarations: [MintDateRangeComponent],
                    exports: [MintDateRangeComponent, MintFormModule],
                }]
        }] });

const logger$1G = MintLogger.getLogger('MintDateComponent');
const MINT_DATE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintDateComponent),
    multi: true,
};
class MintDateComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
    }
    onChange($event, fieldOption) {
        if (this.field.disabled) {
            return;
        }
        // logger.debug('onChange: $event: ', $event);
        this.field.displayValue = $event;
        // propagate value into form control using control value accessor interface
        if (this.propagateChange) {
            this.propagateChange(this.field.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintDateComponent, selector: "mint-date", inputs: { field: "field" }, providers: [MINT_DATE_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'date'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-date-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (nzOnOk)=\"field.onOk($event)\"\n        [nzMode]=\"field.mode\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzShowTime]=\"field.showTime\"\n        [nzShowToday]=\"field.showToday\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-date-picker>\n    </div>\n  </ng-container>\n\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'year'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-year-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-year-picker>\n    </div>\n  </ng-container>\n\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'month'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-month-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-month-picker>\n    </div>\n  </ng-container>\n\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'week'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-week-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (nzOnOk)=\"field.onOk($event)\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-week-picker>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$1.NzDatePickerComponent, selector: "nz-date-picker,nz-week-picker,nz-month-picker,nz-year-picker,nz-range-picker", inputs: ["nzAllowClear", "nzAutoFocus", "nzDisabled", "nzBorderless", "nzInputReadOnly", "nzInline", "nzOpen", "nzDisabledDate", "nzLocale", "nzPlaceHolder", "nzPopupStyle", "nzDropdownClassName", "nzSize", "nzStatus", "nzFormat", "nzDateRender", "nzDisabledTime", "nzRenderExtraFooter", "nzShowToday", "nzMode", "nzShowNow", "nzRanges", "nzDefaultPickerValue", "nzSeparator", "nzSuffixIcon", "nzBackdrop", "nzId", "nzPlacement", "nzShowWeekNumber", "nzShowTime"], outputs: ["nzOnPanelChange", "nzOnCalendarChange", "nzOnOk", "nzOnOpenChange"], exportAs: ["nzDatePicker"] }, { kind: "directive", type: i2$1.NzMonthPickerComponent, selector: "nz-month-picker", exportAs: ["nzMonthPicker"] }, { kind: "directive", type: i2$1.NzYearPickerComponent, selector: "nz-year-picker", exportAs: ["nzYearPicker"] }, { kind: "directive", type: i2$1.NzWeekPickerComponent, selector: "nz-week-picker", exportAs: ["nzWeekPicker"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-date', encapsulation: ViewEncapsulation.None, providers: [MINT_DATE_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'date'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-date-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (nzOnOk)=\"field.onOk($event)\"\n        [nzMode]=\"field.mode\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzShowTime]=\"field.showTime\"\n        [nzShowToday]=\"field.showToday\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-date-picker>\n    </div>\n  </ng-container>\n\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'year'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-year-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-year-picker>\n    </div>\n  </ng-container>\n\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'month'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-month-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-month-picker>\n    </div>\n  </ng-container>\n\n  <ng-container\n    *ngIf=\"field && field.controlType === 'date' && field.type === 'week'\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-week-picker\n        #control\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (nzOnOk)=\"field.onOk($event)\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        (ngModelChange)=\"onChange($event)\"\n        [nzDisabled]=\"field.disabled\"\n        [nzFormat]=\"field.format\"\n        [ngModel]=\"field.displayValue\"\n        [ngClass]=\"field.className\"\n        [ngStyle]=\"field.style\"\n      >\n      </nz-week-picker>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintDateModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintDateModule, declarations: [MintDateComponent], imports: [FormsModule, NzDatePickerModule, CommonModule, MintFormModule], exports: [MintDateComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateModule, imports: [FormsModule, NzDatePickerModule, CommonModule, MintFormModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, NzDatePickerModule, CommonModule, MintFormModule],
                    declarations: [MintDateComponent],
                    exports: [MintDateComponent, MintFormModule],
                }]
        }] });

const logger$1F = MintLogger.getLogger('MintInputTextComponent');
const MINT_INPUT_TEXT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintInputTextComponent),
    multi: true,
};
class MintInputTextComponent extends MintFormFieldComponent {
    constructor() {
        super(...arguments);
        this.passwordVisible = false;
    }
    ngOnInit() {
        super.init(this.field, this.controlElement);
        if (typeof this.field.autocomplete === 'undefined') {
            this.field.autocomplete = MintFormFieldAutocomplete.On;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputTextComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintInputTextComponent, selector: "mint-input-text", inputs: { field: "field" }, providers: [MINT_INPUT_TEXT_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container\n    *ngIf=\"\n      field &&\n      (field.controlType === 'text' ||\n        field.controlType === 'password' ||\n        field.controlType === 'email' ||\n        field.controlType === 'search' ||\n        field.controlType === 'tel' ||\n        field.controlType === 'url')\n    \"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <ng-container *ngIf=\"field.before && !field.after\">\n        <nz-input-group\n          [nzAddOnBefore]=\"field.before\"\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n      <ng-container *ngIf=\"field.after && !field.before\">\n        <nz-input-group\n          [nzAddOnAfter]=\"field.after\"\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n      <ng-container *ngIf=\"field.before && field.after\">\n        <nz-input-group\n          [nzAddOnBefore]=\"field.before\"\n          [nzAddOnAfter]=\"field.after\"\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n      <ng-container *ngIf=\"!field.before && !field.after\">\n        <nz-input-group\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n    </div>\n  </ng-container>\n  <div\n    *ngIf=\"!isValid()\"\n    class=\"mint-form-field-help\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n\n  <div\n    *ngIf=\"isValid()\"\n    class=\"mint-form-field-description\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p>{{ field.description }}</p>\n  </div>\n</ng-container>\n\n<ng-template #inputsTemplate>\n  <input\n    *ngIf=\"!field.mask\"\n    #control\n    id=\"input-{{ uid }}\"\n    nz-input\n    [nzSize]=\"field.size\"\n    (focus)=\"onFocus($event)\"\n    (blur)=\"onBlur($event)\"\n    (keyup)=\"onChange($event)\"\n    [(ngModel)]=\"field.value\"\n    (ngModelChange)=\"field.value = $event; onChange($event)\"\n    [type]=\"field.controlType\"\n    [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n    [autocomplete]=\"field.autocomplete\"\n    [attr.aria-invalid]=\"!isValid()\"\n    [disabled]=\"field.disabled\"\n    [maxlength]=\"field.maxLength\"\n    [attr.data-testid]=\"field.dataTestId\"\n  />\n  <input\n    *ngIf=\"field.mask\"\n    #control\n    id=\"input-mask-{{ uid }}\"\n    nz-input\n    [nzSize]=\"field.size\"\n    (focus)=\"onFocus($event)\"\n    (blur)=\"onBlur($event)\"\n    (keyup)=\"onChange($event)\"\n    [(ngModel)]=\"field.value\"\n    (ngModelChange)=\"field.value = $event; onChange($event)\"\n    [type]=\"field.controlType\"\n    [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n    [autocomplete]=\"field.autocomplete\"\n    [attr.aria-invalid]=\"!isValid()\"\n    [disabled]=\"field.disabled\"\n    [mask]=\"field.mask.mask\"\n    [showMaskTyped]=\"field.mask.showMask\"\n    [hiddenInput]=\"field.mask.secure === false ? undefined : true\"\n    [thousandSeparator]=\"field.mask.thousandSeparator\"\n    [prefix]=\"field.mask.prefix\"\n    [suffix]=\"field.mask.suffix\"\n    [maxlength]=\"field.maxLength\"\n    [attr.data-testid]=\"field.dataTestId\"\n  />\n</ng-template>\n\n<ng-template #suffixTemplate>\n  <i\n    nz-icon\n    *ngIf=\"field.passwordVisibleToggle\"\n    [nzType]=\"passwordVisible ? 'eye' : 'eye-invisible'\"\n    class=\"password-visiblity-toggle-icon\"\n    (click)=\"\n      passwordVisible = !passwordVisible;\n      field.controlType = passwordVisible ? 'text' : 'password'\n    \"\n  ></i>\n</ng-template>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}i{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i4$3.NzIconDirective, selector: "[nz-icon]", inputs: ["nzSpin", "nzRotate", "nzType", "nzTheme", "nzTwotoneColor", "nzIconfont"], exportAs: ["nzIcon"] }, { kind: "directive", type: i2$2.NzInputDirective, selector: "input[nz-input],textarea[nz-input]", inputs: ["nzBorderless", "nzSize", "nzStepperless", "nzStatus", "disabled"], exportAs: ["nzInput"] }, { kind: "component", type: i2$2.NzInputGroupComponent, selector: "nz-input-group", inputs: ["nzAddOnBeforeIcon", "nzAddOnAfterIcon", "nzPrefixIcon", "nzSuffixIcon", "nzAddOnBefore", "nzAddOnAfter", "nzPrefix", "nzStatus", "nzSuffix", "nzSize", "nzSearch", "nzCompact"], exportAs: ["nzInputGroup"] }, { kind: "directive", type: i2$2.NzInputGroupWhitSuffixOrPrefixDirective, selector: "nz-input-group[nzSuffix], nz-input-group[nzPrefix]" }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i5.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputTextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-input-text', encapsulation: ViewEncapsulation.None, providers: [MINT_INPUT_TEXT_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container\n    *ngIf=\"\n      field &&\n      (field.controlType === 'text' ||\n        field.controlType === 'password' ||\n        field.controlType === 'email' ||\n        field.controlType === 'search' ||\n        field.controlType === 'tel' ||\n        field.controlType === 'url')\n    \"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <ng-container *ngIf=\"field.before && !field.after\">\n        <nz-input-group\n          [nzAddOnBefore]=\"field.before\"\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n      <ng-container *ngIf=\"field.after && !field.before\">\n        <nz-input-group\n          [nzAddOnAfter]=\"field.after\"\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n      <ng-container *ngIf=\"field.before && field.after\">\n        <nz-input-group\n          [nzAddOnBefore]=\"field.before\"\n          [nzAddOnAfter]=\"field.after\"\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n      <ng-container *ngIf=\"!field.before && !field.after\">\n        <nz-input-group\n          [nzSuffix]=\"suffixTemplate\"\n          [class.mint-form-field-invalid]=\"!isValid()\"\n        >\n          <ng-container *ngTemplateOutlet=\"inputsTemplate\"></ng-container>\n        </nz-input-group>\n      </ng-container>\n    </div>\n  </ng-container>\n  <div\n    *ngIf=\"!isValid()\"\n    class=\"mint-form-field-help\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n\n  <div\n    *ngIf=\"isValid()\"\n    class=\"mint-form-field-description\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p>{{ field.description }}</p>\n  </div>\n</ng-container>\n\n<ng-template #inputsTemplate>\n  <input\n    *ngIf=\"!field.mask\"\n    #control\n    id=\"input-{{ uid }}\"\n    nz-input\n    [nzSize]=\"field.size\"\n    (focus)=\"onFocus($event)\"\n    (blur)=\"onBlur($event)\"\n    (keyup)=\"onChange($event)\"\n    [(ngModel)]=\"field.value\"\n    (ngModelChange)=\"field.value = $event; onChange($event)\"\n    [type]=\"field.controlType\"\n    [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n    [autocomplete]=\"field.autocomplete\"\n    [attr.aria-invalid]=\"!isValid()\"\n    [disabled]=\"field.disabled\"\n    [maxlength]=\"field.maxLength\"\n    [attr.data-testid]=\"field.dataTestId\"\n  />\n  <input\n    *ngIf=\"field.mask\"\n    #control\n    id=\"input-mask-{{ uid }}\"\n    nz-input\n    [nzSize]=\"field.size\"\n    (focus)=\"onFocus($event)\"\n    (blur)=\"onBlur($event)\"\n    (keyup)=\"onChange($event)\"\n    [(ngModel)]=\"field.value\"\n    (ngModelChange)=\"field.value = $event; onChange($event)\"\n    [type]=\"field.controlType\"\n    [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n    [autocomplete]=\"field.autocomplete\"\n    [attr.aria-invalid]=\"!isValid()\"\n    [disabled]=\"field.disabled\"\n    [mask]=\"field.mask.mask\"\n    [showMaskTyped]=\"field.mask.showMask\"\n    [hiddenInput]=\"field.mask.secure === false ? undefined : true\"\n    [thousandSeparator]=\"field.mask.thousandSeparator\"\n    [prefix]=\"field.mask.prefix\"\n    [suffix]=\"field.mask.suffix\"\n    [maxlength]=\"field.maxLength\"\n    [attr.data-testid]=\"field.dataTestId\"\n  />\n</ng-template>\n\n<ng-template #suffixTemplate>\n  <i\n    nz-icon\n    *ngIf=\"field.passwordVisibleToggle\"\n    [nzType]=\"passwordVisible ? 'eye' : 'eye-invisible'\"\n    class=\"password-visiblity-toggle-icon\"\n    (click)=\"\n      passwordVisible = !passwordVisible;\n      field.controlType = passwordVisible ? 'text' : 'password'\n    \"\n  ></i>\n</ng-template>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}i{cursor:pointer}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintInputTextModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintInputTextModule, declarations: [MintInputTextComponent], imports: [FormsModule,
            NzIconModule,
            NzInputModule,
            CommonModule,
            MintFormModule], exports: [MintInputTextComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputTextModule, providers: [provideNgxMask()], imports: [FormsModule,
            NzIconModule,
            NzInputModule,
            CommonModule,
            MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputTextModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        NzIconModule,
                        NzInputModule,
                        CommonModule,
                        MintFormModule,
                    ],
                    declarations: [MintInputTextComponent],
                    providers: [provideNgxMask()],
                    exports: [MintInputTextComponent],
                }]
        }] });

// From Google Maps:
// A polygon (like a polyline) defines a series of connected coordinates in
// an ordered sequence. Additionally, polygons form a closed loop and define
// a filled region.
class MintPolygon {
    constructor(model) {
        Object.assign(this, model);
    }
}

let MintPlaceModel = class MintPlaceModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintPlaceModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAddressModel)
], MintPlaceModel.prototype, "address", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintPlaceModel.prototype, "photo", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "description", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "category", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintPlaceModel.prototype, "tags", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "context", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "webUrl", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "socialLinks", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "email", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "phoneNumber", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "googlePlaceId", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "googlePlaceUrl", void 0);
__decorate([
    MintProperty()
], MintPlaceModel.prototype, "rating", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPolygon)
], MintPlaceModel.prototype, "polygon", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPlaceModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPlaceModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPlaceModel.prototype, "_meta", void 0);
MintPlaceModel = __decorate([
    MintResource('/places')
], MintPlaceModel);

let MintAddressModel = class MintAddressModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAddressModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPlaceModel)
], MintAddressModel.prototype, "place", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "streetNumber", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "streetName", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "unitNumber", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "street", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "neighborhood", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "borough", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "city", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "county", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "countyCode", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "state", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "stateCode", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "postalCode", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "country", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "countryCode", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "timeZone", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "utcOffset", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "formattedAddress", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "googlePlaceId", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "latitude", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "longitude", void 0);
__decorate([
    MintProperty()
], MintAddressModel.prototype, "indoorFloor", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAddressModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAddressModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAddressModel.prototype, "_meta", void 0);
MintAddressModel = __decorate([
    MintResource('/addresses')
], MintAddressModel);

// describes the UI control for this field
class MintInputText extends MintFormField {
    constructor(model) {
        super(model);
        if (!this.type) {
            this.type = 'text';
        }
        this._controlType = 'text';
        if (model) {
            if (this.type === 'text' || this.type === 'number') {
                this._controlType = 'text';
            }
            else {
                this._controlType = this.type;
            }
        }
        if (typeof this.disableMask === 'undefined') {
            this.disableMask = false;
        }
        this.setDefaultMask();
        if (typeof this.minValue !== 'undefined') {
            this.addValidator(Validators.min(this.minValue));
        }
        if (typeof this.maxValue !== 'undefined') {
            this.addValidator(Validators.max(this.maxValue));
        }
    }
    setDefaultMask() {
        if (this.disableMask) {
            this.mask = null;
        }
        if (this.type === 'number' && !this.disableMask) {
            if (!this.mask) {
                this.mask = {
                    mask: 'separator',
                };
            }
            if (!this.mask.mask) {
                this.mask.mask = 'separator';
            }
        }
        if (this.mask) {
            if (typeof this.mask.showMask === 'undefined') {
                this.mask.showMask = false;
            }
            if (typeof this.mask.secure === 'undefined') {
                this.mask.secure = false;
            }
            if (typeof this.mask.prefix === 'undefined') {
                this.mask.prefix = '';
            }
            if (typeof this.mask.suffix === 'undefined') {
                this.mask.suffix = '';
            }
            if (typeof this.mask.thousandSeparator === 'undefined') {
                this.mask.thousandSeparator = ',';
            }
        }
    }
}

const logger$1E = MintLogger.getLogger('MintGeocoderService');
class MintGeocoderService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintAddressModel, configService.getConfig().api.service?.geocoder ?? 'geocoder');
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async geocode(addressString) {
        return this.httpService.post(this.urlPath, { address: addressString });
    }
    async geocodeAll(addressString) {
        return this.httpService.post(`${this.urlPath}/all`, {
            address: addressString,
        });
    }
    async formatAddress(address) {
        const { formattedAddress } = (await this.httpService.post(this.urlPath + '/formatter', address));
        return formattedAddress;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintGeocoderService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintGeocoderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintGeocoderService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const countries = [
    {
        alpha2: 'AC',
        alpha3: '',
        callingCodes: ['+247'],
        currencies: ['USD'],
        flag: '',
        ioc: 'SHP',
        languages: ['eng'],
        name: 'Ascension Island',
        status: 'reserved',
    },
    {
        alpha2: 'AD',
        alpha3: 'AND',
        callingCodes: ['+376'],
        currencies: ['EUR'],
        flag: '🇦🇩',
        ioc: 'AND',
        languages: ['cat'],
        name: 'Andorra',
        status: 'assigned',
    },
    {
        alpha2: 'AE',
        alpha3: 'ARE',
        callingCodes: ['+971'],
        currencies: ['AED'],
        flag: '🇦🇪',
        ioc: 'UAE',
        languages: ['ara'],
        name: 'United Arab Emirates',
        status: 'assigned',
    },
    {
        alpha2: 'AF',
        alpha3: 'AFG',
        callingCodes: ['+93'],
        currencies: ['AFN'],
        flag: '🇦🇫',
        ioc: 'AFG',
        languages: ['pus'],
        name: 'Afghanistan',
        status: 'assigned',
    },
    {
        alpha2: 'AG',
        alpha3: 'ATG',
        callingCodes: ['+1 268'],
        currencies: ['XCD'],
        flag: '🇦🇬',
        ioc: 'ANT',
        languages: ['eng'],
        name: 'Antigua And Barbuda',
        status: 'assigned',
    },
    {
        alpha2: 'AI',
        alpha3: 'AIA',
        callingCodes: ['+1 264'],
        currencies: ['XCD'],
        flag: '🇦🇮',
        ioc: '',
        languages: ['eng'],
        name: 'Anguilla',
        status: 'assigned',
    },
    {
        alpha2: 'AI',
        alpha3: 'AFI',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'French Afar and Issas',
        status: 'deleted',
    },
    {
        alpha2: 'AL',
        alpha3: 'ALB',
        callingCodes: ['+355'],
        currencies: ['ALL'],
        flag: '🇦🇱',
        ioc: 'ALB',
        languages: ['sqi'],
        name: 'Albania',
        status: 'assigned',
    },
    {
        alpha2: 'AM',
        alpha3: 'ARM',
        callingCodes: ['+374'],
        currencies: ['AMD'],
        flag: '🇦🇲',
        ioc: 'ARM',
        languages: ['hye', 'rus'],
        name: 'Armenia',
        status: 'assigned',
    },
    {
        alpha2: 'AN',
        alpha3: 'ANT',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Netherlands Antilles',
        status: 'deleted',
    },
    {
        alpha2: 'AO',
        alpha3: 'AGO',
        callingCodes: ['+244'],
        currencies: ['AOA'],
        flag: '🇦🇴',
        ioc: 'ANG',
        languages: ['por'],
        name: 'Angola',
        status: 'assigned',
    },
    {
        alpha2: 'AQ',
        alpha3: 'ATA',
        callingCodes: ['+672'],
        currencies: [],
        flag: '🇦🇶',
        ioc: '',
        languages: [],
        name: 'Antarctica',
        status: 'assigned',
    },
    {
        alpha2: 'AR',
        alpha3: 'ARG',
        callingCodes: ['+54'],
        currencies: ['ARS'],
        flag: '🇦🇷',
        ioc: 'ARG',
        languages: ['spa'],
        name: 'Argentina',
        status: 'assigned',
    },
    {
        alpha2: 'AS',
        alpha3: 'ASM',
        callingCodes: ['+1 684'],
        currencies: ['USD'],
        flag: '🇦🇸',
        ioc: 'ASA',
        languages: ['eng', 'smo'],
        name: 'American Samoa',
        status: 'assigned',
    },
    {
        alpha2: 'AT',
        alpha3: 'AUT',
        callingCodes: ['+43'],
        currencies: ['EUR'],
        flag: '🇦🇹',
        ioc: 'AUT',
        languages: ['deu'],
        name: 'Austria',
        status: 'assigned',
    },
    {
        alpha2: 'AU',
        alpha3: 'AUS',
        callingCodes: ['+61'],
        currencies: ['AUD'],
        flag: '🇦🇺',
        ioc: 'AUS',
        languages: ['eng'],
        name: 'Australia',
        status: 'assigned',
    },
    {
        alpha2: 'AW',
        alpha3: 'ABW',
        callingCodes: ['+297'],
        currencies: ['AWG'],
        flag: '🇦🇼',
        ioc: 'ARU',
        languages: ['nld'],
        name: 'Aruba',
        status: 'assigned',
    },
    {
        alpha2: 'AX',
        alpha3: 'ALA',
        callingCodes: ['+358'],
        currencies: ['EUR'],
        flag: '🇦🇽',
        ioc: '',
        languages: ['swe'],
        name: 'Åland Islands',
        status: 'assigned',
    },
    {
        alpha2: 'AZ',
        alpha3: 'AZE',
        callingCodes: ['+994'],
        currencies: ['AZN'],
        flag: '🇦🇿',
        ioc: 'AZE',
        languages: ['aze'],
        name: 'Azerbaijan',
        status: 'assigned',
    },
    {
        alpha2: 'BA',
        alpha3: 'BIH',
        callingCodes: ['+387'],
        currencies: ['BAM'],
        flag: '🇧🇦',
        ioc: 'BIH',
        languages: ['bos', 'cre', 'srp'],
        name: 'Bosnia & Herzegovina',
        status: 'assigned',
    },
    {
        alpha2: 'BB',
        alpha3: 'BRB',
        callingCodes: ['+1 246'],
        currencies: ['BBD'],
        flag: '🇧🇧',
        ioc: 'BAR',
        languages: ['eng'],
        name: 'Barbados',
        status: 'assigned',
    },
    {
        alpha2: 'BD',
        alpha3: 'BGD',
        callingCodes: ['+880'],
        currencies: ['BDT'],
        flag: '🇧🇩',
        ioc: 'BAN',
        languages: ['ben'],
        name: 'Bangladesh',
        status: 'assigned',
    },
    {
        alpha2: 'BE',
        alpha3: 'BEL',
        callingCodes: ['+32'],
        currencies: ['EUR'],
        flag: '🇧🇪',
        ioc: 'BEL',
        languages: ['nld', 'fra', 'deu'],
        name: 'Belgium',
        status: 'assigned',
    },
    {
        alpha2: 'BF',
        alpha3: 'BFA',
        callingCodes: ['+226'],
        currencies: ['XOF'],
        flag: '🇧🇫',
        ioc: 'BUR',
        languages: ['fra'],
        name: 'Burkina Faso',
        status: 'assigned',
    },
    {
        alpha2: 'BG',
        alpha3: 'BGR',
        callingCodes: ['+359'],
        currencies: ['BGN'],
        flag: '🇧🇬',
        ioc: 'BUL',
        languages: ['bul'],
        name: 'Bulgaria',
        status: 'assigned',
    },
    {
        alpha2: 'BH',
        alpha3: 'BHR',
        callingCodes: ['+973'],
        currencies: ['BHD'],
        flag: '🇧🇭',
        ioc: 'BRN',
        languages: ['ara'],
        name: 'Bahrain',
        status: 'assigned',
    },
    {
        alpha2: 'BI',
        alpha3: 'BDI',
        callingCodes: ['+257'],
        currencies: ['BIF'],
        flag: '🇧🇮',
        ioc: 'BDI',
        languages: ['fra'],
        name: 'Burundi',
        status: 'assigned',
    },
    {
        alpha2: 'BJ',
        alpha3: 'BEN',
        callingCodes: ['+229'],
        currencies: ['XOF'],
        flag: '🇧🇯',
        ioc: 'BEN',
        languages: ['fra'],
        name: 'Benin',
        status: 'assigned',
    },
    {
        alpha2: 'BL',
        alpha3: 'BLM',
        callingCodes: ['+590'],
        currencies: ['EUR'],
        flag: '🇧🇱',
        ioc: '',
        languages: ['fra'],
        name: 'Saint Barthélemy',
        status: 'assigned',
    },
    {
        alpha2: 'BM',
        alpha3: 'BMU',
        callingCodes: ['+1 441'],
        currencies: ['BMD'],
        flag: '🇧🇲',
        ioc: 'BER',
        languages: ['eng'],
        name: 'Bermuda',
        status: 'assigned',
    },
    {
        alpha2: 'BN',
        alpha3: 'BRN',
        callingCodes: ['+673'],
        currencies: ['BND'],
        flag: '🇧🇳',
        ioc: 'BRU',
        languages: ['msa', 'eng'],
        name: 'Brunei Darussalam',
        status: 'assigned',
    },
    {
        alpha2: 'BO',
        alpha3: 'BOL',
        callingCodes: ['+591'],
        currencies: ['BOB', 'BOV'],
        flag: '🇧🇴',
        ioc: 'BOL',
        languages: ['spa', 'aym', 'que'],
        name: 'Bolivia, Plurinational State Of',
        status: 'assigned',
    },
    {
        alpha2: 'BQ',
        alpha3: 'BES',
        callingCodes: ['+599'],
        currencies: ['USD'],
        flag: '🇧🇶',
        ioc: '',
        languages: ['nld'],
        name: 'Bonaire, Saint Eustatius And Saba',
        status: 'assigned',
    },
    {
        alpha2: 'BQ',
        alpha3: 'ATB',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'British Antarctic Territory',
        status: 'deleted',
    },
    {
        alpha2: 'BR',
        alpha3: 'BRA',
        callingCodes: ['+55'],
        currencies: ['BRL'],
        flag: '🇧🇷',
        ioc: 'BRA',
        languages: ['por'],
        name: 'Brazil',
        status: 'assigned',
    },
    {
        alpha2: 'BS',
        alpha3: 'BHS',
        callingCodes: ['+1 242'],
        currencies: ['BSD'],
        flag: '🇧🇸',
        ioc: 'BAH',
        languages: ['eng'],
        name: 'Bahamas',
        status: 'assigned',
    },
    {
        alpha2: 'BT',
        alpha3: 'BTN',
        callingCodes: ['+975'],
        currencies: ['INR', 'BTN'],
        flag: '🇧🇹',
        ioc: 'BHU',
        languages: ['dzo'],
        name: 'Bhutan',
        status: 'assigned',
    },
    {
        alpha2: 'BU',
        alpha3: 'BUR',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Burma',
        status: 'deleted',
    },
    {
        alpha2: 'BV',
        alpha3: 'BVT',
        callingCodes: [],
        currencies: ['NOK'],
        flag: '🇧🇻',
        ioc: '',
        languages: [],
        name: 'Bouvet Island',
        status: 'assigned',
    },
    {
        alpha2: 'BW',
        alpha3: 'BWA',
        callingCodes: ['+267'],
        currencies: ['BWP'],
        flag: '🇧🇼',
        ioc: 'BOT',
        languages: ['eng', 'tsn'],
        name: 'Botswana',
        status: 'assigned',
    },
    {
        alpha2: 'BY',
        alpha3: 'BLR',
        callingCodes: ['+375'],
        currencies: ['BYR'],
        flag: '🇧🇾',
        ioc: 'BLR',
        languages: ['bel', 'rus'],
        name: 'Belarus',
        status: 'assigned',
    },
    {
        alpha2: 'BY',
        alpha3: 'BYS',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Byelorussian SSR',
        status: 'deleted',
    },
    {
        alpha2: 'BZ',
        alpha3: 'BLZ',
        callingCodes: ['+501'],
        currencies: ['BZD'],
        flag: '🇧🇿',
        ioc: 'BIZ',
        languages: ['eng'],
        name: 'Belize',
        status: 'assigned',
    },
    {
        alpha2: 'CA',
        alpha3: 'CAN',
        callingCodes: ['+1'],
        currencies: ['CAD'],
        flag: '🇨🇦',
        ioc: 'CAN',
        languages: ['eng', 'fra'],
        name: 'Canada',
        status: 'assigned',
    },
    {
        alpha2: 'CC',
        alpha3: 'CCK',
        callingCodes: ['+61'],
        currencies: ['AUD'],
        flag: '🇨🇨',
        ioc: '',
        languages: ['eng'],
        name: 'Cocos (Keeling) Islands',
        status: 'assigned',
    },
    {
        alpha2: 'CD',
        alpha3: 'COD',
        callingCodes: ['+243'],
        currencies: ['CDF'],
        flag: '🇨🇩',
        ioc: 'COD',
        languages: ['fra', 'lin', 'kon', 'swa'],
        name: 'Democratic Republic Of Congo',
        status: 'assigned',
    },
    {
        alpha2: 'CF',
        alpha3: 'CAF',
        callingCodes: ['+236'],
        currencies: ['XAF'],
        flag: '🇨🇫',
        ioc: 'CAF',
        languages: ['fra', 'sag'],
        name: 'Central African Republic',
        status: 'assigned',
    },
    {
        alpha2: 'CG',
        alpha3: 'COG',
        callingCodes: ['+242'],
        currencies: ['XAF'],
        flag: '🇨🇬',
        ioc: 'CGO',
        languages: ['fra', 'lin'],
        name: 'Republic Of Congo',
        status: 'assigned',
    },
    {
        alpha2: 'CH',
        alpha3: 'CHE',
        callingCodes: ['+41'],
        currencies: ['CHF', 'CHE', 'CHW'],
        flag: '🇨🇭',
        ioc: 'SUI',
        languages: ['deu', 'fra', 'ita', 'roh'],
        name: 'Switzerland',
        status: 'assigned',
    },
    {
        alpha2: 'CI',
        alpha3: 'CIV',
        callingCodes: ['+225'],
        currencies: ['XOF'],
        flag: '🇨🇮',
        ioc: 'CIV',
        languages: ['fra'],
        name: `Côte d'Ivoire`,
        status: 'assigned',
    },
    {
        alpha2: 'CK',
        alpha3: 'COK',
        callingCodes: ['+682'],
        currencies: ['NZD'],
        flag: '🇨🇰',
        ioc: 'COK',
        languages: ['eng', 'mri'],
        name: 'Cook Islands',
        status: 'assigned',
    },
    {
        alpha2: 'CL',
        alpha3: 'CHL',
        callingCodes: ['+56'],
        currencies: ['CLP', 'CLF'],
        flag: '🇨🇱',
        ioc: 'CHI',
        languages: ['spa'],
        name: 'Chile',
        status: 'assigned',
    },
    {
        alpha2: 'CM',
        alpha3: 'CMR',
        callingCodes: ['+237'],
        currencies: ['XAF'],
        flag: '🇨🇲',
        ioc: 'CMR',
        languages: ['eng', 'fra'],
        name: 'Cameroon',
        status: 'assigned',
    },
    {
        alpha2: 'CN',
        alpha3: 'CHN',
        callingCodes: ['+86'],
        currencies: ['CNY'],
        flag: '🇨🇳',
        ioc: 'CHN',
        languages: ['zho'],
        name: 'China',
        status: 'assigned',
    },
    {
        alpha2: 'CO',
        alpha3: 'COL',
        callingCodes: ['+57'],
        currencies: ['COP', 'COU'],
        flag: '🇨🇴',
        ioc: 'COL',
        languages: ['spa'],
        name: 'Colombia',
        status: 'assigned',
    },
    {
        alpha2: 'CP',
        alpha3: '',
        callingCodes: [],
        currencies: ['EUR'],
        flag: '',
        ioc: '',
        languages: [],
        name: 'Clipperton Island',
        status: 'reserved',
    },
    {
        alpha2: 'CR',
        alpha3: 'CRI',
        callingCodes: ['+506'],
        currencies: ['CRC'],
        flag: '🇨🇷',
        ioc: 'CRC',
        languages: ['spa'],
        name: 'Costa Rica',
        status: 'assigned',
    },
    {
        alpha2: 'CS',
        alpha3: 'CSK',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Czechoslovakia',
        status: 'deleted',
    },
    {
        alpha2: 'CS',
        alpha3: 'SCG',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Serbia and Montenegro',
        status: 'deleted',
    },
    {
        alpha2: 'CT',
        alpha3: 'CTE',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Canton and Enderbury Islands',
        status: 'deleted',
    },
    {
        alpha2: 'CU',
        alpha3: 'CUB',
        callingCodes: ['+53'],
        currencies: ['CUP', 'CUC'],
        flag: '🇨🇺',
        ioc: 'CUB',
        languages: ['spa'],
        name: 'Cuba',
        status: 'assigned',
    },
    {
        alpha2: 'CV',
        alpha3: 'CPV',
        callingCodes: ['+238'],
        currencies: ['CVE'],
        flag: '🇨🇻',
        ioc: 'CPV',
        languages: ['por'],
        name: 'Cabo Verde',
        status: 'assigned',
    },
    {
        alpha2: 'CW',
        alpha3: 'CUW',
        callingCodes: ['+599'],
        currencies: ['ANG'],
        flag: '🇨🇼',
        ioc: '',
        languages: ['nld'],
        name: 'Curacao',
        status: 'assigned',
    },
    {
        alpha2: 'CX',
        alpha3: 'CXR',
        callingCodes: ['+61'],
        currencies: ['AUD'],
        flag: '🇨🇽',
        ioc: '',
        languages: ['eng'],
        name: 'Christmas Island',
        status: 'assigned',
    },
    {
        alpha2: 'CY',
        alpha3: 'CYP',
        callingCodes: ['+357'],
        currencies: ['EUR'],
        flag: '🇨🇾',
        ioc: 'CYP',
        languages: ['ell', 'tur'],
        name: 'Cyprus',
        status: 'assigned',
    },
    {
        alpha2: 'CZ',
        alpha3: 'CZE',
        callingCodes: ['+420'],
        currencies: ['CZK'],
        flag: '🇨🇿',
        ioc: 'CZE',
        languages: ['ces'],
        name: 'Czech Republic',
        status: 'assigned',
    },
    {
        alpha2: 'DD',
        alpha3: 'DDR',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'German Democratic Republic',
        status: 'deleted',
    },
    {
        alpha2: 'DE',
        alpha3: 'DEU',
        callingCodes: ['+49'],
        currencies: ['EUR'],
        flag: '🇩🇪',
        ioc: 'GER',
        languages: ['deu'],
        name: 'Germany',
        status: 'assigned',
    },
    {
        alpha2: 'DG',
        alpha3: '',
        callingCodes: [],
        currencies: ['USD'],
        flag: '',
        ioc: '',
        languages: [],
        name: 'Diego Garcia',
        status: 'reserved',
    },
    {
        alpha2: 'DJ',
        alpha3: 'DJI',
        callingCodes: ['+253'],
        currencies: ['DJF'],
        flag: '🇩🇯',
        ioc: 'DJI',
        languages: ['ara', 'fra'],
        name: 'Djibouti',
        status: 'assigned',
    },
    {
        alpha2: 'DK',
        alpha3: 'DNK',
        callingCodes: ['+45'],
        currencies: ['DKK'],
        flag: '🇩🇰',
        ioc: 'DEN',
        languages: ['dan'],
        name: 'Denmark',
        status: 'assigned',
    },
    {
        alpha2: 'DM',
        alpha3: 'DMA',
        callingCodes: ['+1 767'],
        currencies: ['XCD'],
        flag: '🇩🇲',
        ioc: 'DMA',
        languages: ['eng'],
        name: 'Dominica',
        status: 'assigned',
    },
    {
        alpha2: 'DO',
        alpha3: 'DOM',
        callingCodes: ['+1 809', '+1 829', '+1 849'],
        currencies: ['DOP'],
        flag: '🇩🇴',
        ioc: 'DOM',
        languages: ['spa'],
        name: 'Dominican Republic',
        status: 'assigned',
    },
    {
        alpha2: 'DY',
        alpha3: 'DHY',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Dahomey',
        status: 'deleted',
    },
    {
        alpha2: 'DZ',
        alpha3: 'DZA',
        callingCodes: ['+213'],
        currencies: ['DZD'],
        flag: '🇩🇿',
        ioc: 'ALG',
        languages: ['ara'],
        name: 'Algeria',
        status: 'assigned',
    },
    {
        alpha2: 'EA',
        alpha3: '',
        callingCodes: [],
        currencies: ['EUR'],
        flag: '',
        ioc: '',
        languages: [],
        name: 'Ceuta, Mulilla',
        status: 'reserved',
    },
    {
        alpha2: 'EC',
        alpha3: 'ECU',
        callingCodes: ['+593'],
        currencies: ['USD'],
        flag: '🇪🇨',
        ioc: 'ECU',
        languages: ['spa', 'que'],
        name: 'Ecuador',
        status: 'assigned',
    },
    {
        alpha2: 'EE',
        alpha3: 'EST',
        callingCodes: ['+372'],
        currencies: ['EUR'],
        flag: '🇪🇪',
        ioc: 'EST',
        languages: ['est'],
        name: 'Estonia',
        status: 'assigned',
    },
    {
        alpha2: 'EG',
        alpha3: 'EGY',
        callingCodes: ['+20'],
        currencies: ['EGP'],
        flag: '🇪🇬',
        ioc: 'EGY',
        languages: ['ara'],
        name: 'Egypt',
        status: 'assigned',
    },
    {
        alpha2: 'EH',
        alpha3: 'ESH',
        callingCodes: ['+212'],
        currencies: ['MAD'],
        flag: '🇪🇭',
        ioc: '',
        languages: [],
        name: 'Western Sahara',
        status: 'assigned',
    },
    {
        alpha2: 'ER',
        alpha3: 'ERI',
        callingCodes: ['+291'],
        currencies: ['ERN'],
        flag: '🇪🇷',
        ioc: 'ERI',
        languages: ['eng', 'ara', 'tir'],
        name: 'Eritrea',
        status: 'assigned',
    },
    {
        alpha2: 'ES',
        alpha3: 'ESP',
        callingCodes: ['+34'],
        currencies: ['EUR'],
        flag: '🇪🇸',
        ioc: 'ESP',
        languages: ['spa'],
        name: 'Spain',
        status: 'assigned',
    },
    {
        alpha2: 'ET',
        alpha3: 'ETH',
        callingCodes: ['+251'],
        currencies: ['ETB'],
        flag: '🇪🇹',
        ioc: 'ETH',
        languages: ['amh'],
        name: 'Ethiopia',
        status: 'assigned',
    },
    {
        alpha2: 'EU',
        alpha3: '',
        callingCodes: ['+388'],
        currencies: ['EUR'],
        flag: '🇪🇺',
        ioc: '',
        languages: [],
        name: 'European Union',
        status: 'reserved',
    },
    {
        alpha2: 'FI',
        alpha3: 'FIN',
        callingCodes: ['+358'],
        currencies: ['EUR'],
        flag: '🇫🇮',
        ioc: 'FIN',
        languages: ['fin', 'swe'],
        name: 'Finland',
        status: 'assigned',
    },
    {
        alpha2: 'FJ',
        alpha3: 'FJI',
        callingCodes: ['+679'],
        currencies: ['FJD'],
        flag: '🇫🇯',
        ioc: 'FIJ',
        languages: ['eng', 'fij'],
        name: 'Fiji',
        status: 'assigned',
    },
    {
        alpha2: 'FK',
        alpha3: 'FLK',
        callingCodes: ['+500'],
        currencies: ['FKP'],
        flag: '🇫🇰',
        ioc: '',
        languages: ['eng'],
        name: 'Falkland Islands',
        status: 'assigned',
    },
    {
        alpha2: 'FM',
        alpha3: 'FSM',
        callingCodes: ['+691'],
        currencies: ['USD'],
        flag: '🇫🇲',
        ioc: 'FSM',
        languages: ['eng'],
        name: 'Micronesia, Federated States Of',
        status: 'assigned',
    },
    {
        alpha2: 'FO',
        alpha3: 'FRO',
        callingCodes: ['+298'],
        currencies: ['DKK'],
        flag: '🇫🇴',
        ioc: 'FAI',
        languages: ['fao', 'dan'],
        name: 'Faroe Islands',
        status: 'assigned',
    },
    {
        alpha2: 'FQ',
        alpha3: 'ATF',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'French Southern and Antarctic Territories',
        status: 'deleted',
    },
    {
        alpha2: 'FR',
        alpha3: 'FRA',
        callingCodes: ['+33'],
        currencies: ['EUR'],
        flag: '🇫🇷',
        ioc: 'FRA',
        languages: ['fra'],
        name: 'France',
        status: 'assigned',
    },
    {
        alpha2: 'FX',
        alpha3: '',
        callingCodes: ['+241'],
        currencies: ['EUR'],
        flag: '',
        ioc: '',
        languages: ['fra'],
        name: 'France, Metropolitan',
        status: 'reserved',
    },
    {
        alpha2: 'GA',
        alpha3: 'GAB',
        callingCodes: ['+241'],
        currencies: ['XAF'],
        flag: '🇬🇦',
        ioc: 'GAB',
        languages: ['fra'],
        name: 'Gabon',
        status: 'assigned',
    },
    {
        alpha2: 'GB',
        alpha3: 'GBR',
        callingCodes: ['+44'],
        currencies: ['GBP'],
        flag: '🇬🇧',
        ioc: 'GBR',
        languages: ['eng', 'cor', 'gle', 'gla', 'cym'],
        name: 'United Kingdom',
        status: 'assigned',
    },
    {
        alpha2: 'GD',
        alpha3: 'GRD',
        callingCodes: ['+473'],
        currencies: ['XCD'],
        flag: '🇬🇩',
        ioc: 'GRN',
        languages: ['eng'],
        name: 'Grenada',
        status: 'assigned',
    },
    {
        alpha2: 'GE',
        alpha3: 'GEO',
        callingCodes: ['+995'],
        currencies: ['GEL'],
        flag: '🇬🇪',
        ioc: 'GEO',
        languages: ['kat'],
        name: 'Georgia',
        status: 'assigned',
    },
    {
        alpha2: 'GE',
        alpha3: 'GEL',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Gilbert and Ellice Islands',
        status: 'deleted',
    },
    {
        alpha2: 'GF',
        alpha3: 'GUF',
        callingCodes: ['+594'],
        currencies: ['EUR'],
        flag: '🇬🇫',
        ioc: '',
        languages: ['fra'],
        name: 'French Guiana',
        status: 'assigned',
    },
    {
        alpha2: 'GG',
        alpha3: 'GGY',
        callingCodes: ['+44'],
        currencies: ['GBP'],
        flag: '🇬🇬',
        ioc: 'GCI',
        languages: ['fra'],
        name: 'Guernsey',
        status: 'assigned',
    },
    {
        alpha2: 'GH',
        alpha3: 'GHA',
        callingCodes: ['+233'],
        currencies: ['GHS'],
        flag: '🇬🇭',
        ioc: 'GHA',
        languages: ['eng'],
        name: 'Ghana',
        status: 'assigned',
    },
    {
        alpha2: 'GI',
        alpha3: 'GIB',
        callingCodes: ['+350'],
        currencies: ['GIP'],
        flag: '🇬🇮',
        ioc: '',
        languages: ['eng'],
        name: 'Gibraltar',
        status: 'assigned',
    },
    {
        alpha2: 'GL',
        alpha3: 'GRL',
        callingCodes: ['+299'],
        currencies: ['DKK'],
        flag: '🇬🇱',
        ioc: '',
        languages: ['kal'],
        name: 'Greenland',
        status: 'assigned',
    },
    {
        alpha2: 'GM',
        alpha3: 'GMB',
        callingCodes: ['+220'],
        currencies: ['GMD'],
        flag: '🇬🇲',
        ioc: 'GAM',
        languages: ['eng'],
        name: 'Gambia',
        status: 'assigned',
    },
    {
        alpha2: 'GN',
        alpha3: 'GIN',
        callingCodes: ['+224'],
        currencies: ['GNF'],
        flag: '🇬🇳',
        ioc: 'GUI',
        languages: ['fra'],
        name: 'Guinea',
        status: 'assigned',
    },
    {
        alpha2: 'GP',
        alpha3: 'GLP',
        callingCodes: ['+590'],
        currencies: ['EUR'],
        flag: '🇬🇵',
        ioc: '',
        languages: ['fra'],
        name: 'Guadeloupe',
        status: 'assigned',
    },
    {
        alpha2: 'GQ',
        alpha3: 'GNQ',
        callingCodes: ['+240'],
        currencies: ['XAF'],
        flag: '🇬🇶',
        ioc: 'GEQ',
        languages: ['spa', 'fra', 'por'],
        name: 'Equatorial Guinea',
        status: 'assigned',
    },
    {
        alpha2: 'GR',
        alpha3: 'GRC',
        callingCodes: ['+30'],
        currencies: ['EUR'],
        flag: '🇬🇷',
        ioc: 'GRE',
        languages: ['ell'],
        name: 'Greece',
        status: 'assigned',
    },
    {
        alpha2: 'GS',
        alpha3: 'SGS',
        callingCodes: [],
        currencies: ['GBP'],
        flag: '🇬🇸',
        ioc: '',
        languages: ['eng'],
        name: 'South Georgia And The South Sandwich Islands',
        status: 'assigned',
    },
    {
        alpha2: 'GT',
        alpha3: 'GTM',
        callingCodes: ['+502'],
        currencies: ['GTQ'],
        flag: '🇬🇹',
        ioc: 'GUA',
        languages: ['spa'],
        name: 'Guatemala',
        status: 'assigned',
    },
    {
        alpha2: 'GU',
        alpha3: 'GUM',
        callingCodes: ['+1 671'],
        currencies: ['USD'],
        flag: '🇬🇺',
        ioc: 'GUM',
        languages: ['eng'],
        name: 'Guam',
        status: 'assigned',
    },
    {
        alpha2: 'GW',
        alpha3: 'GNB',
        callingCodes: ['+245'],
        currencies: ['XOF'],
        flag: '🇬🇼',
        ioc: 'GBS',
        languages: ['por'],
        name: 'Guinea-bissau',
        status: 'assigned',
    },
    {
        alpha2: 'GY',
        alpha3: 'GUY',
        callingCodes: ['+592'],
        currencies: ['GYD'],
        flag: '🇬🇾',
        ioc: 'GUY',
        languages: ['eng'],
        name: 'Guyana',
        status: 'assigned',
    },
    {
        alpha2: 'HK',
        alpha3: 'HKG',
        callingCodes: ['+852'],
        currencies: ['HKD'],
        flag: '🇭🇰',
        ioc: 'HKG',
        languages: ['zho', 'eng'],
        name: 'Hong Kong',
        status: 'assigned',
    },
    {
        alpha2: 'HM',
        alpha3: 'HMD',
        callingCodes: [],
        currencies: ['AUD'],
        flag: '🇭🇲',
        ioc: '',
        languages: [],
        name: 'Heard Island And McDonald Islands',
        status: 'assigned',
    },
    {
        alpha2: 'HN',
        alpha3: 'HND',
        callingCodes: ['+504'],
        currencies: ['HNL'],
        flag: '🇭🇳',
        ioc: 'HON',
        languages: ['spa'],
        name: 'Honduras',
        status: 'assigned',
    },
    {
        alpha2: 'HR',
        alpha3: 'HRV',
        callingCodes: ['+385'],
        currencies: ['HRK'],
        flag: '🇭🇷',
        ioc: 'CRO',
        languages: ['hrv'],
        name: 'Croatia',
        status: 'assigned',
    },
    {
        alpha2: 'HT',
        alpha3: 'HTI',
        callingCodes: ['+509'],
        currencies: ['HTG', 'USD'],
        flag: '🇭🇹',
        ioc: 'HAI',
        languages: ['fra', 'hat'],
        name: 'Haiti',
        status: 'assigned',
    },
    {
        alpha2: 'HU',
        alpha3: 'HUN',
        callingCodes: ['+36'],
        currencies: ['HUF'],
        flag: '🇭🇺',
        ioc: 'HUN',
        languages: ['hun'],
        name: 'Hungary',
        status: 'assigned',
    },
    {
        alpha2: 'HV',
        alpha3: 'HVO',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Upper Volta',
        status: 'deleted',
    },
    {
        alpha2: 'IC',
        alpha3: '',
        callingCodes: [],
        currencies: ['EUR'],
        flag: '',
        ioc: '',
        languages: [],
        name: 'Canary Islands',
        status: 'reserved',
    },
    {
        alpha2: 'ID',
        alpha3: 'IDN',
        callingCodes: ['+62'],
        currencies: ['IDR'],
        flag: '🇮🇩',
        ioc: 'INA',
        languages: ['ind'],
        name: 'Indonesia',
        status: 'assigned',
    },
    {
        alpha2: 'IE',
        alpha3: 'IRL',
        callingCodes: ['+353'],
        currencies: ['EUR'],
        flag: '🇮🇪',
        ioc: 'IRL',
        languages: ['eng', 'gle'],
        name: 'Ireland',
        status: 'assigned',
    },
    {
        alpha2: 'IL',
        alpha3: 'ISR',
        callingCodes: ['+972'],
        currencies: ['ILS'],
        flag: '🇮🇱',
        ioc: 'ISR',
        languages: ['heb', 'ara', 'eng'],
        name: 'Israel',
        status: 'assigned',
    },
    {
        alpha2: 'IM',
        alpha3: 'IMN',
        callingCodes: ['+44'],
        currencies: ['GBP'],
        flag: '🇮🇲',
        ioc: '',
        languages: ['eng', 'glv'],
        name: 'Isle Of Man',
        status: 'assigned',
    },
    {
        alpha2: 'IN',
        alpha3: 'IND',
        callingCodes: ['+91'],
        currencies: ['INR'],
        flag: '🇮🇳',
        ioc: 'IND',
        languages: ['eng', 'hin'],
        name: 'India',
        status: 'assigned',
    },
    {
        alpha2: 'IO',
        alpha3: 'IOT',
        callingCodes: ['+246'],
        currencies: ['USD'],
        flag: '🇮🇴',
        ioc: '',
        languages: ['eng'],
        name: 'British Indian Ocean Territory',
        status: 'assigned',
    },
    {
        alpha2: 'IQ',
        alpha3: 'IRQ',
        callingCodes: ['+964'],
        currencies: ['IQD'],
        flag: '🇮🇶',
        ioc: 'IRQ',
        languages: ['ara', 'kur'],
        name: 'Iraq',
        status: 'assigned',
    },
    {
        alpha2: 'IR',
        alpha3: 'IRN',
        callingCodes: ['+98'],
        currencies: ['IRR'],
        flag: '🇮🇷',
        ioc: 'IRI',
        languages: ['fas'],
        name: 'Iran, Islamic Republic Of',
        status: 'assigned',
    },
    {
        alpha2: 'IS',
        alpha3: 'ISL',
        callingCodes: ['+354'],
        currencies: ['ISK'],
        flag: '🇮🇸',
        ioc: 'ISL',
        languages: ['isl'],
        name: 'Iceland',
        status: 'assigned',
    },
    {
        alpha2: 'IT',
        alpha3: 'ITA',
        callingCodes: ['+39'],
        currencies: ['EUR'],
        flag: '🇮🇹',
        ioc: 'ITA',
        languages: ['ita'],
        name: 'Italy',
        status: 'assigned',
    },
    {
        alpha2: 'JE',
        alpha3: 'JEY',
        callingCodes: ['+44'],
        currencies: ['GBP'],
        flag: '🇯🇪',
        ioc: 'JCI',
        languages: ['eng', 'fra'],
        name: 'Jersey',
        status: 'assigned',
    },
    {
        alpha2: 'JM',
        alpha3: 'JAM',
        callingCodes: ['+1 876'],
        currencies: ['JMD'],
        flag: '🇯🇲',
        ioc: 'JAM',
        languages: ['eng'],
        name: 'Jamaica',
        status: 'assigned',
    },
    {
        alpha2: 'JO',
        alpha3: 'JOR',
        callingCodes: ['+962'],
        currencies: ['JOD'],
        flag: '🇯🇴',
        ioc: 'JOR',
        languages: ['ara'],
        name: 'Jordan',
        status: 'assigned',
    },
    {
        alpha2: 'JP',
        alpha3: 'JPN',
        callingCodes: ['+81'],
        currencies: ['JPY'],
        flag: '🇯🇵',
        ioc: 'JPN',
        languages: ['jpn'],
        name: 'Japan',
        status: 'assigned',
    },
    {
        alpha2: 'JT',
        alpha3: 'JTN',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Johnston Island',
        status: 'deleted',
    },
    {
        alpha2: 'KE',
        alpha3: 'KEN',
        callingCodes: ['+254'],
        currencies: ['KES'],
        flag: '🇰🇪',
        ioc: 'KEN',
        languages: ['eng', 'swa'],
        name: 'Kenya',
        status: 'assigned',
    },
    {
        alpha2: 'KG',
        alpha3: 'KGZ',
        callingCodes: ['+996'],
        currencies: ['KGS'],
        flag: '🇰🇬',
        ioc: 'KGZ',
        languages: ['rus'],
        name: 'Kyrgyzstan',
        status: 'assigned',
    },
    {
        alpha2: 'KH',
        alpha3: 'KHM',
        callingCodes: ['+855'],
        currencies: ['KHR'],
        flag: '🇰🇭',
        ioc: 'CAM',
        languages: ['khm'],
        name: 'Cambodia',
        status: 'assigned',
    },
    {
        alpha2: 'KI',
        alpha3: 'KIR',
        callingCodes: ['+686'],
        currencies: ['AUD'],
        flag: '🇰🇮',
        ioc: 'KIR',
        languages: ['eng'],
        name: 'Kiribati',
        status: 'assigned',
    },
    {
        alpha2: 'KM',
        alpha3: 'COM',
        callingCodes: ['+269'],
        currencies: ['KMF'],
        flag: '🇰🇲',
        ioc: 'COM',
        languages: ['ara', 'fra'],
        name: 'Comoros',
        status: 'assigned',
    },
    {
        alpha2: 'KN',
        alpha3: 'KNA',
        callingCodes: ['+1 869'],
        currencies: ['XCD'],
        flag: '🇰🇳',
        ioc: 'SKN',
        languages: ['eng'],
        name: 'Saint Kitts And Nevis',
        status: 'assigned',
    },
    {
        alpha2: 'KP',
        alpha3: 'PRK',
        callingCodes: ['+850'],
        currencies: ['KPW'],
        flag: '🇰🇵',
        ioc: 'PRK',
        languages: ['kor'],
        name: `Korea, Democratic People's Republic Of`,
        status: 'assigned',
    },
    {
        alpha2: 'KR',
        alpha3: 'KOR',
        callingCodes: ['+82'],
        currencies: ['KRW'],
        flag: '🇰🇷',
        ioc: 'KOR',
        languages: ['kor'],
        name: 'Korea, Republic Of',
        status: 'assigned',
    },
    {
        alpha2: 'KW',
        alpha3: 'KWT',
        callingCodes: ['+965'],
        currencies: ['KWD'],
        flag: '🇰🇼',
        ioc: 'KUW',
        languages: ['ara'],
        name: 'Kuwait',
        status: 'assigned',
    },
    {
        alpha2: 'KY',
        alpha3: 'CYM',
        callingCodes: ['+1 345'],
        currencies: ['KYD'],
        flag: '🇰🇾',
        ioc: 'CAY',
        languages: ['eng'],
        name: 'Cayman Islands',
        status: 'assigned',
    },
    {
        alpha2: 'KZ',
        alpha3: 'KAZ',
        callingCodes: ['+7', '+7 6', '+7 7'],
        currencies: ['KZT'],
        flag: '🇰🇿',
        ioc: 'KAZ',
        languages: ['kaz', 'rus'],
        name: 'Kazakhstan',
        status: 'assigned',
    },
    {
        alpha2: 'LA',
        alpha3: 'LAO',
        callingCodes: ['+856'],
        currencies: ['LAK'],
        flag: '🇱🇦',
        ioc: 'LAO',
        languages: ['lao'],
        name: `Lao People's Democratic Republic`,
        status: 'assigned',
    },
    {
        alpha2: 'LB',
        alpha3: 'LBN',
        callingCodes: ['+961'],
        currencies: ['LBP'],
        flag: '🇱🇧',
        ioc: 'LIB',
        languages: ['ara', 'hye'],
        name: 'Lebanon',
        status: 'assigned',
    },
    {
        alpha2: 'LC',
        alpha3: 'LCA',
        callingCodes: ['+1 758'],
        currencies: ['XCD'],
        flag: '🇱🇨',
        ioc: 'LCA',
        languages: ['eng'],
        name: 'Saint Lucia',
        status: 'assigned',
    },
    {
        alpha2: 'LI',
        alpha3: 'LIE',
        callingCodes: ['+423'],
        currencies: ['CHF'],
        flag: '🇱🇮',
        ioc: 'LIE',
        languages: ['deu'],
        name: 'Liechtenstein',
        status: 'assigned',
    },
    {
        alpha2: 'LK',
        alpha3: 'LKA',
        callingCodes: ['+94'],
        currencies: ['LKR'],
        flag: '🇱🇰',
        ioc: 'SRI',
        languages: ['sin', 'tam'],
        name: 'Sri Lanka',
        status: 'assigned',
    },
    {
        alpha2: 'LR',
        alpha3: 'LBR',
        callingCodes: ['+231'],
        currencies: ['LRD'],
        flag: '🇱🇷',
        ioc: 'LBR',
        languages: ['eng'],
        name: 'Liberia',
        status: 'assigned',
    },
    {
        alpha2: 'LS',
        alpha3: 'LSO',
        callingCodes: ['+266'],
        currencies: ['LSL', 'ZAR'],
        flag: '🇱🇸',
        ioc: 'LES',
        languages: ['eng', 'sot'],
        name: 'Lesotho',
        status: 'assigned',
    },
    {
        alpha2: 'LT',
        alpha3: 'LTU',
        callingCodes: ['+370'],
        currencies: ['EUR'],
        flag: '🇱🇹',
        ioc: 'LTU',
        languages: ['lit'],
        name: 'Lithuania',
        status: 'assigned',
    },
    {
        alpha2: 'LU',
        alpha3: 'LUX',
        callingCodes: ['+352'],
        currencies: ['EUR'],
        flag: '🇱🇺',
        ioc: 'LUX',
        languages: ['fra', 'deu', 'ltz'],
        name: 'Luxembourg',
        status: 'assigned',
    },
    {
        alpha2: 'LV',
        alpha3: 'LVA',
        callingCodes: ['+371'],
        currencies: ['EUR'],
        flag: '🇱🇻',
        ioc: 'LAT',
        languages: ['lav'],
        name: 'Latvia',
        status: 'assigned',
    },
    {
        alpha2: 'LY',
        alpha3: 'LBY',
        callingCodes: ['+218'],
        currencies: ['LYD'],
        flag: '🇱🇾',
        ioc: 'LBA',
        languages: ['ara'],
        name: 'Libya',
        status: 'assigned',
    },
    {
        alpha2: 'MA',
        alpha3: 'MAR',
        callingCodes: ['+212'],
        currencies: ['MAD'],
        flag: '🇲🇦',
        ioc: 'MAR',
        languages: ['ara'],
        name: 'Morocco',
        status: 'assigned',
    },
    {
        alpha2: 'MC',
        alpha3: 'MCO',
        callingCodes: ['+377'],
        currencies: ['EUR'],
        flag: '🇲🇨',
        ioc: 'MON',
        languages: ['fra'],
        name: 'Monaco',
        status: 'assigned',
    },
    {
        alpha2: 'MD',
        alpha3: 'MDA',
        callingCodes: ['+373'],
        currencies: ['MDL'],
        flag: '🇲🇩',
        ioc: 'MDA',
        languages: ['ron'],
        name: 'Moldova',
        status: 'assigned',
    },
    {
        alpha2: 'ME',
        alpha3: 'MNE',
        callingCodes: ['+382'],
        currencies: ['EUR'],
        flag: '🇲🇪',
        ioc: 'MNE',
        languages: ['mot'],
        name: 'Montenegro',
        status: 'assigned',
    },
    {
        alpha2: 'MF',
        alpha3: 'MAF',
        callingCodes: ['+590'],
        currencies: ['EUR'],
        flag: '🇲🇫',
        ioc: '',
        languages: ['fra'],
        name: 'Saint Martin',
        status: 'assigned',
    },
    {
        alpha2: 'MG',
        alpha3: 'MDG',
        callingCodes: ['+261'],
        currencies: ['MGA'],
        flag: '🇲🇬',
        ioc: 'MAD',
        languages: ['fra', 'mlg'],
        name: 'Madagascar',
        status: 'assigned',
    },
    {
        alpha2: 'MH',
        alpha3: 'MHL',
        callingCodes: ['+692'],
        currencies: ['USD'],
        flag: '🇲🇭',
        ioc: 'MHL',
        languages: ['eng', 'mah'],
        name: 'Marshall Islands',
        status: 'assigned',
    },
    {
        alpha2: 'MI',
        alpha3: 'MID',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Midway Islands',
        status: 'deleted',
    },
    {
        alpha2: 'MK',
        alpha3: 'MKD',
        callingCodes: ['+389'],
        currencies: ['MKD'],
        flag: '🇲🇰',
        ioc: 'MKD',
        languages: ['mkd'],
        name: 'Macedonia, The Former Yugoslav Republic Of',
        status: 'assigned',
    },
    {
        alpha2: 'ML',
        alpha3: 'MLI',
        callingCodes: ['+223'],
        currencies: ['XOF'],
        flag: '🇲🇱',
        ioc: 'MLI',
        languages: ['fra'],
        name: 'Mali',
        status: 'assigned',
    },
    {
        alpha2: 'MM',
        alpha3: 'MMR',
        callingCodes: ['+95'],
        currencies: ['MMK'],
        flag: '🇲🇲',
        ioc: 'MYA',
        languages: ['mya'],
        name: 'Myanmar',
        status: 'assigned',
    },
    {
        alpha2: 'MN',
        alpha3: 'MNG',
        callingCodes: ['+976'],
        currencies: ['MNT'],
        flag: '🇲🇳',
        ioc: 'MGL',
        languages: ['mon'],
        name: 'Mongolia',
        status: 'assigned',
    },
    {
        alpha2: 'MO',
        alpha3: 'MAC',
        callingCodes: ['+853'],
        currencies: ['MOP'],
        flag: '🇲🇴',
        ioc: 'MAC',
        languages: ['zho', 'por'],
        name: 'Macao',
        status: 'assigned',
    },
    {
        alpha2: 'MP',
        alpha3: 'MNP',
        callingCodes: ['+1 670'],
        currencies: ['USD'],
        flag: '🇲🇵',
        ioc: '',
        languages: ['eng'],
        name: 'Northern Mariana Islands',
        status: 'assigned',
    },
    {
        alpha2: 'MQ',
        alpha3: 'MTQ',
        callingCodes: ['+596'],
        currencies: ['EUR'],
        flag: '🇲🇶',
        ioc: '',
        languages: [],
        name: 'Martinique',
        status: 'assigned',
    },
    {
        alpha2: 'MR',
        alpha3: 'MRT',
        callingCodes: ['+222'],
        currencies: ['MRO'],
        flag: '🇲🇷',
        ioc: 'MTN',
        languages: ['ara', 'fra'],
        name: 'Mauritania',
        status: 'assigned',
    },
    {
        alpha2: 'MS',
        alpha3: 'MSR',
        callingCodes: ['+1 664'],
        currencies: ['XCD'],
        flag: '🇲🇸',
        ioc: '',
        languages: [],
        name: 'Montserrat',
        status: 'assigned',
    },
    {
        alpha2: 'MT',
        alpha3: 'MLT',
        callingCodes: ['+356'],
        currencies: ['EUR'],
        flag: '🇲🇹',
        ioc: 'MLT',
        languages: ['mlt', 'eng'],
        name: 'Malta',
        status: 'assigned',
    },
    {
        alpha2: 'MU',
        alpha3: 'MUS',
        callingCodes: ['+230'],
        currencies: ['MUR'],
        flag: '🇲🇺',
        ioc: 'MRI',
        languages: ['eng', 'fra'],
        name: 'Mauritius',
        status: 'assigned',
    },
    {
        alpha2: 'MV',
        alpha3: 'MDV',
        callingCodes: ['+960'],
        currencies: ['MVR'],
        flag: '🇲🇻',
        ioc: 'MDV',
        languages: ['div'],
        name: 'Maldives',
        status: 'assigned',
    },
    {
        alpha2: 'MW',
        alpha3: 'MWI',
        callingCodes: ['+265'],
        currencies: ['MWK'],
        flag: '🇲🇼',
        ioc: 'MAW',
        languages: ['eng', 'nya'],
        name: 'Malawi',
        status: 'assigned',
    },
    {
        alpha2: 'MX',
        alpha3: 'MEX',
        callingCodes: ['+52'],
        currencies: ['MXN', 'MXV'],
        flag: '🇲🇽',
        ioc: 'MEX',
        languages: ['spa'],
        name: 'Mexico',
        status: 'assigned',
    },
    {
        alpha2: 'MY',
        alpha3: 'MYS',
        callingCodes: ['+60'],
        currencies: ['MYR'],
        flag: '🇲🇾',
        ioc: 'MAS',
        languages: ['msa', 'eng'],
        name: 'Malaysia',
        status: 'assigned',
    },
    {
        alpha2: 'MZ',
        alpha3: 'MOZ',
        callingCodes: ['+258'],
        currencies: ['MZN'],
        flag: '🇲🇿',
        ioc: 'MOZ',
        languages: ['por'],
        name: 'Mozambique',
        status: 'assigned',
    },
    {
        alpha2: 'NA',
        alpha3: 'NAM',
        callingCodes: ['+264'],
        currencies: ['NAD', 'ZAR'],
        flag: '🇳🇦',
        ioc: 'NAM',
        languages: ['eng'],
        name: 'Namibia',
        status: 'assigned',
    },
    {
        alpha2: 'NC',
        alpha3: 'NCL',
        callingCodes: ['+687'],
        currencies: ['XPF'],
        flag: '🇳🇨',
        ioc: '',
        languages: ['fra'],
        name: 'New Caledonia',
        status: 'assigned',
    },
    {
        alpha2: 'NE',
        alpha3: 'NER',
        callingCodes: ['+227'],
        currencies: ['XOF'],
        flag: '🇳🇪',
        ioc: 'NIG',
        languages: ['fra'],
        name: 'Niger',
        status: 'assigned',
    },
    {
        alpha2: 'NF',
        alpha3: 'NFK',
        callingCodes: ['+672'],
        currencies: ['AUD'],
        flag: '🇳🇫',
        ioc: '',
        languages: ['eng'],
        name: 'Norfolk Island',
        status: 'assigned',
    },
    {
        alpha2: 'NG',
        alpha3: 'NGA',
        callingCodes: ['+234'],
        currencies: ['NGN'],
        flag: '🇳🇬',
        ioc: 'NGR',
        languages: ['eng'],
        name: 'Nigeria',
        status: 'assigned',
    },
    {
        alpha2: 'NH',
        alpha3: 'NHB',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'New Hebrides',
        status: 'deleted',
    },
    {
        alpha2: 'NI',
        alpha3: 'NIC',
        callingCodes: ['+505'],
        currencies: ['NIO'],
        flag: '🇳🇮',
        ioc: 'NCA',
        languages: ['spa'],
        name: 'Nicaragua',
        status: 'assigned',
    },
    {
        alpha2: 'NL',
        alpha3: 'NLD',
        callingCodes: ['+31'],
        currencies: ['EUR'],
        flag: '🇳🇱',
        ioc: 'NED',
        languages: ['nld'],
        name: 'Netherlands',
        status: 'assigned',
    },
    {
        alpha2: 'NO',
        alpha3: 'NOR',
        callingCodes: ['+47'],
        currencies: ['NOK'],
        flag: '🇳🇴',
        ioc: 'NOR',
        languages: ['nor'],
        name: 'Norway',
        status: 'assigned',
    },
    {
        alpha2: 'NP',
        alpha3: 'NPL',
        callingCodes: ['+977'],
        currencies: ['NPR'],
        flag: '🇳🇵',
        ioc: 'NEP',
        languages: ['nep'],
        name: 'Nepal',
        status: 'assigned',
    },
    {
        alpha2: 'NQ',
        alpha3: 'ATN',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Dronning Maud Land',
        status: 'deleted',
    },
    {
        alpha2: 'NR',
        alpha3: 'NRU',
        callingCodes: ['+674'],
        currencies: ['AUD'],
        flag: '🇳🇷',
        ioc: 'NRU',
        languages: ['eng', 'nau'],
        name: 'Nauru',
        status: 'assigned',
    },
    {
        alpha2: 'NT',
        alpha3: 'NTZ',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Neutral Zone',
        status: 'deleted',
    },
    {
        alpha2: 'NU',
        alpha3: 'NIU',
        callingCodes: ['+683'],
        currencies: ['NZD'],
        flag: '🇳🇺',
        ioc: '',
        languages: ['eng'],
        name: 'Niue',
        status: 'assigned',
    },
    {
        alpha2: 'NZ',
        alpha3: 'NZL',
        callingCodes: ['+64'],
        currencies: ['NZD'],
        flag: '🇳🇿',
        ioc: 'NZL',
        languages: ['eng'],
        name: 'New Zealand',
        status: 'assigned',
    },
    {
        alpha2: 'OM',
        alpha3: 'OMN',
        callingCodes: ['+968'],
        currencies: ['OMR'],
        flag: '🇴🇲',
        ioc: 'OMA',
        languages: ['ara'],
        name: 'Oman',
        status: 'assigned',
    },
    {
        alpha2: 'PA',
        alpha3: 'PAN',
        callingCodes: ['+507'],
        currencies: ['PAB', 'USD'],
        flag: '🇵🇦',
        ioc: 'PAN',
        languages: ['spa'],
        name: 'Panama',
        status: 'assigned',
    },
    {
        alpha2: 'PC',
        alpha3: 'PCI',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Pacific Islands, Trust Territory of the',
        status: 'deleted',
    },
    {
        alpha2: 'PE',
        alpha3: 'PER',
        callingCodes: ['+51'],
        currencies: ['PEN'],
        flag: '🇵🇪',
        ioc: 'PER',
        languages: ['spa', 'aym', 'que'],
        name: 'Peru',
        status: 'assigned',
    },
    {
        alpha2: 'PF',
        alpha3: 'PYF',
        callingCodes: ['+689'],
        currencies: ['XPF'],
        flag: '🇵🇫',
        ioc: '',
        languages: ['fra'],
        name: 'French Polynesia',
        status: 'assigned',
    },
    {
        alpha2: 'PG',
        alpha3: 'PNG',
        callingCodes: ['+675'],
        currencies: ['PGK'],
        flag: '🇵🇬',
        ioc: 'PNG',
        languages: ['eng'],
        name: 'Papua New Guinea',
        status: 'assigned',
    },
    {
        alpha2: 'PH',
        alpha3: 'PHL',
        callingCodes: ['+63'],
        currencies: ['PHP'],
        flag: '🇵🇭',
        ioc: 'PHI',
        languages: ['eng'],
        name: 'Philippines',
        status: 'assigned',
    },
    {
        alpha2: 'PK',
        alpha3: 'PAK',
        callingCodes: ['+92'],
        currencies: ['PKR'],
        flag: '🇵🇰',
        ioc: 'PAK',
        languages: ['urd', 'eng'],
        name: 'Pakistan',
        status: 'assigned',
    },
    {
        alpha2: 'PL',
        alpha3: 'POL',
        callingCodes: ['+48'],
        currencies: ['PLN'],
        flag: '🇵🇱',
        ioc: 'POL',
        languages: ['pol'],
        name: 'Poland',
        status: 'assigned',
    },
    {
        alpha2: 'PM',
        alpha3: 'SPM',
        callingCodes: ['+508'],
        currencies: ['EUR'],
        flag: '🇵🇲',
        ioc: '',
        languages: ['eng'],
        name: 'Saint Pierre And Miquelon',
        status: 'assigned',
    },
    {
        alpha2: 'PN',
        alpha3: 'PCN',
        callingCodes: ['+872'],
        currencies: ['NZD'],
        flag: '🇵🇳',
        ioc: '',
        languages: ['eng'],
        name: 'Pitcairn',
        status: 'assigned',
    },
    {
        alpha2: 'PR',
        alpha3: 'PRI',
        callingCodes: ['+1 787', '+1 939'],
        currencies: ['USD'],
        flag: '🇵🇷',
        ioc: 'PUR',
        languages: ['spa', 'eng'],
        name: 'Puerto Rico',
        status: 'assigned',
    },
    {
        alpha2: 'PS',
        alpha3: 'PSE',
        callingCodes: ['+970'],
        currencies: ['JOD', 'EGP', 'ILS'],
        flag: '🇵🇸',
        ioc: 'PLE',
        languages: ['ara'],
        name: 'Palestinian Territory, Occupied',
        status: 'assigned',
    },
    {
        alpha2: 'PT',
        alpha3: 'PRT',
        callingCodes: ['+351'],
        currencies: ['EUR'],
        flag: '🇵🇹',
        ioc: 'POR',
        languages: ['por'],
        name: 'Portugal',
        status: 'assigned',
    },
    {
        alpha2: 'PU',
        alpha3: 'PUS',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'U.S. Miscellaneous Pacific Islands',
        status: 'deleted',
    },
    {
        alpha2: 'PW',
        alpha3: 'PLW',
        callingCodes: ['+680'],
        currencies: ['USD'],
        flag: '🇵🇼',
        ioc: 'PLW',
        languages: ['eng'],
        name: 'Palau',
        status: 'assigned',
    },
    {
        alpha2: 'PY',
        alpha3: 'PRY',
        callingCodes: ['+595'],
        currencies: ['PYG'],
        flag: '🇵🇾',
        ioc: 'PAR',
        languages: ['spa'],
        name: 'Paraguay',
        status: 'assigned',
    },
    {
        alpha2: 'PZ',
        alpha3: 'PCZ',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Panama Canal Zone',
        status: 'deleted',
    },
    {
        alpha2: 'QA',
        alpha3: 'QAT',
        callingCodes: ['+974'],
        currencies: ['QAR'],
        flag: '🇶🇦',
        ioc: 'QAT',
        languages: ['ara'],
        name: 'Qatar',
        status: 'assigned',
    },
    {
        alpha2: 'RE',
        alpha3: 'REU',
        callingCodes: ['+262'],
        currencies: ['EUR'],
        flag: '🇷🇪',
        ioc: '',
        languages: ['fra'],
        name: 'Reunion',
        status: 'assigned',
    },
    {
        alpha2: 'RH',
        alpha3: 'RHO',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Southern Rhodesia',
        status: 'deleted',
    },
    {
        alpha2: 'RO',
        alpha3: 'ROU',
        callingCodes: ['+40'],
        currencies: ['RON'],
        flag: '🇷🇴',
        ioc: 'ROU',
        languages: ['ron'],
        name: 'Romania',
        status: 'assigned',
    },
    {
        alpha2: 'RS',
        alpha3: 'SRB',
        callingCodes: ['+381'],
        currencies: ['RSD'],
        flag: '🇷🇸',
        ioc: 'SRB',
        languages: ['srp'],
        name: 'Serbia',
        status: 'assigned',
    },
    {
        alpha2: 'RU',
        alpha3: 'RUS',
        callingCodes: ['+7', '+7 3', '+7 4', '+7 8'],
        currencies: ['RUB'],
        flag: '🇷🇺',
        ioc: 'RUS',
        languages: ['rus'],
        name: 'Russian Federation',
        status: 'assigned',
    },
    {
        alpha2: 'RW',
        alpha3: 'RWA',
        callingCodes: ['+250'],
        currencies: ['RWF'],
        flag: '🇷🇼',
        ioc: 'RWA',
        languages: ['eng', 'fra', 'kin'],
        name: 'Rwanda',
        status: 'assigned',
    },
    {
        alpha2: 'SA',
        alpha3: 'SAU',
        callingCodes: ['+966'],
        currencies: ['SAR'],
        flag: '🇸🇦',
        ioc: 'KSA',
        languages: ['ara'],
        name: 'Saudi Arabia',
        status: 'assigned',
    },
    {
        alpha2: 'SB',
        alpha3: 'SLB',
        callingCodes: ['+677'],
        currencies: ['SBD'],
        flag: '🇸🇧',
        ioc: 'SOL',
        languages: ['eng'],
        name: 'Solomon Islands',
        status: 'assigned',
    },
    {
        alpha2: 'SC',
        alpha3: 'SYC',
        callingCodes: ['+248'],
        currencies: ['SCR'],
        flag: '🇸🇨',
        ioc: 'SEY',
        languages: ['eng', 'fra'],
        name: 'Seychelles',
        status: 'assigned',
    },
    {
        alpha2: 'SD',
        alpha3: 'SDN',
        callingCodes: ['+249'],
        currencies: ['SDG'],
        flag: '🇸🇩',
        ioc: 'SUD',
        languages: ['ara', 'eng'],
        name: 'Sudan',
        status: 'assigned',
    },
    {
        alpha2: 'SE',
        alpha3: 'SWE',
        callingCodes: ['+46'],
        currencies: ['SEK'],
        flag: '🇸🇪',
        ioc: 'SWE',
        languages: ['swe'],
        name: 'Sweden',
        status: 'assigned',
    },
    {
        alpha2: 'SG',
        alpha3: 'SGP',
        callingCodes: ['+65'],
        currencies: ['SGD'],
        flag: '🇸🇬',
        ioc: 'SIN',
        languages: ['eng', 'zho', 'msa', 'tam'],
        name: 'Singapore',
        status: 'assigned',
    },
    {
        alpha2: 'SH',
        alpha3: 'SHN',
        callingCodes: ['+290'],
        currencies: ['SHP'],
        flag: '🇸🇭',
        ioc: '',
        languages: ['eng'],
        name: 'Saint Helena, Ascension And Tristan Da Cunha',
        status: 'assigned',
    },
    {
        alpha2: 'SI',
        alpha3: 'SVN',
        callingCodes: ['+386'],
        currencies: ['EUR'],
        flag: '🇸🇮',
        ioc: 'SLO',
        languages: ['slv'],
        name: 'Slovenia',
        status: 'assigned',
    },
    {
        alpha2: 'SJ',
        alpha3: 'SJM',
        callingCodes: ['+47'],
        currencies: ['NOK'],
        flag: '🇸🇯',
        ioc: '',
        languages: [],
        name: 'Svalbard And Jan Mayen',
        status: 'assigned',
    },
    {
        alpha2: 'SK',
        alpha3: 'SVK',
        callingCodes: ['+421'],
        currencies: ['EUR'],
        flag: '🇸🇰',
        ioc: 'SVK',
        languages: ['slk'],
        name: 'Slovakia',
        status: 'assigned',
    },
    {
        alpha2: 'SK',
        alpha3: 'SKM',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Sikkim',
        status: 'deleted',
    },
    {
        alpha2: 'SL',
        alpha3: 'SLE',
        callingCodes: ['+232'],
        currencies: ['SLL'],
        flag: '🇸🇱',
        ioc: 'SLE',
        languages: ['eng'],
        name: 'Sierra Leone',
        status: 'assigned',
    },
    {
        alpha2: 'SM',
        alpha3: 'SMR',
        callingCodes: ['+378'],
        currencies: ['EUR'],
        flag: '🇸🇲',
        ioc: 'SMR',
        languages: ['ita'],
        name: 'San Marino',
        status: 'assigned',
    },
    {
        alpha2: 'SN',
        alpha3: 'SEN',
        callingCodes: ['+221'],
        currencies: ['XOF'],
        flag: '🇸🇳',
        ioc: 'SEN',
        languages: ['fra'],
        name: 'Senegal',
        status: 'assigned',
    },
    {
        alpha2: 'SO',
        alpha3: 'SOM',
        callingCodes: ['+252'],
        currencies: ['SOS'],
        flag: '🇸🇴',
        ioc: 'SOM',
        languages: ['som'],
        name: 'Somalia',
        status: 'assigned',
    },
    {
        alpha2: 'SR',
        alpha3: 'SUR',
        callingCodes: ['+597'],
        currencies: ['SRD'],
        flag: '🇸🇷',
        ioc: 'SUR',
        languages: ['nld'],
        name: 'Suriname',
        status: 'assigned',
    },
    {
        alpha2: 'SS',
        alpha3: 'SSD',
        callingCodes: ['+211'],
        currencies: ['SSP'],
        flag: '🇸🇸',
        ioc: 'SSD',
        languages: ['eng'],
        name: 'South Sudan',
        status: 'assigned',
    },
    {
        alpha2: 'ST',
        alpha3: 'STP',
        callingCodes: ['+239'],
        currencies: ['STD'],
        flag: '🇸🇹',
        ioc: 'STP',
        languages: ['por'],
        name: 'Sao Tome and Principe',
        status: 'assigned',
    },
    {
        alpha2: 'SU',
        alpha3: '',
        callingCodes: [],
        currencies: ['RUB'],
        flag: '',
        ioc: '',
        languages: ['rus'],
        name: 'USSR',
        status: 'reserved',
    },
    {
        alpha2: 'SV',
        alpha3: 'SLV',
        callingCodes: ['+503'],
        currencies: ['USD'],
        flag: '🇸🇻',
        ioc: 'ESA',
        languages: ['spa'],
        name: 'El Salvador',
        status: 'assigned',
    },
    {
        alpha2: 'SX',
        alpha3: 'SXM',
        callingCodes: ['+1 721'],
        currencies: ['ANG'],
        flag: '🇸🇽',
        ioc: '',
        languages: ['nld'],
        name: 'Sint Maarten',
        status: 'assigned',
    },
    {
        alpha2: 'SY',
        alpha3: 'SYR',
        callingCodes: ['+963'],
        currencies: ['SYP'],
        flag: '🇸🇾',
        ioc: 'SYR',
        languages: ['ara'],
        name: 'Syrian Arab Republic',
        status: 'assigned',
    },
    {
        alpha2: 'SZ',
        alpha3: 'SWZ',
        callingCodes: ['+268'],
        currencies: ['SZL'],
        flag: '🇸🇿',
        ioc: 'SWZ',
        languages: ['eng', 'ssw'],
        name: 'Swaziland',
        status: 'assigned',
    },
    {
        alpha2: 'TA',
        alpha3: '',
        callingCodes: ['+290'],
        currencies: ['GBP'],
        flag: '',
        ioc: '',
        languages: [],
        name: 'Tristan de Cunha',
        status: 'reserved',
    },
    {
        alpha2: 'TC',
        alpha3: 'TCA',
        callingCodes: ['+1 649'],
        currencies: ['USD'],
        flag: '🇹🇨',
        ioc: '',
        languages: ['eng'],
        name: 'Turks And Caicos Islands',
        status: 'assigned',
    },
    {
        alpha2: 'TD',
        alpha3: 'TCD',
        callingCodes: ['+235'],
        currencies: ['XAF'],
        flag: '🇹🇩',
        ioc: 'CHA',
        languages: ['ara', 'fra'],
        name: 'Chad',
        status: 'assigned',
    },
    {
        alpha2: 'TF',
        alpha3: 'ATF',
        callingCodes: [],
        currencies: ['EUR'],
        flag: '🇹🇫',
        ioc: '',
        languages: ['fra'],
        name: 'French Southern Territories',
        status: 'assigned',
    },
    {
        alpha2: 'TG',
        alpha3: 'TGO',
        callingCodes: ['+228'],
        currencies: ['XOF'],
        flag: '🇹🇬',
        ioc: 'TOG',
        languages: ['fra'],
        name: 'Togo',
        status: 'assigned',
    },
    {
        alpha2: 'TH',
        alpha3: 'THA',
        callingCodes: ['+66'],
        currencies: ['THB'],
        flag: '🇹🇭',
        ioc: 'THA',
        languages: ['tha'],
        name: 'Thailand',
        status: 'assigned',
    },
    {
        alpha2: 'TJ',
        alpha3: 'TJK',
        callingCodes: ['+992'],
        currencies: ['TJS'],
        flag: '🇹🇯',
        ioc: 'TJK',
        languages: ['tgk', 'rus'],
        name: 'Tajikistan',
        status: 'assigned',
    },
    {
        alpha2: 'TK',
        alpha3: 'TKL',
        callingCodes: ['+690'],
        currencies: ['NZD'],
        flag: '🇹🇰',
        ioc: '',
        languages: ['eng'],
        name: 'Tokelau',
        status: 'assigned',
    },
    {
        alpha2: 'TL',
        alpha3: 'TLS',
        callingCodes: ['+670'],
        currencies: ['USD'],
        flag: '🇹🇱',
        ioc: 'TLS',
        languages: ['por'],
        name: 'Timor-Leste, Democratic Republic of',
        status: 'assigned',
    },
    {
        alpha2: 'TM',
        alpha3: 'TKM',
        callingCodes: ['+993'],
        currencies: ['TMT'],
        flag: '🇹🇲',
        ioc: 'TKM',
        languages: ['tuk', 'rus'],
        name: 'Turkmenistan',
        status: 'assigned',
    },
    {
        alpha2: 'TN',
        alpha3: 'TUN',
        callingCodes: ['+216'],
        currencies: ['TND'],
        flag: '🇹🇳',
        ioc: 'TUN',
        languages: ['ara'],
        name: 'Tunisia',
        status: 'assigned',
    },
    {
        alpha2: 'TO',
        alpha3: 'TON',
        callingCodes: ['+676'],
        currencies: ['TOP'],
        flag: '🇹🇴',
        ioc: 'TGA',
        languages: ['eng'],
        name: 'Tonga',
        status: 'assigned',
    },
    {
        alpha2: 'TP',
        alpha3: 'TMP',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'East Timor',
        status: 'deleted',
    },
    {
        alpha2: 'TR',
        alpha3: 'TUR',
        callingCodes: ['+90'],
        currencies: ['TRY'],
        flag: '🇹🇷',
        ioc: 'TUR',
        languages: ['tur'],
        name: 'Turkey',
        status: 'assigned',
    },
    {
        alpha2: 'TT',
        alpha3: 'TTO',
        callingCodes: ['+1 868'],
        currencies: ['TTD'],
        flag: '🇹🇹',
        ioc: 'TTO',
        languages: ['eng'],
        name: 'Trinidad And Tobago',
        status: 'assigned',
    },
    {
        alpha2: 'TV',
        alpha3: 'TUV',
        callingCodes: ['+688'],
        currencies: ['AUD'],
        flag: '🇹🇻',
        ioc: 'TUV',
        languages: ['eng'],
        name: 'Tuvalu',
        status: 'assigned',
    },
    {
        alpha2: 'TW',
        alpha3: 'TWN',
        callingCodes: ['+886'],
        currencies: ['TWD'],
        flag: '🇹🇼',
        ioc: 'TPE',
        languages: ['zho'],
        name: 'Taiwan',
        status: 'assigned',
    },
    {
        alpha2: 'TZ',
        alpha3: 'TZA',
        callingCodes: ['+255'],
        currencies: ['TZS'],
        flag: '🇹🇿',
        ioc: 'TAN',
        languages: ['swa', 'eng'],
        name: 'Tanzania, United Republic Of',
        status: 'assigned',
    },
    {
        alpha2: 'UA',
        alpha3: 'UKR',
        callingCodes: ['+380'],
        currencies: ['UAH'],
        flag: '🇺🇦',
        ioc: 'UKR',
        languages: ['ukr', 'rus'],
        name: 'Ukraine',
        status: 'assigned',
    },
    {
        alpha2: 'UG',
        alpha3: 'UGA',
        callingCodes: ['+256'],
        currencies: ['UGX'],
        flag: '🇺🇬',
        ioc: 'UGA',
        languages: ['eng', 'swa'],
        name: 'Uganda',
        status: 'assigned',
    },
    {
        alpha2: 'UK',
        alpha3: '',
        callingCodes: [],
        currencies: ['GBP'],
        flag: '',
        ioc: '',
        languages: ['eng', 'cor', 'gle', 'gla', 'cym'],
        name: 'United Kingdom',
        status: 'reserved',
    },
    {
        alpha2: 'UM',
        alpha3: 'UMI',
        callingCodes: ['+1'],
        currencies: ['USD'],
        flag: '🇺🇲',
        ioc: '',
        languages: ['eng'],
        name: 'United States Minor Outlying Islands',
        status: 'assigned',
    },
    {
        alpha2: 'US',
        alpha3: 'USA',
        callingCodes: ['+1'],
        currencies: ['USD'],
        flag: '🇺🇸',
        ioc: 'USA',
        languages: ['eng'],
        name: 'United States',
        status: 'assigned',
    },
    {
        alpha2: 'UY',
        alpha3: 'URY',
        callingCodes: ['+598'],
        currencies: ['UYU', 'UYI'],
        flag: '🇺🇾',
        ioc: 'URU',
        languages: ['spa'],
        name: 'Uruguay',
        status: 'assigned',
    },
    {
        alpha2: 'UZ',
        alpha3: 'UZB',
        callingCodes: ['+998'],
        currencies: ['UZS'],
        flag: '🇺🇿',
        ioc: 'UZB',
        languages: ['uzb', 'rus'],
        name: 'Uzbekistan',
        status: 'assigned',
    },
    {
        alpha2: 'VA',
        alpha3: 'VAT',
        callingCodes: ['+379', '+39'],
        currencies: ['EUR'],
        flag: '🇻🇦',
        ioc: '',
        languages: ['ita'],
        name: 'Vatican City State',
        status: 'assigned',
    },
    {
        alpha2: 'VC',
        alpha3: 'VCT',
        callingCodes: ['+1 784'],
        currencies: ['XCD'],
        flag: '🇻🇨',
        ioc: 'VIN',
        languages: ['eng'],
        name: 'Saint Vincent And The Grenadines',
        status: 'assigned',
    },
    {
        alpha2: 'VD',
        alpha3: 'VDR',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Viet-Nam, Democratic Republic of',
        status: 'deleted',
    },
    {
        alpha2: 'VE',
        alpha3: 'VEN',
        callingCodes: ['+58'],
        currencies: ['VEF'],
        flag: '🇻🇪',
        ioc: 'VEN',
        languages: ['spa'],
        name: 'Venezuela, Bolivarian Republic Of',
        status: 'assigned',
    },
    {
        alpha2: 'VG',
        alpha3: 'VGB',
        callingCodes: ['+1 284'],
        currencies: ['USD'],
        flag: '🇻🇬',
        ioc: 'IVB',
        languages: ['eng'],
        name: 'Virgin Islands (British)',
        status: 'assigned',
    },
    {
        alpha2: 'VI',
        alpha3: 'VIR',
        callingCodes: ['+1 340'],
        currencies: ['USD'],
        flag: '🇻🇮',
        ioc: 'ISV',
        languages: ['eng'],
        name: 'Virgin Islands (US)',
        status: 'assigned',
    },
    {
        alpha2: 'VN',
        alpha3: 'VNM',
        callingCodes: ['+84'],
        currencies: ['VND'],
        flag: '🇻🇳',
        ioc: 'VIE',
        languages: ['vie'],
        name: 'Viet Nam',
        status: 'assigned',
    },
    {
        alpha2: 'VU',
        alpha3: 'VUT',
        callingCodes: ['+678'],
        currencies: ['VUV'],
        flag: '🇻🇺',
        ioc: 'VAN',
        languages: ['bis', 'eng', 'fra'],
        name: 'Vanuatu',
        status: 'assigned',
    },
    {
        alpha2: 'WF',
        alpha3: 'WLF',
        callingCodes: ['+681'],
        currencies: ['XPF'],
        flag: '🇼🇫',
        ioc: '',
        languages: ['fra'],
        name: 'Wallis And Futuna',
        status: 'assigned',
    },
    {
        alpha2: 'WK',
        alpha3: 'WAK',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Wake Island',
        status: 'deleted',
    },
    {
        alpha2: 'WS',
        alpha3: 'WSM',
        callingCodes: ['+685'],
        currencies: ['WST'],
        flag: '🇼🇸',
        ioc: 'SAM',
        languages: ['eng', 'smo'],
        name: 'Samoa',
        status: 'assigned',
    },
    {
        alpha2: 'XK',
        alpha3: '',
        callingCodes: ['+383'],
        currencies: ['EUR'],
        flag: '',
        ioc: 'KOS',
        languages: ['sqi', 'srp', 'bos', 'tur', 'rom'],
        name: 'Kosovo',
        status: 'user assigned',
    },
    {
        alpha2: 'YD',
        alpha3: 'YMD',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Yemen, Democratic',
        status: 'deleted',
    },
    {
        alpha2: 'YE',
        alpha3: 'YEM',
        callingCodes: ['+967'],
        currencies: ['YER'],
        flag: '🇾🇪',
        ioc: 'YEM',
        languages: ['ara'],
        name: 'Yemen',
        status: 'assigned',
    },
    {
        alpha2: 'YT',
        alpha3: 'MYT',
        callingCodes: ['+262'],
        currencies: ['EUR'],
        flag: '🇾🇹',
        ioc: '',
        languages: ['fra'],
        name: 'Mayotte',
        status: 'assigned',
    },
    {
        alpha2: 'YU',
        alpha3: 'YUG',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Yugoslavia',
        status: 'deleted',
    },
    {
        alpha2: 'ZA',
        alpha3: 'ZAF',
        callingCodes: ['+27'],
        currencies: ['ZAR'],
        flag: '🇿🇦',
        ioc: 'RSA',
        languages: ['afr', 'eng', 'nbl', 'som', 'tso', 'ven', 'xho', 'zul'],
        name: 'South Africa',
        status: 'assigned',
    },
    {
        alpha2: 'ZM',
        alpha3: 'ZMB',
        callingCodes: ['+260'],
        currencies: ['ZMW'],
        flag: '🇿🇲',
        ioc: 'ZAM',
        languages: ['eng'],
        name: 'Zambia',
        status: 'assigned',
    },
    {
        alpha2: 'ZR',
        alpha3: 'ZAR',
        callingCodes: [],
        currencies: [],
        ioc: '',
        languages: [],
        name: 'Zaire',
        status: 'deleted',
    },
    {
        alpha2: 'ZW',
        alpha3: 'ZWE',
        callingCodes: ['+263'],
        currencies: ['USD', 'ZAR', 'BWP', 'GBP', 'EUR'],
        flag: '🇿🇼',
        ioc: 'ZIM',
        languages: ['eng', 'sna', 'nde'],
        name: 'Zimbabwe',
        status: 'assigned',
    },
];

const logger$1D = MintLogger.getLogger('MintCountryService');
class MintCountryService {
    constructor() {
        this.sorted = [...countries]
            .filter((_country) => _country.status === 'assigned')
            .sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }
    getCountryList() {
        return this.sorted;
    }
    getCountryName(countryCode) {
        if (!countryCode || countryCode.trim().length === 0) {
            return 'UNKNOWN';
        }
        let code = countryCode.trim().toUpperCase();
        // Normalize some codes
        if (code === 'USA' || code === 'UNITED STATES') {
            code = 'US';
        }
        if (code === 'CAN') {
            code = 'CA';
        }
        // logger.debug('getCountryName: countryCode: ' + code);
        const country = this.sorted.find((_country) => {
            return _country.alpha2 && _country.alpha2 === code;
        });
        if (country) {
            return country.name;
        }
        return code;
    }
    getISOCountryMap() {
        const result = {};
        const map = this.sorted.map((_country) => {
            result[_country.alpha2] = _country.name;
        });
        return result;
    }
    getCountryCode(countryName) {
        const country = this.sorted.find((_country) => {
            return (MintStringUtil.slug(_country.name) === MintStringUtil.slug(countryName));
        });
        if (country) {
            return country.alpha2;
        }
        return null;
    }
    getNameValuePairs(codeAsValue = true) {
        const result = [];
        if (codeAsValue) {
            this.sorted.map((_country) => {
                result.push({
                    key: _country.name,
                    value: _country.alpha2,
                });
            });
        }
        else {
            this.sorted.map((_country) => {
                result.push({
                    key: _country.alpha2,
                    value: _country.name,
                });
            });
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCountryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCountryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCountryService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

const logger$1C = MintLogger.getLogger('AddressModalComponent');
class MintInputAddressModalComponent {
    constructor(geocodeService, countryService) {
        this.geocodeService = geocodeService;
        this.countryService = countryService;
        this.handleModal = new EventEmitter();
        this.callback = new EventEmitter();
    }
    async ngOnInit() {
        if (this.address) {
            this.lastAddress = this.address;
            this.formattedAddress = this.address.formattedAddress;
        }
        this.initAddressForm();
    }
    initAddressForm() {
        // this.streetNumber = new MintInputText({
        //   name: 'streetNumber',
        //   type: 'text',
        //   label: 'Street Address',
        //   placeholder: '123',
        //   size: 'large',
        //   defaultValue: this.address.streetNumber,
        //   required: true,
        //   validator: Validators.required,
        //   onChange: (control: FormControl, data: any) => this.reformatAddress(),
        // });
        // this.streetName = new MintInputText({
        //   name: 'streetName',
        //   type: 'text',
        //   label: 'Street Address',
        //   placeholder: 'Main St.',
        //   size: 'large',
        //   defaultValue: this.address.streetName,
        //   required: true,
        //   validator: Validators.required,
        //   onChange: (control: FormControl, data: any) => this.reformatAddress(),
        // });
        this.street = new MintInputText({
            name: 'street',
            type: 'text',
            label: 'Street',
            placeholder: '123 Main St.',
            size: 'large',
            defaultValue: this.address?.street,
            required: true,
            validator: Validators.required,
            onBlur: async (control, data) => await this.reformatAddress(),
            layout: this.layout,
        });
        this.unitNumber = new MintInputText({
            name: 'unitNumber',
            type: 'text',
            label: 'Apartment / Suite / Unit Number',
            size: 'large',
            defaultValue: this.address?.unitNumber,
            onBlur: async (control, data) => await this.reformatAddress(),
            layout: this.layout,
        });
        this.city = new MintInputText({
            name: 'city',
            type: 'text',
            placeholder: 'City',
            label: 'City',
            size: 'large',
            defaultValue: this.address?.city,
            required: true,
            validator: Validators.required,
            onBlur: async (control, data) => await this.reformatAddress(),
            layout: this.layout,
        });
        this.stateCode = new MintInputText({
            name: 'stateCode',
            type: 'text',
            placeholder: 'State Code',
            size: 'large',
            label: 'State / Region',
            maxLength: 3,
            defaultValue: this.address?.stateCode,
            required: false,
            // conditionally require if country is US or CA
            // validator: Validators.required,
            onBlur: async (control, data) => await this.reformatAddress(),
            layout: this.layout,
        });
        this.postalCode = new MintInputText({
            name: 'postalCode',
            type: 'text',
            placeholder: 'Postal Code',
            label: 'Postal Code',
            size: 'large',
            defaultValue: this.address?.postalCode,
            required: true,
            validator: Validators.required,
            onBlur: async (control, data) => await this.reformatAddress(),
            layout: this.layout,
        });
        this.countryCode = new MintInputText({
            name: 'countryCode',
            type: 'text',
            placeholder: 'Country',
            label: 'Country Code',
            size: 'large',
            maxLength: 3,
            defaultValue: this.address?.countryCode,
            required: true,
            validator: Validators.required,
            onBlur: async (control, data) => await this.reformatAddress(),
            layout: this.layout,
        });
        this.addressForm = new MintFormController([
            // this.streetName,
            // this.streetNumber,
            this.street,
            this.unitNumber,
            this.city,
            this.stateCode,
            this.postalCode,
            this.countryCode,
        ]);
    }
    async reformatAddress(isSubmit) {
        const address = this.buildAddressFromFormData();
        if (!isSubmit && MintObjectUtil.equals(address, this.lastAddress)) {
            logger$1C.info('address did not change; skipping reformat', address);
            return address;
        }
        else {
            this.lastAddress = address;
        }
        if (address) {
            try {
                const formattedAddress = await this.geocodeService.formatAddress(address);
                this.formattedAddress = formattedAddress;
                return formattedAddress;
            }
            catch (err) {
                logger$1C.error(err);
            }
        }
        return this.lastAddress;
    }
    toggleModal() {
        this.handleModal.emit();
    }
    cancelModal() {
        this.callback.emit(null);
    }
    async submit() {
        await this.addressForm.triggerFormValidation();
        this.addressForm.updateValueAndValidity();
        if (!this.addressForm.valid) {
            return;
        }
        this.disableSubmit = true;
        await this.reformatAddress(true);
        const _address = this.buildAddressFromFormData();
        this.callback.emit(_address);
    }
    buildAddressFromFormData() {
        const data = this.addressForm.formValues();
        const changed = !(data['street'] === this.address?.street &&
            data['unitNumber'] === this.address?.unitNumber &&
            data['city'] === this.address?.city &&
            data['stateCode'] === this.address?.stateCode &&
            data['postalCode'] === this.address?.postalCode &&
            data['countryCode'] === this.address?.countryCode &&
            this.formattedAddress === this.address?.formattedAddress);
        if (changed) {
            const streetParts = data['street']?.split(/\s+/) ?? [];
            const streetNumber = streetParts.shift();
            const streetName = streetParts.join(' ');
            return new MintAddressModel({
                ...data,
                streetNumber: streetNumber,
                streetName: streetName,
                country: this.countryService.getCountryName(data['countryCode']),
                formattedAddress: this.formattedAddress,
            });
        }
        return this.address;
    }
    testFormattedAddress(addr) {
        const hasUnknownParts = /UNKNOWN|null/g;
        if (!hasUnknownParts.test(addr)) {
            return addr;
        }
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressModalComponent, deps: [{ token: MintGeocoderService }, { token: MintCountryService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintInputAddressModalComponent, selector: "mint-input-address-modal", inputs: { address: "address", isVisible: "isVisible", layout: "layout" }, outputs: { handleModal: "handleModal", callback: "callback" }, ngImport: i0, template: "<nz-modal\n  [nzClassName]=\"'main-modal small modal-wrapper'\"\n  [(nzVisible)]=\"isVisible\"\n  [nzFooter]=\"null\"\n  (nzOnCancel)=\"cancelModal()\"\n  (nzOnOk)=\"toggleModal()\"\n  [nzMaskClosable]=\"false\"\n  [nzClosable]=\"false\"\n  [nzKeyboard]=\"false\"\n  [nzAutofocus]=\"null\"\n>\n  <ng-container *nzModalContent>\n    <div\n      class=\"modal-header\"\n      [ngClass]=\"{ 'has-lateral': layout === 'standard-lateral' }\"\n    >\n      <div>\n        <h3 class=\"modal-title\">Address</h3>\n        <p>{{ testFormattedAddress(formattedAddress) }}</p>\n      </div>\n    </div>\n\n    <nz-spin\n      [nzSpinning]=\"isLoading\"\n      nzTip=\"Loading...\"\n      *ngIf=\"isLoading\"\n    ></nz-spin>\n\n    <div\n      class=\"modal-body modal-content\"\n      [ngClass]=\"{ 'has-lateral': layout === 'standard-lateral' }\"\n    >\n      <mint-form\n        nz-form\n        [formGroup]=\"addressForm\"\n        (onSubmit)=\"submit()\"\n        nzLayout=\"inline\"\n        class=\"inline-form full-width-form\"\n        *ngIf=\"addressForm\"\n        class=\"modal-form\"\n      >\n        <div class=\"form-items has-margin\">\n          <!-- <nz-form-item>\n          <mint-input-text\n            [field]=\"streetNumber\"\n            [formControlName]=\"streetNumber.name\"\n          ></mint-input-text>\n        </nz-form-item>\n        <nz-form-item>\n          <mint-input-text\n            [field]=\"streetName\"\n            [formControlName]=\"streetName.name\"\n          ></mint-input-text>\n        </nz-form-item> -->\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"street\"\n              [formControlName]=\"street.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"unitNumber\"\n              [formControlName]=\"unitNumber.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"city\"\n              [formControlName]=\"city.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"stateCode\"\n              [formControlName]=\"stateCode.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"postalCode\"\n              [formControlName]=\"postalCode.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"countryCode\"\n              [formControlName]=\"countryCode.name\"\n            ></mint-input-text>\n          </nz-form-item>\n        </div>\n      </mint-form>\n    </div>\n\n    <div\n      class=\"btn-container text-center form-btn-sm\"\n      *ngIf=\"addressForm\"\n      [ngClass]=\"{ 'has-lateral': layout === 'standard-lateral' }\"\n    >\n      <button nz-button (click)=\"cancelModal()\" nzType=\"default\" nzSize=\"large\">\n        Cancel\n      </button>\n\n      <button\n        nz-button\n        [nzLoading]=\"addressForm.submitted\"\n        [disabled]=\"disableSubmit\"\n        (click)=\"addressForm.submit()\"\n        nzType=\"primary\"\n        nzSize=\"large\"\n      >\n        Save\n      </button>\n    </div>\n  </ng-container>\n</nz-modal>\n", styles: [":host{display:block}@media only screen and (max-width: 480px){.btn-container button{margin-bottom:10px}}::ng-deep .modal-header.has-lateral p{text-align:left}::ng-deep .modal-content.has-lateral .mint-form{width:100%}::ng-deep .modal-content.has-lateral .mint-form mint-input-text{width:100%;margin-bottom:1rem}::ng-deep .btn-container.has-lateral{display:flex;justify-content:flex-end;align-items:center}::ng-deep .btn-container.has-lateral button{border-radius:26px;padding:0 2rem}::ng-deep .btn-container.has-lateral button:last-child{margin-left:1rem}::ng-deep .btn-container.has-lateral button:first-child:hover{color:#fea21ab3;border-color:#fea21ab3}::ng-deep .btn-container.has-lateral button:first-child:active{color:#fea21a4d;border-color:#fea21a4d}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: i4$4.NzSpinComponent, selector: "nz-spin", inputs: ["nzIndicator", "nzSize", "nzTip", "nzDelay", "nzSimple", "nzSpinning"], exportAs: ["nzSpin"] }, { kind: "directive", type: i5$1.NzRowDirective, selector: "[nz-row],nz-row,nz-form-item", inputs: ["nzAlign", "nzJustify", "nzGutter"], exportAs: ["nzRow"] }, { kind: "directive", type: i6.NzFormDirective, selector: "[nz-form]", inputs: ["nzLayout", "nzNoColon", "nzAutoTips", "nzDisableAutoTips", "nzTooltipIcon", "nzLabelAlign", "nzLabelWrap"], exportAs: ["nzForm"] }, { kind: "component", type: i6.NzFormItemComponent, selector: "nz-form-item", exportAs: ["nzFormItem"] }, { kind: "component", type: i7.NzModalComponent, selector: "nz-modal", inputs: ["nzMask", "nzMaskClosable", "nzCloseOnNavigation", "nzVisible", "nzClosable", "nzOkLoading", "nzOkDisabled", "nzCancelDisabled", "nzCancelLoading", "nzKeyboard", "nzNoAnimation", "nzCentered", "nzContent", "nzFooter", "nzZIndex", "nzWidth", "nzWrapClassName", "nzClassName", "nzStyle", "nzTitle", "nzCloseIcon", "nzMaskStyle", "nzBodyStyle", "nzOkText", "nzCancelText", "nzOkType", "nzOkDanger", "nzIconType", "nzModalType", "nzAutofocus", "nzOnOk", "nzOnCancel"], outputs: ["nzOnOk", "nzOnCancel", "nzAfterOpen", "nzAfterClose", "nzVisibleChange"], exportAs: ["nzModal"] }, { kind: "directive", type: i7.NzModalContentDirective, selector: "[nzModalContent]", exportAs: ["nzModalContent"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: MintFormComponent, selector: "mint-form", inputs: ["formGroup"], outputs: ["onSubmit"] }, { kind: "component", type: i10.NzButtonComponent, selector: "button[nz-button], a[nz-button]", inputs: ["nzBlock", "nzGhost", "nzSearch", "nzLoading", "nzDanger", "disabled", "tabIndex", "nzType", "nzShape", "nzSize"], exportAs: ["nzButton"] }, { kind: "directive", type: i11.ɵNzTransitionPatchDirective, selector: "[nz-button], nz-button-group, [nz-icon], [nz-menu-item], [nz-submenu], nz-select-top-control, nz-select-placeholder, nz-input-group", inputs: ["hidden"] }, { kind: "directive", type: i12.NzWaveDirective, selector: "[nz-wave],button[nz-button]:not([nzType=\"link\"]):not([nzType=\"text\"])", inputs: ["nzWaveExtraNode"], exportAs: ["nzWave"] }, { kind: "component", type: MintInputTextComponent, selector: "mint-input-text", inputs: ["field"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-input-address-modal', template: "<nz-modal\n  [nzClassName]=\"'main-modal small modal-wrapper'\"\n  [(nzVisible)]=\"isVisible\"\n  [nzFooter]=\"null\"\n  (nzOnCancel)=\"cancelModal()\"\n  (nzOnOk)=\"toggleModal()\"\n  [nzMaskClosable]=\"false\"\n  [nzClosable]=\"false\"\n  [nzKeyboard]=\"false\"\n  [nzAutofocus]=\"null\"\n>\n  <ng-container *nzModalContent>\n    <div\n      class=\"modal-header\"\n      [ngClass]=\"{ 'has-lateral': layout === 'standard-lateral' }\"\n    >\n      <div>\n        <h3 class=\"modal-title\">Address</h3>\n        <p>{{ testFormattedAddress(formattedAddress) }}</p>\n      </div>\n    </div>\n\n    <nz-spin\n      [nzSpinning]=\"isLoading\"\n      nzTip=\"Loading...\"\n      *ngIf=\"isLoading\"\n    ></nz-spin>\n\n    <div\n      class=\"modal-body modal-content\"\n      [ngClass]=\"{ 'has-lateral': layout === 'standard-lateral' }\"\n    >\n      <mint-form\n        nz-form\n        [formGroup]=\"addressForm\"\n        (onSubmit)=\"submit()\"\n        nzLayout=\"inline\"\n        class=\"inline-form full-width-form\"\n        *ngIf=\"addressForm\"\n        class=\"modal-form\"\n      >\n        <div class=\"form-items has-margin\">\n          <!-- <nz-form-item>\n          <mint-input-text\n            [field]=\"streetNumber\"\n            [formControlName]=\"streetNumber.name\"\n          ></mint-input-text>\n        </nz-form-item>\n        <nz-form-item>\n          <mint-input-text\n            [field]=\"streetName\"\n            [formControlName]=\"streetName.name\"\n          ></mint-input-text>\n        </nz-form-item> -->\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"street\"\n              [formControlName]=\"street.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"unitNumber\"\n              [formControlName]=\"unitNumber.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"city\"\n              [formControlName]=\"city.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"stateCode\"\n              [formControlName]=\"stateCode.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"postalCode\"\n              [formControlName]=\"postalCode.name\"\n            ></mint-input-text>\n          </nz-form-item>\n          <nz-form-item>\n            <mint-input-text\n              [field]=\"countryCode\"\n              [formControlName]=\"countryCode.name\"\n            ></mint-input-text>\n          </nz-form-item>\n        </div>\n      </mint-form>\n    </div>\n\n    <div\n      class=\"btn-container text-center form-btn-sm\"\n      *ngIf=\"addressForm\"\n      [ngClass]=\"{ 'has-lateral': layout === 'standard-lateral' }\"\n    >\n      <button nz-button (click)=\"cancelModal()\" nzType=\"default\" nzSize=\"large\">\n        Cancel\n      </button>\n\n      <button\n        nz-button\n        [nzLoading]=\"addressForm.submitted\"\n        [disabled]=\"disableSubmit\"\n        (click)=\"addressForm.submit()\"\n        nzType=\"primary\"\n        nzSize=\"large\"\n      >\n        Save\n      </button>\n    </div>\n  </ng-container>\n</nz-modal>\n", styles: [":host{display:block}@media only screen and (max-width: 480px){.btn-container button{margin-bottom:10px}}::ng-deep .modal-header.has-lateral p{text-align:left}::ng-deep .modal-content.has-lateral .mint-form{width:100%}::ng-deep .modal-content.has-lateral .mint-form mint-input-text{width:100%;margin-bottom:1rem}::ng-deep .btn-container.has-lateral{display:flex;justify-content:flex-end;align-items:center}::ng-deep .btn-container.has-lateral button{border-radius:26px;padding:0 2rem}::ng-deep .btn-container.has-lateral button:last-child{margin-left:1rem}::ng-deep .btn-container.has-lateral button:first-child:hover{color:#fea21ab3;border-color:#fea21ab3}::ng-deep .btn-container.has-lateral button:first-child:active{color:#fea21a4d;border-color:#fea21a4d}\n"] }]
        }], ctorParameters: () => [{ type: MintGeocoderService }, { type: MintCountryService }], propDecorators: { address: [{
                type: Input
            }], isVisible: [{
                type: Input
            }], layout: [{
                type: Input
            }], handleModal: [{
                type: Output
            }], callback: [{
                type: Output
            }] } });

const logger$1B = MintLogger.getLogger('MintInputAddressComponent');
const MINT_INPUT_ADDRESS_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintInputAddressComponent),
    multi: true,
};
class MintInputAddressComponent extends MintFormFieldComponent {
    constructor(geocoderService, notification) {
        super();
        this.geocoderService = geocoderService;
        this.notification = notification;
        this.lastDisplayValue = '';
    }
    ngOnInit() {
        super.init(this.field, this.controlElement);
        this.field.displayValue = this.field.defaultValue?.formattedAddress ?? '';
        this.lastDisplayValue = this.field.displayValue;
        logger$1B.debug('value', this.field);
        this.field.onBlur = (control, event) => {
            logger$1B.debug('address blur');
            const value = this.field.displayValue;
            if (!value) {
                this.field.value = null;
                this.lastDisplayValue = '';
                return false;
            }
            logger$1B.debug('address: value: ', value);
            if (this.lastDisplayValue !== value) {
                this.confirmAddress(value).then();
            }
            if (this.field.applicationBlur) {
                this.field.applicationBlur(control, event);
            }
            return true;
        };
    }
    handleAddressModal() {
        this.isAddressVisible = !this.isAddressVisible;
    }
    handleAddressSuccess(address) {
        if (address) {
            this.field.value = address;
            this.field.displayValue = address.formattedAddress;
            this.lastDisplayValue = this.field.displayValue;
            logger$1B.info('address success. updated value.');
        }
        else {
            this.field.displayValue = this.lastDisplayValue;
            logger$1B.info('address cancelled');
            if (!this.field.displayValue) {
                this.field.value = null;
            }
        }
        // call this.onChange to propagate value
        this.onChange(this.field.value);
        this.handleAddressModal();
    }
    async confirmAddress(_address) {
        if (!_address) {
            return null;
        }
        let result;
        try {
            result = await this.geocoderService.geocode(_address);
        }
        catch (err) {
            logger$1B.error(err);
            // this.notification.error(
            //   'Error',
            //   'There was an error parsing your address'
            // );
        }
        if (!result) {
            this.notification.error('Error', 'The address you entered was not found. Please manually enter your address.');
            // throw new Error('The address you entered does not appear to be valid');
        }
        logger$1B.debug('geocode result: ', result);
        this.field.value = result ?? null;
        this.handleAddressModal();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressComponent, deps: [{ token: MintGeocoderService }, { token: i2$3.NzNotificationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintInputAddressComponent, selector: "mint-input-address", inputs: { field: "field" }, providers: [MINT_INPUT_ADDRESS_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n    <label\n      *ngIf=\"field.label\"\n      class=\"label\"\n      [class.mint-form-label-invalid]=\"!isValid()\"\n      for=\"input-{{ uid }}\"\n      >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n    >\n    <input\n      #control\n      id=\"input-{{ uid }}\"\n      nz-input\n      [nzSize]=\"field.size\"\n      (focus)=\"onFocus($event)\"\n      (blur)=\"onBlur($event)\"\n      (keyup)=\"onChange($event)\"\n      [(ngModel)]=\"field.displayValue\"\n      [type]=\"field.controlType\"\n      [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n      [attr.aria-invalid]=\"!isValid()\"\n      [disabled]=\"field.disabled\"\n      [class.mint-form-field-invalid]=\"!isValid()\"\n      [attr.data-testid]=\"field.dataTestId\"\n    />\n  </div>\n  <!-- <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div> -->\n\n  <mint-input-address-modal\n    *ngIf=\"isAddressVisible\"\n    [isVisible]=\"true\"\n    [address]=\"field.value\"\n    (callback)=\"handleAddressSuccess($event)\"\n    (handleModal)=\"handleAddressModal()\"\n    [layout]=\"field.layout ? field.layout : 'standard-vertical'\"\n  >\n  </mint-input-address-modal>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2$2.NzInputDirective, selector: "input[nz-input],textarea[nz-input]", inputs: ["nzBorderless", "nzSize", "nzStepperless", "nzStatus", "disabled"], exportAs: ["nzInput"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MintInputAddressModalComponent, selector: "mint-input-address-modal", inputs: ["address", "isVisible", "layout"], outputs: ["handleModal", "callback"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-input-address', encapsulation: ViewEncapsulation.None, providers: [MINT_INPUT_ADDRESS_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n    <label\n      *ngIf=\"field.label\"\n      class=\"label\"\n      [class.mint-form-label-invalid]=\"!isValid()\"\n      for=\"input-{{ uid }}\"\n      >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n    >\n    <input\n      #control\n      id=\"input-{{ uid }}\"\n      nz-input\n      [nzSize]=\"field.size\"\n      (focus)=\"onFocus($event)\"\n      (blur)=\"onBlur($event)\"\n      (keyup)=\"onChange($event)\"\n      [(ngModel)]=\"field.displayValue\"\n      [type]=\"field.controlType\"\n      [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n      [attr.aria-invalid]=\"!isValid()\"\n      [disabled]=\"field.disabled\"\n      [class.mint-form-field-invalid]=\"!isValid()\"\n      [attr.data-testid]=\"field.dataTestId\"\n    />\n  </div>\n  <!-- <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div> -->\n\n  <mint-input-address-modal\n    *ngIf=\"isAddressVisible\"\n    [isVisible]=\"true\"\n    [address]=\"field.value\"\n    (callback)=\"handleAddressSuccess($event)\"\n    (handleModal)=\"handleAddressModal()\"\n    [layout]=\"field.layout ? field.layout : 'standard-vertical'\"\n  >\n  </mint-input-address-modal>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"] }]
        }], ctorParameters: () => [{ type: MintGeocoderService }, { type: i2$3.NzNotificationService }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintInputAddressModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressModule, declarations: [MintInputAddressModalComponent, MintInputAddressComponent], imports: [FormsModule,
            NzInputModule,
            NzSpinModule,
            NzFormModule,
            NzModalModule,
            CommonModule,
            MintFormModule,
            NzButtonModule,
            MintInputTextModule,
            NzNotificationServiceModule], exports: [MintInputAddressComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressModule, imports: [FormsModule,
            NzInputModule,
            NzSpinModule,
            NzFormModule,
            NzModalModule,
            CommonModule,
            MintFormModule,
            NzButtonModule,
            MintInputTextModule,
            NzNotificationServiceModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputAddressModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        NzInputModule,
                        NzSpinModule,
                        NzFormModule,
                        NzModalModule,
                        CommonModule,
                        MintFormModule,
                        NzButtonModule,
                        MintInputTextModule,
                        NzNotificationServiceModule,
                    ],
                    declarations: [MintInputAddressModalComponent, MintInputAddressComponent],
                    exports: [MintInputAddressComponent, MintFormModule],
                }]
        }] });

const logger$1A = MintLogger.getLogger('MintInputDateComponent');
const MINT_INPUT_DATE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintInputDateComponent),
    multi: true,
};
class MintInputDateComponent extends MintFormFieldComponent {
    constructor() {
        super();
    }
    onChange($event, fieldOption) {
        if (this.field.disabled) {
            return;
        }
        if (!$event) {
            this.value = null;
            return;
        }
        this.field.displayValue = $event;
        const newDate = new Date($event);
        if (!newDate) {
            return;
        }
        this.value = newDate;
        if (this.propagateChange) {
            this.propagateChange(this.field.value);
        }
    }
    ngOnInit() {
        super.init(this.field, this.controlElement);
        if (typeof this.field.autocomplete === 'undefined') {
            this.field.autocomplete = MintFormFieldAutocomplete.On;
        }
        if (this.field.value) {
            const utcYear = this.field.value.getUTCFullYear().toString();
            let utcMonth = (this.field.value.getUTCMonth() + 1).toString();
            if (utcMonth.length === 1) {
                utcMonth = '0' + utcMonth;
            }
            let utcDay = this.field.value.getUTCDate().toString();
            if (utcDay.length === 1) {
                utcDay = '0' + utcDay;
            }
            this.field.displayValue = utcYear + '-' + utcMonth + '-' + utcDay;
            logger$1A.debug('MintInputDate: this: ', this);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputDateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintInputDateComponent, selector: "mint-input-date", inputs: { field: "field" }, providers: [MINT_INPUT_DATE_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'date'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-input-group\n        #control\n        [nzSize]=\"field.size\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n      >\n        <input\n          nz-input\n          id=\"input-{{ uid }}\"\n          [ngStyle]=\"{ width: '100%' }\"\n          [nzSize]=\"field.size\"\n          (focus)=\"onFocus($event)\"\n          (blur)=\"onBlur($event)\"\n          (ngModelChange)=\"onChange($event)\"\n          [ngModel]=\"field.displayValue\"\n          [type]=\"field.controlType\"\n          [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n          [autocomplete]=\"field.autocomplete\"\n          [attr.aria-invalid]=\"!isValid()\"\n          [disabled]=\"field.disabled\"\n          [min]=\"field.minDate\"\n          [max]=\"field.maxDate\"\n          [attr.data-testid]=\"field.dataTestId\"\n        />\n      </nz-input-group>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n\n  <div\n    *ngIf=\"isValid()\"\n    class=\"mint-form-field-description\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p>{{ field.description }}</p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2$2.NzInputDirective, selector: "input[nz-input],textarea[nz-input]", inputs: ["nzBorderless", "nzSize", "nzStepperless", "nzStatus", "disabled"], exportAs: ["nzInput"] }, { kind: "component", type: i2$2.NzInputGroupComponent, selector: "nz-input-group", inputs: ["nzAddOnBeforeIcon", "nzAddOnAfterIcon", "nzPrefixIcon", "nzSuffixIcon", "nzAddOnBefore", "nzAddOnAfter", "nzPrefix", "nzStatus", "nzSuffix", "nzSize", "nzSearch", "nzCompact"], exportAs: ["nzInputGroup"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputDateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-input-date', encapsulation: ViewEncapsulation.None, providers: [MINT_INPUT_DATE_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'date'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-input-group\n        #control\n        [nzSize]=\"field.size\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n      >\n        <input\n          nz-input\n          id=\"input-{{ uid }}\"\n          [ngStyle]=\"{ width: '100%' }\"\n          [nzSize]=\"field.size\"\n          (focus)=\"onFocus($event)\"\n          (blur)=\"onBlur($event)\"\n          (ngModelChange)=\"onChange($event)\"\n          [ngModel]=\"field.displayValue\"\n          [type]=\"field.controlType\"\n          [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n          [autocomplete]=\"field.autocomplete\"\n          [attr.aria-invalid]=\"!isValid()\"\n          [disabled]=\"field.disabled\"\n          [min]=\"field.minDate\"\n          [max]=\"field.maxDate\"\n          [attr.data-testid]=\"field.dataTestId\"\n        />\n      </nz-input-group>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n\n  <div\n    *ngIf=\"isValid()\"\n    class=\"mint-form-field-description\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p>{{ field.description }}</p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}\n"] }]
        }], ctorParameters: () => [], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintInputDateModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputDateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintInputDateModule, declarations: [MintInputDateComponent], imports: [FormsModule,
            NzInputModule,
            NzInputNumberModule,
            MintInputTextModule,
            CommonModule,
            MintFormModule], exports: [MintInputDateComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputDateModule, providers: [provideNgxMask()], imports: [FormsModule,
            NzInputModule,
            NzInputNumberModule,
            MintInputTextModule,
            CommonModule,
            MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputDateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        NzInputModule,
                        NzInputNumberModule,
                        MintInputTextModule,
                        CommonModule,
                        MintFormModule,
                    ],
                    declarations: [MintInputDateComponent],
                    providers: [provideNgxMask()],
                    exports: [MintInputDateComponent],
                }]
        }] });

const logger$1z = MintLogger.getLogger('MintInputPhoneComponent');
const MINT_INPUT_PHONE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintInputPhoneComponent),
    multi: true,
};
const US_NATIONAL_FORMAT_VALUE_LENGTH = 14;
const US_NATIONAL_FORMAT_REGEX = /\(\d{3}\)\ \d{3}-\d{4}/;
class MintInputPhoneComponent extends MintFormFieldComponent {
    constructor(phoneNumberService, countryService) {
        super();
        this.phoneNumberService = phoneNumberService;
        this.countryService = countryService;
        this.countryCodeOptions = [];
        this.allCountryCodeOptions = [];
        this.debouncer = new MintDebouncer(200);
        for (const country of this.countryService.getCountryList()) {
            if (!country.callingCodes || !country.callingCodes.length) {
                continue;
            }
            const flag = country.flag ? country.flag : '';
            for (const callingCode of country.callingCodes) {
                this.allCountryCodeOptions.push({
                    name: `${flag} ${callingCode}`,
                    value: country.alpha2,
                    displayName: `${flag} ${country.name} | ${callingCode}`,
                });
            }
        }
        this.countryCodeOptions = [...this.allCountryCodeOptions];
    }
    resetFieldValue() {
        return {
            phoneNumber: null,
            countryCode: null,
        };
    }
    ngOnInit() {
        super.init(this.field, this.controlElement);
        if (typeof this.field.autocomplete === 'undefined') {
            this.field.autocomplete = MintFormFieldAutocomplete.On;
        }
        if (!this.field.value || typeof this.field.value === 'string') {
            this.field.value = {
                phoneNumber: null,
                countryCode: null,
            };
        }
        let countryCode = this.field.value.countryCode;
        if (!countryCode && this.field.value.phoneNumber) {
            countryCode = this.phoneNumberService.countryCode(this.field.value.phoneNumber);
        }
        this.field.value = {
            phoneNumber: this.field.value.phoneNumber,
            countryCode: countryCode,
        };
        if (this.field?.value?.phoneNumber && this.field?.value?.countryCode) {
            this.displayValue = this.formatPhoneNumberValue(this.field.value.phoneNumber, this.field.value.countryCode);
        }
    }
    formatPhoneNumberValue(phoneNumber, countryCode) {
        if (!phoneNumber) {
            return null;
        }
        if (!countryCode) {
            countryCode = this.phoneNumberService.countryCode(phoneNumber);
        }
        if (this.field.displayFormat === 'national') {
            return this.phoneNumberService.formatNational(phoneNumber, countryCode);
        }
        return this.phoneNumberService.formatE164(phoneNumber, countryCode);
    }
    resetCountryList($event) {
        // logger.debug('resetCountryList: event: ', $event);
        this.countryCodeOptions = [...this.allCountryCodeOptions];
    }
    onCountrySearch($event) {
        if (!!$event && !!$event.target) {
            const value = MintStringUtil.slug($event.target.value);
            this.debouncer.debounce(() => {
                this.countryCodeOptions = [...this.allCountryCodeOptions].filter((_country) => MintStringUtil.slug(_country.displayName).includes(value));
            });
        }
    }
    onCountryChange($event) {
        // logger.debug('onCountryChange: event: ', $event);
        this.field.value.countryCode = $event;
        this.onChange(this.field.value.phoneNumber);
    }
    onChange($event, fieldOption) {
        if (this.field.disabled) {
            return;
        }
        this.debouncer.debounce(() => {
            const countryCode = this.field.value.countryCode;
            const phoneNumber = this.phoneNumberService.formatE164($event, this.field.value.countryCode);
            this.field.value = {
                phoneNumber: phoneNumber,
                countryCode: countryCode,
            };
            const changedValue = $event;
            const currentCursorPosition = this.phoneInputElement.nativeElement.selectionStart;
            if (changedValue) {
                const formattedPhoneNumber = this.formatPhoneNumberValue(changedValue, this.field.value.countryCode);
                this.displayValue = formattedPhoneNumber;
                this.phoneInputElement.nativeElement.value = formattedPhoneNumber;
                if (this.field?.value?.countryCode === 'US' &&
                    !(formattedPhoneNumber?.match(US_NATIONAL_FORMAT_REGEX) &&
                        changedValue?.length > US_NATIONAL_FORMAT_VALUE_LENGTH)) {
                    this.updateCursorPosition(changedValue, formattedPhoneNumber, currentCursorPosition);
                }
            }
            // propagate value into form control using control value accessor interface
            if (this.propagateChange) {
                this.propagateChange(this.field.value);
            }
        });
    }
    updateCursorPosition(changedValue, formattedPhoneNumber, currentCursorPosition) {
        this.phoneInputElement.nativeElement.readOnly = true;
        const newCursorPosition = MintInputPhoneComponent.getNewCursorPosition(changedValue, formattedPhoneNumber, currentCursorPosition, this.field.displayFormat);
        setTimeout(() => {
            this.phoneInputElement.nativeElement.setSelectionRange(newCursorPosition, newCursorPosition);
            this.phoneInputElement.nativeElement.readOnly = false;
        }, 0);
    }
    static getNewCursorPosition(changedValue, formattedPhoneNumber, cursorSelectionStart, displayFormat) {
        if (displayFormat && displayFormat !== 'national') {
            return cursorSelectionStart;
        }
        return this.getNewCursorPositionForUSNationalDisplayFormat(formattedPhoneNumber, changedValue, cursorSelectionStart);
    }
    static getNewCursorPositionForUSNationalDisplayFormat(formattedPhoneNumber, changedValue, cursorSelectionStart) {
        let offset;
        if (this.isPhoneNumberFormattingApplied(formattedPhoneNumber, changedValue)) {
            if (changedValue.length < US_NATIONAL_FORMAT_VALUE_LENGTH &&
                changedValue.match(US_NATIONAL_FORMAT_REGEX)) {
                return cursorSelectionStart + 1;
            }
            if (cursorSelectionStart < 4) {
                offset = 1;
            }
            else if (cursorSelectionStart < 7) {
                offset = 3;
            }
            else {
                offset = 4;
            }
            return cursorSelectionStart + offset;
        }
        else if (this.isPhoneNumberFormattingRemoved(formattedPhoneNumber, changedValue)) {
            if (cursorSelectionStart < 1) {
                offset = 0;
            }
            else if (cursorSelectionStart < 5) {
                offset = 1;
            }
            else if (cursorSelectionStart < 6) {
                offset = 2;
            }
            else if (cursorSelectionStart < 10) {
                offset = 3;
            }
            else {
                offset = 4;
            }
            return cursorSelectionStart - offset;
        }
        else {
            return cursorSelectionStart;
        }
    }
    static isPhoneNumberFormattingRemoved(formattedPhoneNumber, changedValue) {
        return formattedPhoneNumber.length < changedValue.length;
    }
    static isPhoneNumberFormattingApplied(formattedPhoneNumber, changedValue) {
        return formattedPhoneNumber.length > changedValue.length;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputPhoneComponent, deps: [{ token: MintPhoneNumberService }, { token: MintCountryService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintInputPhoneComponent, selector: "mint-input-phone", inputs: { field: "field" }, providers: [MINT_INPUT_PHONE_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }, { propertyName: "phoneInputElement", first: true, predicate: ["phoneInput"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container\n  *ngIf=\"field && field.visible(field.control) && countryCodeOptions\"\n>\n  <ng-container *ngIf=\"field && field.controlType === 'tel'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-input-group\n        #control\n        [nzAddOnBefore]=\"country\"\n        [nzSize]=\"field.size\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n      >\n        <input\n          #phoneInput\n          nz-input\n          id=\"input-{{ uid }}\"\n          [ngStyle]=\"{ width: '100%' }\"\n          [nzSize]=\"field.size\"\n          (focus)=\"onFocus($event)\"\n          (blur)=\"onBlur($event)\"\n          [ngModel]=\"displayValue\"\n          (ngModelChange)=\"onChange($event)\"\n          [type]=\"field.controlType\"\n          [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n          [autocomplete]=\"field.autocomplete\"\n          [attr.aria-invalid]=\"!isValid()\"\n          [disabled]=\"field.disabled\"\n        />\n      </nz-input-group>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n\n  <div\n    *ngIf=\"isValid()\"\n    class=\"mint-form-field-description\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p>{{ field.description }}</p>\n  </div>\n\n  <ng-template #country>\n    <nz-select\n      [nzSize]=\"field.size\"\n      [nzAllowClear]=\"false\"\n      [nzShowSearch]=\"false\"\n      [nzDropdownMatchSelectWidth]=\"false\"\n      [ngModel]=\"field.value.countryCode\"\n      (nzOnSearch)=\"onCountrySearch($event)\"\n      (nzOpenChange)=\"resetCountryList($event)\"\n      [nzDropdownRender]=\"render\"\n      (ngModelChange)=\"onCountryChange($event)\"\n    >\n      <nz-option\n        *ngFor=\"let option of countryCodeOptions\"\n        nzCustomContent\n        [nzLabel]=\"option.name\"\n        [nzValue]=\"option.value\"\n      >\n        {{ option.displayName ? option.displayName : option.name }}\n      </nz-option>\n    </nz-select>\n  </ng-template>\n\n  <ng-template #render>\n    <nz-divider style=\"margin: 4px 0\"></nz-divider>\n    <div style=\"padding: 8px; cursor: pointer\">\n      <nz-input-group [nzSuffix]=\"suffixIconSearch\">\n        <input\n          type=\"text\"\n          nz-input\n          (keyup)=\"onCountrySearch($event)\"\n          placeholder=\"Country\"\n        />\n      </nz-input-group>\n    </div>\n  </ng-template>\n\n  <ng-template #suffixIconSearch>\n    <i nz-icon nzType=\"search\"></i>\n  </ng-template>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}form .ant-input-group .ant-select{min-width:60px!important}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2$2.NzInputDirective, selector: "input[nz-input],textarea[nz-input]", inputs: ["nzBorderless", "nzSize", "nzStepperless", "nzStatus", "disabled"], exportAs: ["nzInput"] }, { kind: "component", type: i2$2.NzInputGroupComponent, selector: "nz-input-group", inputs: ["nzAddOnBeforeIcon", "nzAddOnAfterIcon", "nzPrefixIcon", "nzSuffixIcon", "nzAddOnBefore", "nzAddOnAfter", "nzPrefix", "nzStatus", "nzSuffix", "nzSize", "nzSearch", "nzCompact"], exportAs: ["nzInputGroup"] }, { kind: "directive", type: i2$2.NzInputGroupWhitSuffixOrPrefixDirective, selector: "nz-input-group[nzSuffix], nz-input-group[nzPrefix]" }, { kind: "component", type: i2$4.NzOptionComponent, selector: "nz-option", inputs: ["nzTitle", "nzLabel", "nzValue", "nzKey", "nzDisabled", "nzHide", "nzCustomContent"], exportAs: ["nzOption"] }, { kind: "component", type: i2$4.NzSelectComponent, selector: "nz-select", inputs: ["nzId", "nzSize", "nzStatus", "nzOptionHeightPx", "nzOptionOverflowSize", "nzDropdownClassName", "nzDropdownMatchSelectWidth", "nzDropdownStyle", "nzNotFoundContent", "nzPlaceHolder", "nzPlacement", "nzMaxTagCount", "nzDropdownRender", "nzCustomTemplate", "nzSuffixIcon", "nzClearIcon", "nzRemoveIcon", "nzMenuItemSelectedIcon", "nzTokenSeparators", "nzMaxTagPlaceholder", "nzMaxMultipleCount", "nzMode", "nzFilterOption", "compareWith", "nzAllowClear", "nzBorderless", "nzShowSearch", "nzLoading", "nzAutoFocus", "nzAutoClearSearchValue", "nzServerSearch", "nzDisabled", "nzOpen", "nzSelectOnTab", "nzBackdrop", "nzOptions", "nzShowArrow"], outputs: ["nzOnSearch", "nzScrollToBottom", "nzOpenChange", "nzBlur", "nzFocus"], exportAs: ["nzSelect"] }, { kind: "component", type: i6$1.NzDividerComponent, selector: "nz-divider", inputs: ["nzText", "nzType", "nzOrientation", "nzDashed", "nzPlain"], exportAs: ["nzDivider"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputPhoneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-input-phone', encapsulation: ViewEncapsulation.None, providers: [MINT_INPUT_PHONE_CONTROL_VALUE_ACCESSOR], template: "<ng-container\n  *ngIf=\"field && field.visible(field.control) && countryCodeOptions\"\n>\n  <ng-container *ngIf=\"field && field.controlType === 'tel'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-input-group\n        #control\n        [nzAddOnBefore]=\"country\"\n        [nzSize]=\"field.size\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n      >\n        <input\n          #phoneInput\n          nz-input\n          id=\"input-{{ uid }}\"\n          [ngStyle]=\"{ width: '100%' }\"\n          [nzSize]=\"field.size\"\n          (focus)=\"onFocus($event)\"\n          (blur)=\"onBlur($event)\"\n          [ngModel]=\"displayValue\"\n          (ngModelChange)=\"onChange($event)\"\n          [type]=\"field.controlType\"\n          [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n          [autocomplete]=\"field.autocomplete\"\n          [attr.aria-invalid]=\"!isValid()\"\n          [disabled]=\"field.disabled\"\n        />\n      </nz-input-group>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n\n  <div\n    *ngIf=\"isValid()\"\n    class=\"mint-form-field-description\"\n    [ngClass]=\"{ 'has-lateral': layoutClassName === 'mint-input-std-lat' }\"\n  >\n    <p>{{ field.description }}</p>\n  </div>\n\n  <ng-template #country>\n    <nz-select\n      [nzSize]=\"field.size\"\n      [nzAllowClear]=\"false\"\n      [nzShowSearch]=\"false\"\n      [nzDropdownMatchSelectWidth]=\"false\"\n      [ngModel]=\"field.value.countryCode\"\n      (nzOnSearch)=\"onCountrySearch($event)\"\n      (nzOpenChange)=\"resetCountryList($event)\"\n      [nzDropdownRender]=\"render\"\n      (ngModelChange)=\"onCountryChange($event)\"\n    >\n      <nz-option\n        *ngFor=\"let option of countryCodeOptions\"\n        nzCustomContent\n        [nzLabel]=\"option.name\"\n        [nzValue]=\"option.value\"\n      >\n        {{ option.displayName ? option.displayName : option.name }}\n      </nz-option>\n    </nz-select>\n  </ng-template>\n\n  <ng-template #render>\n    <nz-divider style=\"margin: 4px 0\"></nz-divider>\n    <div style=\"padding: 8px; cursor: pointer\">\n      <nz-input-group [nzSuffix]=\"suffixIconSearch\">\n        <input\n          type=\"text\"\n          nz-input\n          (keyup)=\"onCountrySearch($event)\"\n          placeholder=\"Country\"\n        />\n      </nz-input-group>\n    </div>\n  </ng-template>\n\n  <ng-template #suffixIconSearch>\n    <i nz-icon nzType=\"search\"></i>\n  </ng-template>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}form .ant-input-group .ant-select{min-width:60px!important}\n"] }]
        }], ctorParameters: () => [{ type: MintPhoneNumberService }, { type: MintCountryService }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }], phoneInputElement: [{
                type: ViewChild,
                args: ['phoneInput', { static: false }]
            }] } });

class MintInputPhoneModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputPhoneModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintInputPhoneModule, declarations: [MintInputPhoneComponent], imports: [FormsModule,
            NzInputModule,
            NzSelectModule,
            NzDividerModule,
            CommonModule,
            MintFormModule], exports: [MintInputPhoneComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputPhoneModule, imports: [FormsModule,
            NzInputModule,
            NzSelectModule,
            NzDividerModule,
            CommonModule,
            MintFormModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInputPhoneModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        NzInputModule,
                        NzSelectModule,
                        NzDividerModule,
                        CommonModule,
                        MintFormModule,
                    ],
                    declarations: [MintInputPhoneComponent],
                    exports: [MintInputPhoneComponent, MintFormModule],
                }]
        }] });

const logger$1y = MintLogger.getLogger('MintNotesComponent');
const MINT_NOTES_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintNotesComponent),
    multi: true,
};
class MintNotesComponent extends MintFormFieldComponent {
    constructor() {
        super(...arguments);
        this.isVisible = false;
        this.characterCount = 0;
    }
    ngOnInit() {
        super.init(this.field, this.controlElement);
        this.characterCount = this.field?.value?.length ?? 0;
    }
    modelChanged(event) {
        this.characterCount = event.length;
    }
    setVisible() {
        this.isVisible = !this.isVisible;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNotesComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintNotesComponent, selector: "mint-notes", inputs: { field: "field" }, providers: [MINT_NOTES_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container\n    *ngIf=\"field && field.controlType === 'notes'\"\n    [class.mint-form-label-invalid]=\"!isValid()\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <span class=\"label-placeholder\"></span>\n      <div class=\"mint-notes-layout\">\n        <div\n          *ngIf=\"field.isCollapsable\"\n          (click)=\"setVisible()\"\n          class=\"notes-collapsable-text\"\n        >\n          <span>\n            {{ isVisible ? field.hideText : field.showText }}\n          </span>\n          <i\n            nz-icon\n            [nzType]=\"isVisible ? 'up' : 'down'\"\n            nzTheme=\"outline\"\n            class=\"icon-size\"\n          ></i>\n        </div>\n        <div\n          *ngIf=\"\n            field.label &&\n            (!field.isCollapsable || (field.isCollapsable && isVisible))\n          \"\n          class=\"notes-label\"\n        >\n          {{ field.label\n          }}<sup *ngIf=\"field.required\" class=\"notes-required\">*</sup>\n        </div>\n        <div\n          *ngIf=\"(field.isCollapsable && isVisible) || !field.isCollapsable\"\n          class=\"width-100\"\n        >\n          <textarea\n            #control\n            id=\"input-{{ uid }}\"\n            nz-input\n            [nzAutosize]=\"{ minRows: 2, maxRows: 16 }\"\n            [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n            type=\"text\"\n            (focus)=\"onFocus($event)\"\n            (blur)=\"onBlur($event)\"\n            (keyup)=\"onChange($event)\"\n            [(ngModel)]=\"field.value\"\n            [attr.aria-invalid]=\"!isValid()\"\n            [disabled]=\"field.disabled\"\n            [maxlength]=\"field.maxLength\"\n            (ngModelChange)=\"modelChanged($event)\"\n            [class.mint-form-field-invalid]=\"!isValid()\"\n          >\n          </textarea>\n          <div *ngIf=\"field?.maxLength\">\n            <div class=\"my-1 align-characters-right\">\n              {{ characterCount + ' / ' + field?.maxLength }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".icon-size{width:17px}.align-characters-right{text-align:right}.notes-collapsable-text{display:flex;align-items:center;color:#0c6af1;font-size:13px}.notes-label{opacity:.7;font-size:12px}.notes-required{top:-3px;font-size:.8rem}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2$2.NzInputDirective, selector: "input[nz-input],textarea[nz-input]", inputs: ["nzBorderless", "nzSize", "nzStepperless", "nzStatus", "disabled"], exportAs: ["nzInput"] }, { kind: "directive", type: i2$2.NzAutosizeDirective, selector: "textarea[nzAutosize]", inputs: ["nzAutosize"], exportAs: ["nzAutosize"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4$3.NzIconDirective, selector: "[nz-icon]", inputs: ["nzSpin", "nzRotate", "nzType", "nzTheme", "nzTwotoneColor", "nzIconfont"], exportAs: ["nzIcon"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNotesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-notes', encapsulation: ViewEncapsulation.None, providers: [MINT_NOTES_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container\n    *ngIf=\"field && field.controlType === 'notes'\"\n    [class.mint-form-label-invalid]=\"!isValid()\"\n  >\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <span class=\"label-placeholder\"></span>\n      <div class=\"mint-notes-layout\">\n        <div\n          *ngIf=\"field.isCollapsable\"\n          (click)=\"setVisible()\"\n          class=\"notes-collapsable-text\"\n        >\n          <span>\n            {{ isVisible ? field.hideText : field.showText }}\n          </span>\n          <i\n            nz-icon\n            [nzType]=\"isVisible ? 'up' : 'down'\"\n            nzTheme=\"outline\"\n            class=\"icon-size\"\n          ></i>\n        </div>\n        <div\n          *ngIf=\"\n            field.label &&\n            (!field.isCollapsable || (field.isCollapsable && isVisible))\n          \"\n          class=\"notes-label\"\n        >\n          {{ field.label\n          }}<sup *ngIf=\"field.required\" class=\"notes-required\">*</sup>\n        </div>\n        <div\n          *ngIf=\"(field.isCollapsable && isVisible) || !field.isCollapsable\"\n          class=\"width-100\"\n        >\n          <textarea\n            #control\n            id=\"input-{{ uid }}\"\n            nz-input\n            [nzAutosize]=\"{ minRows: 2, maxRows: 16 }\"\n            [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n            type=\"text\"\n            (focus)=\"onFocus($event)\"\n            (blur)=\"onBlur($event)\"\n            (keyup)=\"onChange($event)\"\n            [(ngModel)]=\"field.value\"\n            [attr.aria-invalid]=\"!isValid()\"\n            [disabled]=\"field.disabled\"\n            [maxlength]=\"field.maxLength\"\n            (ngModelChange)=\"modelChanged($event)\"\n            [class.mint-form-field-invalid]=\"!isValid()\"\n          >\n          </textarea>\n          <div *ngIf=\"field?.maxLength\">\n            <div class=\"my-1 align-characters-right\">\n              {{ characterCount + ' / ' + field?.maxLength }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [".icon-size{width:17px}.align-characters-right{text-align:right}.notes-collapsable-text{display:flex;align-items:center;color:#0c6af1;font-size:13px}.notes-label{opacity:.7;font-size:12px}.notes-required{top:-3px;font-size:.8rem}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintNotesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNotesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintNotesModule, declarations: [MintNotesComponent], imports: [FormsModule,
            NzInputModule,
            CommonModule,
            MintFormModule,
            NzIconModule], exports: [MintNotesComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNotesModule, imports: [FormsModule,
            NzInputModule,
            CommonModule,
            MintFormModule,
            NzIconModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintNotesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        NzInputModule,
                        CommonModule,
                        MintFormModule,
                        NzIconModule,
                    ],
                    declarations: [MintNotesComponent],
                    exports: [MintNotesComponent, MintFormModule],
                }]
        }] });

const logger$1x = MintLogger.getLogger('MintPlainTextComponent');
const MINT_PLAIN_TEXT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintPlainTextComponent),
    multi: true,
};
class MintPlainTextComponent extends MintFormFieldComponent {
    constructor() {
        super(...arguments);
        this.characterCount = 0;
    }
    ngOnInit() {
        super.init(this.field, this.controlElement);
        this.characterCount = this.field?.value?.length ?? 0;
    }
    modelChanged(event) {
        this.characterCount = event.length;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlainTextComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintPlainTextComponent, selector: "mint-plain-text", inputs: { field: "field" }, providers: [MINT_PLAIN_TEXT_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'textarea'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <textarea\n        #control\n        id=\"input-{{ uid }}\"\n        nz-input\n        [nzAutosize]=\"{ minRows: 2, maxRows: 16 }\"\n        [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n        type=\"text\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (keyup)=\"onChange($event)\"\n        [(ngModel)]=\"field.value\"\n        [attr.aria-invalid]=\"!isValid()\"\n        [disabled]=\"field.disabled\"\n        [maxlength]=\"field.maxLength\"\n        (ngModelChange)=\"modelChanged($event)\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n        [attr.data-testid]=\"field.dataTestId\"\n      >\n      </textarea>\n    </div>\n    <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n      <p\n        *ngFor=\"let error of getErrors()\"\n        [innerHtml]=\"error | mintSafeHtml\"\n        data-testid=\"validation-error\"\n      ></p>\n    </div>\n    <div *ngIf=\"field?.maxLength && field?.showRemainingChar\">\n      <div class=\"mb-1 align-characters-right\">\n        {{ characterCount + ' / ' + field?.maxLength }}\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.align-characters-right{text-align:right}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2$2.NzInputDirective, selector: "input[nz-input],textarea[nz-input]", inputs: ["nzBorderless", "nzSize", "nzStepperless", "nzStatus", "disabled"], exportAs: ["nzInput"] }, { kind: "directive", type: i2$2.NzAutosizeDirective, selector: "textarea[nzAutosize]", inputs: ["nzAutosize"], exportAs: ["nzAutosize"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlainTextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-plain-text', encapsulation: ViewEncapsulation.None, providers: [MINT_PLAIN_TEXT_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'textarea'\">\n    <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n      <label\n        *ngIf=\"field.label\"\n        class=\"label\"\n        [class.mint-form-label-invalid]=\"!isValid()\"\n        for=\"input-{{ uid }}\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <textarea\n        #control\n        id=\"input-{{ uid }}\"\n        nz-input\n        [nzAutosize]=\"{ minRows: 2, maxRows: 16 }\"\n        [placeholder]=\"field.placeholder ? field.placeholder : ''\"\n        type=\"text\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        (keyup)=\"onChange($event)\"\n        [(ngModel)]=\"field.value\"\n        [attr.aria-invalid]=\"!isValid()\"\n        [disabled]=\"field.disabled\"\n        [maxlength]=\"field.maxLength\"\n        (ngModelChange)=\"modelChanged($event)\"\n        [class.mint-form-field-invalid]=\"!isValid()\"\n        [attr.data-testid]=\"field.dataTestId\"\n      >\n      </textarea>\n    </div>\n    <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n      <p\n        *ngFor=\"let error of getErrors()\"\n        [innerHtml]=\"error | mintSafeHtml\"\n        data-testid=\"validation-error\"\n      ></p>\n    </div>\n    <div *ngIf=\"field?.maxLength && field?.showRemainingChar\">\n      <div class=\"mb-1 align-characters-right\">\n        {{ characterCount + ' / ' + field?.maxLength }}\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.align-characters-right{text-align:right}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintPlainTextModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlainTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintPlainTextModule, declarations: [MintPlainTextComponent], imports: [FormsModule, NzInputModule, CommonModule, MintFormModule], exports: [MintPlainTextComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlainTextModule, imports: [FormsModule, NzInputModule, CommonModule, MintFormModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlainTextModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, NzInputModule, CommonModule, MintFormModule],
                    declarations: [MintPlainTextComponent],
                    exports: [MintPlainTextComponent, MintFormModule],
                }]
        }] });

const logger$1w = MintLogger.getLogger('MintRadioGroupComponent');
const MINT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintRadioGroupComponent),
    multi: true,
};
class MintRadioGroupComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
    }
    onChange($event, fieldOption) {
        if (this.field.disabled) {
            return;
        }
        this.field.value = $event;
        // propagate value into form control using control value accessor interface
        if (this.propagateChange) {
            this.propagateChange(this.field.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRadioGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintRadioGroupComponent, selector: "mint-radio-group", inputs: { field: "field" }, providers: [MINT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div\n    class=\"mint-input-layout\"\n    [ngClass]=\"layoutClassName\"\n    *ngIf=\"layoutClassName\"\n  >\n    <ng-container *ngTemplateOutlet=\"radioGroupTemplate\"></ng-container>\n  </div>\n  <ng-container *ngIf=\"!layoutClassName\">\n    <ng-container *ngTemplateOutlet=\"radioGroupTemplate\"></ng-container>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n\n<ng-template #radioGroupTemplate>\n  <nz-radio-group\n    *ngIf=\"field && field.controlType === 'radio-group'\"\n    #control\n    [nzSize]=\"field.size\"\n    [nzDisabled]=\"field.disabled\"\n    [nzButtonStyle]=\"field.buttonStyle\"\n    (ngModelChange)=\"onChange($event)\"\n    [ngModel]=\"field.value\"\n    [class.mint-form-label-invalid]=\"!isValid()\"\n    [attr.data-testid]=\"field.dataTestId\"\n  >\n    <ng-container\n      *ngIf=\"\n        field.buttonStyle;\n        then radioGroupButtonStyle;\n        else radioGroupRadioStyle\n      \"\n    >\n    </ng-container>\n    <ng-template #radioGroupButtonStyle>\n      <label\n        nz-radio-button\n        [nzValue]=\"option.value\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        *ngFor=\"let option of field.options\"\n        [attr.data-testid]=\"option.dataTestId\"\n      >\n        {{ option.name }}\n      </label>\n    </ng-template>\n    <ng-template #radioGroupRadioStyle>\n      <label\n        nz-radio\n        [nzValue]=\"option.value\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        *ngFor=\"let option of field.options\"\n        [attr.data-testid]=\"option.dataTestId\"\n      >\n        {{ option.name }}\n      </label>\n    </ng-template>\n  </nz-radio-group>\n</ng-template>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.mint-input-layout.mint-input-std-vert .ant-radio-group{display:flex;flex-direction:column}.mint-input-layout.mint-input-std-vert .ant-radio-group label{margin-bottom:24px}.mint-input-layout.mint-input-std-vert .ant-radio-group label:last-of-type{margin-bottom:0}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$5.NzRadioComponent, selector: "[nz-radio],[nz-radio-button]", inputs: ["nzValue", "nzDisabled", "nzAutoFocus"], exportAs: ["nzRadio"] }, { kind: "directive", type: i2$5.NzRadioButtonDirective, selector: "[nz-radio-button]" }, { kind: "component", type: i2$5.NzRadioGroupComponent, selector: "nz-radio-group", inputs: ["nzDisabled", "nzButtonStyle", "nzSize", "nzName"], exportAs: ["nzRadioGroup"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-radio-group', encapsulation: ViewEncapsulation.None, providers: [MINT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div\n    class=\"mint-input-layout\"\n    [ngClass]=\"layoutClassName\"\n    *ngIf=\"layoutClassName\"\n  >\n    <ng-container *ngTemplateOutlet=\"radioGroupTemplate\"></ng-container>\n  </div>\n  <ng-container *ngIf=\"!layoutClassName\">\n    <ng-container *ngTemplateOutlet=\"radioGroupTemplate\"></ng-container>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n\n<ng-template #radioGroupTemplate>\n  <nz-radio-group\n    *ngIf=\"field && field.controlType === 'radio-group'\"\n    #control\n    [nzSize]=\"field.size\"\n    [nzDisabled]=\"field.disabled\"\n    [nzButtonStyle]=\"field.buttonStyle\"\n    (ngModelChange)=\"onChange($event)\"\n    [ngModel]=\"field.value\"\n    [class.mint-form-label-invalid]=\"!isValid()\"\n    [attr.data-testid]=\"field.dataTestId\"\n  >\n    <ng-container\n      *ngIf=\"\n        field.buttonStyle;\n        then radioGroupButtonStyle;\n        else radioGroupRadioStyle\n      \"\n    >\n    </ng-container>\n    <ng-template #radioGroupButtonStyle>\n      <label\n        nz-radio-button\n        [nzValue]=\"option.value\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        *ngFor=\"let option of field.options\"\n        [attr.data-testid]=\"option.dataTestId\"\n      >\n        {{ option.name }}\n      </label>\n    </ng-template>\n    <ng-template #radioGroupRadioStyle>\n      <label\n        nz-radio\n        [nzValue]=\"option.value\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        *ngFor=\"let option of field.options\"\n        [attr.data-testid]=\"option.dataTestId\"\n      >\n        {{ option.name }}\n      </label>\n    </ng-template>\n  </nz-radio-group>\n</ng-template>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.mint-input-layout.mint-input-std-vert .ant-radio-group{display:flex;flex-direction:column}.mint-input-layout.mint-input-std-vert .ant-radio-group label{margin-bottom:24px}.mint-input-layout.mint-input-std-vert .ant-radio-group label:last-of-type{margin-bottom:0}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintRadioGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRadioGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintRadioGroupModule, declarations: [MintRadioGroupComponent], imports: [FormsModule,
            NzRadioModule,
            CommonModule,
            MintFormModule,
            NzCollapseModule], exports: [MintRadioGroupComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRadioGroupModule, imports: [FormsModule,
            NzRadioModule,
            CommonModule,
            MintFormModule,
            NzCollapseModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRadioGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        NzRadioModule,
                        CommonModule,
                        MintFormModule,
                        NzCollapseModule,
                    ],
                    declarations: [MintRadioGroupComponent],
                    exports: [MintRadioGroupComponent, MintFormModule],
                }]
        }] });

const logger$1v = MintLogger.getLogger('MintSelectComponent');
const MINT_SELECT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintSelectComponent),
    multi: true,
};
class MintSelectComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
    }
    async ngOnChanges(changes) {
        logger$1v.debug('ngOnChanges: changes: ', changes);
        const _field = changes['field'];
        if (_field && !_field.firstChange) {
            this.field = _field.currentValue;
            this.ngOnInit();
        }
    }
    isOptionGroup(options) {
        if (!options || options.length === 0) {
            return false;
        }
        const option = options[0];
        return typeof option.options !== 'undefined';
    }
    groupOptions(options) {
        return this.isOptionGroup(options) ? options : null;
    }
    fieldOptions(options) {
        return !this.isOptionGroup(options) ? options : null;
    }
    onChange($event, fieldOption) {
        const controlType = this.field.controlType;
        if (this.field.disabled) {
            return;
        }
        this.field.value = $event;
        // propagate value into form control using control value accessor interface
        if (this.propagateChange) {
            this.propagateChange(this.field.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSelectComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintSelectComponent, selector: "mint-select", inputs: { field: "field" }, providers: [MINT_SELECT_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n    <div\n      *ngIf=\"field && field.controlType === 'select'\"\n      [class.mint-form-field-invalid]=\"!isValid()\"\n    >\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-select\n        #control\n        [nzSize]=\"field.size\"\n        [nzDisabled]=\"field.disabled\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        [nzMode]=\"field.mode\"\n        [nzDropdownClassName]=\"\n          field.mode === 'tags' ? 'nz-select-tags-dropdown' : ''\n        \"\n        [nzMaxMultipleCount]=\"field.maxMultipleCount\"\n        [nzShowSearch]=\"field.showSearch\"\n        [nzServerSearch]=\"field.serverSearch\"\n        [nzAllowClear]=\"field.allowClear\"\n        [compareWith]=\"field.compareWith\"\n        [nzDropdownMatchSelectWidth]=\"field.dropDownMatchSelectWidth\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzOpen]=\"field.isOpen\"\n        [ngModel]=\"field.value\"\n        (ngModelChange)=\"onChange($event)\"\n        (nzOpenChange)=\"field.onOpenChange($event)\"\n        (nzOnSearch)=\"field.onSearch($event)\"\n        (nzScrollToBottom)=\"field.onBottomScroll()\"\n        [nzDropdownRender]=\"field.optionsFooterItem\"\n        [nzSelectOnTab]=\"true\"\n        [attr.data-testid]=\"field.dataTestId\"\n        [nzAutoClearSearchValue]=\"field.autoClearSearchValue\"\n      >\n        <nz-option\n          *ngIf=\"field.loading === 'search'\"\n          nzDisabled\n          nzCustomContent\n        >\n          <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n          Loading ...\n        </nz-option>\n\n        <ng-container *ngIf=\"field.loading !== 'search'\">\n          <ng-container\n            *ngIf=\"\n              isOptionGroup(field.options);\n              then selectOptionGroups;\n              else selectOptions\n            \"\n          >\n          </ng-container>\n\n          <nz-option\n            *ngIf=\"field.loading === 'scroll'\"\n            nzDisabled\n            nzCustomContent\n          >\n            <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n            Loading ...\n          </nz-option>\n        </ng-container>\n\n        <ng-template #selectOptionGroups>\n          <nz-option-group\n            [nzLabel]=\"group.name\"\n            *ngFor=\"let group of groupOptions(field.options)\"\n          >\n            <nz-option\n              *ngFor=\"let option of group.options\"\n              nzCustomContent\n              [nzLabel]=\"option.name\"\n              [nzValue]=\"option.value\"\n            >\n              <ng-container\n                *ngIf=\"\n                  (option.name || option.displayName) && !option.displayTemplate\n                \"\n              >\n                <div\n                  [innerHTML]=\"\n                    (option.displayName ? option.displayName : option.name)\n                      | mintSafeHtml\n                  \"\n                  [attr.data-testid]=\"option.dataTestId\"\n                ></div>\n              </ng-container>\n              <ng-container *ngIf=\"option.displayTemplate\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    option.displayTemplate.templateRef;\n                    context: option.displayTemplate.context\n                  \"\n                ></ng-container>\n              </ng-container>\n            </nz-option>\n          </nz-option-group>\n        </ng-template>\n\n        <ng-template #selectOptions>\n          <nz-option\n            *ngFor=\"let option of fieldOptions(field.options)\"\n            nzCustomContent\n            [nzLabel]=\"option.name\"\n            [nzValue]=\"option.value\"\n          >\n            <ng-container\n              *ngIf=\"\n                (option.name || option.displayName) && !option.displayTemplate\n              \"\n            >\n              <div\n                [innerHTML]=\"\n                  (option.displayName ? option.displayName : option.name)\n                    | mintSafeHtml\n                \"\n                [attr.data-testid]=\"option.dataTestId\"\n              ></div>\n            </ng-container>\n\n            <ng-container *ngIf=\"option.displayTemplate\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  option.displayTemplate.templateRef;\n                  context: option.displayTemplate.context\n                \"\n              ></ng-container>\n            </ng-container>\n          </nz-option>\n        </ng-template>\n      </nz-select>\n\n      <!--    <ng-template #mintSelectCustomTemplate let-selected>-->\n      <!--      {{ selected.displayName ? selected.displayName : selected.name }}-->\n      <!--    </ng-template>-->\n    </div>\n  </div>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.ant-select-clear{right:33px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$4.NzOptionComponent, selector: "nz-option", inputs: ["nzTitle", "nzLabel", "nzValue", "nzKey", "nzDisabled", "nzHide", "nzCustomContent"], exportAs: ["nzOption"] }, { kind: "component", type: i2$4.NzSelectComponent, selector: "nz-select", inputs: ["nzId", "nzSize", "nzStatus", "nzOptionHeightPx", "nzOptionOverflowSize", "nzDropdownClassName", "nzDropdownMatchSelectWidth", "nzDropdownStyle", "nzNotFoundContent", "nzPlaceHolder", "nzPlacement", "nzMaxTagCount", "nzDropdownRender", "nzCustomTemplate", "nzSuffixIcon", "nzClearIcon", "nzRemoveIcon", "nzMenuItemSelectedIcon", "nzTokenSeparators", "nzMaxTagPlaceholder", "nzMaxMultipleCount", "nzMode", "nzFilterOption", "compareWith", "nzAllowClear", "nzBorderless", "nzShowSearch", "nzLoading", "nzAutoFocus", "nzAutoClearSearchValue", "nzServerSearch", "nzDisabled", "nzOpen", "nzSelectOnTab", "nzBackdrop", "nzOptions", "nzShowArrow"], outputs: ["nzOnSearch", "nzScrollToBottom", "nzOpenChange", "nzBlur", "nzFocus"], exportAs: ["nzSelect"] }, { kind: "component", type: i2$4.NzOptionGroupComponent, selector: "nz-option-group", inputs: ["nzLabel"], exportAs: ["nzOptionGroup"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-select', encapsulation: ViewEncapsulation.None, providers: [MINT_SELECT_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n    <div\n      *ngIf=\"field && field.controlType === 'select'\"\n      [class.mint-form-field-invalid]=\"!isValid()\"\n    >\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-select\n        #control\n        [nzSize]=\"field.size\"\n        [nzDisabled]=\"field.disabled\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        [nzMode]=\"field.mode\"\n        [nzDropdownClassName]=\"\n          field.mode === 'tags' ? 'nz-select-tags-dropdown' : ''\n        \"\n        [nzMaxMultipleCount]=\"field.maxMultipleCount\"\n        [nzShowSearch]=\"field.showSearch\"\n        [nzServerSearch]=\"field.serverSearch\"\n        [nzAllowClear]=\"field.allowClear\"\n        [compareWith]=\"field.compareWith\"\n        [nzDropdownMatchSelectWidth]=\"field.dropDownMatchSelectWidth\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzOpen]=\"field.isOpen\"\n        [ngModel]=\"field.value\"\n        (ngModelChange)=\"onChange($event)\"\n        (nzOpenChange)=\"field.onOpenChange($event)\"\n        (nzOnSearch)=\"field.onSearch($event)\"\n        (nzScrollToBottom)=\"field.onBottomScroll()\"\n        [nzDropdownRender]=\"field.optionsFooterItem\"\n        [nzSelectOnTab]=\"true\"\n        [attr.data-testid]=\"field.dataTestId\"\n        [nzAutoClearSearchValue]=\"field.autoClearSearchValue\"\n      >\n        <nz-option\n          *ngIf=\"field.loading === 'search'\"\n          nzDisabled\n          nzCustomContent\n        >\n          <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n          Loading ...\n        </nz-option>\n\n        <ng-container *ngIf=\"field.loading !== 'search'\">\n          <ng-container\n            *ngIf=\"\n              isOptionGroup(field.options);\n              then selectOptionGroups;\n              else selectOptions\n            \"\n          >\n          </ng-container>\n\n          <nz-option\n            *ngIf=\"field.loading === 'scroll'\"\n            nzDisabled\n            nzCustomContent\n          >\n            <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n            Loading ...\n          </nz-option>\n        </ng-container>\n\n        <ng-template #selectOptionGroups>\n          <nz-option-group\n            [nzLabel]=\"group.name\"\n            *ngFor=\"let group of groupOptions(field.options)\"\n          >\n            <nz-option\n              *ngFor=\"let option of group.options\"\n              nzCustomContent\n              [nzLabel]=\"option.name\"\n              [nzValue]=\"option.value\"\n            >\n              <ng-container\n                *ngIf=\"\n                  (option.name || option.displayName) && !option.displayTemplate\n                \"\n              >\n                <div\n                  [innerHTML]=\"\n                    (option.displayName ? option.displayName : option.name)\n                      | mintSafeHtml\n                  \"\n                  [attr.data-testid]=\"option.dataTestId\"\n                ></div>\n              </ng-container>\n              <ng-container *ngIf=\"option.displayTemplate\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    option.displayTemplate.templateRef;\n                    context: option.displayTemplate.context\n                  \"\n                ></ng-container>\n              </ng-container>\n            </nz-option>\n          </nz-option-group>\n        </ng-template>\n\n        <ng-template #selectOptions>\n          <nz-option\n            *ngFor=\"let option of fieldOptions(field.options)\"\n            nzCustomContent\n            [nzLabel]=\"option.name\"\n            [nzValue]=\"option.value\"\n          >\n            <ng-container\n              *ngIf=\"\n                (option.name || option.displayName) && !option.displayTemplate\n              \"\n            >\n              <div\n                [innerHTML]=\"\n                  (option.displayName ? option.displayName : option.name)\n                    | mintSafeHtml\n                \"\n                [attr.data-testid]=\"option.dataTestId\"\n              ></div>\n            </ng-container>\n\n            <ng-container *ngIf=\"option.displayTemplate\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  option.displayTemplate.templateRef;\n                  context: option.displayTemplate.context\n                \"\n              ></ng-container>\n            </ng-container>\n          </nz-option>\n        </ng-template>\n      </nz-select>\n\n      <!--    <ng-template #mintSelectCustomTemplate let-selected>-->\n      <!--      {{ selected.displayName ? selected.displayName : selected.name }}-->\n      <!--    </ng-template>-->\n    </div>\n  </div>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.ant-select-clear{right:33px}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

dayjs.extend(dayjsTimezone);
const logger$1u = MintLogger.getLogger('MintSelectTimeZoneComponent');
const MINT_SELECT_TIMEZONE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintSelectTimeZoneComponent),
    multi: true,
};
class MintSelectTimeZoneComponent extends MintSelectComponent {
    ngOnInit() {
        super.ngOnInit();
        this.field.options = this.loadTimeZoneOptions();
    }
    loadTimeZoneOptions() {
        const t = (s) => {
            if (i18n !== void 0 && i18n[s]) {
                return i18n[s];
            }
            return s;
        };
        const timezones = [
            'Etc/GMT+12',
            'Pacific/Midway',
            'Pacific/Honolulu',
            'America/Juneau',
            'America/Dawson',
            'America/Boise',
            'America/Chihuahua',
            'America/Phoenix',
            'America/Chicago',
            'America/Regina',
            'America/Mexico_City',
            'America/Belize',
            'America/Detroit',
            'America/Indiana/Indianapolis',
            'America/Bogota',
            'America/Glace_Bay',
            'America/Caracas',
            'America/Santiago',
            'America/St_Johns',
            'America/Sao_Paulo',
            'America/Argentina/Buenos_Aires',
            'America/Godthab',
            'Etc/GMT+2',
            'Atlantic/Azores',
            'Atlantic/Cape_Verde',
            'GMT',
            'Africa/Casablanca',
            'Atlantic/Canary',
            'Europe/Belgrade',
            'Europe/Sarajevo',
            'Europe/Brussels',
            'Europe/Amsterdam',
            'Africa/Algiers',
            'Europe/Bucharest',
            'Africa/Cairo',
            'Europe/Helsinki',
            'Europe/Athens',
            'Asia/Jerusalem',
            'Africa/Harare',
            'Europe/Moscow',
            'Asia/Kuwait',
            'Africa/Nairobi',
            'Asia/Baghdad',
            'Asia/Tehran',
            'Asia/Dubai',
            'Asia/Baku',
            'Asia/Kabul',
            'Asia/Yekaterinburg',
            'Asia/Karachi',
            'Asia/Kolkata',
            'Asia/Kathmandu',
            'Asia/Dhaka',
            'Asia/Colombo',
            'Asia/Almaty',
            'Asia/Rangoon',
            'Asia/Bangkok',
            'Asia/Krasnoyarsk',
            'Asia/Shanghai',
            'Asia/Kuala_Lumpur',
            'Asia/Taipei',
            'Australia/Perth',
            'Asia/Irkutsk',
            'Asia/Seoul',
            'Asia/Tokyo',
            'Asia/Yakutsk',
            'Australia/Darwin',
            'Australia/Adelaide',
            'Australia/Sydney',
            'Australia/Brisbane',
            'Australia/Hobart',
            'Asia/Vladivostok',
            'Pacific/Guam',
            'Asia/Magadan',
            'Pacific/Fiji',
            'Pacific/Auckland',
            'Pacific/Tongatapu',
        ];
        const i18n = {
            'Etc/GMT+12': 'International Date Line West',
            'Pacific/Midway': 'Midway Island, Samoa',
            'Pacific/Honolulu': 'Hawaii',
            'America/Juneau': 'Alaska',
            'America/Dawson': 'Pacific Time (US and Canada); Tijuana',
            'America/Boise': 'Mountain Time (US and Canada)',
            'America/Chihuahua': 'Chihuahua, La Paz, Mazatlan',
            'America/Phoenix': 'Arizona',
            'America/Chicago': 'Central Time (US and Canada)',
            'America/Regina': 'Saskatchewan',
            'America/Mexico_City': 'Guadalajara, Mexico City, Monterrey',
            'America/Belize': 'Central America',
            'America/Detroit': 'Eastern Time (US and Canada)',
            'America/Indiana/Indianapolis': 'Indiana (East)',
            'America/Bogota': 'Bogota, Lima, Quito',
            'America/Glace_Bay': 'Atlantic Time (Canada)',
            'America/Caracas': 'Caracas, La Paz',
            'America/Santiago': 'Santiago',
            'America/St_Johns': 'Newfoundland and Labrador',
            'America/Sao_Paulo': 'Brasilia',
            'America/Argentina/Buenos_Aires': 'Buenos Aires, Georgetown',
            'America/Godthab': 'Greenland',
            'Etc/GMT+2': 'Mid-Atlantic',
            'Atlantic/Azores': 'Azores',
            'Atlantic/Cape_Verde': 'Cape Verde Islands',
            GMT: 'Dublin, Edinburgh, Lisbon, London',
            'Africa/Casablanca': 'Casablanca, Monrovia',
            'Atlantic/Canary': 'Canary Islands',
            'Europe/Belgrade': 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
            'Europe/Sarajevo': 'Sarajevo, Skopje, Warsaw, Zagreb',
            'Europe/Brussels': 'Brussels, Copenhagen, Madrid, Paris',
            'Europe/Amsterdam': 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
            'Africa/Algiers': 'West Central Africa',
            'Europe/Bucharest': 'Bucharest',
            'Africa/Cairo': 'Cairo',
            'Europe/Helsinki': 'Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
            'Europe/Athens': 'Athens, Istanbul, Minsk',
            'Asia/Jerusalem': 'Jerusalem',
            'Africa/Harare': 'Harare, Pretoria',
            'Europe/Moscow': 'Moscow, St. Petersburg, Volgograd',
            'Asia/Kuwait': 'Kuwait, Riyadh',
            'Africa/Nairobi': 'Nairobi',
            'Asia/Baghdad': 'Baghdad',
            'Asia/Tehran': 'Tehran',
            'Asia/Dubai': 'Abu Dhabi, Muscat',
            'Asia/Baku': 'Baku, Tbilisi, Yerevan',
            'Asia/Kabul': 'Kabul',
            'Asia/Yekaterinburg': 'Ekaterinburg',
            'Asia/Karachi': 'Islamabad, Karachi, Tashkent',
            'Asia/Kolkata': 'Chennai, Kolkata, Mumbai, New Delhi',
            'Asia/Kathmandu': 'Kathmandu',
            'Asia/Dhaka': 'Astana, Dhaka',
            'Asia/Colombo': 'Sri Jayawardenepura',
            'Asia/Almaty': 'Almaty, Novosibirsk',
            'Asia/Rangoon': 'Yangon Rangoon',
            'Asia/Bangkok': 'Bangkok, Hanoi, Jakarta',
            'Asia/Krasnoyarsk': 'Krasnoyarsk',
            'Asia/Shanghai': 'Beijing, Chongqing, Hong Kong SAR, Urumqi',
            'Asia/Kuala_Lumpur': 'Kuala Lumpur, Singapore',
            'Asia/Taipei': 'Taipei',
            'Australia/Perth': 'Perth',
            'Asia/Irkutsk': 'Irkutsk, Ulaanbaatar',
            'Asia/Seoul': 'Seoul',
            'Asia/Tokyo': 'Osaka, Sapporo, Tokyo',
            'Asia/Yakutsk': 'Yakutsk',
            'Australia/Darwin': 'Darwin',
            'Australia/Adelaide': 'Adelaide',
            'Australia/Sydney': 'Canberra, Melbourne, Sydney',
            'Australia/Brisbane': 'Brisbane',
            'Australia/Hobart': 'Hobart',
            'Asia/Vladivostok': 'Vladivostok',
            'Pacific/Guam': 'Guam, Port Moresby',
            'Asia/Magadan': 'Magadan, Solomon Islands, New Caledonia',
            'Pacific/Fiji': 'Fiji Islands, Kamchatka, Marshall Islands',
            'Pacific/Auckland': 'Auckland, Wellington',
            'Pacific/Tongatapu': "Nuku'alofa",
        };
        // const selectorOptions = dayjs.tz
        //   .names()
        //   .filter((tz) => {
        //     return timezones.includes(tz);
        //   })
        const selectorOptions = timezones
            .reduce((memo, tz) => {
            memo.push({
                name: tz,
                offset: dayjs.tz(tz).utcOffset(),
            });
            return memo;
        }, [])
            .sort((a, b) => {
            return a.offset - b.offset;
        })
            .map((tz) => {
            const timezone = tz.offset
                ? dayjs.tz(tz.name).format('Z')
                : '';
            return { name: `(GMT${timezone}) ${t(tz.name)}`, value: tz.name };
        });
        return selectorOptions;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSelectTimeZoneComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintSelectTimeZoneComponent, selector: "mint-select-timezone", providers: [MINT_SELECT_TIMEZONE_CONTROL_VALUE_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n    <div\n      *ngIf=\"field && field.controlType === 'select'\"\n      [class.mint-form-field-invalid]=\"!isValid()\"\n    >\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-select\n        #control\n        [nzSize]=\"field.size\"\n        [nzDisabled]=\"field.disabled\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        [nzMode]=\"field.mode\"\n        [nzDropdownClassName]=\"\n          field.mode === 'tags' ? 'nz-select-tags-dropdown' : ''\n        \"\n        [nzMaxMultipleCount]=\"field.maxMultipleCount\"\n        [nzShowSearch]=\"field.showSearch\"\n        [nzServerSearch]=\"field.serverSearch\"\n        [nzAllowClear]=\"field.allowClear\"\n        [compareWith]=\"field.compareWith\"\n        [nzDropdownMatchSelectWidth]=\"field.dropDownMatchSelectWidth\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzOpen]=\"field.isOpen\"\n        [ngModel]=\"field.value\"\n        (ngModelChange)=\"onChange($event)\"\n        (nzOpenChange)=\"field.onOpenChange($event)\"\n        (nzOnSearch)=\"field.onSearch($event)\"\n        (nzScrollToBottom)=\"field.onBottomScroll()\"\n        [nzDropdownRender]=\"field.optionsFooterItem\"\n        [nzSelectOnTab]=\"true\"\n        [attr.data-testid]=\"field.dataTestId\"\n        [nzAutoClearSearchValue]=\"field.autoClearSearchValue\"\n      >\n        <nz-option\n          *ngIf=\"field.loading === 'search'\"\n          nzDisabled\n          nzCustomContent\n        >\n          <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n          Loading ...\n        </nz-option>\n\n        <ng-container *ngIf=\"field.loading !== 'search'\">\n          <ng-container\n            *ngIf=\"\n              isOptionGroup(field.options);\n              then selectOptionGroups;\n              else selectOptions\n            \"\n          >\n          </ng-container>\n\n          <nz-option\n            *ngIf=\"field.loading === 'scroll'\"\n            nzDisabled\n            nzCustomContent\n          >\n            <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n            Loading ...\n          </nz-option>\n        </ng-container>\n\n        <ng-template #selectOptionGroups>\n          <nz-option-group\n            [nzLabel]=\"group.name\"\n            *ngFor=\"let group of groupOptions(field.options)\"\n          >\n            <nz-option\n              *ngFor=\"let option of group.options\"\n              nzCustomContent\n              [nzLabel]=\"option.name\"\n              [nzValue]=\"option.value\"\n            >\n              <ng-container\n                *ngIf=\"\n                  (option.name || option.displayName) && !option.displayTemplate\n                \"\n              >\n                <div\n                  [innerHTML]=\"\n                    (option.displayName ? option.displayName : option.name)\n                      | mintSafeHtml\n                  \"\n                  [attr.data-testid]=\"option.dataTestId\"\n                ></div>\n              </ng-container>\n              <ng-container *ngIf=\"option.displayTemplate\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    option.displayTemplate.templateRef;\n                    context: option.displayTemplate.context\n                  \"\n                ></ng-container>\n              </ng-container>\n            </nz-option>\n          </nz-option-group>\n        </ng-template>\n\n        <ng-template #selectOptions>\n          <nz-option\n            *ngFor=\"let option of fieldOptions(field.options)\"\n            nzCustomContent\n            [nzLabel]=\"option.name\"\n            [nzValue]=\"option.value\"\n          >\n            <ng-container\n              *ngIf=\"\n                (option.name || option.displayName) && !option.displayTemplate\n              \"\n            >\n              <div\n                [innerHTML]=\"\n                  (option.displayName ? option.displayName : option.name)\n                    | mintSafeHtml\n                \"\n                [attr.data-testid]=\"option.dataTestId\"\n              ></div>\n            </ng-container>\n\n            <ng-container *ngIf=\"option.displayTemplate\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  option.displayTemplate.templateRef;\n                  context: option.displayTemplate.context\n                \"\n              ></ng-container>\n            </ng-container>\n          </nz-option>\n        </ng-template>\n      </nz-select>\n\n      <!--    <ng-template #mintSelectCustomTemplate let-selected>-->\n      <!--      {{ selected.displayName ? selected.displayName : selected.name }}-->\n      <!--    </ng-template>-->\n    </div>\n  </div>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.ant-select-clear{right:33px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$4.NzOptionComponent, selector: "nz-option", inputs: ["nzTitle", "nzLabel", "nzValue", "nzKey", "nzDisabled", "nzHide", "nzCustomContent"], exportAs: ["nzOption"] }, { kind: "component", type: i2$4.NzSelectComponent, selector: "nz-select", inputs: ["nzId", "nzSize", "nzStatus", "nzOptionHeightPx", "nzOptionOverflowSize", "nzDropdownClassName", "nzDropdownMatchSelectWidth", "nzDropdownStyle", "nzNotFoundContent", "nzPlaceHolder", "nzPlacement", "nzMaxTagCount", "nzDropdownRender", "nzCustomTemplate", "nzSuffixIcon", "nzClearIcon", "nzRemoveIcon", "nzMenuItemSelectedIcon", "nzTokenSeparators", "nzMaxTagPlaceholder", "nzMaxMultipleCount", "nzMode", "nzFilterOption", "compareWith", "nzAllowClear", "nzBorderless", "nzShowSearch", "nzLoading", "nzAutoFocus", "nzAutoClearSearchValue", "nzServerSearch", "nzDisabled", "nzOpen", "nzSelectOnTab", "nzBackdrop", "nzOptions", "nzShowArrow"], outputs: ["nzOnSearch", "nzScrollToBottom", "nzOpenChange", "nzBlur", "nzFocus"], exportAs: ["nzSelect"] }, { kind: "component", type: i2$4.NzOptionGroupComponent, selector: "nz-option-group", inputs: ["nzLabel"], exportAs: ["nzOptionGroup"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSelectTimeZoneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-select-timezone', encapsulation: ViewEncapsulation.None, providers: [MINT_SELECT_TIMEZONE_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <div class=\"mint-input-layout\" [ngClass]=\"layoutClassName\">\n    <div\n      *ngIf=\"field && field.controlType === 'select'\"\n      [class.mint-form-field-invalid]=\"!isValid()\"\n    >\n      <label *ngIf=\"field.label\" class=\"label\"\n        >{{ field.label }}<sup *ngIf=\"field.required\">*</sup></label\n      >\n      <nz-select\n        #control\n        [nzSize]=\"field.size\"\n        [nzDisabled]=\"field.disabled\"\n        [nzPlaceHolder]=\"field.placeholder\"\n        [nzMode]=\"field.mode\"\n        [nzDropdownClassName]=\"\n          field.mode === 'tags' ? 'nz-select-tags-dropdown' : ''\n        \"\n        [nzMaxMultipleCount]=\"field.maxMultipleCount\"\n        [nzShowSearch]=\"field.showSearch\"\n        [nzServerSearch]=\"field.serverSearch\"\n        [nzAllowClear]=\"field.allowClear\"\n        [compareWith]=\"field.compareWith\"\n        [nzDropdownMatchSelectWidth]=\"field.dropDownMatchSelectWidth\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"\n        [nzOpen]=\"field.isOpen\"\n        [ngModel]=\"field.value\"\n        (ngModelChange)=\"onChange($event)\"\n        (nzOpenChange)=\"field.onOpenChange($event)\"\n        (nzOnSearch)=\"field.onSearch($event)\"\n        (nzScrollToBottom)=\"field.onBottomScroll()\"\n        [nzDropdownRender]=\"field.optionsFooterItem\"\n        [nzSelectOnTab]=\"true\"\n        [attr.data-testid]=\"field.dataTestId\"\n        [nzAutoClearSearchValue]=\"field.autoClearSearchValue\"\n      >\n        <nz-option\n          *ngIf=\"field.loading === 'search'\"\n          nzDisabled\n          nzCustomContent\n        >\n          <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n          Loading ...\n        </nz-option>\n\n        <ng-container *ngIf=\"field.loading !== 'search'\">\n          <ng-container\n            *ngIf=\"\n              isOptionGroup(field.options);\n              then selectOptionGroups;\n              else selectOptions\n            \"\n          >\n          </ng-container>\n\n          <nz-option\n            *ngIf=\"field.loading === 'scroll'\"\n            nzDisabled\n            nzCustomContent\n          >\n            <i nz-icon nzType=\"loading\" class=\"mint-select-loading-icon\"></i>\n            Loading ...\n          </nz-option>\n        </ng-container>\n\n        <ng-template #selectOptionGroups>\n          <nz-option-group\n            [nzLabel]=\"group.name\"\n            *ngFor=\"let group of groupOptions(field.options)\"\n          >\n            <nz-option\n              *ngFor=\"let option of group.options\"\n              nzCustomContent\n              [nzLabel]=\"option.name\"\n              [nzValue]=\"option.value\"\n            >\n              <ng-container\n                *ngIf=\"\n                  (option.name || option.displayName) && !option.displayTemplate\n                \"\n              >\n                <div\n                  [innerHTML]=\"\n                    (option.displayName ? option.displayName : option.name)\n                      | mintSafeHtml\n                  \"\n                  [attr.data-testid]=\"option.dataTestId\"\n                ></div>\n              </ng-container>\n              <ng-container *ngIf=\"option.displayTemplate\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    option.displayTemplate.templateRef;\n                    context: option.displayTemplate.context\n                  \"\n                ></ng-container>\n              </ng-container>\n            </nz-option>\n          </nz-option-group>\n        </ng-template>\n\n        <ng-template #selectOptions>\n          <nz-option\n            *ngFor=\"let option of fieldOptions(field.options)\"\n            nzCustomContent\n            [nzLabel]=\"option.name\"\n            [nzValue]=\"option.value\"\n          >\n            <ng-container\n              *ngIf=\"\n                (option.name || option.displayName) && !option.displayTemplate\n              \"\n            >\n              <div\n                [innerHTML]=\"\n                  (option.displayName ? option.displayName : option.name)\n                    | mintSafeHtml\n                \"\n                [attr.data-testid]=\"option.dataTestId\"\n              ></div>\n            </ng-container>\n\n            <ng-container *ngIf=\"option.displayTemplate\">\n              <ng-container\n                *ngTemplateOutlet=\"\n                  option.displayTemplate.templateRef;\n                  context: option.displayTemplate.context\n                \"\n              ></ng-container>\n            </ng-container>\n          </nz-option>\n        </ng-template>\n      </nz-select>\n\n      <!--    <ng-template #mintSelectCustomTemplate let-selected>-->\n      <!--      {{ selected.displayName ? selected.displayName : selected.name }}-->\n      <!--    </ng-template>-->\n    </div>\n  </div>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p\n      *ngFor=\"let error of getErrors()\"\n      [innerHtml]=\"error | mintSafeHtml\"\n      data-testid=\"validation-error\"\n    ></p>\n  </div>\n</ng-container>\n", styles: [".mint-input-layout.mint-input-std-lat{display:flex;align-items:center;flex-direction:row;justify-content:flex-start}.mint-input-layout.mint-input-std-lat>div{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;width:100%}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat>div{align-items:flex-start;flex-direction:column}}.mint-input-layout.mint-input-std-lat label{min-width:140px;margin-right:1rem}@media (max-width: 991px){.mint-input-layout.mint-input-std-lat{align-items:flex-start;flex-direction:column}}.mint-form-field-help.has-lateral{margin-left:calc(140px + 1rem);width:calc(100% - 140px - 1rem)}:host{display:block}.ant-select-clear{right:33px}\n"] }]
        }] });

class MintSelectModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintSelectModule, declarations: [MintSelectComponent, MintSelectTimeZoneComponent], imports: [FormsModule, NzSelectModule, CommonModule, MintFormModule], exports: [MintSelectComponent, MintSelectTimeZoneComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSelectModule, imports: [FormsModule, NzSelectModule, CommonModule, MintFormModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, NzSelectModule, CommonModule, MintFormModule],
                    declarations: [MintSelectComponent, MintSelectTimeZoneComponent],
                    exports: [MintSelectComponent, MintSelectTimeZoneComponent, MintFormModule],
                }]
        }] });

const logger$1t = MintLogger.getLogger('MintToggleComponent');
const MINT_TOGGLE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintToggleComponent),
    multi: true,
};
class MintToggleComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
    }
    onChange($event, fieldOption) {
        const controlType = this.field.controlType;
        if (this.field.disabled) {
            return;
        }
        if (typeof this.field.value === 'undefined') {
            this.field.value = false;
        }
        this.field.value = !this.field.value;
        // propagate value into form control using control value accessor interface
        if (this.propagateChange) {
            this.propagateChange(this.field.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintToggleComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintToggleComponent, selector: "mint-toggle", inputs: { field: "field" }, providers: [MINT_TOGGLE_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'toggle'\">\n    <nz-switch\n      #control\n      (focus)=\"onFocus($event)\"\n      (blur)=\"onBlur($event)\"\n      (click)=\"onChange($event)\"\n      [nzSize]=\"field.size\"\n      [nzDisabled]=\"field.disabled\"\n      [nzControl]=\"true\"\n      [(ngModel)]=\"field.value\"\n    >\n    </nz-switch>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [":host{display:block}\n"], dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$6.NzSwitchComponent, selector: "nz-switch", inputs: ["nzLoading", "nzDisabled", "nzControl", "nzCheckedChildren", "nzUnCheckedChildren", "nzSize", "nzId"], exportAs: ["nzSwitch"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: MintSafeHtmlPipe, name: "mintSafeHtml" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-toggle', encapsulation: ViewEncapsulation.None, providers: [MINT_TOGGLE_CONTROL_VALUE_ACCESSOR], template: "<ng-container *ngIf=\"field && field.visible(field.control)\">\n  <ng-container *ngIf=\"field && field.controlType === 'toggle'\">\n    <nz-switch\n      #control\n      (focus)=\"onFocus($event)\"\n      (blur)=\"onBlur($event)\"\n      (click)=\"onChange($event)\"\n      [nzSize]=\"field.size\"\n      [nzDisabled]=\"field.disabled\"\n      [nzControl]=\"true\"\n      [(ngModel)]=\"field.value\"\n    >\n    </nz-switch>\n  </ng-container>\n  <div *ngIf=\"!isValid()\" class=\"mint-form-field-help\">\n    <p *ngFor=\"let error of getErrors()\" [innerHtml]=\"error | mintSafeHtml\"></p>\n  </div>\n</ng-container>\n", styles: [":host{display:block}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintToggleModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintToggleModule, declarations: [MintToggleComponent], imports: [FormsModule, NzSwitchModule, CommonModule, MintFormModule], exports: [MintToggleComponent, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintToggleModule, imports: [FormsModule, NzSwitchModule, CommonModule, MintFormModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, NzSwitchModule, CommonModule, MintFormModule],
                    declarations: [MintToggleComponent],
                    exports: [MintToggleComponent, MintFormModule],
                }]
        }] });

const logger$1s = MintLogger.getLogger('MintAutoFieldComponent');
const MINT_DYNAMIC_FIELD_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MintAutoFieldComponent),
    multi: true,
};
class MintAutoFieldComponent extends MintFormFieldComponent {
    ngOnInit() {
        super.init(this.field, this.controlElement);
        this.field.valueChanges.subscribe(async (data) => {
            // logger.debug(
            //   'valueChanged: data: ',
            //   data,
            //   '\nfield.value: ',
            //   this.field.value
            // );
            if (this.propagateChange) {
                this.propagateChange(data);
            }
        });
        // logger.debug('Initialized: ', this);
    }
    async ngOnChanges(changes) {
        const _field = changes['field'];
        if (_field && !_field.firstChange) {
            this.field = _field.currentValue;
            this.ngOnInit();
        }
    }
    addressField() {
        return MintFormUtil.isAddressField(this.field) ? this.field : null;
    }
    textField() {
        return MintFormUtil.isTextField(this.field) ? this.field : null;
    }
    phoneField() {
        return MintFormUtil.isPhoneField(this.field) ? this.field : null;
    }
    numberField() {
        return MintFormUtil.isNumberField(this.field) ? this.field : null;
    }
    selectField() {
        return MintFormUtil.isSelectField(this.field) ? this.field : null;
    }
    toggleField() {
        return MintFormUtil.isToggleField(this.field) ? this.field : null;
    }
    dateField() {
        return MintFormUtil.isDateField(this.field) ? this.field : null;
    }
    dateRangeField() {
        return MintFormUtil.isDateRangeField(this.field) ? this.field : null;
    }
    datePickerField() {
        return MintFormUtil.isDatePickerField(this.field) ? this.field : null;
    }
    radioGroup() {
        return MintFormUtil.isRadioGroup(this.field) ? this.field : null;
    }
    checkboxGroup() {
        return MintFormUtil.isCheckboxGroup(this.field) ? this.field : null;
    }
    textArea() {
        return MintFormUtil.isTextArea(this.field) ? this.field : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFieldComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintAutoFieldComponent, selector: "mint-auto-field", inputs: { field: "field" }, providers: [MINT_DYNAMIC_FIELD_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "controlElement", first: true, predicate: ["control"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"form-control-group\"\n  *ngIf=\"\n    field.controlType === 'text' ||\n    field.controlType === 'password' ||\n    field.controlType === 'email' ||\n    field.controlType === 'search' ||\n    field.controlType === 'url'\n  \"\n>\n  <mint-input-text [field]=\"textField()\"></mint-input-text>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'address'\">\n  <mint-input-address [field]=\"addressField()\"></mint-input-address>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'tel'\">\n  <mint-input-phone [field]=\"phoneField()\"></mint-input-phone>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'number'\">\n  <mint-input-number [field]=\"numberField()\"></mint-input-number>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'select'\">\n  <mint-select [field]=\"selectField()\"></mint-select>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'toggle'\">\n  <mint-toggle [field]=\"toggleField()\"></mint-toggle>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'date'\">\n  <mint-input-date [field]=\"dateField()\"></mint-input-date>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'daterange'\">\n  <mint-date-range [field]=\"dateRangeField()\"></mint-date-range>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'datepicker'\">\n  <mint-date [field]=\"datePickerField()\"></mint-date>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'radio-group'\">\n  <mint-radio-group [field]=\"radioGroup()\"></mint-radio-group>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'checkbox-group'\">\n  <mint-checkbox-group [field]=\"checkboxGroup()\"></mint-checkbox-group>\n</div>\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'textarea'\">\n  <mint-plain-text [field]=\"textArea()\"></mint-plain-text>\n</div>\n", styles: [":host{display:block}\n"], dependencies: [{ kind: "component", type: MintInputAddressComponent, selector: "mint-input-address", inputs: ["field"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MintInputTextComponent, selector: "mint-input-text", inputs: ["field"] }, { kind: "component", type: MintInputNumberComponent, selector: "mint-input-number", inputs: ["field"] }, { kind: "component", type: MintSelectComponent, selector: "mint-select", inputs: ["field"] }, { kind: "component", type: MintDateComponent, selector: "mint-date", inputs: ["field"] }, { kind: "component", type: MintInputDateComponent, selector: "mint-input-date", inputs: ["field"] }, { kind: "component", type: MintDateRangeComponent, selector: "mint-date-range", inputs: ["field"] }, { kind: "component", type: MintToggleComponent, selector: "mint-toggle", inputs: ["field"] }, { kind: "component", type: MintCheckboxGroupComponent, selector: "mint-checkbox-group", inputs: ["field"] }, { kind: "component", type: MintRadioGroupComponent, selector: "mint-radio-group", inputs: ["field"] }, { kind: "component", type: MintPlainTextComponent, selector: "mint-plain-text", inputs: ["field"] }, { kind: "component", type: MintInputPhoneComponent, selector: "mint-input-phone", inputs: ["field"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-auto-field', encapsulation: ViewEncapsulation.None, providers: [MINT_DYNAMIC_FIELD_CONTROL_VALUE_ACCESSOR], template: "<div\n  class=\"form-control-group\"\n  *ngIf=\"\n    field.controlType === 'text' ||\n    field.controlType === 'password' ||\n    field.controlType === 'email' ||\n    field.controlType === 'search' ||\n    field.controlType === 'url'\n  \"\n>\n  <mint-input-text [field]=\"textField()\"></mint-input-text>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'address'\">\n  <mint-input-address [field]=\"addressField()\"></mint-input-address>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'tel'\">\n  <mint-input-phone [field]=\"phoneField()\"></mint-input-phone>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'number'\">\n  <mint-input-number [field]=\"numberField()\"></mint-input-number>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'select'\">\n  <mint-select [field]=\"selectField()\"></mint-select>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'toggle'\">\n  <mint-toggle [field]=\"toggleField()\"></mint-toggle>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'date'\">\n  <mint-input-date [field]=\"dateField()\"></mint-input-date>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'daterange'\">\n  <mint-date-range [field]=\"dateRangeField()\"></mint-date-range>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'datepicker'\">\n  <mint-date [field]=\"datePickerField()\"></mint-date>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'radio-group'\">\n  <mint-radio-group [field]=\"radioGroup()\"></mint-radio-group>\n</div>\n\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'checkbox-group'\">\n  <mint-checkbox-group [field]=\"checkboxGroup()\"></mint-checkbox-group>\n</div>\n<div class=\"form-control-group\" *ngIf=\"field.controlType === 'textarea'\">\n  <mint-plain-text [field]=\"textArea()\"></mint-plain-text>\n</div>\n", styles: [":host{display:block}\n"] }]
        }], propDecorators: { field: [{
                type: Input
            }], controlElement: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

const MODULES$5 = [
    MintInputAddressModule,
    MintInputTextModule,
    MintInputNumberModule,
    MintSelectModule,
    MintDateModule,
    MintInputDateModule,
    MintDateRangeModule,
    MintToggleModule,
    MintCheckboxGroupModule,
    MintRadioGroupModule,
    MintPlainTextModule,
    MintInputPhoneModule,
    MintNotesModule,
];
const COMPONENTS$5 = [MintAutoFieldComponent];
class MintAutoFieldModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFieldModule, declarations: [MintAutoFieldComponent], imports: [MintInputAddressModule,
            MintInputTextModule,
            MintInputNumberModule,
            MintSelectModule,
            MintDateModule,
            MintInputDateModule,
            MintDateRangeModule,
            MintToggleModule,
            MintCheckboxGroupModule,
            MintRadioGroupModule,
            MintPlainTextModule,
            MintInputPhoneModule,
            MintNotesModule], exports: [MintAutoFieldComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFieldModule, imports: [MODULES$5] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$5],
                    declarations: [...COMPONENTS$5],
                    exports: [...COMPONENTS$5],
                }]
        }] });

// describes the UI control for this field
class MintNotes extends MintFormField {
    constructor(model) {
        super(model);
        this.minRows = 2;
        this.maxRows = 16;
        this._controlType = 'notes';
    }
}

class MintRadioGroup extends MintFormField {
    constructor(model) {
        super(model);
        this._controlType = 'radio-group';
    }
}

const logger$1r = MintLogger.getLogger('MintUploadComponent');
class MintUploadComponent {
    constructor(httpService) {
        this.httpService = httpService;
        this.loading = false;
        this.previewImage = '';
        this.previewVisible = false;
        // automatically called once for each file of multi-file uploads
        this.customReq = (item) => {
            logger$1r.debug('customReq: item: ', item);
            return this.httpService.uploadFile(this.field.urlPath, item.postFile, {
                onError: (err) => {
                    item.onError(err, item.file);
                },
                onProgress: async (event) => {
                    if (item.onProgress) {
                        item.onProgress(event, item.file);
                    }
                    if (this.field.onUploadProgress) {
                        await this.field.onUploadProgress(event, item.file);
                    }
                },
                onSuccess: async (media) => {
                    if (item.onSuccess) {
                        item.onSuccess(media, item.file, media);
                        logger$1r.debug('onSuccess: result: ', media);
                    }
                    if (this.field.onUploadSuccess) {
                        await this.field.onUploadSuccess(media, item.file);
                    }
                },
            }, this.field.formData);
        };
        this.onRemove = (file) => {
            if (this.field.onRemove) {
                return new Observable((observer) => {
                    this.field.onRemove(file).then((valid) => {
                        observer.next(valid);
                        observer.complete();
                    });
                });
            }
            return null;
        };
        this.onPreview = async (file) => {
            logger$1r.debug('handlePreview: file: ', file);
            // set uid to '-1' to bypass content-type check.  necessary for
            // when files are manually added to fileList and content type is not
            // available.
            if (file.uid !== '-1' &&
                !MintMediaUtil.IMAGE_MIME_TYPES.includes(file.type)) {
                logger$1r.error(`Cannot preview ${file.name}.`);
                if (this.field.onPreviewError) {
                    await this.field.onPreviewError(`Cannot preview ${file.name}.`, file);
                }
                return;
            }
            this.previewImage = file.url || file.thumbUrl;
            this.previewVisible = true;
        };
        this.beforeUpload = (uploadedFile, fileList) => {
            return new Observable((observer) => {
                this.field.valid(uploadedFile).then((valid) => {
                    this.field.onBeforeUpload(uploadedFile).then((continueUpload) => {
                        const isUpload = continueUpload && valid;
                        observer.next(isUpload);
                        observer.complete();
                    });
                });
            });
        };
    }
    ngOnInit() { }
    async onChange(event) {
        // logger.debug('onChange: event: ', event);
        switch (event.file.status) {
            case 'uploading':
                this.loading = true;
                if (this.field.onUploading) {
                    await this.field.onUploading(event, event.file);
                }
                break;
            case 'done':
                this.loading = false;
                if (this.field.onUploadDone) {
                    await this.field.onUploadDone(event, event.file);
                }
                break;
            case 'removed':
                logger$1r.debug('onChange: event: ', event);
                this.loading = false;
                if (this.field.onUploadRemoved) {
                    await this.field.onUploadRemoved(event, event.file);
                }
                break;
            case 'error':
                this.loading = false;
                logger$1r.error(`${event.file.name} file upload failed.`);
                if (this.field.onUploadError) {
                    await this.field.onUploadError(event, event.file);
                }
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUploadComponent, deps: [{ token: MintHttpService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintUploadComponent, selector: "mint-upload", inputs: { field: "field" }, viewQueries: [{ propertyName: "control", first: true, predicate: ["control"], descendants: true }], ngImport: i0, template: "<div class=\"clearfix\" *ngIf=\"field && field.visible\">\n  <nz-upload\n    #control\n    [nzType]=\"field.uploadType\"\n    [nzCustomRequest]=\"customReq\"\n    [nzDirectory]=\"false\"\n    [nzMultiple]=\"field.multiple\"\n    [nzLimit]=\"field.multipleLimit\"\n    [(nzFileList)]=\"field.fileList\"\n    [nzListType]=\"field.uploadListType\"\n    [nzShowUploadList]=\"field.showUploadList\"\n    [nzDisabled]=\"field.disabled\"\n    [nzBeforeUpload]=\"beforeUpload\"\n    [nzPreview]=\"onPreview\"\n    [nzRemove]=\"onRemove\"\n    (nzChange)=\"onChange($event)\"\n    [nzShowButton]=\"field.fileList.length < field.maxUploadCount\"\n  >\n    <ng-container *ngIf=\"field.uploadType === 'drag'\">\n      <p class=\"ant-upload-drag-icon\">\n        <i nz-icon nzType=\"inbox\"></i>\n      </p>\n      <p class=\"ant-upload-text\">\n        {{ field.dragUploadTypeText }}\n      </p>\n    </ng-container>\n\n    <ng-container *ngIf=\"field.uploadType !== 'drag'\">\n      <ng-container *ngIf=\"field.uploadListType === 'picture-card'\">\n        <i\n          class=\"upload-icon\"\n          nz-icon\n          [nzType]=\"loading ? 'loading' : 'plus'\"\n        ></i>\n        <div class=\"ant-upload-text\">Upload</div>\n      </ng-container>\n\n      <ng-container *ngIf=\"field.uploadListType !== 'picture-card'\">\n        <button nz-button>\n          <i nz-icon nzType=\"upload\"></i><span>Click to Upload</span>\n        </button>\n      </ng-container>\n    </ng-container>\n\n    <!--    <img *ngIf=\"imageUrl\" [src]=\"imageUrl\" class=\"avatar\" />-->\n  </nz-upload>\n\n  <nz-modal\n    [nzVisible]=\"previewVisible\"\n    [nzContent]=\"modalContent\"\n    [nzFooter]=\"null\"\n    (nzOnCancel)=\"previewVisible = false\"\n  >\n    <ng-template #modalContent>\n      <img [src]=\"previewImage\" [ngStyle]=\"{ width: '100%' }\"/>\n    </ng-template>\n  </nz-modal>\n</div>\n", styles: [":host{display:block}\n"], dependencies: [{ kind: "component", type: i2$7.NzUploadComponent, selector: "nz-upload", inputs: ["nzType", "nzLimit", "nzSize", "nzFileType", "nzAccept", "nzAction", "nzDirectory", "nzOpenFileDialogOnClick", "nzBeforeUpload", "nzCustomRequest", "nzData", "nzFilter", "nzFileList", "nzDisabled", "nzHeaders", "nzListType", "nzMultiple", "nzName", "nzShowUploadList", "nzShowButton", "nzWithCredentials", "nzRemove", "nzPreview", "nzPreviewFile", "nzPreviewIsImage", "nzTransformFile", "nzDownload", "nzIconRender", "nzFileListRender"], outputs: ["nzChange", "nzFileListChange"], exportAs: ["nzUpload"] }, { kind: "component", type: i7.NzModalComponent, selector: "nz-modal", inputs: ["nzMask", "nzMaskClosable", "nzCloseOnNavigation", "nzVisible", "nzClosable", "nzOkLoading", "nzOkDisabled", "nzCancelDisabled", "nzCancelLoading", "nzKeyboard", "nzNoAnimation", "nzCentered", "nzContent", "nzFooter", "nzZIndex", "nzWidth", "nzWrapClassName", "nzClassName", "nzStyle", "nzTitle", "nzCloseIcon", "nzMaskStyle", "nzBodyStyle", "nzOkText", "nzCancelText", "nzOkType", "nzOkDanger", "nzIconType", "nzModalType", "nzAutofocus", "nzOnOk", "nzOnCancel"], outputs: ["nzOnOk", "nzOnCancel", "nzAfterOpen", "nzAfterClose", "nzVisibleChange"], exportAs: ["nzModal"] }, { kind: "directive", type: i4$3.NzIconDirective, selector: "[nz-icon]", inputs: ["nzSpin", "nzRotate", "nzType", "nzTheme", "nzTwotoneColor", "nzIconfont"], exportAs: ["nzIcon"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-upload', encapsulation: ViewEncapsulation.None, template: "<div class=\"clearfix\" *ngIf=\"field && field.visible\">\n  <nz-upload\n    #control\n    [nzType]=\"field.uploadType\"\n    [nzCustomRequest]=\"customReq\"\n    [nzDirectory]=\"false\"\n    [nzMultiple]=\"field.multiple\"\n    [nzLimit]=\"field.multipleLimit\"\n    [(nzFileList)]=\"field.fileList\"\n    [nzListType]=\"field.uploadListType\"\n    [nzShowUploadList]=\"field.showUploadList\"\n    [nzDisabled]=\"field.disabled\"\n    [nzBeforeUpload]=\"beforeUpload\"\n    [nzPreview]=\"onPreview\"\n    [nzRemove]=\"onRemove\"\n    (nzChange)=\"onChange($event)\"\n    [nzShowButton]=\"field.fileList.length < field.maxUploadCount\"\n  >\n    <ng-container *ngIf=\"field.uploadType === 'drag'\">\n      <p class=\"ant-upload-drag-icon\">\n        <i nz-icon nzType=\"inbox\"></i>\n      </p>\n      <p class=\"ant-upload-text\">\n        {{ field.dragUploadTypeText }}\n      </p>\n    </ng-container>\n\n    <ng-container *ngIf=\"field.uploadType !== 'drag'\">\n      <ng-container *ngIf=\"field.uploadListType === 'picture-card'\">\n        <i\n          class=\"upload-icon\"\n          nz-icon\n          [nzType]=\"loading ? 'loading' : 'plus'\"\n        ></i>\n        <div class=\"ant-upload-text\">Upload</div>\n      </ng-container>\n\n      <ng-container *ngIf=\"field.uploadListType !== 'picture-card'\">\n        <button nz-button>\n          <i nz-icon nzType=\"upload\"></i><span>Click to Upload</span>\n        </button>\n      </ng-container>\n    </ng-container>\n\n    <!--    <img *ngIf=\"imageUrl\" [src]=\"imageUrl\" class=\"avatar\" />-->\n  </nz-upload>\n\n  <nz-modal\n    [nzVisible]=\"previewVisible\"\n    [nzContent]=\"modalContent\"\n    [nzFooter]=\"null\"\n    (nzOnCancel)=\"previewVisible = false\"\n  >\n    <ng-template #modalContent>\n      <img [src]=\"previewImage\" [ngStyle]=\"{ width: '100%' }\"/>\n    </ng-template>\n  </nz-modal>\n</div>\n", styles: [":host{display:block}\n"] }]
        }], ctorParameters: () => [{ type: MintHttpService }], propDecorators: { field: [{
                type: Input
            }], control: [{
                type: ViewChild,
                args: ['control', { static: false }]
            }] } });

class MintUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintUploadModule, declarations: [MintUploadComponent], imports: [NzUploadModule,
            NzModalModule,
            NzIconModule,
            CommonModule,
            FormsModule,
            MintFormModule], exports: [MintUploadComponent, NzModalModule, MintFormModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUploadModule, imports: [NzUploadModule,
            NzModalModule,
            NzIconModule,
            CommonModule,
            FormsModule,
            MintFormModule, NzModalModule, MintFormModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        NzUploadModule,
                        NzModalModule,
                        NzIconModule,
                        CommonModule,
                        FormsModule,
                        MintFormModule,
                    ],
                    declarations: [MintUploadComponent],
                    exports: [MintUploadComponent, NzModalModule, MintFormModule],
                }]
        }] });

const logger$1q = MintLogger.getLogger('MintRoutePathParams');
// Route path params are not exposed to non-routed form.  Since auth pages
// are usually contained in a sub-component (e.g. /auth/login) they are non-routed
// and do not have access to the path params that might be present to their outer
// form.
// To work around this, the parent container is responsible for setting the path
// params that any of its children might need.  Each child component must then
// check for this
// Context and credit:
// https://medium.com/@tomastrajan/how-to-get-route-path-parameters-in-non-routed-angular-components-32fc90d9cb52
const MINT_ROUTE_PATH_PARAMS_KEY = 'mint-route-path-params';
class MintRoutePathParamsService {
    constructor(storageService) {
        this.storageService = storageService;
    }
    async setParams(params) {
        logger$1q.debug('updateParams: params: ', params);
        return lastValueFrom(this.storageService.setItem(MINT_ROUTE_PATH_PARAMS_KEY, params, MintStorageType.Session));
    }
    async getParams() {
        return lastValueFrom(this.storageService.getItem(MINT_ROUTE_PATH_PARAMS_KEY, MintStorageType.Session));
    }
    async clear() {
        await lastValueFrom(this.storageService.removeItem(MINT_ROUTE_PATH_PARAMS_KEY, MintStorageType.Session));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoutePathParamsService, deps: [{ token: MintStorageService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoutePathParamsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRoutePathParamsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintStorageService }] });

const logger$1p = MintLogger.getLogger('MintViewService');
const LAYOUT_BREAKPOINTS = {
    xs: 400,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
    xxxl: 1600,
};
class MintViewService {
    constructor() {
        this.width$ = new Subject();
        window.addEventListener('resize', (event) => {
            const width = event.target.innerWidth;
            this.width$.next(width);
            this.currentWidth = width;
            // logger.debug('windowResizeEvent: width: ', width);
        });
    }
    // return the breakpoint width that is less than or equal to both the current
    // screen width and the max size specified.
    maxBreakpoint(maxSize = 'lg') {
        let lastValue = LAYOUT_BREAKPOINTS['xs'];
        let maxValue = LAYOUT_BREAKPOINTS[maxSize];
        if (this.currentWidth < maxValue) {
            maxValue = this.currentWidth;
        }
        const values = Object.values(LAYOUT_BREAKPOINTS).sort((a, b) => a - b);
        for (const value of values) {
            if (maxValue < value) {
                break;
            }
            if (maxValue === value) {
                lastValue = maxValue;
                break;
            }
            lastValue = value;
        }
        // logger.debug(`maxBreakpoint:\n
        //   screenWidth: [${this.currentWidth}]\n
        //   maxSize: [${maxSize}]\n
        //   maxValue: [${maxValue}]\n
        //   maxWidth: [${lastValue}]`);
        return lastValue;
    }
    breakpoint(size) {
        return LAYOUT_BREAKPOINTS[size];
    }
    get width() {
        // this.width$.next();
        return this.width$.pipe(share(), delay(1));
    }
    resize() {
        // logger.debug('onResize: called ...');
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintViewService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintViewService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintViewService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

const logger$1o = MintLogger.getLogger('MintAutoFormComponent');
class MintAutoFormComponent {
    constructor() {
        this.mintSubmit = new EventEmitter();
    }
    submitForm(event) {
        logger$1o.debug('formSubmit: called ...');
        this.mintSubmit.emit(event);
    }
    textField(field) {
        return MintFormUtil.isTextField(field) ? field : null;
    }
    phoneField(field) {
        return MintFormUtil.isPhoneField(field) ? field : null;
    }
    numberField(field) {
        return MintFormUtil.isNumberField(field) ? field : null;
    }
    selectField(field) {
        return MintFormUtil.isSelectField(field) ? field : null;
    }
    toggleField(field) {
        return MintFormUtil.isToggleField(field) ? field : null;
    }
    dateField(field) {
        return MintFormUtil.isDateField(field) ? field : null;
    }
    dateRangeField(field) {
        return MintFormUtil.isDateRangeField(field) ? field : null;
    }
    datePickerField(field) {
        return MintFormUtil.isDatePickerField(field) ? field : null;
    }
    radioGroup(field) {
        return MintFormUtil.isRadioGroup(field) ? field : null;
    }
    checkboxGroup(field) {
        return MintFormUtil.isCheckboxGroup(field) ? field : null;
    }
    textArea(field) {
        return MintFormUtil.isTextArea(field) ? field : null;
    }
    notes(field) {
        return MintFormUtil.isNotes(field) ? field : null;
    }
    addressField(field) {
        return MintFormUtil.isAddressField(field) ? field : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintAutoFormComponent, selector: "mint-auto-form", inputs: { controller: "controller" }, outputs: { mintSubmit: "mintSubmit" }, ngImport: i0, template: "<mint-form (onSubmit)=\"submitForm($event)\" [formGroup]=\"controller\">\n  <ng-container *ngFor=\"let field of controller.fields\">\n    <div\n      class=\"form-control-group\"\n      *ngIf=\"\n        field.controlType === 'text' ||\n        field.controlType === 'password' ||\n        field.controlType === 'email' ||\n        field.controlType === 'search' ||\n        field.controlType === 'url'\n      \"\n    >\n      <mint-input-text\n        [formControlName]=\"field.name\"\n        [field]=\"textField(field)\"\n      ></mint-input-text>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'tel'\">\n      <mint-input-phone\n        [formControlName]=\"field.name\"\n        [field]=\"phoneField(field)\"\n      ></mint-input-phone>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'number'\">\n      <mint-input-number\n        [formControlName]=\"field.name\"\n        [field]=\"numberField(field)\"\n      ></mint-input-number>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'address'\">\n      <mint-input-address\n        [formControlName]=\"field.name\"\n        [field]=\"addressField(field)\"\n      ></mint-input-address>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'select'\">\n      <mint-select\n        [formControlName]=\"field.name\"\n        [field]=\"selectField(field)\"\n      ></mint-select>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'toggle'\">\n      <mint-toggle\n        [formControlName]=\"field.name\"\n        [field]=\"toggleField(field)\"\n      ></mint-toggle>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'date'\">\n      <mint-input-date\n        [formControlName]=\"field.name\"\n        [field]=\"dateField(field)\"\n      ></mint-input-date>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'datepicker'\">\n      <mint-date\n        [formControlName]=\"field.name\"\n        [field]=\"datePickerField(field)\"\n      ></mint-date>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'daterange'\">\n      <mint-date-range\n        [formControlName]=\"field.name\"\n        [field]=\"dateRangeField(field)\"\n      ></mint-date-range>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'radio-group'\">\n      <mint-radio-group\n        [formControlName]=\"field.name\"\n        [field]=\"radioGroup(field)\"\n      ></mint-radio-group>\n    </div>\n\n    <div\n      class=\"form-control-group\"\n      *ngIf=\"field.controlType === 'checkbox-group'\"\n    >\n      <mint-checkbox-group\n        [formControlName]=\"field.name\"\n        [field]=\"checkboxGroup(field)\"\n      ></mint-checkbox-group>\n    </div>\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'textarea'\">\n      <mint-plain-text\n        [formControlName]=\"field.name\"\n        [field]=\"textArea(field)\"\n      ></mint-plain-text>\n    </div>\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'notes'\">\n      <mint-notes\n        [formControlName]=\"field.name\"\n        [field]=\"notes(field)\"\n      ></mint-notes>\n    </div>\n  </ng-container>\n</mint-form>\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: MintFormComponent, selector: "mint-form", inputs: ["formGroup"], outputs: ["onSubmit"] }, { kind: "component", type: MintInputTextComponent, selector: "mint-input-text", inputs: ["field"] }, { kind: "component", type: MintInputNumberComponent, selector: "mint-input-number", inputs: ["field"] }, { kind: "component", type: MintSelectComponent, selector: "mint-select", inputs: ["field"] }, { kind: "component", type: MintDateComponent, selector: "mint-date", inputs: ["field"] }, { kind: "component", type: MintInputDateComponent, selector: "mint-input-date", inputs: ["field"] }, { kind: "component", type: MintDateRangeComponent, selector: "mint-date-range", inputs: ["field"] }, { kind: "component", type: MintToggleComponent, selector: "mint-toggle", inputs: ["field"] }, { kind: "component", type: MintCheckboxGroupComponent, selector: "mint-checkbox-group", inputs: ["field"] }, { kind: "component", type: MintRadioGroupComponent, selector: "mint-radio-group", inputs: ["field"] }, { kind: "component", type: MintPlainTextComponent, selector: "mint-plain-text", inputs: ["field"] }, { kind: "component", type: MintInputPhoneComponent, selector: "mint-input-phone", inputs: ["field"] }, { kind: "component", type: MintInputAddressComponent, selector: "mint-input-address", inputs: ["field"] }, { kind: "component", type: MintNotesComponent, selector: "mint-notes", inputs: ["field"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-auto-form', template: "<mint-form (onSubmit)=\"submitForm($event)\" [formGroup]=\"controller\">\n  <ng-container *ngFor=\"let field of controller.fields\">\n    <div\n      class=\"form-control-group\"\n      *ngIf=\"\n        field.controlType === 'text' ||\n        field.controlType === 'password' ||\n        field.controlType === 'email' ||\n        field.controlType === 'search' ||\n        field.controlType === 'url'\n      \"\n    >\n      <mint-input-text\n        [formControlName]=\"field.name\"\n        [field]=\"textField(field)\"\n      ></mint-input-text>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'tel'\">\n      <mint-input-phone\n        [formControlName]=\"field.name\"\n        [field]=\"phoneField(field)\"\n      ></mint-input-phone>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'number'\">\n      <mint-input-number\n        [formControlName]=\"field.name\"\n        [field]=\"numberField(field)\"\n      ></mint-input-number>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'address'\">\n      <mint-input-address\n        [formControlName]=\"field.name\"\n        [field]=\"addressField(field)\"\n      ></mint-input-address>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'select'\">\n      <mint-select\n        [formControlName]=\"field.name\"\n        [field]=\"selectField(field)\"\n      ></mint-select>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'toggle'\">\n      <mint-toggle\n        [formControlName]=\"field.name\"\n        [field]=\"toggleField(field)\"\n      ></mint-toggle>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'date'\">\n      <mint-input-date\n        [formControlName]=\"field.name\"\n        [field]=\"dateField(field)\"\n      ></mint-input-date>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'datepicker'\">\n      <mint-date\n        [formControlName]=\"field.name\"\n        [field]=\"datePickerField(field)\"\n      ></mint-date>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'daterange'\">\n      <mint-date-range\n        [formControlName]=\"field.name\"\n        [field]=\"dateRangeField(field)\"\n      ></mint-date-range>\n    </div>\n\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'radio-group'\">\n      <mint-radio-group\n        [formControlName]=\"field.name\"\n        [field]=\"radioGroup(field)\"\n      ></mint-radio-group>\n    </div>\n\n    <div\n      class=\"form-control-group\"\n      *ngIf=\"field.controlType === 'checkbox-group'\"\n    >\n      <mint-checkbox-group\n        [formControlName]=\"field.name\"\n        [field]=\"checkboxGroup(field)\"\n      ></mint-checkbox-group>\n    </div>\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'textarea'\">\n      <mint-plain-text\n        [formControlName]=\"field.name\"\n        [field]=\"textArea(field)\"\n      ></mint-plain-text>\n    </div>\n    <div class=\"form-control-group\" *ngIf=\"field.controlType === 'notes'\">\n      <mint-notes\n        [formControlName]=\"field.name\"\n        [field]=\"notes(field)\"\n      ></mint-notes>\n    </div>\n  </ng-container>\n</mint-form>\n" }]
        }], propDecorators: { controller: [{
                type: Input
            }], mintSubmit: [{
                type: Output
            }] } });

const MODULES$4 = [
    MintFormModule,
    MintInputTextModule,
    MintInputNumberModule,
    MintSelectModule,
    MintDateModule,
    MintInputDateModule,
    MintDateRangeModule,
    MintToggleModule,
    MintCheckboxGroupModule,
    MintRadioGroupModule,
    MintPlainTextModule,
    MintInputPhoneModule,
    MintInputAddressModule,
    MintNotesModule,
];
const COMPONENTS$4 = [MintAutoFormComponent];
class MintAutoFormModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFormModule, declarations: [MintAutoFormComponent], imports: [MintFormModule,
            MintInputTextModule,
            MintInputNumberModule,
            MintSelectModule,
            MintDateModule,
            MintInputDateModule,
            MintDateRangeModule,
            MintToggleModule,
            MintCheckboxGroupModule,
            MintRadioGroupModule,
            MintPlainTextModule,
            MintInputPhoneModule,
            MintInputAddressModule,
            MintNotesModule], exports: [MintAutoFormComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFormModule, imports: [MODULES$4] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAutoFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$4],
                    declarations: [...COMPONENTS$4],
                    exports: [...COMPONENTS$4],
                }]
        }] });

const logger$1n = MintLogger.getLogger('MintFormCardComponent');
class MintFormCardComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
        this.buttonLabel = 'Save';
        this.size = 'xs';
        this.mintSubmit = new EventEmitter();
    }
    async ngOnInit() {
        this.maxWidth = this.layoutService.breakpoint(this.size);
    }
    async ngOnChanges(changes) {
        const _title = changes['title'];
        const _buttonLabel = changes['buttonLabel'];
        const _size = changes['size'];
        if (_title && !_title.firstChange) {
            this.title = _title.currentValue;
        }
        if (_buttonLabel && !_buttonLabel.firstChange) {
            this.buttonLabel = _buttonLabel.currentValue;
        }
        if (_size && !_size.firstChange) {
            this.size = _size.currentValue;
            this.maxWidth = this.layoutService.breakpoint(this.size);
        }
    }
    async save() {
        this.mintSubmit.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormCardComponent, deps: [{ token: MintViewService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintFormCardComponent, selector: "mint-form-card", inputs: { controller: "controller", title: "title", buttonLabel: "buttonLabel", size: "size" }, outputs: { mintSubmit: "mintSubmit" }, usesOnChanges: true, ngImport: i0, template: "<nz-card class=\"mint-form-card\" [nzTitle]=\"title\" *ngIf=\"controller\">\n  <div class=\"mint-form-card-content\" [ngStyle]=\"{ 'max-width.px': maxWidth }\">\n    <div class=\"mint-form-card-header\">\n      <ng-content select=\"[mint-form-card-header]\"></ng-content>\n    </div>\n\n    <div class=\"mint-form-card-body\">\n      <mint-auto-form (mintSubmit)=\"save()\" [controller]=\"controller\">\n      </mint-auto-form>\n    </div>\n    <div class=\"mint-form-card-footer\">\n      <ng-content select=\"[mint-form-card-footer]\"></ng-content>\n    </div>\n  </div>\n\n  <div class=\"mint-form-card-actions\">\n    <button\n      nz-button\n      type=\"button\"\n      (click)=\"controller.submit()\"\n      [nzSize]=\"'default'\"\n      [nzType]=\"'primary'\"\n      [disabled]=\"!controller.ready\"\n      [nzLoading]=\"controller.submitted\"\n    >\n      {{ buttonLabel }}\n    </button>\n  </div>\n</nz-card>\n", styles: ["nz-card.mint-form-card{width:100%;box-shadow:3px 3px 3px #0000004d}nz-card .mint-form-card-content{margin:auto}nz-card .mint-form-card-actions{text-align:right;background-color:#fefefe;border-top:1px solid #e1e1e1;margin:3rem -24px -24px;padding:10px 24px 14px}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3$1.NzCardComponent, selector: "nz-card", inputs: ["nzBordered", "nzBorderless", "nzLoading", "nzHoverable", "nzBodyStyle", "nzCover", "nzActions", "nzType", "nzSize", "nzTitle", "nzExtra"], exportAs: ["nzCard"] }, { kind: "component", type: i10.NzButtonComponent, selector: "button[nz-button], a[nz-button]", inputs: ["nzBlock", "nzGhost", "nzSearch", "nzLoading", "nzDanger", "disabled", "tabIndex", "nzType", "nzShape", "nzSize"], exportAs: ["nzButton"] }, { kind: "directive", type: i11.ɵNzTransitionPatchDirective, selector: "[nz-button], nz-button-group, [nz-icon], [nz-menu-item], [nz-submenu], nz-select-top-control, nz-select-placeholder, nz-input-group", inputs: ["hidden"] }, { kind: "directive", type: i12.NzWaveDirective, selector: "[nz-wave],button[nz-button]:not([nzType=\"link\"]):not([nzType=\"text\"])", inputs: ["nzWaveExtraNode"], exportAs: ["nzWave"] }, { kind: "component", type: MintAutoFormComponent, selector: "mint-auto-form", inputs: ["controller"], outputs: ["mintSubmit"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-form-card', template: "<nz-card class=\"mint-form-card\" [nzTitle]=\"title\" *ngIf=\"controller\">\n  <div class=\"mint-form-card-content\" [ngStyle]=\"{ 'max-width.px': maxWidth }\">\n    <div class=\"mint-form-card-header\">\n      <ng-content select=\"[mint-form-card-header]\"></ng-content>\n    </div>\n\n    <div class=\"mint-form-card-body\">\n      <mint-auto-form (mintSubmit)=\"save()\" [controller]=\"controller\">\n      </mint-auto-form>\n    </div>\n    <div class=\"mint-form-card-footer\">\n      <ng-content select=\"[mint-form-card-footer]\"></ng-content>\n    </div>\n  </div>\n\n  <div class=\"mint-form-card-actions\">\n    <button\n      nz-button\n      type=\"button\"\n      (click)=\"controller.submit()\"\n      [nzSize]=\"'default'\"\n      [nzType]=\"'primary'\"\n      [disabled]=\"!controller.ready\"\n      [nzLoading]=\"controller.submitted\"\n    >\n      {{ buttonLabel }}\n    </button>\n  </div>\n</nz-card>\n", styles: ["nz-card.mint-form-card{width:100%;box-shadow:3px 3px 3px #0000004d}nz-card .mint-form-card-content{margin:auto}nz-card .mint-form-card-actions{text-align:right;background-color:#fefefe;border-top:1px solid #e1e1e1;margin:3rem -24px -24px;padding:10px 24px 14px}\n"] }]
        }], ctorParameters: () => [{ type: MintViewService }], propDecorators: { controller: [{
                type: Input
            }], title: [{
                type: Input
            }], buttonLabel: [{
                type: Input
            }], size: [{
                type: Input
            }], mintSubmit: [{
                type: Output
            }] } });

const MODULES$3 = [
    CommonModule,
    NzCardModule,
    NzMessageModule,
    NzButtonModule,
    NzGridModule,
    MintFormModule,
    MintAutoFormModule,
    MintInputTextModule,
    MintInputNumberModule,
    MintSelectModule,
    MintDateModule,
    MintInputDateModule,
    MintDateRangeModule,
    MintToggleModule,
    MintCheckboxGroupModule,
    MintRadioGroupModule,
    MintPlainTextModule,
    MintInputPhoneModule,
    MintNotesModule,
];
const COMPONENTS$3 = [MintFormCardComponent];
class MintFormCardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintFormCardModule, declarations: [MintFormCardComponent], imports: [CommonModule,
            NzCardModule,
            NzMessageModule,
            NzButtonModule,
            NzGridModule,
            MintFormModule,
            MintAutoFormModule,
            MintInputTextModule,
            MintInputNumberModule,
            MintSelectModule,
            MintDateModule,
            MintInputDateModule,
            MintDateRangeModule,
            MintToggleModule,
            MintCheckboxGroupModule,
            MintRadioGroupModule,
            MintPlainTextModule,
            MintInputPhoneModule,
            MintNotesModule], exports: [MintFormCardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormCardModule, imports: [MODULES$3] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintFormCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$3],
                    declarations: [...COMPONENTS$3],
                    exports: [...COMPONENTS$3],
                }]
        }] });

const logger$1m = MintLogger.getLogger('MintDataTableComponent');
class MintDataTable {
    constructor(opts) {
        this.initialized = false;
        this.singleSort = false;
        this.pageSizeOptions = [5, 10, 25, 50, 100];
        this.pageNumber = 1;
        this.rows = [];
        this.loading = false;
        this.serverPaging = true;
        this.bordered = false;
        this.hideOnSinglePage = false;
        this.sort = [];
        this.pageSize = opts.pageSize;
        this.fetchResultSet = opts.fetchResultSet;
        this.columns = opts.columns;
        this._onClick = opts.onClick;
        this._modelToRow = opts.modelToRow;
        this._rowClass = opts.rowClass;
        this.currentFilter = opts.initialFilter;
        if (opts.pageNumber) {
            this.pageNumber = opts.pageNumber;
        }
        if (opts.pageSizeOptions) {
            this.pageSizeOptions = opts.pageSizeOptions;
        }
        if (typeof opts.singleSort !== 'undefined') {
            this.singleSort = opts.singleSort;
        }
        if (typeof opts.hideOnSinglePage !== 'undefined') {
            this.hideOnSinglePage = opts.hideOnSinglePage;
        }
        if (typeof opts.bordered !== 'undefined') {
            this.bordered = opts.bordered;
        }
        this.resultSet = new MintResultSet({
            data: [],
        });
        this.refresh().then(() => {
            this.initialized = true;
            logger$1m.debug('initialized');
        });
    }
    async ready() {
        if (!this.initialized) {
            await MintSystemUtil.sleep(1);
            return this.ready();
        }
        return true;
    }
    rowEdits(row) {
        return row['__edits__'];
    }
    async filterItems(filter) {
        logger$1m.debug('filterItems: filter: ', filter);
        if (typeof filter === 'string') {
            const value = MintStringUtil.getFullTextSearchValue(filter);
            this.currentFilter = {
                fts: value,
            };
        }
        else if (typeof filter === 'object') {
            this.currentFilter = filter;
        }
        else if (filter === false) {
            this.currentFilter = undefined;
        }
        this.refresh();
    }
    rowToModel(row) {
        return row['__object__'];
    }
    modelToRow(model) {
        const row = this._modelToRow(model);
        return {
            ...row,
            __object__: model,
        };
    }
    onClick(row) {
        const model = row['__object__'];
        this._onClick(model);
    }
    async onSort(event) {
        if (!event) {
            return;
        }
        if (event.value === null) {
            // do not sort this key so remove it from sort list if exists
            if (this.sort && this.sort.length) {
                this.sort = this.sort.filter((item) => {
                    return item.field !== event.key;
                });
            }
        }
        else {
            const order = event.value === 'ascend'
                ? MintQuerySortOrder.Asc
                : MintQuerySortOrder.Desc;
            // check if sort key already exists
            let exists = false;
            for (const item of this.sort) {
                if (item.field === event.key) {
                    exists = true;
                    item.order = order;
                }
            }
            if (!exists) {
                this.sort.push({
                    field: event.key,
                    order: order,
                });
            }
        }
        logger$1m.debug('onSort: this.sort: ', this.sort);
        // If you change sorting, should reset page to 1
        this.pageNumber = 1;
        await this.refresh();
    }
    rowClass(row) {
        // logger.debug(`[rowClass] called ...`, row);
        let _rowClass = {
            'cursor-pointer': !!this._onClick,
        };
        if (this._rowClass) {
            const result = this._rowClass(row);
            if (result) {
                _rowClass = {
                    ..._rowClass,
                    ...result,
                };
            }
        }
        // logger.debug(`[rowClass] result:`, _rowClass);
        return _rowClass;
    }
    async onActivate(event) {
        if (event.type === 'click') {
            logger$1m.debug('onActivate: event: ', event);
            const model = this.resultSet.data.find((item) => {
                return item.uid === event.row.uid;
            });
            logger$1m.debug('onActivate: model: ', model);
            if (this.onClick) {
                this.onClick(model);
            }
        }
    }
    async refresh() {
        this.loading = true;
        const offset = this.pageSize * (this.pageNumber - 1);
        const limit = this.pageSize;
        this.resultSet = await this.fetchResultSet(offset, limit, this.sort, this.currentFilter);
        this.updateData();
        this.loading = false;
        return this.resultSet;
    }
    updateData() {
        const rows = [];
        for (const model of this.resultSet.data) {
            const row = this.modelToRow(model);
            rows.push(row);
        }
        this.rows = rows;
    }
    async onPageSizeChange(pageSize) {
        logger$1m.debug('onPageSizeChange: pageSize: ');
        this.pageSize = pageSize;
        this.refresh();
    }
    async onPageNumberChange(pageNumber) {
        logger$1m.debug('onPageNumberChange: pageNumber: ');
        this.pageNumber = pageNumber;
        this.refresh();
    }
}

const logger$1l = MintLogger.getLogger('MintDataTableComponent');
class MintDataTableComponent {
    constructor() {
        this.change = new EventEmitter();
        this.rowUpdated = new EventEmitter();
    }
    ngOnInit() {
        logger$1l.debug('table: ', this.table);
    }
    rowEdits(row) {
        return row['__edits__'];
    }
    editingRow(row) {
        return !!row.__edits__;
    }
    startRowEdit(row) {
        row.__edits__ = {};
        for (const key of Object.keys(row)) {
            if (key.startsWith('__') && key.endsWith('__')) {
                continue;
            }
            row.__edits__[key] = row[key];
        }
    }
    cancelRowEdit(row) {
        row.__edits__ = null;
    }
    updateRow(row) {
        this.rowUpdated.emit(row);
    }
    templateRef(val) {
        if (val instanceof TemplateRef) {
            return true;
        }
        // secondary check .. should not be needed
        if (val && val.elementRef && val.elementRef instanceof ElementRef) {
            return true;
        }
        return false;
    }
    form(cols, row) {
        const fields = [];
        for (const col of cols) {
            if (col.editable && col.field) {
                const field = MintDeepMerge.merge({}, col.field);
                field.defaultValue = row[col.prop];
                fields.push(field);
            }
        }
        return new MintFormController(fields);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDataTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintDataTableComponent, selector: "mint-data-table", inputs: { table: "table" }, outputs: { change: "change", rowUpdated: "rowUpdated" }, ngImport: i0, template: "<div class=\"mint-data-table\" *ngIf=\"table\">\n  <div class=\"mint-data-table-content\">\n    <div class=\"mint-data-table-header\">\n      <ng-content select=\"[mint-data-table-header]\"></ng-content>\n    </div>\n\n    <div class=\"mint-data-table-body\">\n      <nz-table\n        [nzBordered]=\"table.bordered\"\n        [nzData]=\"table.rows\"\n        [nzLoading]=\"table.loading\"\n        [nzFrontPagination]=\"!table.serverPaging\"\n        [nzShowPagination]=\"true\"\n        [nzTotal]=\"table.resultSet.totalSize\"\n        [nzPageSize]=\"table.resultSet.pageSize\"\n        [nzPageIndex]=\"table.resultSet.currentPage\"\n        [nzShowSizeChanger]=\"true\"\n        [nzHideOnSinglePage]=\"table.hideOnSinglePage\"\n        [nzPageSizeOptions]=\"table.pageSizeOptions\"\n        (nzPageIndexChange)=\"table.onPageNumberChange($event)\"\n        (nzPageSizeChange)=\"table.onPageSizeChange($event)\"\n      >\n        <thead (nzSortOrderChange)=\"table.onSort($event)\">\n          <tr>\n            <ng-container *ngFor=\"let col of table.columns\">\n              <th [nzShowSort]=\"col.sortable\">\n                <ng-container *ngIf=\"!templateRef(col.name)\">\n                  {{ col.name }}\n                </ng-container>\n                <ng-container *ngIf=\"templateRef(col.name)\">\n                  <ng-template\n                    [ngTemplateOutlet]=\"col.name\"\n                    [ngTemplateOutletContext]=\"{ data: col }\"\n                  >\n                  </ng-template>\n                </ng-container>\n              </th>\n            </ng-container>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let row of table.rows\">\n            <ng-container *ngIf=\"editingRow(row)\">\n              <tr [ngClass]=\"table.rowClass(row)\">\n                <td *ngFor=\"let col of table.columns\">\n                  <ng-container *ngIf=\"col.editable\">\n                    <mint-auto-field\n                      [field]=\"col.field\"\n                      [(ngModel)]=\"row['__edits__'][col.prop]\"\n                    ></mint-auto-field>\n                  </ng-container>\n\n                  <ng-container *ngIf=\"!col.editable\">\n                    <ng-container *ngIf=\"!templateRef(row[col.prop])\">\n                      {{ row[col.prop] }}\n                    </ng-container>\n                    <ng-container *ngIf=\"templateRef(row[col.prop])\">\n                      <ng-template\n                        [ngTemplateOutlet]=\"row[col.prop]\"\n                        [ngTemplateOutletContext]=\"{ data: row }\"\n                      >\n                      </ng-template>\n                    </ng-container>\n                  </ng-container>\n                </td>\n              </tr>\n            </ng-container>\n            <ng-container *ngIf=\"!editingRow(row)\">\n              <tr [ngClass]=\"table.rowClass(row)\" (click)=\"table.onClick(row)\">\n                <td *ngFor=\"let col of table.columns\">\n                  <ng-container *ngIf=\"!templateRef(row[col.prop])\">\n                    {{ row[col.prop] }}\n                  </ng-container>\n                  <ng-container *ngIf=\"templateRef(row[col.prop])\">\n                    <ng-template\n                      [ngTemplateOutlet]=\"row[col.prop]\"\n                      [ngTemplateOutletContext]=\"{ data: row }\"\n                    >\n                    </ng-template>\n                  </ng-container>\n                </td>\n              </tr>\n            </ng-container>\n          </ng-container>\n        </tbody>\n      </nz-table>\n    </div>\n    <div class=\"mint-data-table-footer\">\n      <ng-content select=\"[mint-data-table-footer]\"></ng-content>\n    </div>\n  </div>\n</div>\n", styles: [".mint-data-table .mint-data-table-content .form-control-group{margin:0}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: MintAutoFieldComponent, selector: "mint-auto-field", inputs: ["field"] }, { kind: "component", type: i4$5.NzTableComponent, selector: "nz-table", inputs: ["nzTableLayout", "nzShowTotal", "nzItemRender", "nzTitle", "nzFooter", "nzNoResult", "nzPageSizeOptions", "nzVirtualItemSize", "nzVirtualMaxBufferPx", "nzVirtualMinBufferPx", "nzVirtualForTrackBy", "nzLoadingDelay", "nzPageIndex", "nzPageSize", "nzTotal", "nzWidthConfig", "nzData", "nzCustomColumn", "nzPaginationPosition", "nzScroll", "nzPaginationType", "nzFrontPagination", "nzTemplateMode", "nzShowPagination", "nzLoading", "nzOuterBordered", "nzLoadingIndicator", "nzBordered", "nzSize", "nzShowSizeChanger", "nzHideOnSinglePage", "nzShowQuickJumper", "nzSimple"], outputs: ["nzPageSizeChange", "nzPageIndexChange", "nzQueryParams", "nzCurrentPageDataChange", "nzCustomColumnChange"], exportAs: ["nzTable"] }, { kind: "component", type: i4$5.NzThAddOnComponent, selector: "th[nzColumnKey], th[nzSortFn], th[nzSortOrder], th[nzFilters], th[nzShowSort], th[nzShowFilter], th[nzCustomFilter]", inputs: ["nzColumnKey", "nzFilterMultiple", "nzSortOrder", "nzSortPriority", "nzSortDirections", "nzFilters", "nzSortFn", "nzFilterFn", "nzShowSort", "nzShowFilter", "nzCustomFilter"], outputs: ["nzCheckedChange", "nzSortOrderChange", "nzFilterChange"] }, { kind: "directive", type: i4$5.NzTableCellDirective, selector: "th:not(.nz-disable-th):not([mat-cell]), td:not(.nz-disable-td):not([mat-cell])" }, { kind: "directive", type: i4$5.NzThMeasureDirective, selector: "th", inputs: ["nzWidth", "colspan", "colSpan", "rowspan", "rowSpan"] }, { kind: "component", type: i4$5.NzTheadComponent, selector: "thead:not(.ant-table-thead)", outputs: ["nzSortOrderChange"] }, { kind: "component", type: i4$5.NzTbodyComponent, selector: "tbody" }, { kind: "directive", type: i4$5.NzTrDirective, selector: "tr:not([mat-row]):not([mat-header-row]):not([nz-table-measure-row]):not([nzExpand]):not([nz-table-fixed-row])" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mint-data-table', template: "<div class=\"mint-data-table\" *ngIf=\"table\">\n  <div class=\"mint-data-table-content\">\n    <div class=\"mint-data-table-header\">\n      <ng-content select=\"[mint-data-table-header]\"></ng-content>\n    </div>\n\n    <div class=\"mint-data-table-body\">\n      <nz-table\n        [nzBordered]=\"table.bordered\"\n        [nzData]=\"table.rows\"\n        [nzLoading]=\"table.loading\"\n        [nzFrontPagination]=\"!table.serverPaging\"\n        [nzShowPagination]=\"true\"\n        [nzTotal]=\"table.resultSet.totalSize\"\n        [nzPageSize]=\"table.resultSet.pageSize\"\n        [nzPageIndex]=\"table.resultSet.currentPage\"\n        [nzShowSizeChanger]=\"true\"\n        [nzHideOnSinglePage]=\"table.hideOnSinglePage\"\n        [nzPageSizeOptions]=\"table.pageSizeOptions\"\n        (nzPageIndexChange)=\"table.onPageNumberChange($event)\"\n        (nzPageSizeChange)=\"table.onPageSizeChange($event)\"\n      >\n        <thead (nzSortOrderChange)=\"table.onSort($event)\">\n          <tr>\n            <ng-container *ngFor=\"let col of table.columns\">\n              <th [nzShowSort]=\"col.sortable\">\n                <ng-container *ngIf=\"!templateRef(col.name)\">\n                  {{ col.name }}\n                </ng-container>\n                <ng-container *ngIf=\"templateRef(col.name)\">\n                  <ng-template\n                    [ngTemplateOutlet]=\"col.name\"\n                    [ngTemplateOutletContext]=\"{ data: col }\"\n                  >\n                  </ng-template>\n                </ng-container>\n              </th>\n            </ng-container>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let row of table.rows\">\n            <ng-container *ngIf=\"editingRow(row)\">\n              <tr [ngClass]=\"table.rowClass(row)\">\n                <td *ngFor=\"let col of table.columns\">\n                  <ng-container *ngIf=\"col.editable\">\n                    <mint-auto-field\n                      [field]=\"col.field\"\n                      [(ngModel)]=\"row['__edits__'][col.prop]\"\n                    ></mint-auto-field>\n                  </ng-container>\n\n                  <ng-container *ngIf=\"!col.editable\">\n                    <ng-container *ngIf=\"!templateRef(row[col.prop])\">\n                      {{ row[col.prop] }}\n                    </ng-container>\n                    <ng-container *ngIf=\"templateRef(row[col.prop])\">\n                      <ng-template\n                        [ngTemplateOutlet]=\"row[col.prop]\"\n                        [ngTemplateOutletContext]=\"{ data: row }\"\n                      >\n                      </ng-template>\n                    </ng-container>\n                  </ng-container>\n                </td>\n              </tr>\n            </ng-container>\n            <ng-container *ngIf=\"!editingRow(row)\">\n              <tr [ngClass]=\"table.rowClass(row)\" (click)=\"table.onClick(row)\">\n                <td *ngFor=\"let col of table.columns\">\n                  <ng-container *ngIf=\"!templateRef(row[col.prop])\">\n                    {{ row[col.prop] }}\n                  </ng-container>\n                  <ng-container *ngIf=\"templateRef(row[col.prop])\">\n                    <ng-template\n                      [ngTemplateOutlet]=\"row[col.prop]\"\n                      [ngTemplateOutletContext]=\"{ data: row }\"\n                    >\n                    </ng-template>\n                  </ng-container>\n                </td>\n              </tr>\n            </ng-container>\n          </ng-container>\n        </tbody>\n      </nz-table>\n    </div>\n    <div class=\"mint-data-table-footer\">\n      <ng-content select=\"[mint-data-table-footer]\"></ng-content>\n    </div>\n  </div>\n</div>\n", styles: [".mint-data-table .mint-data-table-content .form-control-group{margin:0}\n"] }]
        }], propDecorators: { table: [{
                type: Input
            }], change: [{
                type: Output
            }], rowUpdated: [{
                type: Output
            }] } });

const MODULES$2 = [
    CommonModule,
    FormsModule,
    MintAutoFieldModule,
    NzTableModule,
    NzCardModule,
    NzInputModule,
];
const COMPONENTS$2 = [MintDataTableComponent];
class MintDataTableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDataTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintDataTableModule, declarations: [MintDataTableComponent], imports: [CommonModule,
            FormsModule,
            MintAutoFieldModule,
            NzTableModule,
            NzCardModule,
            NzInputModule, CommonModule], exports: [CommonModule,
            FormsModule,
            MintAutoFieldModule,
            NzTableModule,
            NzCardModule,
            NzInputModule, MintDataTableComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDataTableModule, imports: [MODULES$2, CommonModule, CommonModule,
            FormsModule,
            MintAutoFieldModule,
            NzTableModule,
            NzCardModule,
            NzInputModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDataTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$2, CommonModule],
                    declarations: [...COMPONENTS$2],
                    exports: [...MODULES$2, ...COMPONENTS$2],
                }]
        }] });

class MintCheckboxGroup extends MintFormField {
    constructor(model) {
        super(model);
        this.isOptionCollapsible = false;
        this.areOptionsActive = true;
        this._controlType = 'checkbox-group';
        this.optionContentTemplate = model.optionContentTemplate;
        this.isOptionCollapsible = model.isOptionCollapsible;
        this.areOptionsActive = model.areOptionsActive ?? true;
    }
}

class MintToggle extends MintFormField {
    constructor(model) {
        super(model);
        this._controlType = 'toggle';
    }
}

// describes the UI control for this field
class MintDate extends MintFormField {
    constructor(model) {
        super(model);
        this._controlType = 'datepicker';
        if (typeof this.mode === 'undefined') {
            this.mode = 'date';
        }
        if (typeof this.open === 'undefined') {
            this.open = false;
        }
        if (typeof this.showToday === 'undefined') {
            this.showToday = true;
        }
        if (typeof this.showTime === 'undefined') {
            this.showTime = true;
        }
        if (typeof this.format === 'undefined') {
            this.format = 'yyyy-MM-dd';
        }
        if (typeof this.size === 'undefined') {
            this.size = 'default';
        }
        if (typeof this.onOk === 'undefined') {
            this.onOk = (date) => { };
        }
        this._displayValue = this.getDisplayDate();
    }
    set displayValue(date) {
        this._displayValue = date;
        this.storeDisplayDate();
    }
    get displayValue() {
        return this._displayValue;
    }
    getDisplayDate() {
        if (this.showTime || !this.value) {
            return this.value;
        }
        const date = new Date(this.value);
        const offset = date.getTimezoneOffset() / 60;
        date.setHours(date.getHours() + offset);
        return date;
    }
    storeDisplayDate() {
        if (this.showTime) {
            this.value = this.displayValue;
            return;
        }
        if (!this.displayValue) {
            this.value = null;
            return;
        }
        const date = new Date(this.displayValue);
        // Store as noon UTC on the date of the the user's selected date in their local time
        date.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        date.setUTCHours(0, 0, 0, 0);
        this.value = date;
    }
}

/*
 * NOTE: the type of the value of this control is Date[]
 */
// describes the UI control for this field
class MintDateRange extends MintDate {
    constructor(model) {
        super(model);
        this._controlType = 'daterange';
    }
}

// describes the UI control for this field
class MintSelect extends MintFormField {
    constructor(model) {
        super(model);
        this._controlType = 'select';
        if (typeof this.mode === 'undefined') {
            this.mode = 'default';
        }
        if (this.mode !== 'default') {
            this.maxMultipleCount = 100;
        }
        if (typeof this.loading === 'undefined') {
            this.loading = false;
        }
        if (typeof this.dropDownMatchSelectWidth === 'undefined') {
            this.dropDownMatchSelectWidth = false;
        }
        if (typeof this.onSearch === 'undefined') {
            this.onSearch = (value) => value;
        }
        if (typeof this.onBottomScroll === 'undefined') {
            this.onBottomScroll = () => undefined;
        }
        if (typeof this.onOpenChange === 'undefined') {
            this.onOpenChange = (opened) => undefined;
        }
        if (typeof this.autoClearSearchValue === 'undefined') {
            this.autoClearSearchValue = true;
        }
    }
}

class MintMenuItem {
    static getParents(item) {
        const parents = [];
        let parent = item.parent;
        while (parent) {
            parents.unshift(parent);
            parent = parent.parent;
        }
        return parents;
    }
    static isParent(item, possibleChild) {
        return possibleChild.parent
            ? possibleChild.parent === item ||
                this.isParent(item, possibleChild.parent)
            : false;
    }
}

const logger$1k = MintLogger.getLogger('MintInputPhone');
class MintInputPhone extends MintInputText {
    constructor(model) {
        super(model);
        this.type = 'tel';
        this._controlType = 'tel';
        if (typeof this.displayFormat === 'undefined') {
            this.displayFormat = 'national';
        }
        logger$1k.debug('MintInputPhone: this: ', this);
    }
}

const logger$1j = MintLogger.getLogger('MintRedirectComponent');
// credit: https://www.bennadel.com/blog/3600-chaining-absolute-and-local-redirects-with-the-router-in-angular-7-2-13.htm
class MintRedirectComponent {
    constructor(route, router) {
        this.route = route;
        this.router = router;
        this.router = router;
        this.redirectTo = route.snapshot.data['redirectTo'];
    }
    async ngOnInit() {
        logger$1j.debug('redirect: ', this.redirectTo);
        if (this.redirectTo.startsWith('..')) {
            return await this.router.navigate([this.redirectTo], {
                relativeTo: this.route,
            });
        }
        return await this.router.navigateByUrl(this.redirectTo);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRedirectComponent, deps: [{ token: i4$1.ActivatedRoute }, { token: i4$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.8", type: MintRedirectComponent, selector: "mint-redirect", ngImport: i0, template: ``, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRedirectComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'mint-redirect',
                    template: ``,
                }]
        }], ctorParameters: () => [{ type: i4$1.ActivatedRoute }, { type: i4$1.Router }] });

const MODULES$1 = [];
const COMPONENTS$1 = [MintRedirectComponent];
class MintRedirectModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRedirectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintRedirectModule, declarations: [MintRedirectComponent], exports: [MintRedirectComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRedirectModule, imports: [MODULES$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRedirectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1],
                    declarations: [...COMPONENTS$1],
                    exports: [...COMPONENTS$1],
                }]
        }] });

const logger$1i = MintLogger.getLogger('MintInputDate');
class MintInputDate extends MintInputText {
    constructor(model) {
        super(model);
        this.type = 'date';
        this._controlType = 'date';
        if (!this.minDate) {
            this.minDate = '1900-01-01';
        }
        if (!this.maxDate) {
            this.maxDate = '2100-12-31';
        }
    }
}

class MintInputAddress extends MintFormField {
    constructor(model) {
        super(model);
        this._controlType = 'address';
    }
}

// describes the UI control for this field
class MintPlainText extends MintFormField {
    constructor(model) {
        super(model);
        this.minRows = 2;
        this.maxRows = 16;
        this.showRemainingChar = model.showRemainingChar ?? true;
        this._controlType = 'textarea';
    }
}

const logger$1h = MintLogger.getLogger('MintCssUtil');
function mintCssToString(style) {
    const rules = style.cssRules;
    if (!rules.length) {
        return '';
    }
    let result = '';
    for (let i = 0; i < rules.length; i++) {
        result += rules.item(i).cssText + '\n';
    }
    return result;
}
function mintPixelToValue(value, defaultValue) {
    if (typeof value === 'undefined' || value === null) {
        return defaultValue;
    }
    let result;
    try {
        if (value.endsWith('px')) {
            result = MintTypeUtil.parseFloat(value.replace('px', ''));
        }
        else if (value.endsWith('vw')) {
            const vwHeight = MintTypeUtil.parseFloat(value.replace('vw', ''));
            result = vwHeight / (100 / window.innerWidth);
        }
        else if (value.endsWith('vh')) {
            const vhHeight = MintTypeUtil.parseFloat(value.replace('vh', ''));
            result = vhHeight / (100 / window.innerHeight);
        }
        else {
            result = MintTypeUtil.parseFloat(value);
        }
    }
    catch (err) {
        logger$1h.error(err);
        result = defaultValue;
    }
    result = Math.floor(result);
    logger$1h.debug('toPixels: result: ', result);
    return result;
}

const logger$1g = MintLogger.getLogger('MintBlobUtil');
function mintBase64ToBlob(b64Data, contentType, sliceSize = 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
}
function mintBlobToBase64(data) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result.toString()));
        reader.readAsDataURL(data);
    });
}

const logger$1f = MintLogger.getLogger('MintJepCache');
/**
 * A doubly linked list-based Least Recently Used (LRU)
 * cache. Will keep most recently used items while
 * discarding least recently used items when its limit is
 * reached. This is a bare-bone version of
 * Rasmus Andersson's js-lru:
 *
 * https://github.com/rsms/js-lru
 */
class MintJepCache {
    constructor(limit) {
        this._keymap = Object.create(null);
        this.size = 0;
        this.limit = limit;
        this.head = this.tail = undefined;
        this._keymap = Object.create(null);
    }
    /**
     * Put <value> into the cache associated with <key>.
     * Returns the entry which was removed to make room for
     * the new entry. Otherwise undefined is returned.
     * (i.e. if there was enough room already).
     */
    put(key, value) {
        let removed;
        if (this.size === this.limit) {
            removed = this._shift();
        }
        let entry = this.get(key, true);
        if (!entry) {
            entry = {
                key: key,
            };
            this._keymap[key] = entry;
            if (this.tail) {
                this.tail.newer = entry;
                entry.older = this.tail;
            }
            else {
                this.head = entry;
            }
            this.tail = entry;
            this.size++;
        }
        entry.value = value;
        return removed;
    }
    /**
     * Purge the least recently used (oldest) entry from the
     * cache. Returns the removed entry or undefined if the
     * cache was empty.
     */
    _shift() {
        const entry = this.head;
        if (entry) {
            this.head = this.head.newer;
            this.head.older = undefined;
            entry.newer = entry.older = undefined;
            this._keymap[entry.key] = undefined;
            this.size--;
        }
        return entry;
    }
    /**
     * Get and register recent use of <key>. Returns the value
     * associated with <key> or undefined if not in cache.
     */
    get(key, returnEntry) {
        const entry = this._keymap[key];
        if (typeof entry === 'undefined') {
            return;
        }
        if (entry !== this.tail) {
            // HEAD--------------TAIL
            //   <.older   .newer>
            //  <--- add direction --
            //   A  B  C  <D>  E
            if (entry.newer) {
                if (entry === this.head) {
                    this.head = entry.newer;
                }
                entry.newer.older = entry.older; // C <-- E.
            }
            if (entry.older) {
                entry.older.newer = entry.newer; // C. --> E
            }
            entry.newer = undefined; // D --x
            entry.older = this.tail; // D. --> E
            if (this.tail) {
                this.tail.newer = entry; // E. <-- D
            }
            this.tail = entry;
        }
        return returnEntry ? entry : entry.value;
    }
}

const logger$1e = MintLogger.getLogger('MintJep');
/**
 * Typescript port of the excellent JEP library
 * https://github.com/cnlon/jep
 */
/**
 * Come from Vue.js v1.0.24
 * https://github.com/vuejs/vue
 */
// tslint:disable-next-line
const defaultAllowedKeywords = `
  Math,Date,this,true,false,null,undefined,Infinity,NaN,isNaN,isFinite,
  decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,parseInt,parseFloat
  `;
// keywords that don't make sense inside expressions
const improperKeywordsRE = new RegExp('^(' +
    // tslint:disable-next-line
    'break,case,class,catch,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,in,instanceof,let,return,super,switch,throw,try,var,while,with,yield,enum,await,implements,package,protected,static,interface,private,public'.replace(/,/g, '\\b|') +
    '\\b)');
const wsRE = /\s/g;
const newlineRE = /\n/g;
// tslint:disable-next-line
const saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
const restoreRE = /"(\d+)"/g;
const pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
const identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
const booleanLiteralRE = /^(?:true|false)$/;
/**
 * Save / Rewrite / Restore
 *
 * When rewriting paths found in an expression, it is
 * possible for the same letter sequences to be found in
 * strings and Object literal property keys. Therefore we
 * remove and store these parts in a temporary array, and
 * restore them after the path rewrite.
 */
const saved = [];
/**
 * Save replacer
 *
 * The save regex can match two possible cases:
 * 1. An opening object literal
 * 2. A string
 * If matched as a plain string, we need to escape its
 * newlines, since the string needs to be preserved when
 * generating the function body.
 */
function save(str, isString) {
    const i = saved.length;
    saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
    return '"' + i + '"';
}
/**
 * Restore replacer
 */
function restore(str, i) {
    return saved[i];
}
/**
 * Check if an expression is a simple path.
 */
function isSimplePath(expression) {
    return (pathTestRE.test(expression) &&
        // don't treat true/false as paths
        !booleanLiteralRE.test(expression));
}
function parseKeywordsToRE(keywords) {
    return new RegExp('^(?:' +
        keywords.replace(wsRE, '').replace(/\$/g, '\\$').replace(/,/g, '\\b|') +
        '\\b)');
}
/**
 *   - {Number} cache, default 1000
 *              limited for MintJepCache
 *   - {Array} params, default ['$']
 *              first one is for scope and you can add more params
 */
class MintJep {
    constructor(options) {
        this.options = {
            cache: 1000,
            scope: '$',
        };
        if (options) {
            this.options = options;
        }
        const cache = this.options.cache || 1000;
        const scope = this.options.scope || '$';
        const scopes = this.options.scopes;
        let params = this.options.params;
        if (!params) {
            if (scopes) {
                params = Object.keys(scopes);
                params.unshift(scope);
            }
            else {
                params = [scope];
            }
        }
        this._cache = new MintJepCache(cache);
        this._funcParams = params.join(',').replace(wsRE, '');
        this._funcBefore = 'function(' + this._funcParams + '){return ';
        this._funcAfter = '}';
        this.scope = scope;
        if (scopes) {
            const keys = Object.keys(scopes);
            for (let i = 0, l = keys.length, key, keywords; i < l; i++) {
                key = keys[i];
                keywords = scopes[key];
                scopes[key] = parseKeywordsToRE(Object.prototype.toString.call(keywords) === '[object Array]'
                    ? keywords.join(',')
                    : keywords);
            }
            this._scopeREs = scopes;
        }
        let paramsPrefix;
        if (params.length > 1) {
            params = params.slice(1);
            paramsPrefix = params.join(',');
            this._paramsPrefixRE = parseKeywordsToRE(paramsPrefix);
        }
        const allowedKeywords = paramsPrefix
            ? paramsPrefix + ',' + defaultAllowedKeywords
            : defaultAllowedKeywords;
        this._allowedKeywordsRE = parseKeywordsToRE(allowedKeywords);
    }
    _addScope(expression) {
        if (this._paramsPrefixRE && this._paramsPrefixRE.test(expression)) {
            return expression;
        }
        if (this._scopeREs) {
            const keys = Object.keys(this._scopeREs);
            for (let i = 0, l = keys.length, re; i < l; i++) {
                re = this._scopeREs[keys[i]];
                if (re.test(expression)) {
                    return keys[i] + '.' + expression;
                }
            }
        }
        return this.scope + '.' + expression;
    }
    /**
     * Rewrite an expression, prefixing all path accessors with
     * `scope.` and return the new expression.
     */
    compile(expression) {
        if (improperKeywordsRE.test(expression)) {
            logger$1e.warn('Avoid using reserved keywords in expression: ' + expression);
        }
        // reset state
        saved.length = 0;
        // save strings and object literal keys
        const body = expression.replace(saveRE, save).replace(wsRE, '');
        // rewrite all paths
        // pad 1 space here becaue the regex matches 1 extra char
        const self = this;
        let c;
        let path;
        return (' ' + body)
            .replace(identRE, (raw) => {
            c = raw.charAt(0);
            path = raw.slice(1);
            if (self._allowedKeywordsRE.test(path)) {
                return raw;
            }
            else {
                path =
                    path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
                return c + self._addScope(path);
            }
        })
            .replace(restoreRE, restore)
            .slice(1);
    }
    /**
     * Parse source to expression.
     */
    parse(source) {
        if (!(source && source === source.trim())) {
            return '';
        }
        // try cache
        const hit = this._cache.get(source);
        if (hit) {
            return hit;
        }
        const result = isSimplePath(source) && source.indexOf('[') < 0
            ? this._addScope(source)
            : this.compile(source);
        this._cache.put(source, result);
        return result;
    }
    /**
     * Build expression to function. Requires eval.
     */
    build(expression) {
        try {
            /* eslint-disable no-new-func */
            return new Function(this._funcParams, 'return ' + expression);
            /* eslint-enable no-new-func */
        }
        catch (e) {
            logger$1e.warn('Invalid expression. Generated function body: ' + expression);
            return undefined;
        }
    }
    /**
     * Build expression to function string.
     */
    buildToString(expression) {
        return this._funcBefore + expression + this._funcAfter;
    }
    /**
     * Parse source to expression and build it to function.
     */
    make(source) {
        const expression = this.parse(source);
        return this.build(expression);
    }
    /**
     * Parse source to expression and build it to function string.
     */
    makeToString(source) {
        const expression = this.parse(source);
        return this.buildToString(expression);
    }
}

class MintCurrencyUtil {
    static { this.formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }); }
    static format(value) {
        let _value = BigNumber.isBigNumber(value) ? value.toNumber() : value;
        if (typeof _value === 'string') {
            _value = MintTypeUtil.parseFloat(_value);
        }
        if (isNullish(_value) || !MintTypeUtil.isNumeric(_value)) {
            return '';
        }
        return MintCurrencyUtil.formatter.format(_value);
    }
    static getValue(value) {
        return MintTypeUtil.parseBigNumber(value);
    }
}

const logger$1d = MintLogger.getLogger('MintEventUtil');
function mintEventSrcContainsClassName(event, ...classNames) {
    if (!event || !event.target) {
        return false;
    }
    // const classList = event.srcElement.classList;
    const target = event.target;
    const classList = target.classList;
    logger$1d.debug('mintEventSrcContainsClassName: classList: ', classList);
    for (const className of classNames) {
        if (classList.contains(className)) {
            return true;
        }
    }
    return false;
}

const logger$1c = MintLogger.getLogger('MintDownloadUtil');
async function mintDownloadData(data, contentType, filename, charset = 'utf8') {
    const blob = new Blob([data], {
        type: `${contentType};charset=${charset};`,
    });
    logger$1c.debug('download:  blob created: size: ', blob.size);
    await mintDownloadBlob(blob, filename);
}
async function mintDownloadBlob(blob, filename) {
    logger$1c.debug('download: filename: ', filename);
    const debouncer = new MintDebouncer(200);
    if (navigator.msSaveBlob) {
        logger$1c.debug('download: msSaveBlob called ...');
        navigator.msSaveBlob(blob, filename);
    }
    else {
        logger$1c.debug('download: msSaveBlob not found. generating link ...');
        await debouncer.debounce(() => {
            const link = document.createElement('a');
            link.setAttribute('visibility', 'hidden');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            logger$1c.debug('download: link created, clicked and removed');
        });
    }
}

const logger$1b = MintLogger.getLogger('MintListUtil');
class MintListUtil {
    static removeItem(list, item, compare, clone = false) {
        return MintListUtil.updateList(list, item, true, compare, false, clone);
    }
    static replaceItem(list, item, compare, addIfNotFound = true, clone = false) {
        return MintListUtil.updateList(list, item, false, compare, addIfNotFound, clone);
    }
    static updateList(list, item, remove, compare, addIfNotFound = true, clone = false) {
        if (!list) {
            list = [];
        }
        let found = false;
        for (let i = 0; i < list.length; i++) {
            const object = list[i];
            if (compare(object, item) === true) {
                found = true;
                if (remove) {
                    // remove item
                    list.splice(i, 1);
                }
                else {
                    // replace existing item
                    list.splice(i, 1, item);
                }
                break;
            }
        }
        if (!found && !remove && addIfNotFound) {
            list.push(item);
        }
        let result = list;
        if (clone) {
            result = [...list];
        }
        return result;
    }
}

const logger$1a = MintLogger.getLogger('MintOperatorUtil');
class MintOperatorUtil {
    // returns result of value1 <op> value2
    // if value1 and value2 are arrays:
    //      value1 = value2 // checks if each element of the arrays are equal to each other
    // if value2 only is an array:
    //      value1  (in | not in |between | not between) value2
    static applyOperator(operator, value1, value2) {
        logger$1a.debug(`applyOperator: operator: ${[
            operator,
        ]}  value1: ${value1}  value2: ${value2}`);
        if (Array.isArray(value2)) {
            if (Array.isArray(value1)) {
                switch (operator) {
                    case '=':
                        if (!value1 || !value2) {
                            return false;
                        }
                        // compare lengths - can save a lot of time
                        if (value1.length !== value2.length) {
                            return false;
                        }
                        for (let i = 0, l = value1.length; i < l; i++) {
                            // Check if we have nested arrays
                            if (value1[i] instanceof Array && value2[i] instanceof Array) {
                                // recurse into the nested arrays
                                if (!this.applyOperator('=', value1[i], value2[i])) {
                                    return false;
                                }
                                else if (value1[i] !== value2[i]) {
                                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
                                    return false;
                                }
                            }
                            return true;
                        }
                        break;
                    default:
                        throw Error('Invalid operator to compare arrays: ' + operator);
                }
            }
            else {
                switch (operator) {
                    case 'in':
                        return value2.indexOf(value1) >= 0;
                    case 'not in':
                        return value2.indexOf(value1) < 0;
                    case 'between':
                        if (value2.length !== 2) {
                            throw Error(`'between' operator requires array with exactly 2 values`);
                        }
                        return value1 >= value2[0] && value1 <= value2[1];
                    case 'not between':
                        if (value2.length !== 2) {
                            throw Error(`'not between' operator requires array with exactly 2 values`);
                        }
                        return !(value1 >= value2[0] && value1 <= value2[1]);
                    default:
                        throw Error('Invalid operator to compare value in array: ' + operator);
                }
            }
        }
        if (typeof value1 !== typeof value2) {
            value1 = value1.toString();
            value2 = value2.toString();
        }
        switch (operator) {
            case '=':
                return value1 === value2;
            case '!=':
                return value1 !== value2;
            case '<':
                return value1 < value2;
            case '<=':
                return value1 <= value2;
            case '>':
                return value1 > value2;
            case '>=':
                return value1 >= value2;
            default:
                throw Error('Invalid operator to compare values: ' + operator);
        }
    }
}

const logger$19 = MintLogger.getLogger('MintCsvExporter');
const CSV_EOL = '\r\n';
const CSV_BOM = '\ufeff';
const DEFAULT_OPTIONS = {
    filename: 'file.csv',
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: false,
    showTitle: false,
    title: 'CSV Download',
    useBom: true,
    headers: [],
    keys: [],
    removeNewLines: false,
};
class MintCsvExporter {
    constructor(dataJSON, filename, options) {
        this.csv = '';
        const config = options || {};
        this.data = typeof dataJSON !== 'object' ? JSON.parse(dataJSON) : dataJSON;
        this._options = MintObjectUtil.objectAssign({}, DEFAULT_OPTIONS, config);
        if (this._options.filename) {
            this._options.filename = filename;
        }
    }
    /**
     * Generate and Download Csv
     */
    export() {
        if (this._options.useBom) {
            this.csv += CSV_BOM;
        }
        if (this._options.showTitle) {
            this.csv += this._options.title + '\r\n\n';
        }
        this.getHeaders();
        this.getBody();
        if (this.csv === '') {
            logger$19.debug('Invalid data');
            return;
        }
        const filename = this._options.filename.replace(/ /g, '_') + '.csv';
        mintDownloadData(this.csv, 'text/csv', filename, 'utf8');
    }
    /**
     * Create Headers
     */
    getHeaders() {
        if (this._options.headers.length > 0) {
            let row = '';
            for (const column of this._options.headers) {
                row += column + this._options.fieldSeparator;
            }
            row = row.slice(0, -1);
            this.csv += row + CSV_EOL;
        }
    }
    /**
     * Create Body
     */
    getBody() {
        for (const dataRow of this.data) {
            let row = '';
            if (this._options.keys && this._options.keys.length > 0) {
                for (const key of this._options.keys) {
                    row += this.formatData(dataRow[key]) + this._options.fieldSeparator;
                }
                row = row.slice(0, -1);
                this.csv += row + CSV_EOL;
            }
            else {
                for (const data of dataRow) {
                    row += this.formatData(data) + this._options.fieldSeparator;
                }
                row = row.slice(0, -1);
                this.csv += row + CSV_EOL;
            }
        }
    }
    formatData(data) {
        if (this._options.decimalSeparator === 'locale' &&
            MintTypeUtil.isFloat(data)) {
            return data.toLocaleString();
        }
        if (this._options.decimalSeparator !== '.' && MintTypeUtil.isFloat(data)) {
            return data.toString().replace('.', this._options.decimalSeparator);
        }
        if (typeof data === 'string') {
            data = data.replace(/"/g, '""');
            if (this._options.quoteStrings ||
                data.indexOf(',') > -1 ||
                data.indexOf('\n') > -1 ||
                data.indexOf('\r') > -1) {
                data = this._options.quoteStrings + data + this._options.quoteStrings;
            }
            return data;
        }
        if (typeof data === 'boolean') {
            return data ? 'TRUE' : 'FALSE';
        }
        return data;
    }
}

const logger$18 = MintLogger.getLogger('MintCsvUtil');
// Credits:  https://github.com/javiertelioz/angular2-csv/blob/v0.2.5/Angular2-csv.ts
class MintCsvService {
    download(filename, data) {
        if (!data || data.length === 0) {
            throw Error(`Error exporting empty data set.`);
        }
        // note Angular2Csv appends .csv extension to filename
        if (filename.toLowerCase().endsWith('.csv')) {
            filename = filename.substring(0, filename.length - 4);
        }
        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            useBom: false,
            headers: Object.keys(data[0]),
        };
        logger$18.debug('calling processCSV for data: ', data);
        const exporter = new MintCsvExporter(data, filename, options);
        exporter.export();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCsvService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCsvService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCsvService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

// Adapted from Nebular by Akevo
// @dynamic
class MintBase64Util {
    static urlBase64Decode(str) {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: {
                break;
            }
            case 2: {
                output += '==';
                break;
            }
            case 3: {
                output += '=';
                break;
            }
            default: {
                throw new Error('Illegal base64url string!');
            }
        }
        return MintBase64Util.b64DecodeUnicode(output);
    }
    static b64decode(str) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = '';
        str = String(str).replace(/=+$/, '');
        if (str.length % 4 === 1) {
            throw new Error(`'atob' failed: The string to be decoded is not correctly encoded.`);
        }
        for (
        // initialize result and counters
        let bc = 0, bs, buffer, idx = 0; 
        // get next character
        // tslint:disable-next-line:no-conditional-assignment
        (buffer = str.charAt(idx++)); 
        // character found in table? initialize bit storage and add its ascii value;
        // tslint:disable-next-line:no-bitwise
        ~buffer &&
            // tslint:disable-next-line:no-conditional-assignment
            ((bs = bc % 4 ? bs * 64 + buffer : buffer),
                // and if not first of each 4 characters,
                // convert the first 8 bits to one ascii character
                bc++ % 4)
            ? // tslint:disable-next-line:no-bitwise
                (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
            : 0) {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        return output;
    }
    // https://developer.mozilla.org/en/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
    static b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map
            .call(MintBase64Util.b64decode(str), (c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
    }
}

const logger$17 = MintLogger.getLogger('MintAnalyticsGoogle');
if (typeof gtag === 'undefined' || !gtag) {
    logger$17.info(`'gtag' global variable not set.`);
    window['gtag'] = (...args) => { };
}
class MintAnalyticsGoogle {
    constructor(configService) {
        this.configService = configService;
        this.trackingId =
            this.configService.getConfig().analytics?.google?.trackingId;
        logger$17.debug('trackingId: ', this.trackingId);
        if (gtag && this.trackingId) {
            gtag('config', this.trackingId);
        }
    }
    event(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('addEvent: ', event);
        gtag('event', event.action, {
            event_category: event.category,
            event_label: event.label,
            value: event.value,
            non_interaction: event.nonInteraction,
            // ...event.params
        });
    }
    purchase(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('purchase: ', event);
        const params = {
            event_action: 'purchase',
            event_category: 'ecommerce',
            transaction_id: event.invoiceNo,
            value: event.amount,
            tax: event.tax,
            shipping: event.shipping,
            affiliation: event.affiliation,
            currency: event.currency ? event.currency : 'USD',
        };
        gtag('event', params.event_action, params);
    }
    contactUs(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('contactUs: ', event);
        const params = {
            event_action: 'contact_us',
            event_category: 'engagement',
        };
        gtag('event', params.event_action, params);
    }
    pageView(event) {
        if (!gtag || !this.trackingId) {
            return;
        }
        if (!event.path) {
            // event.path = window.location.pathname + window.location.search + window.location.hash;
            event.path = window.location.pathname;
        }
        if (!event.location) {
            event.location = event.path;
            if (event.section && event.section.trim().length > 0) {
                if (!event.location.endsWith('/')) {
                    event.location += '/';
                }
                event.location += '#' + event.section;
            }
        }
        logger$17.debug('pageView: ', event);
        // const params: GTag.PageViewEvent = {
        //     event_action: 'page_view',
        //     event_category: 'engagement',
        //     title: event.title,
        //     location: event.location,
        //     path: event.path
        // }
        // gtag('event', params.event_action, params);
        gtag('config', this.trackingId, {
            page_title: event.title,
            page_location: event.location,
            page_path: event.path,
        });
    }
    screenView(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('screenView: ', event);
        const params = {
            event_action: 'screen_view',
            event_category: 'engagement',
            screen_name: event.screenName,
            app_name: event.appName,
            app_id: event.appId,
            app_version: event.appVersion,
            app_installer_id: event.appInstallerId,
        };
        gtag('event', params.event_action, params);
    }
    signup(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('signup: ', event);
        let label = event.method || '';
        if (event.step) {
            label += '/' + event.step;
        }
        if (event.userUid) {
            label += '/' + event.userUid;
        }
        const params = {
            event_action: 'sign_up',
            event_category: 'engagement',
            event_label: label,
        };
        gtag('event', params.event_action, params);
    }
    login(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('login: ', event);
        let label = event.method || '';
        if (event.userUid) {
            label += '/' + event.userUid;
        }
        const params = {
            event_action: 'login',
            event_category: 'engagement',
            event_label: event.method,
        };
        gtag('event', params.event_action, params);
    }
    logout(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('logout: ', event);
        const label = event.userUid || '';
        const params = {
            event_action: 'logout',
            event_category: 'engagement',
            event_label: label,
        };
        gtag('event', params.event_action, params);
    }
    password(event) {
        if (!gtag) {
            return;
        }
        logger$17.debug('password: ', event);
        let label = event.type || '';
        if (event.userUid) {
            label += '/' + event.userUid;
        }
        const params = {
            event_action: 'password',
            event_category: 'engagement',
            event_label: event.userUid,
        };
        gtag('event', params.event_action, params);
    }
    setUser(userUid, clientUid) {
        if (!gtag) {
            return;
        }
        logger$17.debug('setUser: ', event);
        gtag('set', {
            user_id: userUid,
            client_id: clientUid,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalyticsGoogle, deps: [{ token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalyticsGoogle, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalyticsGoogle, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }] });

class MintAnalyticsEvent {
}
class MintAnalyticsPurchaseEvent extends MintAnalyticsEvent {
}
class MintAnalyticsContactUsEvent extends MintAnalyticsEvent {
}
class MintAnalyticsPageViewEvent extends MintAnalyticsEvent {
}
class MintAnalyticsScreenViewEvent extends MintAnalyticsEvent {
}
class MintAnalyticsSignupEvent extends MintAnalyticsEvent {
}
class MintAnalyticsLoginEvent extends MintAnalyticsEvent {
}
class MintAnalyticsLogoutEvent extends MintAnalyticsEvent {
}
class MintAnalyticsPasswordEvent extends MintAnalyticsEvent {
}

const logger$16 = MintLogger.getLogger('MintAnalyticsMixpanel');
let haveMixPanel = true;
if (typeof mixpanel === 'undefined' || !mixpanel) {
    logger$16.info(`'mixpanel' global variable not set.`);
    haveMixPanel = false;
    window['mixpanel'] = {
        init: (token, opts) => { },
        track: (name, properties, callback) => { },
        identify: (personId) => { },
        alias: (newPersonId, originalId) => { },
    };
}
class MintAnalyticsMixpanel {
    constructor(configService) {
        this.configService = configService;
        this.trackingId =
            this.configService.getConfig().analytics?.mixpanel?.trackingId;
        logger$16.debug('trackingId: ', this.trackingId);
        if (haveMixPanel && !this.trackingId) {
            haveMixPanel = false;
        }
        if (haveMixPanel) {
            mixpanel.init(this.trackingId);
        }
    }
    event(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('addEvent: ', event);
        mixpanel.track(event.action, {
            event_action: event.action,
            event_category: event.category,
            event_label: event.label,
            value: event.value,
            non_interaction: event.nonInteraction,
            // ...event.params
        });
    }
    purchase(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('purchase: ', event);
        const params = {
            event_action: 'purchase',
            event_category: 'ecommerce',
            transaction_id: event.invoiceNo,
            value: event.amount,
            tax: event.tax,
            shipping: event.shipping,
            affiliation: event.affiliation,
            currency: event.currency ? event.currency : 'USD',
        };
        mixpanel.track(params.event_action, params);
    }
    pageView(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('pageView: ', event);
        if (!event.path) {
            // event.path = window.location.pathname + window.location.search + window.location.hash;
            event.path = window.location.pathname;
        }
        if (!event.location) {
            event.location = event.path;
            if (event.section && event.section.trim().length > 0) {
                if (!event.location.endsWith('/')) {
                    event.location += '/';
                }
                event.location += '#' + event.section;
            }
        }
        logger$16.debug('pageView: ', event);
        const params = {
            event_action: 'page_view',
            event_category: 'engagement',
            title: event.title,
            location: event.location,
            path: event.path,
        };
        mixpanel.track(params.event_action, params);
    }
    screenView(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('screenView: ', event);
        const params = {
            event_action: 'screen_view',
            event_category: 'engagement',
            screen_name: event.screenName,
            app_name: event.appName,
            app_id: event.appId,
            app_version: event.appVersion,
            app_installer_id: event.appInstallerId,
        };
        mixpanel.track(params.event_action, params);
    }
    signup(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('signup: ', event);
        let label = event.method || '';
        if (event.step) {
            label += '/' + event.step;
        }
        if (event.userUid) {
            label += '/' + event.userUid;
        }
        const params = {
            event_action: 'sign_up',
            event_category: 'engagement',
            event_label: label,
        };
        mixpanel.track(params.event_action, params);
    }
    login(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('login: ', event);
        let label = event.method || '';
        if (event.userUid) {
            label += '/' + event.userUid;
        }
        const params = {
            event_action: 'login',
            event_category: 'engagement',
            event_label: event.method,
        };
        mixpanel.track(params.event_action, params);
    }
    logout(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('logout: ', event);
        const label = event.userUid || '';
        const params = {
            event_action: 'logout',
            event_category: 'engagement',
            event_label: label,
        };
        mixpanel.track(params.event_action, params);
    }
    password(event) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('password: ', event);
        let label = event.type || '';
        if (event.userUid) {
            label += '/' + event.userUid;
        }
        const params = {
            event_action: 'password',
            event_category: 'engagement',
            event_label: event.userUid,
        };
        mixpanel.track(params.event_action, params);
    }
    setUser(userUid, signup) {
        if (!haveMixPanel) {
            return;
        }
        logger$16.debug('setUser: ', event);
        if (typeof signup !== 'undefined' && signup === true) {
            mixpanel.alias(userUid);
        }
        mixpanel.identify(userUid);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalyticsMixpanel, deps: [{ token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalyticsMixpanel, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalyticsMixpanel, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }] });

const logger$15 = MintLogger.getLogger('MintAnalytics');
class MintAnalytics {
    constructor(google, mixpanel) {
        this.google = google;
        this.mixpanel = mixpanel;
    }
    event(action, category, label, value, nonIteraction) {
        let event;
        if (typeof action === 'string') {
            event = {
                action: action,
                category: category,
                label: label,
                value: value,
                nonInteraction: nonIteraction,
            };
        }
        else {
            event = action;
        }
        this.google.event(event);
        this.mixpanel.event(event);
    }
    // make sure ecommerce enabled: Account-> View -> Ecommerce Settings
    purchase(event) {
        this.google.purchase(event);
        this.mixpanel.purchase(event);
    }
    contactUs(event) {
        if (!event) {
            event = {
                action: 'contactUs',
                category: 'engagement',
            };
        }
        this.google.contactUs(event);
        // this.mixpanel.purchase(event);
    }
    pageView(section, title, location, path) {
        if (!section) {
            section = '';
        }
        let event;
        if (typeof section === 'string') {
            event = {
                action: 'pageView',
                category: 'engagement',
                title: title,
                location: location,
                path: path,
                section: section,
            };
        }
        else {
            event = section;
        }
        logger$15.debug('event: ' + event);
        this.google.pageView(event);
        this.mixpanel.pageView(event);
    }
    screenView(screenName, appName, appVersion) {
        let event;
        if (typeof screenName === 'string') {
            event = {
                action: 'screenView',
                category: 'engagement',
                screenName: screenName,
                appName: appName,
                appVersion: appVersion,
            };
        }
        else {
            event = screenName;
        }
        this.google.screenView(event);
        this.mixpanel.screenView(event);
    }
    signup(step, userUid, method) {
        let event;
        if (typeof step === 'string') {
            event = {
                action: 'signup',
                category: 'engagement',
                step: step,
                userUid: userUid,
                method: method,
            };
        }
        else {
            event = step;
        }
        if (!event.method) {
            event.method = 'direct';
        }
        this.google.signup(event);
        this.mixpanel.signup(event);
        if (event.userUid) {
            this.setUser(event.userUid, null, true);
        }
    }
    login(userUid, method) {
        let event;
        if (!userUid || typeof userUid === 'string') {
            event = {
                action: 'login',
                category: 'engagement',
                userUid: userUid,
                method: method,
            };
        }
        else {
            event = userUid;
        }
        if (!event.method) {
            event.method = 'direct';
        }
        this.google.login(event);
        this.mixpanel.login(event);
        if (event.userUid) {
            this.setUser(event.userUid);
        }
    }
    logout(userUid) {
        let event;
        if (!userUid || typeof userUid === 'string') {
            event = {
                action: 'logout',
                category: 'engagement',
                userUid: userUid,
            };
        }
        else {
            event = userUid;
        }
        this.google.logout(event);
        this.mixpanel.logout(event);
        if (event.userUid) {
            // this.setUser('_guest');
        }
    }
    password(type, userUid) {
        let event;
        if (typeof type === 'string') {
            event = {
                action: 'password',
                category: 'engagement',
                type: type,
                userUid: userUid,
            };
        }
        else {
            event = type;
        }
        this.google.password(event);
        this.mixpanel.password(event);
    }
    // make sure tracking enabled: Account-> Property -> Tracking Info -> User-ID
    setUser(userUid, clientUid, signup) {
        this.google.setUser(userUid, clientUid);
        this.mixpanel.setUser(userUid, signup);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalytics, deps: [{ token: MintAnalyticsGoogle }, { token: MintAnalyticsMixpanel }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalytics, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAnalytics, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintAnalyticsGoogle }, { type: MintAnalyticsMixpanel }] });

var MintAccessRole;
(function (MintAccessRole) {
    MintAccessRole["System"] = "system";
    MintAccessRole["SuperAdmin"] = "super-admin";
    MintAccessRole["User"] = "user";
})(MintAccessRole || (MintAccessRole = {}));

// @dynamic
let MintAccessPrivModel = class MintAccessPrivModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAccessPrivModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAccessPrivModel.prototype, "effect", void 0);
__decorate([
    MintProperty()
], MintAccessPrivModel.prototype, "resource", void 0);
__decorate([
    MintProperty()
], MintAccessPrivModel.prototype, "action", void 0);
__decorate([
    MintProperty()
], MintAccessPrivModel.prototype, "conditions", void 0);
__decorate([
    MintProperty()
], MintAccessPrivModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessPrivModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessPrivModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAccessPrivModel.prototype, "_meta", void 0);
MintAccessPrivModel = __decorate([
    MintResource('/access-privs')
], MintAccessPrivModel);

let MintExecutionRequestModel = class MintExecutionRequestModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintExecutionRequestModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintExecutionRequestModel.prototype, "device", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintExecutionRequestModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintExecutionRequestModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAuthTokenModel)
], MintExecutionRequestModel.prototype, "authToken", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppClientModel)
], MintExecutionRequestModel.prototype, "appClient", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "apiVersion", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "appVersion", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "appBuild", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "ipAddress", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "hostname", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "userAgent", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "contentType", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "osName", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "osVersion", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "referer", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "locales", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "fingerprintHash", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "coords", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "idempotencyKey", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestMethod", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestFullUrl", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestUrl", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestUrlPath", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestUrlQuery", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestUrlParams", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintExecutionRequestModel.prototype, "requestAt", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestLatency", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestPayload", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestPayloadSize", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "requestTransferRate", void 0);
__decorate([
    MintProperty()
], MintExecutionRequestModel.prototype, "isSystem", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintExecutionRequestModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintExecutionRequestModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintExecutionRequestModel.prototype, "_meta", void 0);
MintExecutionRequestModel = __decorate([
    MintResource('/execution-requests')
], MintExecutionRequestModel);

// @dynamic
let MintAuthTokenModel = class MintAuthTokenModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintAuthTokenModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintAuthTokenModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintAuthTokenModel.prototype, "createdBy", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintAuthTokenModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAuthTokenModel)
], MintAuthTokenModel.prototype, "refreshRef", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppClientModel)
], MintAuthTokenModel.prototype, "appClient", void 0);
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "session", void 0);
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "nonce", void 0);
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "accessToken", void 0);
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "refreshToken", void 0);
__decorate([
    MintProperty()
], MintAuthTokenModel.prototype, "accessPrivs", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthTokenModel.prototype, "accessExpiresAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthTokenModel.prototype, "refreshExpiresAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthTokenModel.prototype, "loggedOutAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthTokenModel.prototype, "revokedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthTokenModel.prototype, "refreshedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthTokenModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthTokenModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAuthTokenModel.prototype, "_meta", void 0);
MintAuthTokenModel = __decorate([
    MintResource('/auth-tokens')
], MintAuthTokenModel);

// @dynamic
let MintAppClientModel = class MintAppClientModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAppClientModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintAppClientModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAuthTokenModel)
], MintAppClientModel.prototype, "serviceToken", void 0);
__decorate([
    MintProperty()
], MintAppClientModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintAppClientModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintAppClientModel.prototype, "description", void 0);
__decorate([
    MintProperty()
], MintAppClientModel.prototype, "clientSecret", void 0);
__decorate([
    MintProperty(),
    IsArray()
], MintAppClientModel.prototype, "authorizedRedirectUris", void 0);
__decorate([
    MintProperty(),
    IsArray()
], MintAppClientModel.prototype, "authorizedOrigins", void 0);
__decorate([
    MintProperty(),
    IsArray()
], MintAppClientModel.prototype, "scope", void 0);
__decorate([
    MintProperty()
], MintAppClientModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintAppClientModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintAppClientModel.prototype, "isSandbox", void 0);
__decorate([
    MintProperty(),
    IsDate(),
    Type(() => Date)
], MintAppClientModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    IsDate(),
    Type(() => Date)
], MintAppClientModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAppClientModel.prototype, "_meta", void 0);
MintAppClientModel = __decorate([
    MintResource('/app-clients')
], MintAppClientModel);

let MintExecutionRequest = class MintExecutionRequest {
    // this is set by the authentication controller on login.
    // it determines the access privs of the authentication token.
    // if not set, the token's access privs are ['/**:any'] by default
    #authTokenAccessPrivsFn;
    constructor(model) {
        if (model) {
            // remove references to readonly properties
            delete model['isSuperAdmin'];
            delete model['defaultAccount'];
            Object.assign(this, model);
            MintObjectUtil.parseDates(this);
            this.app = model.app ? new MintAppModel(model.app) : undefined;
            this.user = model.user ? new MintUserModel(model.user) : undefined;
            this.account = model.account
                ? new MintAccountModel(model.account)
                : undefined;
            this.device = model.device
                ? new MintDeviceModel(model.device)
                : undefined;
            this.accessRoles = model.accessRoles?.length
                ? model.accessRoles.map((role) => new MintAccessRoleModel(role))
                : [];
            this.accessPrivs = model.accessPrivs?.length
                ? model.accessPrivs.map((priv) => new MintAccessPrivModel(priv))
                : [];
            this.authToken = model.authToken
                ? new MintAuthTokenModel(model.authToken)
                : undefined;
        }
    }
    setAuthTokenAccessPrivsFn(fn) {
        this.#authTokenAccessPrivsFn = fn;
    }
    async authTokenAccessPrivs(user) {
        if (this.#authTokenAccessPrivsFn) {
            return this.#authTokenAccessPrivsFn(this, user);
        }
        return null;
    }
    get isSuperAdmin() {
        let admin = false;
        if (this.accessRoles?.length) {
            const userRoles = this.accessRoles.map((role) => role.slug);
            if (userRoles.includes(MintAccessRole.SuperAdmin)) {
                admin = true;
            }
        }
        return admin;
    }
};
__decorate([
    Expose()
], MintExecutionRequest.prototype, "uid", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "isSystem", void 0);
__decorate([
    Expose(),
    Type(() => MintAppModel)
], MintExecutionRequest.prototype, "app", void 0);
__decorate([
    Expose(),
    Type(() => MintAppClientModel)
], MintExecutionRequest.prototype, "appClient", void 0);
__decorate([
    Expose(),
    Type(() => MintDeviceModel)
], MintExecutionRequest.prototype, "device", void 0);
__decorate([
    Expose(),
    Type(() => MintUserModel)
], MintExecutionRequest.prototype, "user", void 0);
__decorate([
    Expose(),
    Type(() => MintAccountModel)
], MintExecutionRequest.prototype, "account", void 0);
__decorate([
    Expose(),
    Type(() => MintAccessRoleModel)
], MintExecutionRequest.prototype, "accessRoles", void 0);
__decorate([
    Expose(),
    Type(() => MintAccessPrivModel)
], MintExecutionRequest.prototype, "accessPrivs", void 0);
__decorate([
    Expose(),
    Type(() => MintAccessPrivModel)
], MintExecutionRequest.prototype, "accessGuards", void 0);
__decorate([
    Expose(),
    Type(() => MintAuthTokenModel)
], MintExecutionRequest.prototype, "authToken", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "apiVersion", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "appVersion", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "appBuild", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "ipAddress", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "hostname", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "userAgent", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "contentType", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "osName", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "osVersion", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "referer", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "locales", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "fingerprintHash", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "coords", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "idempotencyKey", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestMethod", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestFullUrl", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestUrl", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestUrlPath", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestUrlQuery", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestUrlParams", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintExecutionRequest.prototype, "requestAt", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestLatency", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestPayload", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestPayloadSize", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "requestTransferRate", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintExecutionRequest.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    Type(() => Date)
], MintExecutionRequest.prototype, "updatedAt", void 0);
__decorate([
    Expose()
], MintExecutionRequest.prototype, "isSuperAdmin", null);
MintExecutionRequest = __decorate([
    Exclude()
], MintExecutionRequest);

const logger$14 = MintLogger.getLogger('MintExecutionRequestService');
class MintExecutionRequestService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintExecutionRequestModel, configService.getConfig().api.service?.executionRequest ??
            MintExecutionRequestModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByApp(app, options) {
        const filter = MintQueryFilter.from(options.filter);
        filter.addCondition({
            key: 'app.uid',
            operator: MintQueryOperator.Equals,
            value: typeof app === 'string' ? app : app.uid,
        });
        return this.find({
            ...options,
            filter: filter,
        });
    }
    async findByAppClient(appClient, options) {
        const filter = MintQueryFilter.from(options.filter);
        filter.addCondition({
            key: 'appClient.uid',
            operator: MintQueryOperator.Equals,
            value: typeof appClient === 'string' ? appClient : appClient.uid,
        });
        return this.find({
            ...options,
            filter: filter,
        });
    }
    // note this is `appClient.clientId`
    async findByAppClientId(clientId, options) {
        const filter = MintQueryFilter.from(options.filter);
        filter.addCondition({
            key: 'appClient.clientId',
            operator: MintQueryOperator.Equals,
            value: clientId,
        });
        return this.find({
            ...options,
            filter: filter,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintExecutionRequestService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintExecutionRequestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintExecutionRequestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

var MintAppType;
(function (MintAppType) {
    MintAppType["Internal"] = "internal";
    MintAppType["Partner"] = "partner";
    MintAppType["Public"] = "public";
})(MintAppType || (MintAppType = {}));
var MintAppStatus;
(function (MintAppStatus) {
    MintAppStatus["Enabled"] = "enabled";
    MintAppStatus["Disabled"] = "disabled";
    MintAppStatus["Deleted"] = "deleted";
})(MintAppStatus || (MintAppStatus = {}));
var MintAppClientStatus;
(function (MintAppClientStatus) {
    MintAppClientStatus["Enabled"] = "enabled";
    MintAppClientStatus["Disabled"] = "disabled";
    MintAppClientStatus["Deleted"] = "deleted";
})(MintAppClientStatus || (MintAppClientStatus = {}));
const MINT_SYSTEM_APP_UID = '_system';
const MINT_SYSTEM_APP_SLUG = 'system';
class MintCreateAppClientDto {
}

class MintAppContext {
    constructor(value) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

let MintAppSettingModel = class MintAppSettingModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppSettingModel)
], MintAppSettingModel.prototype, "parent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintAppSettingModel.prototype, "app", void 0);
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "env", void 0);
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "key", void 0);
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "description", void 0);
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "value", void 0);
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "isReadonly", void 0);
__decorate([
    MintProperty()
], MintAppSettingModel.prototype, "isSystem", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAppSettingModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAppSettingModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAppSettingModel.prototype, "_meta", void 0);
MintAppSettingModel = __decorate([
    MintResource('/app-settings')
], MintAppSettingModel);

const logger$13 = MintLogger.getLogger('MintAppSettingService');
class MintAppSettingService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintAppSettingModel, configService.getConfig().api.service?.appSetting ??
            MintAppSettingModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppSettingService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppSettingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppSettingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

class MintAppVersion {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}

const logger$12 = MintLogger.getLogger('MintAppClientService');
class MintAppClientService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintAppClientModel, configService.getConfig().api.service?.appClient ??
            MintAppClientModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    async createClient(model) {
        try {
            const apiPath = this.urlPath + '/create';
            const result = await this.httpService.post(apiPath, model);
            return this.toModel(result);
        }
        catch (err) {
            logger$12.error(err);
            throw err;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppClientService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppClientService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppClientService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

// import { MintCreateClientAppDto, MintCreateClientAppResponse } from "./mint-app.types";
const logger$11 = MintLogger.getLogger('MintAppService');
class MintAppService extends MintService {
    constructor(configService, httpService, cacheService, appClientService) {
        super(httpService, cacheService, MintAppModel, configService.getConfig().api.service?.app ??
            MintAppModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.appClientService = appClientService;
    }
    async createApp(model) {
        try {
            const apiPath = this.urlPath + '/create';
            const result = await this.httpService.post(apiPath, model);
            return {
                app: this.toModel(result.app),
                client: this.appClientService.toModel(result.client),
            };
        }
        catch (err) {
            logger$11.error(err);
            throw err;
        }
    }
    async fetchClients(app) {
        try {
            const apiPath = this.apiPath(app, 'clients');
            const result = await this.httpService.get(apiPath);
            return this.appClientService.toResultSet(result);
        }
        catch (err) {
            logger$11.error(err);
            throw err;
        }
    }
    async fetchSettings(app, env) {
        try {
            const query = env ? { env: env } : null;
            const apiPath = this.apiPath(app, 'settings', query);
            return await this.httpService.get(apiPath);
        }
        catch (err) {
            logger$11.debug('fetchSettings: error: ', err);
            throw new MintAuthException('Error fetching user settings', MintAuthErrorType.InternalError, err);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }, { token: MintAppClientService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAppService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }, { type: MintAppClientService }] });

let MintUserSignatureModel = class MintUserSignatureModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserSignatureModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserSignatureModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintUserSignatureModel.prototype, "file", void 0);
__decorate([
    MintProperty()
], MintUserSignatureModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintUserSignatureModel.prototype, "source", void 0);
__decorate([
    MintProperty()
], MintUserSignatureModel.prototype, "isDefault", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserSignatureModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserSignatureModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserSignatureModel.prototype, "_meta", void 0);
MintUserSignatureModel = __decorate([
    MintResource('/user-signatures')
], MintUserSignatureModel);

let MintESignatureModel = class MintESignatureModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintESignatureModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintESignatureModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintESignatureModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintESignatureModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintESignatureModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintESignatureModel.prototype, "originalFile", void 0);
__decorate([
    MintProperty()
], MintESignatureModel.prototype, "originalFileHash", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintESignatureModel.prototype, "signedFile", void 0);
__decorate([
    MintProperty()
], MintESignatureModel.prototype, "signedFileHash", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserSignatureModel)
], MintESignatureModel.prototype, "signature", void 0);
__decorate([
    MintProperty()
], MintESignatureModel.prototype, "signerFullName", void 0);
__decorate([
    MintProperty()
], MintESignatureModel.prototype, "signerTitle", void 0);
__decorate([
    MintProperty()
], MintESignatureModel.prototype, "signatureHash", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintESignatureModel.prototype, "signatureAt", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintESignatureModel.prototype, "tags", void 0);
__decorate([
    MintProperty()
], MintESignatureModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintESignatureModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintESignatureModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintESignatureModel.prototype, "_meta", void 0);
MintESignatureModel = __decorate([
    MintResource('/legal/e-signatures')
], MintESignatureModel);

let MintPolicyModel = class MintPolicyModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintPolicyModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintPolicyModel.prototype, "account", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "locale", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "title", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "contentText", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "contentHtml", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "contentHash", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "templateParams", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "version", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "isCurrent", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "isSignatureRequired", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPolicyModel.prototype, "publishedAt", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "templateValues", void 0);
__decorate([
    MintProperty()
], MintPolicyModel.prototype, "isRendered", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPolicyModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPolicyModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPolicyModel.prototype, "_meta", void 0);
MintPolicyModel = __decorate([
    MintResource('/legal/policies')
], MintPolicyModel);

var MintPolicy;
(function (MintPolicy) {
    MintPolicy["TermsOfUse"] = "terms-of-use";
    MintPolicy["PrivacyPolicy"] = "privacy-policy";
    MintPolicy["HippaPolicy"] = "hippa-policy";
    MintPolicy["ESignatureConsent"] = "e-signature-consent";
    MintPolicy["InformedConsent"] = "informed-consent";
})(MintPolicy || (MintPolicy = {}));

const logger$10 = MintLogger.getLogger('MintPolicyService');
class MintPolicyService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPolicyModel, configService.getConfig().api.service?.policy ??
            MintPolicyModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async getCurrent(app, account, policyType, locale = 'en-US', templateValues) {
        // const slug = typeof policy === 'string' ? policy : policy.slug;
        // clients/:uid/:type
        const urlPath = `${this.urlPath}/${policyType}/current`;
        const params = {
            app: typeof app === 'string' ? app : app.uid,
            account: typeof account === 'string' ? account : account.uid,
            locale: locale,
            templateValues: templateValues,
        };
        return await this.httpService.get(urlPath, {
            queryParams: params,
        });
    }
    async getTermsOfUse(app, account) {
        return this.getCurrent(app, account, MintPolicy.TermsOfUse);
    }
    async getPrivacyPolicy(app, account) {
        return this.getCurrent(app, account, MintPolicy.PrivacyPolicy);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPolicyService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPolicyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPolicyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintPolicyConsentModel = class MintPolicyConsentModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintPolicyConsentModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintPolicyConsentModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintPolicyConsentModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintPolicyConsentModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPolicyModel)
], MintPolicyConsentModel.prototype, "policy", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintPolicyConsentModel.prototype, "file", void 0);
__decorate([
    MintProperty(),
    Type(() => MintESignatureModel)
], MintPolicyConsentModel.prototype, "eSignature", void 0);
__decorate([
    MintProperty()
], MintPolicyConsentModel.prototype, "policyHash", void 0);
__decorate([
    MintProperty()
], MintPolicyConsentModel.prototype, "policyTemplateValues", void 0);
__decorate([
    MintProperty()
], MintPolicyConsentModel.prototype, "consentStatus", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPolicyConsentModel.prototype, "consentAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPolicyConsentModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPolicyConsentModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPolicyConsentModel.prototype, "_meta", void 0);
MintPolicyConsentModel = __decorate([
    MintResource('/legal/policy-consents')
], MintPolicyConsentModel);

var MintPolicyConsentStatus;
(function (MintPolicyConsentStatus) {
    MintPolicyConsentStatus["Granted"] = "granted";
    MintPolicyConsentStatus["NotGranted"] = "not-granted";
})(MintPolicyConsentStatus || (MintPolicyConsentStatus = {}));

var MintContactType;
(function (MintContactType) {
    MintContactType["Individual"] = "individual";
    MintContactType["Business"] = "business";
})(MintContactType || (MintContactType = {}));
var MintContactSource;
(function (MintContactSource) {
    MintContactSource["Manual"] = "manual";
    MintContactSource["Campaign"] = "campaign";
})(MintContactSource || (MintContactSource = {}));
var MintContactRelationship;
(function (MintContactRelationship) {
    MintContactRelationship["Acquaintance"] = "acquaintance";
    MintContactRelationship["Colleague"] = "colleague";
    MintContactRelationship["Prospect"] = "prospect";
    MintContactRelationship["Customer"] = "customer";
    MintContactRelationship["Partner"] = "partner";
    MintContactRelationship["Vendor"] = "vendor";
    MintContactRelationship["Staff"] = "staff";
    MintContactRelationship["Other"] = "other";
})(MintContactRelationship || (MintContactRelationship = {}));

let MintCampaignModel = class MintCampaignModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignModel.prototype, "goal", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignModel.prototype, "kpi", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintCampaignModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintCampaignModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCampaignModel.prototype, "conversionCount", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCampaignModel.prototype, "conversionTarget", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignModel.prototype, "startDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignModel.prototype, "endDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignModel.prototype, "_meta", void 0);
MintCampaignModel = __decorate([
    MintResource('/campaigns')
], MintCampaignModel);

let MintContactModel = class MintContactModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintContactModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintContactModel)
], MintContactModel.prototype, "parent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintContactModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintContactModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintContactModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintContactModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintContactModel.prototype, "photo", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintContactModel.prototype, "logo", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPlaceModel)
], MintContactModel.prototype, "place", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintContactModel.prototype, "refUser", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintContactModel.prototype, "refAccount", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintContactType)
], MintContactModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintContactSource)
], MintContactModel.prototype, "source", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintContactRelationship)
], MintContactModel.prototype, "relationship", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "prefix", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "firstName", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "middleName", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "maidenName", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "lastName", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "suffix", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "preferredName", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "businessName", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintProfileGender)
], MintContactModel.prototype, "gender", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintProfileRace)
], MintContactModel.prototype, "race", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintProfileMaritalStatus)
], MintContactModel.prototype, "maritalStatus", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintContactModel.prototype, "birthDate", void 0);
__decorate([
    MintProperty(),
    IsLocale()
], MintContactModel.prototype, "locale", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "timeZone", void 0);
__decorate([
    MintProperty(),
    IsEmail({ require_tld: false })
], MintContactModel.prototype, "primaryEmail", void 0);
__decorate([
    MintProperty(),
    IsPhoneNumber()
], MintContactModel.prototype, "primaryPhoneNumber", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPhoneType)
], MintContactModel.prototype, "primaryPhoneType", void 0);
__decorate([
    MintProperty(),
    IsUrl({ require_tld: false })
], MintContactModel.prototype, "webUrl", void 0);
__decorate([
    MintProperty(),
    IsArray()
], MintContactModel.prototype, "socialLinks", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintContactModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintContactModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintContactModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintContactModel.prototype, "invitedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintContactModel.prototype, "registeredAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintContactModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintContactModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintContactModel.prototype, "_meta", void 0);
MintContactModel = __decorate([
    MintResource('/contacts')
], MintContactModel);

const logger$$ = MintLogger.getLogger('MintInvitationService');
class MintContactService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintContactModel, configService.getConfig().api.service?.contact ??
            MintContactModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByOwner(owner) {
        const uid = typeof owner === 'string' ? owner : owner.uid;
        return this.findAllByProperty('owner', { uid: uid });
    }
    async createContact(email) {
        return await this.save(new MintContactModel({
            primaryEmail: email,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintContactService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintContactService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintContactService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintExecutionResponseModel = class MintExecutionResponseModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintExecutionResponseModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintExecutionResponseModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintExecutionResponseModel.prototype, "payloadFile", void 0);
__decorate([
    MintProperty()
], MintExecutionResponseModel.prototype, "payload", void 0);
__decorate([
    MintProperty()
], MintExecutionResponseModel.prototype, "payloadSize", void 0);
__decorate([
    MintProperty()
], MintExecutionResponseModel.prototype, "statusCode", void 0);
__decorate([
    MintProperty()
], MintExecutionResponseModel.prototype, "errors", void 0);
__decorate([
    MintProperty()
], MintExecutionResponseModel.prototype, "executionTime", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintExecutionResponseModel.prototype, "responseAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintExecutionResponseModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintExecutionResponseModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintExecutionResponseModel.prototype, "_meta", void 0);
MintExecutionResponseModel = __decorate([
    MintResource('/execution-responses')
], MintExecutionResponseModel);

const logger$_ = MintLogger.getLogger('MintExecutionResponseService');
class MintExecutionResponseService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintExecutionResponseModel, configService.getConfig().api.service?.executionResponse ??
            MintExecutionResponseModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByExecutionRequest(executionRequest) {
        return this.findOne(MintQueryFilter.from({
            key: 'executionRequest',
            operator: MintQueryOperator.Equals,
            value: typeof executionRequest === 'string'
                ? executionRequest
                : executionRequest.uid,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintExecutionResponseService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintExecutionResponseService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintExecutionResponseService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

var MintDeviceMotion_1;
// @dynamic
let MintDeviceMotion = MintDeviceMotion_1 = class MintDeviceMotion {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintDeviceMotion_1, model));
        }
    }
};
__decorate([
    Expose()
], MintDeviceMotion.prototype, "speed", void 0);
__decorate([
    Expose()
], MintDeviceMotion.prototype, "heading", void 0);
__decorate([
    Expose()
], MintDeviceMotion.prototype, "course", void 0);
__decorate([
    Expose()
], MintDeviceMotion.prototype, "acceleration", void 0);
__decorate([
    Expose()
], MintDeviceMotion.prototype, "rotationRate", void 0);
MintDeviceMotion = MintDeviceMotion_1 = __decorate([
    Exclude()
], MintDeviceMotion);

let MintPositionModel = class MintPositionModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintPositionModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintPositionModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintPositionModel.prototype, "device", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPlaceModel)
], MintPositionModel.prototype, "place", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "placeDwell", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "source", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "latitude", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "longitude", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "indoorFloor", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "horizontalAccuracy", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "altitude", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "altitudeAccuracy", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "heading", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "course", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "speed", void 0);
__decorate([
    MintProperty()
], MintPositionModel.prototype, "countryCode", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPositionModel.prototype, "positionAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPositionModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPositionModel.prototype, "updatedAt", void 0);
MintPositionModel = __decorate([
    MintResource('/positions')
], MintPositionModel);

var MintDeviceNetwork_1;
var MintDeviceNetworkType;
(function (MintDeviceNetworkType) {
    MintDeviceNetworkType["Wifi"] = "wifi";
    MintDeviceNetworkType["Cell4G"] = "cell-4g";
    MintDeviceNetworkType["Cell5G"] = "cell-5g";
    MintDeviceNetworkType["CellLTE"] = "cell-lte";
    MintDeviceNetworkType["CellOther"] = "cell-other";
})(MintDeviceNetworkType || (MintDeviceNetworkType = {}));
// @dynamic
let MintDeviceNetwork = MintDeviceNetwork_1 = class MintDeviceNetwork {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintDeviceNetwork_1, model));
        }
    }
};
__decorate([
    Expose()
], MintDeviceNetwork.prototype, "type", void 0);
__decorate([
    Expose()
], MintDeviceNetwork.prototype, "carrier", void 0);
__decorate([
    Expose()
], MintDeviceNetwork.prototype, "serviceProvider", void 0);
__decorate([
    Expose()
], MintDeviceNetwork.prototype, "ipv4", void 0);
__decorate([
    Expose()
], MintDeviceNetwork.prototype, "ipv6", void 0);
__decorate([
    Expose()
], MintDeviceNetwork.prototype, "wifiSsid", void 0);
__decorate([
    Expose()
], MintDeviceNetwork.prototype, "wifiBssid", void 0);
MintDeviceNetwork = MintDeviceNetwork_1 = __decorate([
    Exclude()
], MintDeviceNetwork);

var MintDeviceScanRecord_1;
let MintDeviceScanRecord = MintDeviceScanRecord_1 = class MintDeviceScanRecord {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintDeviceScanRecord_1, model));
        }
    }
};
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "deviceName", void 0);
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "advertiseFlags", void 0);
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "txPowerLevel", void 0);
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "bytes", void 0);
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "manufacturerSpecificData", void 0);
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "serviceData", void 0);
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "serviceSolicitationUuids", void 0);
__decorate([
    Expose()
], MintDeviceScanRecord.prototype, "serviceUuids", void 0);
MintDeviceScanRecord = MintDeviceScanRecord_1 = __decorate([
    Exclude()
], MintDeviceScanRecord);

let MintDevicePingModel = class MintDevicePingModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintDevicePingModel.prototype, "device", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintDevicePingModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintDevicePingModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPositionModel)
], MintDevicePingModel.prototype, "position", void 0);
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "isBackgroundMode", void 0);
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "battery", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceNetwork)
], MintDevicePingModel.prototype, "network", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceMotion)
], MintDevicePingModel.prototype, "motion", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceScanRecord)
], MintDevicePingModel.prototype, "scanRecord", void 0);
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "userAgent", void 0);
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "osName", void 0);
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "osVersion", void 0);
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "stateCode", void 0);
__decorate([
    MintProperty()
], MintDevicePingModel.prototype, "countryCode", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintDevicePingModel.prototype, "capturedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintDevicePingModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintDevicePingModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintDevicePingModel.prototype, "_meta", void 0);
MintDevicePingModel = __decorate([
    MintResource('/device-pings')
], MintDevicePingModel);

const logger$Z = MintLogger.getLogger('MintDeviceService');
class MintDeviceService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintDeviceModel, configService.getConfig().api.service?.device ??
            MintDeviceModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByAdvertiserId(advertiserId) {
        return this.findOneByProperty('advertiserId', advertiserId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDeviceService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDeviceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintDeviceService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

var MintDeviceStatus;
(function (MintDeviceStatus) {
    MintDeviceStatus["Enabled"] = "enabled";
    MintDeviceStatus["Disabled"] = "disabled";
    MintDeviceStatus["Deleted"] = "deleted";
})(MintDeviceStatus || (MintDeviceStatus = {}));
var MintDeviceOS;
(function (MintDeviceOS) {
    MintDeviceOS["iOS"] = "ios";
    MintDeviceOS["Android"] = "android";
})(MintDeviceOS || (MintDeviceOS = {}));
var MintDeviceType;
(function (MintDeviceType) {
    MintDeviceType["System"] = "system";
    MintDeviceType["Phone"] = "phone";
    MintDeviceType["Watch"] = "watch";
    MintDeviceType["Tablet"] = "tablet";
    MintDeviceType["Desktop"] = "desktop";
    MintDeviceType["Wearable"] = "wearable";
    MintDeviceType["Sensor"] = "sensor";
    MintDeviceType["Other"] = "other";
})(MintDeviceType || (MintDeviceType = {}));
var MintDeviceCapability;
(function (MintDeviceCapability) {
    MintDeviceCapability["BLE"] = "ble";
    MintDeviceCapability["RFID"] = "rfid";
    MintDeviceCapability["Wifi"] = "wifi";
    MintDeviceCapability["Cellular"] = "cellular";
    MintDeviceCapability["GPS"] = "gps";
    MintDeviceCapability["Camera"] = "camera";
    MintDeviceCapability["Audio"] = "AUDIO";
    MintDeviceCapability["Microphone"] = "MICROPHONE";
    MintDeviceCapability["Accelerometer"] = "ACCELEROMETER";
    MintDeviceCapability["Gyroscope"] = "GYROSCOPE";
})(MintDeviceCapability || (MintDeviceCapability = {}));

var MintDeviceFingerprint_1;
let MintDeviceFingerprint = MintDeviceFingerprint_1 = class MintDeviceFingerprint {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintDeviceFingerprint_1, model));
        }
    }
};
__decorate([
    Expose()
], MintDeviceFingerprint.prototype, "hash", void 0);
__decorate([
    Expose()
], MintDeviceFingerprint.prototype, "components", void 0);
MintDeviceFingerprint = MintDeviceFingerprint_1 = __decorate([
    Exclude()
], MintDeviceFingerprint);

var MintPaymentProcessor;
(function (MintPaymentProcessor) {
    MintPaymentProcessor["Stripe"] = "stripe";
})(MintPaymentProcessor || (MintPaymentProcessor = {}));

let MintPaymentProcessorModel = class MintPaymentProcessorModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintPaymentProcessorModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentProcessorModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentProcessorModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintPaymentProcessorModel.prototype, "isDefault", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPaymentProcessorModel.prototype, "transactionFlatFee", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPaymentProcessorModel.prototype, "transactionPercentFee", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPeriod)
], MintPaymentProcessorModel.prototype, "maxTransactionPeriod", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPaymentProcessorModel.prototype, "maxTransactionAmount", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintPaymentProcessorModel.prototype, "maxTransactionCount", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentProcessorModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintPaymentProcessorModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintPaymentProcessorModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPaymentProcessorModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPaymentProcessorModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPaymentProcessorModel.prototype, "_meta", void 0);
MintPaymentProcessorModel = __decorate([
    MintResource('/payment-processors')
], MintPaymentProcessorModel);

const logger$Y = MintLogger.getLogger('MintPaymentProcessorService');
class MintPaymentProcessorService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPaymentProcessorModel, configService.getConfig().api.service?.paymentProcessor ??
            MintPaymentProcessorModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentProcessorService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentProcessorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentProcessorService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

var MintPaymentAccountType;
(function (MintPaymentAccountType) {
    MintPaymentAccountType["CreditCard"] = "credit-card";
    MintPaymentAccountType["DebitCard"] = "debit-card";
    MintPaymentAccountType["PrepaidCard"] = "prepaid-card";
    MintPaymentAccountType["PayPal"] = "paypal";
    MintPaymentAccountType["Venmo"] = "venmo";
    MintPaymentAccountType["Zelle"] = "zelle";
    MintPaymentAccountType["PersonalChecking"] = "personal-checking";
    MintPaymentAccountType["PersonalSavings"] = "personal-savings";
    MintPaymentAccountType["BusinessChecking"] = "business-checking";
    MintPaymentAccountType["BusinessSavings"] = "business-savings";
    MintPaymentAccountType["CryptoCurrency"] = "crypto-currency";
    // used when payment account is initially created by the type is not yet known
    MintPaymentAccountType["Unknown"] = "unknown";
})(MintPaymentAccountType || (MintPaymentAccountType = {}));
var MintPaymentAccountCardBrand;
(function (MintPaymentAccountCardBrand) {
    MintPaymentAccountCardBrand["AmericanExpress"] = "american-express";
    MintPaymentAccountCardBrand["ChinaUnionPay"] = "china-union-pay";
    MintPaymentAccountCardBrand["Discover"] = "discover";
    MintPaymentAccountCardBrand["JapanCreditBureau"] = "japan-credit-bureau";
    MintPaymentAccountCardBrand["Mastercard"] = "mastercard";
    MintPaymentAccountCardBrand["Visa"] = "visa";
})(MintPaymentAccountCardBrand || (MintPaymentAccountCardBrand = {}));

let MintPaymentAccountModel = class MintPaymentAccountModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintPaymentAccountModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintPaymentAccountModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintPaymentAccountModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAddressModel)
], MintPaymentAccountModel.prototype, "accountAddress", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPaymentProcessorModel)
], MintPaymentAccountModel.prototype, "processor", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPaymentAccountType)
], MintPaymentAccountModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintPaymentAccountModel.prototype, "isDefault", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPeriod)
], MintPaymentAccountModel.prototype, "maxTransactionPeriod", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPaymentAccountModel.prototype, "maxTransactionAmount", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintPaymentAccountModel.prototype, "maxTransactionCount", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "processorCustomerId", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "cardId", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "cardFingerprint", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "cardLast4", void 0);
__decorate([
    MintProperty(),
    IsInt(),
    Min(1),
    Max(12)
], MintPaymentAccountModel.prototype, "cardExpMonth", void 0);
__decorate([
    MintProperty(),
    IsInt(),
    Min(new Date().getFullYear() - 5),
    Max(new Date().getFullYear() + 20)
], MintPaymentAccountModel.prototype, "cardExpYear", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "cardPostalCode", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPaymentAccountCardBrand)
], MintPaymentAccountModel.prototype, "cardBrand", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "routingNumber", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "accountNumber", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "accountHolder", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentAccountModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintPaymentAccountModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintPaymentAccountModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPaymentAccountModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPaymentAccountModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPaymentAccountModel.prototype, "_meta", void 0);
MintPaymentAccountModel = __decorate([
    MintResource('/payment-accounts')
], MintPaymentAccountModel);

class MintPaymentAccountSaveCardDto extends MintPaymentAccountModel {
    constructor(model) {
        super(model);
    }
}
__decorate([
    IsString(),
    IsOptional()
], MintPaymentAccountSaveCardDto.prototype, "cardTokenId", void 0);

const logger$X = MintLogger.getLogger('MintPaymentAccountService');
class MintPaymentAccountService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPaymentAccountModel, configService.getConfig().api.service?.paymentAccount ??
            MintPaymentAccountModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async patch(propertyPath, paymentAccount, urlPathVars, params) {
        return await super.patch(propertyPath, paymentAccount, urlPathVars, params);
    }
    async detachCard(paymentAccount) {
        const propertyPath = `detach-card`;
        paymentAccount = await super.patch(propertyPath, paymentAccount);
        return paymentAccount;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentAccountService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentAccountService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentAccountService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintCurrencyModel = class MintCurrencyModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCurrencyModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCurrencyModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCurrencyModel.prototype, "code", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCurrencyModel.prototype, "numericCode", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCurrencyModel.prototype, "minorUnit", void 0);
__decorate([
    MintProperty(),
    IsString({ each: true })
], MintCurrencyModel.prototype, "countries", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCurrencyModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCurrencyModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCurrencyModel.prototype, "_meta", void 0);
MintCurrencyModel = __decorate([
    MintResource('/currencies')
], MintCurrencyModel);

const logger$W = MintLogger.getLogger('MintCurrencyService');
class MintCurrencyService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintCurrencyModel, configService.getConfig().api.service?.currency ??
            MintCurrencyModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCurrencyService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCurrencyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCurrencyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

const MINT_DEFAULT_CURRENCY = 'USD';

let MintCampaignPartnerModel = class MintCampaignPartnerModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignPartnerModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignPartnerModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintContactModel)
], MintCampaignPartnerModel.prototype, "contact", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCampaignPartnerModel.prototype, "populationCount", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignPartnerModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignPartnerModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignPartnerModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignPartnerModel.prototype, "_meta", void 0);
MintCampaignPartnerModel = __decorate([
    MintResource('/campaign-partners')
], MintCampaignPartnerModel);

let MintCampaignSegmentModel = class MintCampaignSegmentModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignSegmentModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignSegmentModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignSegmentModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignSegmentModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignSegmentModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignPartnerModel)
], MintCampaignSegmentModel.prototype, "partner", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignSegmentModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignSegmentModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintCampaignSegmentModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintCampaignSegmentModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignSegmentModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCampaignSegmentModel.prototype, "conversionCount", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignSegmentModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignSegmentModel.prototype, "startDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignSegmentModel.prototype, "endDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignSegmentModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignSegmentModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignSegmentModel.prototype, "_meta", void 0);
MintCampaignSegmentModel = __decorate([
    MintResource('/campaign-segments')
], MintCampaignSegmentModel);

var MintCampaignChannelType;
(function (MintCampaignChannelType) {
    MintCampaignChannelType["Organic"] = "organic";
    MintCampaignChannelType["Affiliate"] = "affiliate";
    MintCampaignChannelType["BlogPost"] = "blog-post";
    MintCampaignChannelType["PressRelease"] = "press-release";
    MintCampaignChannelType["Email"] = "email";
    MintCampaignChannelType["SMS"] = "sms";
    MintCampaignChannelType["GoogleAdwords"] = "google-adwords";
    MintCampaignChannelType["TikTok"] = "tiktok";
    MintCampaignChannelType["Facebook"] = "facebook";
    MintCampaignChannelType["Instagram"] = "instagram";
    MintCampaignChannelType["Twitter"] = "twitter";
    MintCampaignChannelType["LinkedIn"] = "linkedin";
    MintCampaignChannelType["SnapChat"] = "snapchat";
    MintCampaignChannelType["Pinterest"] = "pinterest";
    MintCampaignChannelType["YouTube"] = "youtube";
    MintCampaignChannelType["BannerAd"] = "banner-ad";
    MintCampaignChannelType["SocialDeal"] = "social-deal";
    MintCampaignChannelType["Other"] = "other";
})(MintCampaignChannelType || (MintCampaignChannelType = {}));
var MintCampaignChannelStrategy;
(function (MintCampaignChannelStrategy) {
    MintCampaignChannelStrategy["Random"] = "random";
    MintCampaignChannelStrategy["RoundRobin"] = "round-robin";
    MintCampaignChannelStrategy["MaxViews"] = "max-views";
    MintCampaignChannelStrategy["MaxConversions"] = "max-conversions";
})(MintCampaignChannelStrategy || (MintCampaignChannelStrategy = {}));

let MintCampaignChannelModel = class MintCampaignChannelModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignChannelModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignChannelModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignChannelModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignChannelModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignChannelModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignSegmentModel)
], MintCampaignChannelModel.prototype, "segment", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintCampaignChannelType)
], MintCampaignChannelModel.prototype, "channelType", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintCampaignChannelStrategy)
], MintCampaignChannelModel.prototype, "targetStrategy", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintCampaignChannelStrategy)
], MintCampaignChannelModel.prototype, "replyStrategy", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignChannelModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignChannelModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignChannelModel.prototype, "adwordsKeywords", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignChannelModel.prototype, "smsNumber", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignChannelModel.prototype, "smsKeyword", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignChannelModel.prototype, "promoCode", void 0);
__decorate([
    MintProperty(),
    IsUrl()
], MintCampaignChannelModel.prototype, "shortUrl", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCampaignChannelModel.prototype, "conversionCount", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignChannelModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignChannelModel.prototype, "isReplyEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignChannelModel.prototype, "startDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignChannelModel.prototype, "endDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignChannelModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignChannelModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignChannelModel.prototype, "_meta", void 0);
MintCampaignChannelModel = __decorate([
    MintResource('/campaign-channels')
], MintCampaignChannelModel);

var MintCartStatus;
(function (MintCartStatus) {
    MintCartStatus["Active"] = "active";
    MintCartStatus["Expired"] = "expired";
    MintCartStatus["Canceled"] = "canceled";
    MintCartStatus["Invoiced"] = "invoiced";
})(MintCartStatus || (MintCartStatus = {}));

let MintCartModel = class MintCartModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCartModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCartModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCartModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCartModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintCartModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintCartModel.prototype, "campaignChannel", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintCartStatus)
], MintCartModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCartModel.prototype, "itemCount", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCartModel.prototype, "currencyCode", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartModel.prototype, "subtotal", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartModel.prototype, "discount", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartModel.prototype, "tax", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartModel.prototype, "shipping", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartModel.prototype, "total", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartModel.prototype, "invoicedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartModel.prototype, "expiredAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartModel.prototype, "canceledAt", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintCartModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintCartModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCartModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCartModel.prototype, "_meta", void 0);
MintCartModel = __decorate([
    MintResource('/carts')
], MintCartModel);

const logger$V = MintLogger.getLogger('MintCartService');
class MintCartService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCartModel, configService.getConfig().api.service?.cart ??
            MintCartModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintProductModel = class MintProductModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintProductModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintProductModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintProductModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintProductModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintProductModel.prototype, "isSubscription", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintProductModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintProductModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintProductModel.prototype, "_meta", void 0);
MintProductModel = __decorate([
    MintResource('/products')
], MintProductModel);

let MintProductSkuModel = class MintProductSkuModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintProductSkuModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintProductSkuModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintProductSkuModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductModel)
], MintProductSkuModel.prototype, "product", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductSkuModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductSkuModel.prototype, "sku", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintProductSkuModel.prototype, "variant", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintProductSkuModel.prototype, "displayOrder", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductSkuModel.prototype, "currencyCode", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintProductSkuModel.prototype, "price", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintProductSkuModel.prototype, "setupFee", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintProductSkuModel.prototype, "trialDays", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintProductSkuModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintProductSkuModel.prototype, "isSubscription", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPeriod)
], MintProductSkuModel.prototype, "subscriptionPeriod", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintProductSkuModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintProductSkuModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductSkuModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductSkuModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductSkuModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintProductSkuModel.prototype, "_meta", void 0);
MintProductSkuModel = __decorate([
    MintResource('/product-skus')
], MintProductSkuModel);

let MintPromoModel = class MintPromoModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintPromoModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintPromoModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintPromoModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPromoModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPromoModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintPromoModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoModel.prototype, "startAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoModel.prototype, "endAt", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintPromoModel.prototype, "useCount", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintPromoModel.prototype, "maxUseCount", void 0);
__decorate([
    MintProperty(),
    IsNumber(),
    Min(0),
    Max(1)
], MintPromoModel.prototype, "discountPercent", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPromoModel.prototype, "discountAmount", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPromoModel.prototype, "setupFee", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintPromoModel.prototype, "trialDays", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintPromoModel.prototype, "subscriptionDays", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPromoModel.prototype, "validationRule", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintPromoModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintPromoModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPromoModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPromoModel.prototype, "_meta", void 0);
MintPromoModel = __decorate([
    MintResource('/promos')
], MintPromoModel);

let MintCartItemModel = class MintCartItemModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCartItemModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCartModel)
], MintCartItemModel.prototype, "cart", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductSkuModel)
], MintCartItemModel.prototype, "productSku", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPromoModel)
], MintCartItemModel.prototype, "promo", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintCartItemModel.prototype, "campaignChannel", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCartItemModel.prototype, "quantity", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCartItemModel.prototype, "currencyCode", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartItemModel.prototype, "unitPrice", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartItemModel.prototype, "setupFee", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartItemModel.prototype, "subtotal", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartItemModel.prototype, "discount", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCartItemModel.prototype, "total", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCartItemModel.prototype, "isSubscription", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPeriod)
], MintCartItemModel.prototype, "subscriptionPeriod", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintCartItemModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintCartItemModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCartItemModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCartItemModel.prototype, "discountDescription", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartItemModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartItemModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCartItemModel.prototype, "_meta", void 0);
MintCartItemModel = __decorate([
    MintResource('/cart-items')
], MintCartItemModel);

const logger$U = MintLogger.getLogger('MintCartItemService');
class MintCartItemService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCartItemModel, configService.getConfig().api.service?.cartItem ??
            MintCartItemModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartItemService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartItemService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartItemService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintCartPromoModel = class MintCartPromoModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCartPromoModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCartModel)
], MintCartPromoModel.prototype, "cart", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPromoModel)
], MintCartPromoModel.prototype, "promo", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCartPromoModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCartPromoModel.prototype, "discountDescription", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartPromoModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCartPromoModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCartPromoModel.prototype, "_meta", void 0);
MintCartPromoModel = __decorate([
    MintResource('/cart-promos')
], MintCartPromoModel);

const logger$T = MintLogger.getLogger('MintCartPromoService');
class MintCartPromoService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCartPromoModel, configService.getConfig().api.service?.cartPromo ??
            MintCartPromoModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartPromoService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartPromoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCartPromoService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

class MintCartWithItemsDto extends MintCartModel {
    constructor(item) {
        super(item);
    }
}
__decorate([
    MintProperty(),
    Type(() => MintCartItemModel)
], MintCartWithItemsDto.prototype, "items", void 0);

const logger$S = MintLogger.getLogger('MintProductSkuService');
class MintProductSkuService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintProductSkuModel, configService.getConfig().api.service?.productSku ??
            MintProductSkuModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductSkuService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductSkuService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductSkuService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintProductTaxonomyModel = class MintProductTaxonomyModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintProductTaxonomyModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintProductTaxonomyModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintProductTaxonomyModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductTaxonomyModel)
], MintProductTaxonomyModel.prototype, "parent", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductTaxonomyModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductTaxonomyModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintProductTaxonomyModel.prototype, "level", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintProductTaxonomyModel.prototype, "displayOrder", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintProductTaxonomyModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintProductTaxonomyModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintProductTaxonomyModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductTaxonomyModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductTaxonomyModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintProductTaxonomyModel.prototype, "_meta", void 0);
MintProductTaxonomyModel = __decorate([
    MintResource('/product-taxonomies')
], MintProductTaxonomyModel);

let MintProductTaxonomyProductModel = class MintProductTaxonomyProductModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintProductTaxonomyProductModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductModel)
], MintProductTaxonomyProductModel.prototype, "product", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductTaxonomyModel)
], MintProductTaxonomyProductModel.prototype, "taxonomy", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintProductTaxonomyProductModel.prototype, "isPrimary", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductTaxonomyProductModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintProductTaxonomyProductModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintProductTaxonomyProductModel.prototype, "_meta", void 0);
MintProductTaxonomyProductModel = __decorate([
    MintResource('/product-taxonomy-products')
], MintProductTaxonomyProductModel);

const logger$R = MintLogger.getLogger('MintProductTaxonomyProductService');
class MintProductTaxonomyProductService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintProductTaxonomyProductModel, configService.getConfig().api.service?.productTaxonomyProduct ??
            MintProductTaxonomyProductModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductTaxonomyProductService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductTaxonomyProductService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductTaxonomyProductService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$Q = MintLogger.getLogger('MintProductTaxonomyService');
class MintProductTaxonomyService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintProductTaxonomyModel, configService.getConfig().api.service?.productTaxonomy ??
            MintProductTaxonomyModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductTaxonomyService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductTaxonomyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductTaxonomyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$P = MintLogger.getLogger('MintProductService');
class MintProductService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintProductModel, configService.getConfig().api.service?.product ??
            MintProductModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintProductService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintPromoTaxonomyModel = class MintPromoTaxonomyModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintPromoTaxonomyModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPromoModel)
], MintPromoTaxonomyModel.prototype, "promo", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductTaxonomyModel)
], MintPromoTaxonomyModel.prototype, "taxonomy", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintPromoTaxonomyModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoTaxonomyModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoTaxonomyModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPromoTaxonomyModel.prototype, "_meta", void 0);
MintPromoTaxonomyModel = __decorate([
    MintResource('/promo-taxonomies')
], MintPromoTaxonomyModel);

const logger$O = MintLogger.getLogger('MintPromoTaxonomyService');
class MintPromoTaxonomyService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPromoTaxonomyModel, configService.getConfig().api.service?.promoTaxonomy ??
            MintPromoTaxonomyModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoTaxonomyService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoTaxonomyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoTaxonomyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintPromoCodeModel = class MintPromoCodeModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintPromoCodeModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPromoModel)
], MintPromoCodeModel.prototype, "promo", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPromoCodeModel.prototype, "promoCode", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintPromoCodeModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoCodeModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoCodeModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPromoCodeModel.prototype, "_meta", void 0);
MintPromoCodeModel = __decorate([
    MintResource('/promo-codes')
], MintPromoCodeModel);

const logger$N = MintLogger.getLogger('MintPromoCodeService');
class MintPromoCodeService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPromoCodeModel, configService.getConfig().api.service?.promoCode ??
            MintPromoCodeModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoCodeService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoCodeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoCodeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintPromoProductModel = class MintPromoProductModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintPromoProductModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPromoModel)
], MintPromoProductModel.prototype, "promo", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductModel)
], MintPromoProductModel.prototype, "product", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductSkuModel)
], MintPromoProductModel.prototype, "productSku", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintPromoProductModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoProductModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPromoProductModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPromoProductModel.prototype, "_meta", void 0);
MintPromoProductModel = __decorate([
    MintResource('/promo-products')
], MintPromoProductModel);

const logger$M = MintLogger.getLogger('MintPromoProductService');
class MintPromoProductService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPromoProductModel, configService.getConfig().api.service?.promoProduct ??
            MintPromoProductModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoProductService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoProductService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoProductService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$L = MintLogger.getLogger('MintPromoService');
class MintPromoService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPromoModel, configService.getConfig().api.service?.promo ??
            MintPromoModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPromoService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

var MintInvoiceNoteVisibility;
(function (MintInvoiceNoteVisibility) {
    MintInvoiceNoteVisibility["Public"] = "public";
    MintInvoiceNoteVisibility["Private"] = "private";
})(MintInvoiceNoteVisibility || (MintInvoiceNoteVisibility = {}));
var MintInvoiceStatus;
(function (MintInvoiceStatus) {
    MintInvoiceStatus["Draft"] = "draft";
    MintInvoiceStatus["Open"] = "open";
    MintInvoiceStatus["Uncollectible"] = "uncollectible";
    MintInvoiceStatus["Delinquent"] = "delinquent";
    MintInvoiceStatus["Paid"] = "paid";
    MintInvoiceStatus["Closed"] = "closed";
    MintInvoiceStatus["Void"] = "void";
})(MintInvoiceStatus || (MintInvoiceStatus = {}));

let MintInvoiceModel = class MintInvoiceModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintInvoiceModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintInvoiceModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintInvoiceModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintInvoiceModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCartModel)
], MintInvoiceModel.prototype, "cart", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPaymentProcessorModel)
], MintInvoiceModel.prototype, "processor", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintInvoiceModel.prototype, "processorInvoiceId", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintInvoiceModel.prototype, "invoiceNumber", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintInvoiceStatus)
], MintInvoiceModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintInvoiceModel.prototype, "currencyCode", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintInvoiceModel.prototype, "currentBalance", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintInvoiceModel.prototype, "amountDue", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintInvoiceModel.prototype, "amountPaid", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "draftedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "openedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "dueAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "paidAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "closedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "voidedAt", void 0);
__decorate([
    MintProperty(),
    IsArray()
], MintInvoiceModel.prototype, "notes", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintInvoiceModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintInvoiceModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoiceModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintInvoiceModel.prototype, "_meta", void 0);
MintInvoiceModel = __decorate([
    MintResource('/invoices')
], MintInvoiceModel);

var MintPaymentType;
(function (MintPaymentType) {
    MintPaymentType["Charge"] = "charge";
    MintPaymentType["Refund"] = "refund";
})(MintPaymentType || (MintPaymentType = {}));
var MintPaymentMethod;
(function (MintPaymentMethod) {
    MintPaymentMethod["Cash"] = "cash";
    MintPaymentMethod["Check"] = "check";
    MintPaymentMethod["Card"] = "card";
    MintPaymentMethod["Wire"] = "wire";
    MintPaymentMethod["ACH"] = "ach";
    MintPaymentMethod["PayPal"] = "paypal";
    MintPaymentMethod["Credit"] = "credit";
    MintPaymentMethod["Promo"] = "promo";
    MintPaymentMethod["AppleAppStore"] = "apple-app-store";
    MintPaymentMethod["GoogleAppStore"] = "google-app-store";
    MintPaymentMethod["Partner"] = "partner";
    MintPaymentMethod["External"] = "external";
    MintPaymentMethod["Other"] = "other";
})(MintPaymentMethod || (MintPaymentMethod = {}));
var MintPaymentStatus;
(function (MintPaymentStatus) {
    MintPaymentStatus["Success"] = "success";
    MintPaymentStatus["AuthorizationPending"] = "authorization-pending";
    MintPaymentStatus["AuthorizationDenied"] = "authorization-denied";
    MintPaymentStatus["AuthorizationExpired"] = "authorization-expired";
    MintPaymentStatus["AuthorizationError"] = "authorization-error";
    MintPaymentStatus["CardInvalidNumber"] = "card-invalid-number";
    MintPaymentStatus["CardInvalidMonth"] = "card-invalid-month";
    MintPaymentStatus["CardInvalidYear"] = "card-invalid-year";
    MintPaymentStatus["CardInvalidCVC"] = "card-invalid-cvc";
    MintPaymentStatus["CardInvalidAddress"] = "card-invalid-address";
    MintPaymentStatus["CardInvalidZip"] = "card-invalid-zip";
    MintPaymentStatus["CardExpired"] = "card-expired";
    MintPaymentStatus["CardDeclined"] = "card-declined";
    MintPaymentStatus["CardMissing"] = "card-missing";
    MintPaymentStatus["AccountInvalid"] = "account-invalid";
    MintPaymentStatus["AccountDisabled"] = "account-disabled";
    MintPaymentStatus["AmountInvalid"] = "amount-invalid";
    MintPaymentStatus["InsufficientFunds"] = "insufficient-funds";
    MintPaymentStatus["ProcessorError"] = "processor-error";
    MintPaymentStatus["SystemError"] = "system-error";
})(MintPaymentStatus || (MintPaymentStatus = {}));

let MintPaymentModel = class MintPaymentModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintPaymentModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintPaymentModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintPaymentModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintPaymentModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintInvoiceModel)
], MintPaymentModel.prototype, "invoice", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPaymentAccountModel)
], MintPaymentModel.prototype, "paymentAccount", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintPaymentModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPaymentProcessorModel)
], MintPaymentModel.prototype, "processor", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintPaymentModel.prototype, "receipt", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPaymentType)
], MintPaymentModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPaymentMethod)
], MintPaymentModel.prototype, "method", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPaymentStatus)
], MintPaymentModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentModel.prototype, "currencyCode", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPaymentModel.prototype, "amount", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintPaymentModel.prototype, "processorRef", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintPaymentModel.prototype, "processorResponse", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintPaymentModel.prototype, "processorFee", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPaymentModel.prototype, "processedAt", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintPaymentModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsArray()
], MintPaymentModel.prototype, "errors", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintPaymentModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPaymentModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintPaymentModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintPaymentModel.prototype, "_meta", void 0);
MintPaymentModel = __decorate([
    MintResource('/payments')
], MintPaymentModel);

let MintSubscriptionModel = class MintSubscriptionModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintSubscriptionModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintSubscriptionModel)
], MintSubscriptionModel.prototype, "parent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintSubscriptionModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintSubscriptionModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintSubscriptionModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductModel)
], MintSubscriptionModel.prototype, "product", void 0);
__decorate([
    MintProperty(),
    Type(() => MintProductSkuModel)
], MintSubscriptionModel.prototype, "productSku", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPromoModel)
], MintSubscriptionModel.prototype, "promo", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignPartnerModel)
], MintSubscriptionModel.prototype, "partner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintSubscriptionModel.prototype, "campaignChannel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintInvoiceModel)
], MintSubscriptionModel.prototype, "invoice", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPaymentModel)
], MintSubscriptionModel.prototype, "payment", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPaymentMethod)
], MintSubscriptionModel.prototype, "paymentMethod", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintSubscriptionModel.prototype, "kind", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintSubscriptionModel.prototype, "quantity", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintSubscriptionModel.prototype, "isAutoRenewEnabled", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintSubscriptionModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintSubscriptionModel.prototype, "startAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintSubscriptionModel.prototype, "endAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintSubscriptionModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintSubscriptionModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintSubscriptionModel.prototype, "_meta", void 0);
MintSubscriptionModel = __decorate([
    MintResource('/subscriptions')
], MintSubscriptionModel);

const logger$K = MintLogger.getLogger('MintSubscriptionService');
class MintSubscriptionService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintSubscriptionModel, configService.getConfig().api.service?.subscription ??
            MintSubscriptionModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSubscriptionService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSubscriptionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintSubscriptionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$J = MintLogger.getLogger('MintPaymentService');
class MintPaymentService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPaymentModel, configService.getConfig().api.service?.payment ??
            MintPaymentModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPaymentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

class MintInvoiceNote {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintInvoiceNote, model));
        }
    }
}
__decorate([
    IsString()
], MintInvoiceNote.prototype, "note", void 0);
__decorate([
    IsEnum(MintInvoiceNoteVisibility)
], MintInvoiceNote.prototype, "visibility", void 0);
__decorate([
    Type(() => MintUserModel)
], MintInvoiceNote.prototype, "createdBy", void 0);
__decorate([
    Type(() => Date)
], MintInvoiceNote.prototype, "createdAt", void 0);

const logger$I = MintLogger.getLogger('MintInvoiceService');
class MintInvoiceService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintInvoiceModel, configService.getConfig().api.service?.invoice ??
            MintInvoiceModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvoiceService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvoiceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvoiceService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintInvoicePaymentModel = class MintInvoicePaymentModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintInvoicePaymentModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintInvoiceModel)
], MintInvoicePaymentModel.prototype, "invoice", void 0);
__decorate([
    MintProperty(),
    Type(() => MintPaymentModel)
], MintInvoicePaymentModel.prototype, "payment", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintInvoiceStatus)
], MintInvoicePaymentModel.prototype, "invoiceStatus", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintPaymentStatus)
], MintInvoicePaymentModel.prototype, "paymentStatus", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintInvoicePaymentModel.prototype, "currencyCode", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintInvoicePaymentModel.prototype, "startingBalance", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintInvoicePaymentModel.prototype, "amountDue", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintInvoicePaymentModel.prototype, "amountPaid", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintInvoicePaymentModel.prototype, "amountRemaining", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoicePaymentModel.prototype, "paidAt", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintInvoicePaymentModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintInvoicePaymentModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoicePaymentModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvoicePaymentModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintInvoicePaymentModel.prototype, "_meta", void 0);
MintInvoicePaymentModel = __decorate([
    MintResource('/invoice-payments')
], MintInvoicePaymentModel);

const logger$H = MintLogger.getLogger('MintInvoicePaymentService');
class MintInvoicePaymentService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintInvoicePaymentModel, configService.getConfig().api.service?.invoicePayment ??
            MintInvoicePaymentModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvoicePaymentService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvoicePaymentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvoicePaymentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintHelpdeskMessageModel = class MintHelpdeskMessageModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintHelpdeskMessageModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintHelpdeskMessageModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintHelpdeskMessageModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintHelpdeskMessageModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "firstName", void 0);
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "lastName", void 0);
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "email", void 0);
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "mobileNumber", void 0);
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "message", void 0);
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "error", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintHelpdeskMessageModel.prototype, "tags", void 0);
__decorate([
    MintProperty()
], MintHelpdeskMessageModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintHelpdeskMessageModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintHelpdeskMessageModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintHelpdeskMessageModel.prototype, "_meta", void 0);
MintHelpdeskMessageModel = __decorate([
    MintResource('/helpdesk/messages')
], MintHelpdeskMessageModel);

const logger$G = MintLogger.getLogger('MintHelpdeskMessageService');
class MintHelpdeskMessageService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintHelpdeskMessageModel, configService.getConfig().api.service?.helpdeskMessage ??
            MintHelpdeskMessageModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHelpdeskMessageService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHelpdeskMessageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintHelpdeskMessageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$F = MintLogger.getLogger('MintCoreModule');
const COMPONENTS = [MintAclDirective];
const MODULES = [
    MintCommonModule,
    RouterModule,
    MintInputTextModule,
    MintToggleModule,
    NzIconModule,
    NzAlertModule,
    NzNotificationModule,
    NzButtonModule,
    NzDividerModule,
    NzGridModule,
];
function socialAuthServiceConfig(config) {
    const autoLogin = config.getBoolean('auth.sso.autoLogin', false);
    const googleClientId = config.getString('auth.sso.google.clientId');
    const facebookClientId = config.getString('auth.sso.facebook.clientId');
    const azureClientId = config.getString('auth.sso.azure.clientId');
    const providers = [];
    if (googleClientId) {
        providers.push({
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(googleClientId),
        });
    }
    if (facebookClientId) {
        providers.push({
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(facebookClientId),
        });
    }
    if (azureClientId) {
        const azureOptions = config.getObject('auth.sso.azure.options');
        providers.push({
            id: MintAzureLoginProvider.PROVIDER_ID,
            provider: new MintAzureLoginProvider(azureClientId, azureOptions),
        });
    }
    return {
        autoLogin: autoLogin,
        providers: providers,
        onError: (error) => {
            logger$F.error('Error configuring social login providers: ', error);
        },
    };
}
class MintCoreModule {
    static forRoot(aclOptions) {
        return {
            ngModule: MintCoreModule,
            providers: [
                {
                    provide: MINT_ACL_SERVICE_OPTIONS,
                    useValue: aclOptions,
                },
                {
                    provide: 'SocialAuthServiceConfig',
                    useFactory: socialAuthServiceConfig,
                    deps: [MintConfigService],
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: MintAuthInterceptor,
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintCoreModule, declarations: [MintAclDirective], imports: [MintCommonModule,
            RouterModule,
            MintInputTextModule,
            MintToggleModule,
            NzIconModule,
            NzAlertModule,
            NzNotificationModule,
            NzButtonModule,
            NzDividerModule,
            NzGridModule], exports: [MintCommonModule,
            RouterModule,
            MintInputTextModule,
            MintToggleModule,
            NzIconModule,
            NzAlertModule,
            NzNotificationModule,
            NzButtonModule,
            NzDividerModule,
            NzGridModule, MintAclDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCoreModule, imports: [MODULES, MintCommonModule,
            RouterModule,
            MintInputTextModule,
            MintToggleModule,
            NzIconModule,
            NzAlertModule,
            NzNotificationModule,
            NzButtonModule,
            NzDividerModule,
            NzGridModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES],
                    declarations: [...COMPONENTS],
                    exports: [...MODULES, ...COMPONENTS],
                }]
        }] });

// @dynamic
let MintApiEventModel = class MintApiEventModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintApiEventModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintApiEventModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintApiEventModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintApiEventModel.prototype, "isTest", void 0);
__decorate([
    MintProperty()
], MintApiEventModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Transform(mintTagModelTransformer)
], MintApiEventModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiEventModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiEventModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintApiEventModel.prototype, "_meta", void 0);
MintApiEventModel = __decorate([
    MintResource('/api-events')
], MintApiEventModel);

// @dynamic
let MintApiModel = class MintApiModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintApiModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintApiModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintApiModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintApiModel.prototype, "isTest", void 0);
__decorate([
    MintProperty()
], MintApiModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Transform(mintTagModelTransformer)
], MintApiModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintApiModel.prototype, "_meta", void 0);
MintApiModel = __decorate([
    MintResource('/apis')
], MintApiModel);

// @dynamic
let MintWebhookModel = class MintWebhookModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintWebhookModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintWebhookModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintWebhookModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintWebhookModel.prototype, "owner", void 0);
__decorate([
    MintProperty()
], MintWebhookModel.prototype, "url", void 0);
__decorate([
    MintProperty()
], MintWebhookModel.prototype, "secret", void 0);
__decorate([
    MintProperty()
], MintWebhookModel.prototype, "status", void 0);
__decorate([
    MintProperty()
], MintWebhookModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Transform(mintTagModelTransformer)
], MintWebhookModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintWebhookModel.prototype, "_meta", void 0);
MintWebhookModel = __decorate([
    MintResource('/webhooks')
], MintWebhookModel);

const MINT_DEFAULT_WEBHOOK_SIGNATURE_HEADER_KEY = 'Mint-Webhook-Signature';
const MINT_DEFAULT_WEBHOOK_USER_AGENT = 'Mint/1.0';
var MintWebhookStatus;
(function (MintWebhookStatus) {
    MintWebhookStatus["Enabled"] = "enabled";
    // disabled by user
    MintWebhookStatus["Disabled"] = "disabled";
    // received error when attempting delivery to endpoint but system will retry
    MintWebhookStatus["InError"] = "in-error";
    // deactivated by system -- max retries have been reached
    MintWebhookStatus["Deactivated"] = "deactivated";
})(MintWebhookStatus || (MintWebhookStatus = {}));
var MintWebhookEventStatus;
(function (MintWebhookEventStatus) {
    // Request is queued
    MintWebhookEventStatus["Queued"] = "queued";
    // A queued request was canceled because the webhook was deactivated
    MintWebhookEventStatus["Canceled"] = "canceled";
    // A queued request was delayed because webhook is in-error
    MintWebhookEventStatus["Pending"] = "pending";
    // Webhook is attempting delivery
    MintWebhookEventStatus["Sending"] = "sending";
    // Webhook succeeded (received 200 from client)
    MintWebhookEventStatus["Success"] = "success";
    // Webhook received client error and will make another attempt
    MintWebhookEventStatus["Error"] = "error";
    // Max attempts have been made
    MintWebhookEventStatus["Failed"] = "failed";
})(MintWebhookEventStatus || (MintWebhookEventStatus = {}));

const logger$E = MintLogger.getLogger('MintWebhookPayload');
class MintWebhookPayload {
    constructor(model, clazz) {
        if (model) {
            Object.assign(this, plainToInstance(MintWebhookPayload, model));
            if (clazz) {
                this.data = plainToInstance(clazz, model.data);
            }
        }
    }
}
__decorate([
    Expose(),
    IsString(),
    IsDefined()
], MintWebhookPayload.prototype, "uid", void 0);
__decorate([
    Expose(),
    IsDefined(),
    IsString()
], MintWebhookPayload.prototype, "apiEvent", void 0);
__decorate([
    Expose(),
    IsDate(),
    IsDefined(),
    Type(() => Date)
], MintWebhookPayload.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    IsString(),
    IsDefined()
], MintWebhookPayload.prototype, "accountId", void 0);
__decorate([
    Expose(),
    IsString(),
    IsDefined()
], MintWebhookPayload.prototype, "appId", void 0);
__decorate([
    Expose(),
    IsString(),
    IsDefined()
], MintWebhookPayload.prototype, "appClientId", void 0);
__decorate([
    Expose(),
    IsString(),
    IsDefined()
], MintWebhookPayload.prototype, "webhookUrl", void 0);
__decorate([
    Expose(),
    IsObject(),
    IsDefined()
], MintWebhookPayload.prototype, "data", void 0);

// @dynamic
let MintWebhookEventModel = class MintWebhookEventModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintWebhookEventModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintWebhookModel)
], MintWebhookEventModel.prototype, "webhook", void 0);
__decorate([
    MintProperty(),
    Type(() => MintApiModel)
], MintWebhookEventModel.prototype, "api", void 0);
__decorate([
    MintProperty(),
    Type(() => MintApiEventModel)
], MintWebhookEventModel.prototype, "apiEvent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintWebhookEventModel.prototype, "apiRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionResponseModel)
], MintWebhookEventModel.prototype, "apiResponse", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintWebhookEventModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintWebhookEventModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintWebhookEventModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppClientModel)
], MintWebhookEventModel.prototype, "appClient", void 0);
__decorate([
    MintProperty(),
    Type(() => MintWebhookPayload)
], MintWebhookEventModel.prototype, "payload", void 0);
__decorate([
    MintProperty()
], MintWebhookEventModel.prototype, "payloadHash", void 0);
__decorate([
    MintProperty()
], MintWebhookEventModel.prototype, "attemptCount", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintWebhookEventStatus)
], MintWebhookEventModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookEventModel.prototype, "firstAttemptedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookEventModel.prototype, "lastAttemptedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookEventModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookEventModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintWebhookEventModel.prototype, "_meta", void 0);
MintWebhookEventModel = __decorate([
    MintResource('/webhook-events')
], MintWebhookEventModel);

const logger$D = MintLogger.getLogger('MintWebhookEventService');
class MintWebhookEventService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintWebhookEventModel, configService.getConfig().api.service?.webhookEvent ??
            MintWebhookEventModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookEventService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookEventService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookEventService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

// @dynamic
let MintWebhookLogModel = class MintWebhookLogModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintWebhookLogModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintWebhookEventModel)
], MintWebhookLogModel.prototype, "webhookEvent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintApiModel)
], MintWebhookLogModel.prototype, "api", void 0);
__decorate([
    MintProperty(),
    Type(() => MintApiEventModel)
], MintWebhookLogModel.prototype, "apiEvent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintWebhookLogModel.prototype, "apiRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionResponseModel)
], MintWebhookLogModel.prototype, "apiResponse", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintWebhookLogModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintWebhookLogModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintWebhookLogModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppClientModel)
], MintWebhookLogModel.prototype, "appClient", void 0);
__decorate([
    MintProperty()
], MintWebhookLogModel.prototype, "attemptCount", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookLogModel.prototype, "attemptedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookLogModel.prototype, "responseAt", void 0);
__decorate([
    MintProperty()
], MintWebhookLogModel.prototype, "responseStatus", void 0);
__decorate([
    MintProperty()
], MintWebhookLogModel.prototype, "responseError", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintWebhookEventStatus)
], MintWebhookLogModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintWebhookLogModel.prototype, "ipAddress", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintWebhookLogModel.prototype, "httpMethod", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintWebhookLogModel.prototype, "userAgent", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintWebhookLogModel.prototype, "contentType", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookLogModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookLogModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintWebhookLogModel.prototype, "_meta", void 0);
MintWebhookLogModel = __decorate([
    MintResource('/webhook-logs')
], MintWebhookLogModel);

const logger$C = MintLogger.getLogger('MintWebhookLogService');
class MintWebhookLogService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintWebhookLogModel, configService.getConfig().api.service?.webhookLog ??
            MintWebhookLogModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookLogService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookLogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookLogService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

const logger$B = MintLogger.getLogger('MintWebhookService');
class MintWebhookService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintWebhookModel, configService.getConfig().api.service?.webhook ??
            MintWebhookModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    async test(webhook) {
        const status = await this.httpService.post(this.urlPath + '/' + webhook.uid + '/test', {});
        return status;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

var MintWebhookClientStatus;
(function (MintWebhookClientStatus) {
    MintWebhookClientStatus["Enabled"] = "enabled";
    MintWebhookClientStatus["Disabled"] = "disabled";
})(MintWebhookClientStatus || (MintWebhookClientStatus = {}));

// @dynamic
let MintWebhookClientModel = class MintWebhookClientModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintWebhookClientModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintWebhookModel)
], MintWebhookClientModel.prototype, "webhook", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppClientModel)
], MintWebhookClientModel.prototype, "appClient", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintWebhookClientStatus)
], MintWebhookClientModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookClientModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookClientModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintWebhookClientModel.prototype, "_meta", void 0);
MintWebhookClientModel = __decorate([
    MintResource('/webhook-clients')
], MintWebhookClientModel);

const logger$A = MintLogger.getLogger('MintWebhookClientService');
class MintWebhookClientService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintWebhookClientModel, configService.getConfig().api.service?.webhookClient ??
            MintWebhookClientModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    async findByWebhook(webhook) {
        return this.findAll(MintQueryFilter.from([
            {
                key: 'webhook.uid',
                operator: MintQueryOperator.Equals,
                value: typeof webhook === 'string' ? webhook : webhook.uid,
            },
        ]));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookClientService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookClientService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookClientService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

// @dynamic
let MintWebhookSubscriptionModel = class MintWebhookSubscriptionModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintWebhookSubscriptionModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintWebhookSubscriptionModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintApiModel)
], MintWebhookSubscriptionModel.prototype, "api", void 0);
__decorate([
    MintProperty(),
    Type(() => MintApiEventModel)
], MintWebhookSubscriptionModel.prototype, "apiEvent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintWebhookModel)
], MintWebhookSubscriptionModel.prototype, "webhook", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookSubscriptionModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintWebhookSubscriptionModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintWebhookSubscriptionModel.prototype, "_meta", void 0);
MintWebhookSubscriptionModel = __decorate([
    MintResource('/webhook-subscriptions')
], MintWebhookSubscriptionModel);

const logger$z = MintLogger.getLogger('MintWebhookSubscriptionService');
class MintWebhookSubscriptionService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintWebhookSubscriptionModel, configService.getConfig().api.service?.webhookSubscription ??
            MintWebhookSubscriptionModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookSubscriptionService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookSubscriptionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintWebhookSubscriptionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

// @dynamic
let MintApiLogModel = class MintApiLogModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintApiLogModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintApiModel)
], MintApiLogModel.prototype, "api", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintApiLogModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintApiLogModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintApiLogModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppClientModel)
], MintApiLogModel.prototype, "appClient", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintApiLogModel.prototype, "request", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionResponseModel)
], MintApiLogModel.prototype, "response", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiLogModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiLogModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintApiLogModel.prototype, "_meta", void 0);
MintApiLogModel = __decorate([
    MintResource('/api-logs')
], MintApiLogModel);

const logger$y = MintLogger.getLogger('MintApiService');
class MintApiLogService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintApiLogModel, configService.getConfig().api.service?.apiLog ??
            MintApiLogModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiLogService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiLogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiLogService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

const logger$x = MintLogger.getLogger('MintApiService');
class MintApiEventService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintApiEventModel, configService.getConfig().api.service?.apiEvent ??
            MintApiEventModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiEventService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiEventService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiEventService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

const logger$w = MintLogger.getLogger('MintApiService');
class MintApiService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintApiModel, configService.getConfig().api.service?.api ??
            MintApiModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

var MintApiVersionModel_1;
var MintApiVersionStatus;
(function (MintApiVersionStatus) {
    MintApiVersionStatus["Enabled"] = "enabled";
    MintApiVersionStatus["Disabled"] = "disabled";
    MintApiVersionStatus["Deprecated"] = "deprecated";
})(MintApiVersionStatus || (MintApiVersionStatus = {}));
let MintApiVersionModel = MintApiVersionModel_1 = class MintApiVersionModel extends MintModel {
    constructor(model) {
        super(model);
    }
    get name() {
        return MintApiVersionModel_1.versionName(this);
    }
    static versionName(model) {
        let version = `${model.major}.${model.minor}.${model.patch}`;
        if (model.preRelease) {
            version += '-' + model.preRelease;
        }
        return version;
    }
};
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "major", void 0);
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "minor", void 0);
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "patch", void 0);
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "preRelease", void 0);
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "status", void 0);
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "releaseNotes", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiVersionModel.prototype, "releasedDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiVersionModel.prototype, "deprecatedDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiVersionModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintApiVersionModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty()
], MintApiVersionModel.prototype, "name", null);
MintApiVersionModel = MintApiVersionModel_1 = __decorate([
    MintResource('/api-versions')
], MintApiVersionModel);

const logger$v = MintLogger.getLogger('MintApiService');
class MintApiVersionService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintApiVersionModel, configService.getConfig().api.service?.apiVersion ??
            MintApiVersionModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiVersionService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiVersionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintApiVersionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

var MintAddressType;
(function (MintAddressType) {
    MintAddressType["Residential"] = "residential";
    MintAddressType["Commercial"] = "commercial";
    MintAddressType["POBox"] = "po-box";
    MintAddressType["Rural"] = "rural";
    MintAddressType["Military"] = "military";
    MintAddressType["Mailbox"] = "mailbox";
    MintAddressType["Virtual"] = "virtual";
    MintAddressType["Other"] = "other";
})(MintAddressType || (MintAddressType = {}));
var MintAddressOwnership;
(function (MintAddressOwnership) {
    MintAddressOwnership["Rent"] = "rent";
    MintAddressOwnership["Own"] = "own";
    MintAddressOwnership["LivingRentFree"] = "living-rent-free";
})(MintAddressOwnership || (MintAddressOwnership = {}));
var MintAddressUse;
(function (MintAddressUse) {
    MintAddressUse["PrimaryResidence"] = "primary-residence";
    MintAddressUse["SecondaryResidence"] = "secondary-residence";
    MintAddressUse["InvestmentProperty"] = "investment-property";
    MintAddressUse["Business"] = "business-use";
    MintAddressUse["Other"] = "other";
})(MintAddressUse || (MintAddressUse = {}));

const logger$u = MintLogger.getLogger('MintAddressService');
class MintAddressService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintAddressModel, configService.getConfig().api.service?.address ??
            MintAddressModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAddressService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAddressService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAddressService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

class MintCountryToCodePipe {
    constructor(countryService) {
        this.countryService = countryService;
    }
    transform(countryName) {
        return this.countryService.getCountryCode(countryName);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCountryToCodePipe, deps: [{ token: MintCountryService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintCountryToCodePipe, name: "mintCountryToCode" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCountryToCodePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintCountryToCode' }]
        }], ctorParameters: () => [{ type: MintCountryService }] });

class MintCountryToNamePipe {
    constructor(countryService) {
        this.countryService = countryService;
    }
    transform(countryCode) {
        return this.countryService.getCountryName(countryCode);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCountryToNamePipe, deps: [{ token: MintCountryService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintCountryToNamePipe, name: "mintCountryToName" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCountryToNamePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'mintCountryToName' }]
        }], ctorParameters: () => [{ type: MintCountryService }] });

const PIPES = [MintCountryToNamePipe, MintCountryToCodePipe];
class MintGeoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintGeoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.8", ngImport: i0, type: MintGeoModule, declarations: [MintCountryToNamePipe, MintCountryToCodePipe], exports: [MintCountryToNamePipe, MintCountryToCodePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintGeoModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintGeoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...PIPES],
                    exports: [...PIPES],
                }]
        }] });

const stateCodeFormOptions = [
    { name: 'Alabama', value: 'AL' },
    { name: 'Alaska', value: 'AK' },
    { name: 'American Samoa', value: 'AS' },
    { name: 'Arizona', value: 'AZ' },
    { name: 'Arkansas', value: 'AR' },
    { name: 'California', value: 'CA' },
    { name: 'Colorado', value: 'CO' },
    { name: 'Connecticut', value: 'CT' },
    { name: 'Delaware', value: 'DE' },
    { name: 'District of Columbia', value: 'DC' },
    { name: 'Florida', value: 'FL' },
    { name: 'Georgia', value: 'GA' },
    { name: 'Guam', value: 'GU' },
    { name: 'Hawaii', value: 'HI' },
    { name: 'Idaho', value: 'ID' },
    { name: 'Illinois', value: 'IL' },
    { name: 'Indiana', value: 'IN' },
    { name: 'Iowa', value: 'IA' },
    { name: 'Kansas', value: 'KS' },
    { name: 'Kentucky', value: 'KY' },
    { name: 'Louisiana', value: 'LA' },
    { name: 'Maine', value: 'ME' },
    { name: 'Maryland', value: 'MD' },
    { name: 'Massachusetts', value: 'MA' },
    { name: 'Michigan', value: 'MI' },
    { name: 'Minnesota', value: 'MN' },
    { name: 'Mississippi', value: 'MS' },
    { name: 'Missouri', value: 'MO' },
    { name: 'Montana', value: 'MT' },
    { name: 'Nebraska', value: 'NE' },
    { name: 'Nevada', value: 'NV' },
    { name: 'New Hampshire', value: 'NH' },
    { name: 'New Jersey', value: 'NJ' },
    { name: 'New Mexico', value: 'NM' },
    { name: 'New York', value: 'NY' },
    { name: 'North Carolina', value: 'NC' },
    { name: 'North Dakota', value: 'ND' },
    { name: 'Ohio', value: 'OH' },
    { name: 'Oklahoma', value: 'OK' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Pennsylvania', value: 'PA' },
    { name: 'Puerto Rico', value: 'PR' },
    { name: 'Rhode Island', value: 'RI' },
    { name: 'South Carolina', value: 'SC' },
    { name: 'South Dakota', value: 'SD' },
    { name: 'Tennessee', value: 'TN' },
    { name: 'Texas', value: 'TX' },
    { name: 'Utah', value: 'UT' },
    { name: 'Vermont', value: 'VT' },
    { name: 'Virgin Islands', value: 'VI' },
    { name: 'Virginia', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'West Virginia', value: 'WV' },
    { name: 'Wisconsin', value: 'WI' },
    { name: 'Wyoming', value: 'WY' },
];

const logger$t = MintLogger.getLogger('MintGeocoderService');
class MintPlaceService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintPlaceModel, configService.getConfig().api.service?.place ?? 'places');
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async autocomplete(addressString) {
        return this.httpService.post(`${this.urlPath}/autocomplete`, {
            address: addressString,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlaceService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlaceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintPlaceService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

class MintCoordinates {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}

var MintPositionSource;
(function (MintPositionSource) {
    MintPositionSource["GPS"] = "gps";
    MintPositionSource["AccessPoint"] = "access-point";
    MintPositionSource["IPAddress"] = "ip-address";
    MintPositionSource["Beacon"] = "beacon";
    MintPositionSource["Mixed"] = "mixed";
    MintPositionSource["Unknown"] = "unknown";
})(MintPositionSource || (MintPositionSource = {}));
class MintPosition extends MintCoordinates {
    constructor(model) {
        super(model);
    }
}

const countryGroups = [
    {
        name: 'latam',
        description: 'Latin America',
        countryList: [
            'BZ',
            'CR',
            'SV',
            'GT',
            'HN',
            'MX',
            'NI',
            'PA',
            'AR',
            'BO',
            'BR',
            'CL',
            'CO',
            'EC',
            'GF',
            'GY',
            'PY',
            'PE',
            'SR',
            'UY',
            'VE',
            'CU',
            'DO',
            'HT',
            'GP',
            'MQ',
            'PR',
            'BL',
            'MF',
        ],
    },
];
const countryList = [
    {
        name: 'United States',
        isoCode: 'US',
        callingCode: '+1',
        flag: '🇺🇸',
    },
];
const mintCountryMap = {
    AF: 'Afghanistan',
    AX: 'Aland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua And Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia And Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: `Cote D'Ivoire`,
    HR: 'Croatia',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island & Mcdonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic Of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle Of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KR: 'Korea',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: `Lao People's Democratic Republic`,
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States Of',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    AN: 'Netherlands Antilles',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory, Occupied',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts And Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre And Miquelon',
    VC: 'Saint Vincent And Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome And Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia And Sandwich Isl.',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard And Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad And Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks And Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Viet Nam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis And Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};

// http://country.io/phone.json
const mintCountryCodePhoneMap = {
    BD: '880',
    BE: '32',
    BF: '226',
    BG: '359',
    BA: '387',
    BB: '1-246',
    WF: '681',
    BL: '590',
    BM: '1-441',
    BN: '673',
    BO: '591',
    BH: '973',
    BI: '257',
    BJ: '229',
    BT: '975',
    JM: '1-876',
    BV: '',
    BW: '267',
    WS: '685',
    BQ: '599',
    BR: '55',
    BS: '1-242',
    JE: '44-1534',
    BY: '375',
    BZ: '501',
    RU: '7',
    RW: '250',
    RS: '381',
    TL: '670',
    RE: '262',
    TM: '993',
    TJ: '992',
    RO: '40',
    TK: '690',
    GW: '245',
    GU: '1-671',
    GT: '502',
    GS: '',
    GR: '30',
    GQ: '240',
    GP: '590',
    JP: '81',
    GY: '592',
    GG: '44-1481',
    GF: '594',
    GE: '995',
    GD: '1-473',
    GB: '44',
    GA: '241',
    SV: '503',
    GN: '224',
    GM: '220',
    GL: '299',
    GI: '350',
    GH: '233',
    OM: '968',
    TN: '216',
    JO: '962',
    HR: '385',
    HT: '509',
    HU: '36',
    HK: '852',
    HN: '504',
    HM: ' ',
    VE: '58',
    PR: ['1-787', '1-939'],
    PS: '970',
    PW: '680',
    PT: '351',
    SJ: '47',
    PY: '595',
    IQ: '964',
    PA: '507',
    PF: '689',
    PG: '675',
    PE: '51',
    PK: '92',
    PH: '63',
    PN: '870',
    PL: '48',
    PM: '508',
    ZM: '260',
    EH: '212',
    EE: '372',
    EG: '20',
    ZA: '27',
    EC: '593',
    IT: '39',
    VN: '84',
    SB: '677',
    ET: '251',
    SO: '252',
    ZW: '263',
    SA: '966',
    ES: '34',
    ER: '291',
    ME: '382',
    MD: '373',
    MG: '261',
    MF: '590',
    MA: '212',
    MC: '377',
    UZ: '998',
    MM: '95',
    ML: '223',
    MO: '853',
    MN: '976',
    MH: '692',
    MK: '389',
    MU: '230',
    MT: '356',
    MW: '265',
    MV: '960',
    MQ: '596',
    MP: '1-670',
    MS: '1-664',
    MR: '222',
    IM: '44-1624',
    UG: '256',
    TZ: '255',
    MY: '60',
    MX: '52',
    IL: '972',
    FR: '33',
    IO: '246',
    SH: '290',
    FI: '358',
    FJ: '679',
    FK: '500',
    FM: '691',
    FO: '298',
    NI: '505',
    NL: '31',
    NO: '47',
    NA: '264',
    VU: '678',
    NC: '687',
    NE: '227',
    NF: '672',
    NG: '234',
    NZ: '64',
    NP: '977',
    NR: '674',
    NU: '683',
    CK: '682',
    XK: '',
    CI: '225',
    CH: '41',
    CO: '57',
    CN: '86',
    CM: '237',
    CL: '56',
    CC: '61',
    CA: '1',
    CG: '242',
    CF: '236',
    CD: '243',
    CZ: '420',
    CY: '357',
    CX: '61',
    CR: '506',
    CW: '599',
    CV: '238',
    CU: '53',
    SZ: '268',
    SY: '963',
    SX: '599',
    KG: '996',
    KE: '254',
    SS: '211',
    SR: '597',
    KI: '686',
    KH: '855',
    KN: '1-869',
    KM: '269',
    ST: '239',
    SK: '421',
    KR: '82',
    SI: '386',
    KP: '850',
    KW: '965',
    SN: '221',
    SM: '378',
    SL: '232',
    SC: '248',
    KZ: '7',
    KY: '1-345',
    SG: '65',
    SE: '46',
    SD: '249',
    DO: ['1-809', '1-829'],
    DM: '1-767',
    DJ: '253',
    DK: '45',
    VG: '1-284',
    DE: '49',
    YE: '967',
    DZ: '213',
    US: '1',
    UY: '598',
    YT: '262',
    UM: '1',
    LB: '961',
    LC: '1-758',
    LA: '856',
    TV: '688',
    TW: '886',
    TT: '1-868',
    TR: '90',
    LK: '94',
    LI: '423',
    LV: '371',
    TO: '676',
    LT: '370',
    LU: '352',
    LR: '231',
    LS: '266',
    TH: '66',
    TF: '',
    TG: '228',
    TD: '235',
    TC: '1-649',
    LY: '218',
    VA: '379',
    VC: '1-784',
    AE: '971',
    AD: '376',
    AG: '1-268',
    AF: '93',
    AI: '1-264',
    VI: '1-340',
    IS: '354',
    IR: '98',
    AM: '374',
    AL: '355',
    AO: '244',
    AQ: '',
    AS: '1-684',
    AR: '54',
    AU: '61',
    AT: '43',
    AW: '297',
    IN: '91',
    AX: '358-18',
    AZ: '994',
    IE: '353',
    ID: '62',
    UA: '380',
    QA: '974',
    MZ: '258',
};

// https://github.com/OpenBookPrices/country-data
class MintCountry {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}

let MintAppMigrationModel = class MintAppMigrationModel extends MintModel {
    constructor(value) {
        super(value);
    }
};
__decorate([
    MintProperty()
], MintAppMigrationModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAppMigrationModel.prototype, "versionMajor", void 0);
__decorate([
    MintProperty()
], MintAppMigrationModel.prototype, "versionMinor", void 0);
__decorate([
    MintProperty()
], MintAppMigrationModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAppMigrationModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAppMigrationModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAppMigrationModel.prototype, "_meta", void 0);
MintAppMigrationModel = __decorate([
    MintResource('/app-migrations')
], MintAppMigrationModel);

let MintBatchResultModel = class MintBatchResultModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintBatchResultModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintBatchResultModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintBatchResultModel.prototype, "user", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "processName", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintBatchResultModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintBatchResultModel.prototype, "context", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "description", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "batchMeta", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "batchCount", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "successCount", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "errorCount", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "isStopOnErrorEnabled", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "isTransaction", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "result", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "errors", void 0);
__decorate([
    MintProperty()
], MintBatchResultModel.prototype, "runTimeMs", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintBatchResultModel.prototype, "startedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintBatchResultModel.prototype, "endedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintBatchResultModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintBatchResultModel.prototype, "updatedAt", void 0);
MintBatchResultModel = __decorate([
    MintResource('/batch-results')
], MintBatchResultModel);

var MintInvitationType;
(function (MintInvitationType) {
    MintInvitationType["Referral"] = "referral";
    MintInvitationType["Account"] = "account";
    MintInvitationType["Friend"] = "friend";
})(MintInvitationType || (MintInvitationType = {}));
var MintInvitationStatus;
(function (MintInvitationStatus) {
    MintInvitationStatus["Pending"] = "pending";
    MintInvitationStatus["Revoked"] = "revoked";
    MintInvitationStatus["Accepted"] = "accepted";
    MintInvitationStatus["Declined"] = "declined";
    MintInvitationStatus["Ignore"] = "ignored";
})(MintInvitationStatus || (MintInvitationStatus = {}));
var MintInvitationChannel;
(function (MintInvitationChannel) {
    MintInvitationChannel["InApp"] = "in-app";
    MintInvitationChannel["Email"] = "email";
    MintInvitationChannel["Sms"] = "sms";
    MintInvitationChannel["Push"] = "push";
})(MintInvitationChannel || (MintInvitationChannel = {}));
var MintInvitationEventType;
(function (MintInvitationEventType) {
    MintInvitationEventType["Created"] = "created";
    MintInvitationEventType["Sent"] = "sent";
    MintInvitationEventType["Resent"] = "resent";
    MintInvitationEventType["Revoked"] = "revoked";
    MintInvitationEventType["Expired"] = "expired";
    MintInvitationEventType["Viewed"] = "viewed";
    MintInvitationEventType["Ignored"] = "ignored";
    MintInvitationEventType["Rejected"] = "rejected";
    MintInvitationEventType["Accepted"] = "accepted";
    MintInvitationEventType["Registered"] = "registered";
})(MintInvitationEventType || (MintInvitationEventType = {}));

let MintInvitationModel = class MintInvitationModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintInvitationModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintInvitationModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintInvitationModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintInvitationModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintContactModel)
], MintInvitationModel.prototype, "toContact", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintInvitationModel.prototype, "toUser", void 0);
__decorate([
    MintProperty()
], MintInvitationModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintInvitationModel.prototype, "channel", void 0);
__decorate([
    MintProperty()
], MintInvitationModel.prototype, "status", void 0);
__decorate([
    MintProperty()
], MintInvitationModel.prototype, "invitationCode", void 0);
__decorate([
    MintProperty()
], MintInvitationModel.prototype, "message", void 0);
__decorate([
    MintProperty()
], MintInvitationModel.prototype, "invitedCount", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "invitedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "resentAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "revokedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "viewedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "ignoredAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "acceptedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "registeredAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintInvitationModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintInvitationModel.prototype, "_meta", void 0);
MintInvitationModel = __decorate([
    MintResource('/invitations')
], MintInvitationModel);

const logger$s = MintLogger.getLogger('MintInvitationService');
class MintInvitationService extends MintService {
    constructor(httpService, cacheService, configService, contactService) {
        super(httpService, cacheService, MintInvitationModel, configService.getConfig().api.service?.invitation ??
            MintInvitationModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
        this.contactService = contactService;
    }
    async findByCode(invitationCode) {
        return this.findOneByProperty('invitationCode', invitationCode);
    }
    async findByOwner(owner) {
        const uid = typeof owner === 'string' ? owner : owner.uid;
        return this.findAllByProperty('owner', { uid: uid });
    }
    async addAccountMember(owner, email, firstName, lastName) {
        const toContact = await this.contactService.save({
            owner,
            firstName,
            lastName,
        });
        const invitation = new MintInvitationModel({
            owner: owner,
            toContact: toContact,
            channel: MintInvitationChannel.Email,
            type: MintInvitationType.Account,
        });
        return super.save(invitation);
    }
    async resend(invitation) {
        await this.clearCache();
        const urlPath = `${this.urlPath}/${invitation.uid}/resend`;
        const tmp = await this.httpService.patch(urlPath, null);
        return this.toModel(tmp);
    }
    async revoke(invitation) {
        await this.clearCache();
        const urlPath = `${this.urlPath}/${invitation.uid}/revoke`;
        const tmp = await this.httpService.patch(urlPath, null);
        return this.toModel(tmp);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvitationService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }, { token: MintContactService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvitationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintInvitationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }, { type: MintContactService }] });

var MintAccountType;
(function (MintAccountType) {
    MintAccountType["System"] = "system";
    MintAccountType["User"] = "user";
    MintAccountType["Business"] = "business";
})(MintAccountType || (MintAccountType = {}));
var MintAccountStatus;
(function (MintAccountStatus) {
    MintAccountStatus["Enabled"] = "enabled";
    MintAccountStatus["Disabled"] = "disabled";
    MintAccountStatus["Deleted"] = "deleted";
})(MintAccountStatus || (MintAccountStatus = {}));

let MintMessageAddressModel = class MintMessageAddressModel extends MintModel {
    constructor(value) {
        super(value);
    }
};
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "uid", void 0);
__decorate([
    Type(() => MintUserModel)
], MintMessageAddressModel.prototype, "user", void 0);
__decorate([
    Type(() => MintAddressModel)
], MintMessageAddressModel.prototype, "address", void 0);
__decorate([
    Type(() => MintDeviceModel)
], MintMessageAddressModel.prototype, "device", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "deviceAdvertiserId", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "devicePlatform", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "firstName", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "lastName", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "gender", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "birthDate", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "companyName", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "companyTitle", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "mobileNumber", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "email", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "isEmailRole", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "isEmailDisposable", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "emailDeliverability", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "emailRisk", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "emailRiskReason", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "emailAlternatives", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "emailRootAddress", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintMessageAddressModel.prototype, "tags", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "source", void 0);
__decorate([
    MintProperty()
], MintMessageAddressModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "scrubbedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "validatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "confirmedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "optedInAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "optedOutAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "bouncedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "complainedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageAddressModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintMessageAddressModel.prototype, "_meta", void 0);
MintMessageAddressModel = __decorate([
    MintResource('/message-addresses')
], MintMessageAddressModel);

let MintMessageTemplateModel = class MintMessageTemplateModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintMessageTemplateModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintMessageTemplateModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintMessageTemplateModel.prototype, "owner", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "header", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "footer", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "category", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "description", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "subject", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "contentText", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "contentHtml", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "params", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintMessageTemplateModel.prototype, "tags", void 0);
__decorate([
    MintProperty()
], MintMessageTemplateModel.prototype, "isSystem", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageTemplateModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageTemplateModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintMessageTemplateModel.prototype, "_meta", void 0);
MintMessageTemplateModel = __decorate([
    MintResource('/message-templates')
], MintMessageTemplateModel);

// @dynamic
let MintMessageContentModel = class MintMessageContentModel extends MintModel {
    constructor(value) {
        super(value);
    }
};
__decorate([
    MintProperty()
], MintMessageContentModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintMessageContentModel.prototype, "messageThreadUid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageTemplateModel)
], MintMessageContentModel.prototype, "template", void 0);
__decorate([
    MintProperty()
], MintMessageContentModel.prototype, "templateValues", void 0);
__decorate([
    MintProperty()
], MintMessageContentModel.prototype, "contentText", void 0);
__decorate([
    MintProperty()
], MintMessageContentModel.prototype, "contentHtml", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageContentModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageContentModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintMessageContentModel.prototype, "_meta", void 0);
MintMessageContentModel = __decorate([
    MintResource('/message-contents')
], MintMessageContentModel);

let MintMessageListModel = class MintMessageListModel extends MintModel {
    constructor(value) {
        super(value);
    }
};
__decorate([
    MintProperty()
], MintMessageListModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintMessageListModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintMessageListModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintMessageListModel.prototype, "owner", void 0);
__decorate([
    MintProperty()
], MintMessageListModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintMessageListModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintMessageListModel.prototype, "utm", void 0);
__decorate([
    MintProperty()
], MintMessageListModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageListModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageListModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintMessageListModel.prototype, "_meta", void 0);
MintMessageListModel = __decorate([
    MintResource('/message-lists')
], MintMessageListModel);

const MINT_MESSAGE_APP_TAG_KEY = 'mint-app';
const MINT_MESSAGE_ENV_TAG_KEY = 'mint-env';
var MintMessageAddressDeliverability;
(function (MintMessageAddressDeliverability) {
    MintMessageAddressDeliverability["Deliverable"] = "deliverable";
    MintMessageAddressDeliverability["Undeliverable"] = "undeliverable";
    MintMessageAddressDeliverability["DoNotSend"] = "do-not-send";
    MintMessageAddressDeliverability["CatchAll"] = "catch-all";
    MintMessageAddressDeliverability["Unknown"] = "unknown";
})(MintMessageAddressDeliverability || (MintMessageAddressDeliverability = {}));
var MintMessageAddressRisk;
(function (MintMessageAddressRisk) {
    MintMessageAddressRisk["Low"] = "low";
    MintMessageAddressRisk["Medium"] = "medium";
    MintMessageAddressRisk["High"] = "high";
    MintMessageAddressRisk["Unknown"] = "unknown";
})(MintMessageAddressRisk || (MintMessageAddressRisk = {}));
var MintMessageType;
(function (MintMessageType) {
    MintMessageType["Email"] = "email";
    MintMessageType["Sms"] = "sms";
    MintMessageType["Push"] = "push";
})(MintMessageType || (MintMessageType = {}));
var MintMessageToType;
(function (MintMessageToType) {
    MintMessageToType["To"] = "to";
    MintMessageToType["Cc"] = "cc";
    MintMessageToType["Bcc"] = "bcc";
})(MintMessageToType || (MintMessageToType = {}));
// These statuses track closely with event types
var MintMessageStatus;
(function (MintMessageStatus) {
    MintMessageStatus["Created"] = "created";
    MintMessageStatus["Accepted"] = "accepted";
    MintMessageStatus["Queued"] = "queued";
    MintMessageStatus["Sending"] = "sending";
    MintMessageStatus["Sent"] = "sent";
    MintMessageStatus["Failed"] = "failed";
    MintMessageStatus["Rejected"] = "rejected";
    MintMessageStatus["Delivered"] = "delivered";
    MintMessageStatus["Undelivered"] = "undelivered";
    MintMessageStatus["Receiving"] = "receiving";
    MintMessageStatus["Received"] = "received";
    MintMessageStatus["Delayed"] = "delayed";
    MintMessageStatus["Bounced"] = "bounced";
})(MintMessageStatus || (MintMessageStatus = {}));
// based largely on a mix of AWS SES and Twilio statuses:
// https://www.twilio.com/docs/sms/api/message-resource#message-status-values
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/ses/latest/dg/event-publishing-retrieving-sns-contents.html#event-publishing-retrieving-sns-contents-failure-object
var MintMessageEventType;
(function (MintMessageEventType) {
    // Message locally created but not yet sent to provider for delivery
    MintMessageEventType["Created"] = "created";
    // Provider has received your API request to send a message
    MintMessageEventType["Accepted"] = "accepted";
    // Message was not sent by provider due to an issue with the message itself
    // - same as 'Failed' event in Twilio
    // - in AWS this means a failure to render a template
    MintMessageEventType["Failed"] = "failed";
    // Message was not sent by provider due to an issue with the message content
    // - in AWS, occurs when the message contains a virus
    MintMessageEventType["Rejected"] = "rejected";
    // Provider accepted message and queued it internally to send out
    MintMessageEventType["Queued"] = "queued";
    // Provider is in the process of dispatching message
    MintMessageEventType["Sending"] = "sending";
    // Message was accepted by receiving party
    MintMessageEventType["Sent"] = "sent";
    // Message was delivered to recipient
    MintMessageEventType["Delivered"] = "delivered";
    // Temporary delay in sending message
    MintMessageEventType["DeliveryDelayed"] = "delivery-delayed";
    // Message could not be delivered to recipient. Payload will contain details.
    MintMessageEventType["Bounced"] = "bounced";
    // An inbound message is being processed
    MintMessageEventType["Receiving"] = "receiving";
    // An inbound message has been received
    MintMessageEventType["Received"] = "received";
    MintMessageEventType["Opened"] = "opened";
    MintMessageEventType["Clicked"] = "clicked";
    MintMessageEventType["Forwarded"] = "forwarded";
    MintMessageEventType["Printed"] = "printed";
    MintMessageEventType["OptedOut"] = "opted-out";
    MintMessageEventType["Complained"] = "complained";
})(MintMessageEventType || (MintMessageEventType = {}));
var MintTemplateParamType;
(function (MintTemplateParamType) {
    MintTemplateParamType["Html"] = "html";
    MintTemplateParamType["Text"] = "text";
    MintTemplateParamType["Url"] = "url";
    MintTemplateParamType["Media"] = "media";
    MintTemplateParamType["Object"] = "object";
})(MintTemplateParamType || (MintTemplateParamType = {}));
var MintMessageProvider;
(function (MintMessageProvider) {
    MintMessageProvider["Aws"] = "aws";
    MintMessageProvider["Google"] = "google";
    MintMessageProvider["Twilio"] = "twilio";
    MintMessageProvider["Mailgun"] = "mailgun";
    MintMessageProvider["Mailjet"] = "mailjet";
})(MintMessageProvider || (MintMessageProvider = {}));
var MintMessageCampaignStatus;
(function (MintMessageCampaignStatus) {
    MintMessageCampaignStatus["Created"] = "created";
    MintMessageCampaignStatus["Running"] = "running";
    MintMessageCampaignStatus["Processing"] = "processing";
    MintMessageCampaignStatus["Completed"] = "completed";
    MintMessageCampaignStatus["Error"] = "error";
})(MintMessageCampaignStatus || (MintMessageCampaignStatus = {}));

let MintMessageCampaignModel = class MintMessageCampaignModel extends MintModel {
    constructor(value) {
        super(value);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel),
    IsInstance(MintUserModel)
], MintMessageCampaignModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel),
    IsInstance(MintCampaignModel)
], MintMessageCampaignModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignSegmentModel),
    IsInstance(MintCampaignSegmentModel)
], MintMessageCampaignModel.prototype, "campaignGroup", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel),
    IsInstance(MintCampaignChannelModel)
], MintMessageCampaignModel.prototype, "campaignChannel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageListModel),
    IsInstance(MintMessageListModel)
], MintMessageCampaignModel.prototype, "messageList", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageContentModel),
    IsInstance(MintMessageContentModel)
], MintMessageCampaignModel.prototype, "messageContent", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintMessageCampaignStatus)
], MintMessageCampaignModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "fromAddress", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "replyTo", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "subject", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "copyrightHolder", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintMessageCampaignModel.prototype, "isCanSpamPermissionEnabled", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "canSpamPermissionReminder", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintMessageCampaignModel.prototype, "canSpamCompanyName", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAddressModel),
    IsInstance(MintAddressModel)
], MintMessageCampaignModel.prototype, "canSpamAddress", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "failedCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "failedRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "deliveredCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "deliveredRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "bouncedCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "bouncedRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "complainedCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "complainedRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "optedOutCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "optedOutRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "openedCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "openedAllRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "clickedCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "clickedAllRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "printedCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "printedAllRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "forwardedCount", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "forwardedAllRate", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "openedDeliveredRate", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "clickedDeliveredRate", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "printedDeliveredRate", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "forwardedDeliveredRate", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "clickedOpenedRate", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "printedOpenedRate", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintMessageCampaignModel.prototype, "forwardedOpenedRate", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintMessageCampaignModel.prototype, "messageCount", void 0);
__decorate([
    MintProperty(),
    Type(() => Date),
    IsDate()
], MintMessageCampaignModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date),
    IsDate()
], MintMessageCampaignModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta),
    IsObject()
], MintMessageCampaignModel.prototype, "_meta", void 0);
MintMessageCampaignModel = __decorate([
    MintResource('/message-campaigns')
], MintMessageCampaignModel);

let MintMessageModel = class MintMessageModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintMessageModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintMessageModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageModel)
], MintMessageModel.prototype, "parent", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "threadUid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageCampaignModel)
], MintMessageModel.prototype, "messageCampaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageAddressModel)
], MintMessageModel.prototype, "messageAddress", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageContentModel)
], MintMessageModel.prototype, "messageContent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintMessageModel.prototype, "fromUser", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintMessageModel.prototype, "replyToUser", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintMessageModel.prototype, "toUser", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintMessageModel.prototype, "toDevice", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMediaModel)
], MintMessageModel.prototype, "pushImage", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "pushActionUrl", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "provider", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "providerMessageId", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "fromAddress", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "replyToAddress", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "toAddress", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "toAddressType", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "subject", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "locale", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "status", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "openCount", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "clickCount", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "printCount", void 0);
__decorate([
    MintProperty()
], MintMessageModel.prototype, "forwardCount", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "sentAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "openedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "clickedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "optedOutAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "complainedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "bouncedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "deliveredAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "failedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintMessageModel.prototype, "_meta", void 0);
MintMessageModel = __decorate([
    MintResource('/messages')
], MintMessageModel);

var MintCampaignTargetType;
(function (MintCampaignTargetType) {
    MintCampaignTargetType["LandingPage"] = "landing-page";
    MintCampaignTargetType["AppleAppStore"] = "apple-app-store";
    MintCampaignTargetType["GoogleAppStore"] = "google-app-store";
})(MintCampaignTargetType || (MintCampaignTargetType = {}));

let MintCampaignTargetModel = class MintCampaignTargetModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintCampaignTargetModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignTargetModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignTargetModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignTargetModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignTargetModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignSegmentModel)
], MintCampaignTargetModel.prototype, "segment", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintCampaignTargetModel.prototype, "channel", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintCampaignTargetType)
], MintCampaignTargetModel.prototype, "targetType", void 0);
__decorate([
    MintProperty(),
    IsUrl()
], MintCampaignTargetModel.prototype, "targetUrl", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignTargetModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignTargetModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignTargetModel.prototype, "analyticsTrackingId", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignTargetModel.prototype, "appStoreProviderId", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignTargetModel.prototype, "conversionPixel", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintCampaignTargetModel.prototype, "conversionCount", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignTargetModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignTargetModel.prototype, "startDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignTargetModel.prototype, "endDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignTargetModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignTargetModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignTargetModel.prototype, "_meta", void 0);
MintCampaignTargetModel = __decorate([
    MintResource('/campaign-targets')
], MintCampaignTargetModel);

var MintCampaignReplyType;
(function (MintCampaignReplyType) {
    MintCampaignReplyType["Email"] = "email";
    MintCampaignReplyType["SMS"] = "sms";
    MintCampaignReplyType["Push"] = "push";
})(MintCampaignReplyType || (MintCampaignReplyType = {}));

let MintCampaignReplyTemplateModel = class MintCampaignReplyTemplateModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignReplyTemplateModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignReplyTemplateModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignReplyTemplateModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignReplyTemplateModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignReplyTemplateModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignSegmentModel)
], MintCampaignReplyTemplateModel.prototype, "segment", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintCampaignReplyTemplateModel.prototype, "channel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignTargetModel)
], MintCampaignReplyTemplateModel.prototype, "target", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageTemplateModel)
], MintCampaignReplyTemplateModel.prototype, "messageTemplate", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintCampaignReplyType)
], MintCampaignReplyTemplateModel.prototype, "replyType", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignReplyTemplateModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignReplyTemplateModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignReplyTemplateModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignReplyTemplateModel.prototype, "startDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignReplyTemplateModel.prototype, "endDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignReplyTemplateModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignReplyTemplateModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignReplyTemplateModel.prototype, "_meta", void 0);
MintCampaignReplyTemplateModel = __decorate([
    MintResource('/campaign-reply-templates')
], MintCampaignReplyTemplateModel);

let MintCampaignResponseModel = class MintCampaignResponseModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignResponseModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignResponseModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignResponseModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignResponseModel.prototype, "owner", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignResponseModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignSegmentModel)
], MintCampaignResponseModel.prototype, "segment", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintCampaignResponseModel.prototype, "channel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignTargetModel)
], MintCampaignResponseModel.prototype, "target", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignReplyTemplateModel)
], MintCampaignResponseModel.prototype, "replyTemplate", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageModel)
], MintCampaignResponseModel.prototype, "message", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignResponseModel.prototype, "toUser", void 0);
__decorate([
    MintProperty(),
    IsEmail()
], MintCampaignResponseModel.prototype, "toEmail", void 0);
__decorate([
    MintProperty(),
    IsPhoneNumber()
], MintCampaignResponseModel.prototype, "toMobileNumber", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignResponseModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignResponseModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignResponseModel.prototype, "_meta", void 0);
MintCampaignResponseModel = __decorate([
    MintResource('/campaign-responses')
], MintCampaignResponseModel);

const logger$r = MintLogger.getLogger('MintInvitationService');
class MintCampaignResponseService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignResponseModel, configService.getConfig().api.service?.campaignResponse ??
            MintCampaignResponseModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignResponseService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignResponseService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignResponseService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintCampaignLeadModel = class MintCampaignLeadModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignLeadModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignLeadModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignLeadModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintContactModel)
], MintCampaignLeadModel.prototype, "contact", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignLeadModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignSegmentModel)
], MintCampaignLeadModel.prototype, "segment", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintCampaignLeadModel.prototype, "channel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignTargetModel)
], MintCampaignLeadModel.prototype, "target", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignLeadModel.prototype, "referredBy", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintCampaignLeadModel.prototype, "refUser", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintCampaignLeadModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignLeadModel.prototype, "isCampaignConversion", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignLeadModel.prototype, "message", void 0);
__decorate([
    MintProperty(),
    IsArray()
], MintCampaignLeadModel.prototype, "socialLinks", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintCampaignLeadModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintCampaignLeadModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignLeadModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignLeadModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignLeadModel.prototype, "_meta", void 0);
MintCampaignLeadModel = __decorate([
    MintResource('/campaign-leads')
], MintCampaignLeadModel);

const logger$q = MintLogger.getLogger('MintInvitationService');
class MintCampaignLeadService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignLeadModel, configService.getConfig().api.service?.campaignLead ??
            MintCampaignLeadModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignLeadService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignLeadService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignLeadService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$p = MintLogger.getLogger('MintInvitationService');
class MintCampaignTargetService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignTargetModel, configService.getConfig().api.service?.campaignTarget ??
            MintCampaignTargetModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignTargetService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignTargetService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignTargetService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$o = MintLogger.getLogger('MintInvitationService');
class MintCampaignService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignModel, configService.getConfig().api.service?.campaign ??
            MintCampaignModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$n = MintLogger.getLogger('MintInvitationService');
class MintCampaignChannelService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignChannelModel, configService.getConfig().api.service?.campaignChannel ??
            MintCampaignChannelModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignChannelService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignChannelService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignChannelService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintCampaignAnalyticsModel = class MintCampaignAnalyticsModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintCampaignAnalyticsModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintCampaignAnalyticsModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintCampaignAnalyticsModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignModel)
], MintCampaignAnalyticsModel.prototype, "campaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignSegmentModel)
], MintCampaignAnalyticsModel.prototype, "segment", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintCampaignAnalyticsModel.prototype, "channel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignTargetModel)
], MintCampaignAnalyticsModel.prototype, "target", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignReplyTemplateModel)
], MintCampaignAnalyticsModel.prototype, "replyTemplate", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignResponseModel)
], MintCampaignAnalyticsModel.prototype, "response", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintCampaignAnalyticsModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignLeadModel)
], MintCampaignAnalyticsModel.prototype, "conversionLead", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintCampaignAnalyticsModel.prototype, "isConversionEvent", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignAnalyticsModel.prototype, "eventCategory", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignAnalyticsModel.prototype, "eventAction", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintCampaignAnalyticsModel.prototype, "eventLabel", void 0);
__decorate([
    MintProperty(),
    Transform(mintBigNumberModelTransformer)
], MintCampaignAnalyticsModel.prototype, "eventValue", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignAnalyticsModel.prototype, "eventAt", void 0);
__decorate([
    MintProperty(),
    IsPhoneNumber()
], MintCampaignAnalyticsModel.prototype, "sourceMobileNumber", void 0);
__decorate([
    MintProperty(),
    IsUrl()
], MintCampaignAnalyticsModel.prototype, "sourceUrl", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignAnalyticsModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintCampaignAnalyticsModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintCampaignAnalyticsModel.prototype, "_meta", void 0);
MintCampaignAnalyticsModel = __decorate([
    MintResource('/campaign-analytics')
], MintCampaignAnalyticsModel);

const logger$m = MintLogger.getLogger('MintInvitationService');
class MintCampaignAnalyticsService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignAnalyticsModel, configService.getConfig().api.service?.campaignAnalytics ??
            MintCampaignAnalyticsModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignAnalyticsService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignAnalyticsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignAnalyticsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$l = MintLogger.getLogger('MintInvitationService');
class MintCampaignReplyTemplateService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignReplyTemplateModel, configService.getConfig().api.service?.campaignReplyTemplate ??
            MintCampaignReplyTemplateModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignReplyTemplateService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignReplyTemplateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignReplyTemplateService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$k = MintLogger.getLogger('MintInvitationService');
class MintCampaignPartnerService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignPartnerModel, configService.getConfig().api.service?.campaignPartner ??
            MintCampaignPartnerModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignPartnerService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignPartnerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignPartnerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintLandingPageModel = class MintLandingPageModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintLandingPageModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintLandingPageModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintLandingPageModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintLandingPageModel.prototype, "_meta", void 0);
MintLandingPageModel = __decorate([
    MintResource('/landing-pages')
], MintLandingPageModel);

let MintLandingPageTemplateModel = class MintLandingPageTemplateModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintLandingPageTemplateModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintLandingPageTemplateModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintLandingPageTemplateModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintLandingPageTemplateModel.prototype, "_meta", void 0);
MintLandingPageTemplateModel = __decorate([
    MintResource('/landing-page-templates')
], MintLandingPageTemplateModel);

const logger$j = MintLogger.getLogger('MintInvitationService');
class MintCampaignSegmentService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintCampaignSegmentModel, configService.getConfig().api.service?.campaignSegment ??
            MintCampaignSegmentModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignSegmentService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignSegmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintCampaignSegmentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintFileModel = class MintFileModel extends MintModel {
    constructor(model) {
        super(model);
    }
    static toFileAccess(value) {
        const result = Object.values(MintObjectAccess).includes(value);
        if (!result) {
            throw new MintError('Invalid MintFileAccess: ' + value);
        }
        return value;
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintFileType)
], MintFileModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintFileStatus)
], MintFileModel.prototype, "status", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintObjectAccess)
], MintFileModel.prototype, "access", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintObjectOwnership)
], MintFileModel.prototype, "ownership", void 0);
__decorate([
    MintProperty(),
    Type(() => MintFileModel)
], MintFileModel.prototype, "parent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintFileModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintFileModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintFileModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintFileModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAuthTokenModel)
], MintFileModel.prototype, "authToken", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "name", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "slug", void 0);
__decorate([
    MintProperty(),
    IsMimeType()
], MintFileModel.prototype, "contentType", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "checksum", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintFileModel.prototype, "size", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "password", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintFileModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintFileModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintFileModel.prototype, "isHidden", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintFileModel.prototype, "isTempFile", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintFileModel.prototype, "isResizeable", void 0);
__decorate([
    MintProperty(),
    IsBoolean()
], MintFileModel.prototype, "isSprite", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "srcHostname", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "srcFilename", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "localPath", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "urlPath", void 0);
__decorate([
    MintProperty(),
    Type(() => MintImage)
], MintFileModel.prototype, "image", void 0);
__decorate([
    MintProperty(),
    IsString()
], MintFileModel.prototype, "uploadUid", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintFileModel.prototype, "coords", void 0);
__decorate([
    MintProperty(),
    IsInt()
], MintFileModel.prototype, "uploadTimeMs", void 0);
__decorate([
    MintProperty(),
    IsNumber()
], MintFileModel.prototype, "transferRate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintFileModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintFileModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintFileModel.prototype, "_meta", void 0);
MintFileModel = __decorate([
    MintResource('/files')
], MintFileModel);

var MintFileMeta_1;
let MintFileMeta = MintFileMeta_1 = class MintFileMeta {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintFileMeta_1, model));
        }
    }
};
__decorate([
    Expose(),
    IsEnum(MintFileType)
], MintFileMeta.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString()
], MintFileMeta.prototype, "name", void 0);
__decorate([
    Expose(),
    IsMimeType()
], MintFileMeta.prototype, "contentType", void 0);
__decorate([
    Expose(),
    IsString()
], MintFileMeta.prototype, "checksum", void 0);
__decorate([
    Expose(),
    IsInt()
], MintFileMeta.prototype, "size", void 0);
__decorate([
    Expose(),
    IsString()
], MintFileMeta.prototype, "extension", void 0);
__decorate([
    Expose(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintFileMeta.prototype, "tags", void 0);
MintFileMeta = MintFileMeta_1 = __decorate([
    Exclude()
], MintFileMeta);

let MintUserDeviceModel = class MintUserDeviceModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserDeviceModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserDeviceModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintUserDeviceModel.prototype, "device", void 0);
__decorate([
    MintProperty()
], MintUserDeviceModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintUserDeviceModel.prototype, "slug", void 0);
__decorate([
    MintProperty()
], MintUserDeviceModel.prototype, "isEnabled", void 0);
__decorate([
    MintProperty()
], MintUserDeviceModel.prototype, "pushToken", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserDeviceModel.prototype, "lastVerifiedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserDeviceModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserDeviceModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserDeviceModel.prototype, "_meta", void 0);
MintUserDeviceModel = __decorate([
    MintResource('/user-devices')
], MintUserDeviceModel);

let MintUserAddressModel = class MintUserAddressModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserAddressModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserAddressModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAddressModel)
], MintUserAddressModel.prototype, "address", void 0);
__decorate([
    MintProperty()
], MintUserAddressModel.prototype, "ownership", void 0);
__decorate([
    MintProperty()
], MintUserAddressModel.prototype, "addressUse", void 0);
__decorate([
    MintProperty()
], MintUserAddressModel.prototype, "isActive", void 0);
__decorate([
    MintProperty()
], MintUserAddressModel.prototype, "isPrimary", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserAddressModel.prototype, "startDate", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserAddressModel.prototype, "endDate", void 0);
__decorate([
    MintProperty(),
    IsArray(),
    Transform(mintTagModelTransformer)
], MintUserAddressModel.prototype, "tags", void 0);
__decorate([
    MintProperty()
], MintUserAddressModel.prototype, "context", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserAddressModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserAddressModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserAddressModel.prototype, "_meta", void 0);
MintUserAddressModel = __decorate([
    MintResource('/user-addresses')
], MintUserAddressModel);

const logger$i = MintLogger.getLogger('MintUserAddressService');
class MintUserAddressService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintUserAddressModel, configService.getConfig().api.service?.userAddress ??
            MintUserAddressModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserAddressService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserAddressService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserAddressService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

var MintUserSignatureType;
(function (MintUserSignatureType) {
    MintUserSignatureType["Signature"] = "signature";
    MintUserSignatureType["Initials"] = "initials";
})(MintUserSignatureType || (MintUserSignatureType = {}));
var MintUserSignatureSource;
(function (MintUserSignatureSource) {
    MintUserSignatureSource["Drawn"] = "drawn";
    MintUserSignatureSource["Generated"] = "generated";
    MintUserSignatureSource["Uploaded"] = "uploaded";
})(MintUserSignatureSource || (MintUserSignatureSource = {}));

let MintUserEmailModel = class MintUserEmailModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserEmailModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintUserEmailModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserEmailModel.prototype, "user", void 0);
__decorate([
    MintProperty()
], MintUserEmailModel.prototype, "email", void 0);
__decorate([
    MintProperty()
], MintUserEmailModel.prototype, "isPrimary", void 0);
__decorate([
    MintProperty()
], MintUserEmailModel.prototype, "verificationStatus", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserEmailModel.prototype, "verifiedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserEmailModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserEmailModel.prototype, "updatedAt", void 0);
MintUserEmailModel = __decorate([
    MintResource('/user-emails')
], MintUserEmailModel);

const logger$h = MintLogger.getLogger('MintUserAddressService');
class MintUserEmailService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintUserEmailModel, configService.getConfig().api.service?.userEmail ??
            MintUserEmailModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserEmailService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserEmailService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserEmailService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

let MintUserSettingModel = class MintUserSettingModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserSettingModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserSettingModel)
], MintUserSettingModel.prototype, "parent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintUserSettingModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserSettingModel.prototype, "user", void 0);
__decorate([
    MintProperty()
], MintUserSettingModel.prototype, "key", void 0);
__decorate([
    MintProperty()
], MintUserSettingModel.prototype, "name", void 0);
__decorate([
    MintProperty()
], MintUserSettingModel.prototype, "description", void 0);
__decorate([
    MintProperty()
], MintUserSettingModel.prototype, "value", void 0);
__decorate([
    MintProperty()
], MintUserSettingModel.prototype, "isReadonly", void 0);
__decorate([
    MintProperty()
], MintUserSettingModel.prototype, "isSystem", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserSettingModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserSettingModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserSettingModel.prototype, "_meta", void 0);
MintUserSettingModel = __decorate([
    MintResource('/user-settings')
], MintUserSettingModel);

const logger$g = MintLogger.getLogger('MintUserSettingService');
class MintUserSettingService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintUserSettingModel, configService.getConfig().api.service?.userSetting ??
            MintUserSettingModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserSettingService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserSettingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserSettingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

let MintUserAccountModel = class MintUserAccountModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserAccountModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserAccountModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintUserAccountModel.prototype, "account", void 0);
__decorate([
    MintProperty()
], MintUserAccountModel.prototype, "isOwner", void 0);
__decorate([
    MintProperty()
], MintUserAccountModel.prototype, "isDefault", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserAccountModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserAccountModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserAccountModel.prototype, "_meta", void 0);
MintUserAccountModel = __decorate([
    MintResource('/user-accounts')
], MintUserAccountModel);

const logger$f = MintLogger.getLogger('MintUserAccountService');
class MintUserAccountService extends MintService {
    constructor(configService, httpService, cacheService) {
        super(httpService, cacheService, MintUserAccountModel, configService.getConfig().api.service?.userAccount ??
            MintUserAccountModel._mintResourceName);
        this.configService = configService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserAccountService, deps: [{ token: MintConfigService }, { token: MintHttpService }, { token: MintCacheService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserAccountService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintUserAccountService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintConfigService }, { type: MintHttpService }, { type: MintCacheService }] });

let MintUserProfileModel = class MintUserProfileModel extends MintModel {
    constructor(model) {
        super(model);
    }
    get ssnLast4() {
        return this.ssn ? this.ssn.slice(this.ssn.length - 4) : null;
    }
};
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserProfileModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type((ty) => MintPositionModel)
], MintUserProfileModel.prototype, "position", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "ssn", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "gender", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "race", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "maritalStatus", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserProfileModel.prototype, "birthDate", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "heightCm", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "weightKg", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "eyeColor", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "residenceCity", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "residenceState", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "residencePostalCode", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "residenceCountryCode", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "residenceLatitude", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "residenceLongitude", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "currentCountryCode", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "citizenshipCountryCode", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "presence", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "visibility", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "webUrl", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "socialLinks", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "description", void 0);
__decorate([
    MintProperty(),
    Transform(mintTagModelTransformer)
], MintUserProfileModel.prototype, "tags", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserProfileModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserProfileModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserProfileModel.prototype, "_meta", void 0);
__decorate([
    MintProperty()
], MintUserProfileModel.prototype, "ssnLast4", null);
MintUserProfileModel = __decorate([
    MintResource('/user-profiles')
], MintUserProfileModel);

const logger$e = MintLogger.getLogger('MintMessageContentService');
class MintMessageContentService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageContentModel, configService.getConfig().api.service?.messageContent ??
            MintMessageContentModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageContentService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageContentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageContentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

let MintMessageListAddressModel = class MintMessageListAddressModel extends MintModel {
    constructor(value) {
        super(value);
    }
};
__decorate([
    MintProperty()
], MintMessageListAddressModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageListModel)
], MintMessageListAddressModel.prototype, "list", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageAddressModel)
], MintMessageListAddressModel.prototype, "address", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageListAddressModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintMessageListAddressModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintMessageListAddressModel.prototype, "_meta", void 0);
MintMessageListAddressModel = __decorate([
    MintResource('/message-list-addresses')
], MintMessageListAddressModel);

const logger$d = MintLogger.getLogger('MintMessageListAddressService');
class MintMessageListAddressService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageListAddressModel, configService.getConfig().api.service?.messageListAddress ??
            MintMessageListAddressModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageListAddressService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageListAddressService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageListAddressService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$c = MintLogger.getLogger('MintMessageListService');
class MintMessageListService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageListModel, configService.getConfig().api.service?.messageList ??
            MintMessageListModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageListService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageListService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageListService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$b = MintLogger.getLogger('MintMessageAddressService');
class MintMessageAddressService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageAddressModel, configService.getConfig().api.service?.messageAddress ??
            MintMessageAddressModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageAddressService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageAddressService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageAddressService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$a = MintLogger.getLogger('MintMessageTemplateService');
class MintMessageTemplateService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageTemplateModel, configService.getConfig().api.service?.messageTemplate ??
            MintMessageTemplateModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageTemplateService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageTemplateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageTemplateService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

// @dynamic
let MintMessageEventModel = class MintMessageEventModel extends MintModel {
    constructor(value) {
        super(value);
    }
};
__decorate([
    MintProperty(),
    IsString()
], MintMessageEventModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageModel),
    IsInstance(MintMessageModel)
], MintMessageEventModel.prototype, "message", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel),
    IsInstance(MintUserModel)
], MintMessageEventModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintMessageCampaignModel),
    IsInstance(MintMessageCampaignModel)
], MintMessageEventModel.prototype, "messageCampaign", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel),
    IsInstance(MintExecutionRequestModel)
], MintMessageEventModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty(),
    IsEnum(MintMessageEventType)
], MintMessageEventModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    IsObject()
], MintMessageEventModel.prototype, "event", void 0);
__decorate([
    MintProperty(),
    Type(() => Date),
    IsDate()
], MintMessageEventModel.prototype, "eventAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date),
    IsDate()
], MintMessageEventModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date),
    IsDate()
], MintMessageEventModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta),
    IsObject()
], MintMessageEventModel.prototype, "_meta", void 0);
MintMessageEventModel = __decorate([
    MintResource('/message-events')
], MintMessageEventModel);

const logger$9 = MintLogger.getLogger('MintMessageEventService');
class MintMessageEventService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageEventModel, configService.getConfig().api.service?.messageEvent ??
            MintMessageEventModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageEventService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageEventService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageEventService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$8 = MintLogger.getLogger('MintMessageService');
class MintMessageService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageModel, configService.getConfig().api.service?.message ??
            MintMessageModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

const logger$7 = MintLogger.getLogger('MintMessageCampaignService');
class MintMessageCampaignService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintMessageCampaignModel, configService.getConfig().api.service?.messageCampaign ??
            MintMessageCampaignModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageCampaignService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageCampaignService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintMessageCampaignService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

// https://www.loginradius.com/blog/async/everything-you-want-to-know-about-authorization-headers/
var MintAuthTokenType;
(function (MintAuthTokenType) {
    MintAuthTokenType["Bearer"] = "bearer";
    MintAuthTokenType["Basic"] = "basic";
    MintAuthTokenType["Digest"] = "digest";
    MintAuthTokenType["Hawk"] = "hawk";
    MintAuthTokenType["AWS"] = "aws4-hmac-sha256";
    MintAuthTokenType["ServiceToken"] = "service-token";
})(MintAuthTokenType || (MintAuthTokenType = {}));
var MintAuthTokenStatus;
(function (MintAuthTokenStatus) {
    MintAuthTokenStatus["Active"] = "active";
    MintAuthTokenStatus["LoggedOut"] = "logged-out";
    MintAuthTokenStatus["Expired"] = "expired";
    MintAuthTokenStatus["Revoked"] = "revoked";
    MintAuthTokenStatus["Refreshed"] = "refreshed";
})(MintAuthTokenStatus || (MintAuthTokenStatus = {}));

const logger$6 = MintLogger.getLogger('MintAuthTokenService');
class MintAuthTokenService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintAuthTokenModel, configService.getConfig().api.service?.authToken ??
            MintAuthTokenModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    findByUser(user) {
        return this.findAll(MintQueryFilter.from({
            key: 'user.uid',
            operator: MintQueryOperator.Equals,
            value: typeof user === 'string' ? user : user.uid,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthTokenService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthTokenService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthTokenService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

// @dynamic
let MintAuthLogModel = class MintAuthLogModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintAuthLogModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintAuthLogModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintAuthLogModel.prototype, "targetUser", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintAuthLogModel.prototype, "device", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintAuthLogModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "fingerprintHash", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "authType", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "authStatus", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "authChannel", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "targetUsername", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "badUsername", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "badPassword", void 0);
__decorate([
    MintProperty()
], MintAuthLogModel.prototype, "badAuthCode", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthLogModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthLogModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAuthLogModel.prototype, "_meta", void 0);
MintAuthLogModel = __decorate([
    MintResource('/auth-logs')
], MintAuthLogModel);

const logger$5 = MintLogger.getLogger('MintAuthLogService');
class MintAuthLogService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintAuthLogModel, configService.getConfig().api.service?.authLog ??
            MintAuthLogModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    findByUser(user) {
        return this.findAll(MintQueryFilter.from({
            key: 'user.uid',
            operator: MintQueryOperator.Equals,
            value: typeof user === 'string' ? user : user.uid,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthLogService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthLogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthLogService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

// @dynamic
let MintAuthCodeModel = class MintAuthCodeModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "type", void 0);
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "channel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintAuthCodeModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintAuthCodeModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintDeviceModel)
], MintAuthCodeModel.prototype, "device", void 0);
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "code", void 0);
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "test", void 0);
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "valid", void 0);
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "useCount", void 0);
__decorate([
    MintProperty()
], MintAuthCodeModel.prototype, "maxUseCount", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthCodeModel.prototype, "expirationAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthCodeModel.prototype, "confirmedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthCodeModel.prototype, "lastAccessedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthCodeModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAuthCodeModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAuthCodeModel.prototype, "_meta", void 0);
MintAuthCodeModel = __decorate([
    MintResource('/auth-codes')
], MintAuthCodeModel);

const logger$4 = MintLogger.getLogger('MintAuthCodeService');
class MintAuthCodeService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintAuthCodeModel, configService.getConfig().api.service?.authCode ??
            MintAuthCodeModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    findByUser(user) {
        return this.findAll(MintQueryFilter.from({
            key: 'user.uid',
            operator: MintQueryOperator.Equals,
            value: typeof user === 'string' ? user : user.uid,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthCodeService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthCodeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAuthCodeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

/*
A 'forgot password' reset is a multi-step process.
1. User submits username/email
2. Code sent to email
3. User enters code.  If correct, single use token is generated.
4. User submits new password and token to be changed.

This object represents the data received in step 1.
Step 4 is represented by `MintAuthPasswordResetChangeDto`
 */
class MintAuthPasswordResetDto {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintAuthPasswordResetDto.prototype, "username", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthPasswordResetDto.prototype, "context", void 0);

class MintAuthPasswordResetChangeDto {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintAuthPasswordResetChangeDto.prototype, "password", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], MintAuthPasswordResetChangeDto.prototype, "login", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthPasswordResetChangeDto.prototype, "context", void 0);

class MintAuthCodeVerificationDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintAuthCodeVerificationDto, model));
        }
    }
}
__decorate([
    IsEnum(MintAuthType),
    IsDefined()
], MintAuthCodeVerificationDto.prototype, "type", void 0);
__decorate([
    IsEnum(MintAuthChannel),
    IsDefined()
], MintAuthCodeVerificationDto.prototype, "channel", void 0);
__decorate([
    IsString(),
    IsOptional()
], MintAuthCodeVerificationDto.prototype, "username", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintAuthCodeVerificationDto.prototype, "authCode", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], MintAuthCodeVerificationDto.prototype, "login", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], MintAuthCodeVerificationDto.prototype, "rememberDevice", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthCodeVerificationDto.prototype, "context", void 0);

class MintUserEmailUpdateDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintUserEmailUpdateDto, model));
        }
    }
}
__decorate([
    IsEmail({ require_tld: false }),
    IsDefined()
], MintUserEmailUpdateDto.prototype, "email", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintUserEmailUpdateDto.prototype, "context", void 0);

class MintRegistrationDto {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
            this.context = model.context
                ? new MintAppContext(model.context)
                : undefined;
            this.user = model.user ? new MintUserModel(model.user) : undefined;
        }
    }
}
__decorate([
    IsDefined(),
    Type(() => MintUserModel)
], MintRegistrationDto.prototype, "user", void 0);
__decorate([
    IsOptional(),
    IsString()
], MintRegistrationDto.prototype, "password", void 0);
__decorate([
    IsOptional(),
    IsString()
], MintRegistrationDto.prototype, "passcode", void 0);
__decorate([
    IsOptional(),
    IsString()
], MintRegistrationDto.prototype, "ssoProvider", void 0);
__decorate([
    IsOptional(),
    IsString()
], MintRegistrationDto.prototype, "referredBy", void 0);
__decorate([
    IsOptional(),
    IsString()
], MintRegistrationDto.prototype, "invitationCode", void 0);
__decorate([
    IsOptional(),
    IsString()
], MintRegistrationDto.prototype, "promoCode", void 0);
__decorate([
    IsOptional(),
    IsInt()
], MintRegistrationDto.prototype, "signupTime", void 0);
__decorate([
    IsOptional(),
    IsObject()
], MintRegistrationDto.prototype, "utm", void 0);
__decorate([
    IsOptional(),
    IsString()
], MintRegistrationDto.prototype, "nonce", void 0);
__decorate([
    IsOptional(),
    IsObject()
], MintRegistrationDto.prototype, "context", void 0);

class MintAuthPasscodeVerificationDto {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintAuthPasscodeVerificationDto.prototype, "passcode", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthPasscodeVerificationDto.prototype, "context", void 0);

class MintAuthPasswordUpdateDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintAuthPasswordUpdateDto, model));
        }
    }
}
__decorate([
    IsString(),
    IsOptional()
], MintAuthPasswordUpdateDto.prototype, "oldPassword", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintAuthPasswordUpdateDto.prototype, "newPassword", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], MintAuthPasswordUpdateDto.prototype, "login", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthPasswordUpdateDto.prototype, "context", void 0);

class MintUserMobileUpdateDto {
    constructor(value) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
__decorate([
    IsMobilePhone(),
    IsDefined()
], MintUserMobileUpdateDto.prototype, "mobileNumber", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintUserMobileUpdateDto.prototype, "context", void 0);

// NOTE: current _password_ is used to further authenticate user before
//  updating the new _passcode_
class MintAuthPasscodeUpdateDto {
    constructor(model) {
        if (model) {
            Object.assign(this, model);
        }
    }
}
__decorate([
    IsString(),
    IsOptional()
], MintAuthPasscodeUpdateDto.prototype, "currentPassword", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintAuthPasscodeUpdateDto.prototype, "newPasscode", void 0);
__decorate([
    IsObject(),
    IsOptional()
], MintAuthPasscodeUpdateDto.prototype, "context", void 0);

class MintAuthSessionCreateDto {
    constructor(model) {
        if (model) {
            Object.assign(this, plainToInstance(MintAuthSessionCreateDto, model));
        }
    }
}
__decorate([
    IsString(),
    IsDefined()
], MintAuthSessionCreateDto.prototype, "userUid", void 0);
__decorate([
    IsString(),
    IsDefined()
], MintAuthSessionCreateDto.prototype, "clientId", void 0);
__decorate([
    IsBoolean(),
    IsDefined()
], MintAuthSessionCreateDto.prototype, "bypassMfa", void 0);

const logger$3 = MintLogger.getLogger('MintRegistrationModel');
// @dynamic
let MintRegistrationModel = class MintRegistrationModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintRegistrationModel.prototype, "uid", void 0);
__decorate([
    MintProperty()
], MintRegistrationModel.prototype, "type", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppModel)
], MintRegistrationModel.prototype, "app", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccountModel)
], MintRegistrationModel.prototype, "account", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintRegistrationModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintCampaignChannelModel)
], MintRegistrationModel.prototype, "campaignChannel", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintRegistrationModel.prototype, "referredBy", void 0);
__decorate([
    MintProperty(),
    Type(() => MintExecutionRequestModel)
], MintRegistrationModel.prototype, "executionRequest", void 0);
__decorate([
    MintProperty()
], MintRegistrationModel.prototype, "invitationCode", void 0);
__decorate([
    MintProperty()
], MintRegistrationModel.prototype, "promoCode", void 0);
__decorate([
    MintProperty()
], MintRegistrationModel.prototype, "signupTime", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAppContext)
], MintRegistrationModel.prototype, "context", void 0);
__decorate([
    MintProperty()
], MintRegistrationModel.prototype, "utm", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintRegistrationModel.prototype, "registeredAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintRegistrationModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintRegistrationModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintRegistrationModel.prototype, "_meta", void 0);
MintRegistrationModel = __decorate([
    MintResource('/registrations')
], MintRegistrationModel);

const logger$2 = MintLogger.getLogger('MinRegistrationService');
class MintRegistrationService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintRegistrationModel, configService.getConfig().api.service?.authToken ??
            MintRegistrationModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByUsername(username) {
        return this.findOneByProperty('user', { username: username });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRegistrationService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRegistrationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintRegistrationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

var MintUserPriv;
(function (MintUserPriv) {
    MintUserPriv["AllAuth"] = "any:/auth/**";
    MintUserPriv["AllMe"] = "any:/me/**";
})(MintUserPriv || (MintUserPriv = {}));

// @dynamic
let MintUserPrivModel = class MintUserPrivModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintUserPrivModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintUserModel)
], MintUserPrivModel.prototype, "user", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccessPrivModel)
], MintUserPrivModel.prototype, "priv", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserPrivModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintUserPrivModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintUserPrivModel.prototype, "_meta", void 0);
MintUserPrivModel = __decorate([
    MintResource('/user-privs')
], MintUserPrivModel);

const logger$1 = MintLogger.getLogger('MintAccessPrivService');
class MintAccessPrivService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintAccessPrivModel, configService.getConfig().api.service?.accessPriv ??
            MintAccessPrivModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByResource(resource) {
        return this.findAllByProperty('resource', resource);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccessPrivService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccessPrivService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccessPrivService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

// @dynamic
let MintAccessRoleParentModel = class MintAccessRoleParentModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAccessRoleParentModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccessRoleModel)
], MintAccessRoleParentModel.prototype, "parent", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccessRoleModel)
], MintAccessRoleParentModel.prototype, "role", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessRoleParentModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessRoleParentModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAccessRoleParentModel.prototype, "_meta", void 0);
MintAccessRoleParentModel = __decorate([
    MintResource('/access-role-parents')
], MintAccessRoleParentModel);

// @dynamic
let MintAccessRolePrivModel = class MintAccessRolePrivModel extends MintModel {
    constructor(model) {
        super(model);
    }
};
__decorate([
    MintProperty()
], MintAccessRolePrivModel.prototype, "uid", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccessRoleModel)
], MintAccessRolePrivModel.prototype, "role", void 0);
__decorate([
    MintProperty(),
    Type(() => MintAccessPrivModel)
], MintAccessRolePrivModel.prototype, "priv", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessRolePrivModel.prototype, "createdAt", void 0);
__decorate([
    MintProperty(),
    Type(() => Date)
], MintAccessRolePrivModel.prototype, "updatedAt", void 0);
__decorate([
    MintProperty(),
    Type(() => MintEntityMeta)
], MintAccessRolePrivModel.prototype, "_meta", void 0);
MintAccessRolePrivModel = __decorate([
    MintResource('/access-role-privs')
], MintAccessRolePrivModel);

const logger = MintLogger.getLogger('MintAccessRoleService');
class MintAccessRoleService extends MintService {
    constructor(httpService, cacheService, configService) {
        super(httpService, cacheService, MintAccessRoleModel, configService.getConfig().api.service?.accessRole ??
            MintAccessRoleModel._mintResourceName);
        this.httpService = httpService;
        this.cacheService = cacheService;
        this.configService = configService;
    }
    async findByName(name) {
        const slug = MintStringUtil.slug(name);
        return this.findOneByProperty('slug', slug);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccessRoleService, deps: [{ token: MintHttpService }, { token: MintCacheService }, { token: MintConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccessRoleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.8", ngImport: i0, type: MintAccessRoleService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MintHttpService }, { type: MintCacheService }, { type: MintConfigService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LAYOUT_BREAKPOINTS, MINT_ACL_SERVICE_OPTIONS, MINT_AUTH_DEFAULT_ACCESS_TOKEN_TIMEOUT, MINT_AUTH_DEFAULT_REFRESH_TOKEN_TIMEOUT, MINT_AUTH_DEFAULT_SERVICE_TOKEN_TIMEOUT, MINT_AUTH_FAILURE_LOCKOUT_ATTEMPTS, MINT_AUTH_FAILURE_TIMEOUT_ATTEMPTS, MINT_AUTH_FAILURE_TIMEOUT_DURATION, MINT_AUTH_NONCE_KEY, MINT_AUTH_SESSION_KEY, MINT_AUTH_USERNAME_KEY, MINT_CACHE_SERVICE_OPTIONS, MINT_CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR, MINT_CONFIG_OPTIONS, MINT_DATE_CONTROL_VALUE_ACCESSOR, MINT_DATE_RANGE_CONTROL_VALUE_ACCESSOR, MINT_DECORATOR_PROPERTY_KEY, MINT_DECORATOR_RESOURCE_CALLBACK_KEY, MINT_DECORATOR_RESOURCE_KEY, MINT_DEFAULT_CURRENCY, MINT_DEFAULT_WEBHOOK_SIGNATURE_HEADER_KEY, MINT_DEFAULT_WEBHOOK_USER_AGENT, MINT_DUPE, MINT_DYNAMIC_FIELD_CONTROL_VALUE_ACCESSOR, MINT_INPUT_ADDRESS_CONTROL_VALUE_ACCESSOR, MINT_INPUT_DATE_CONTROL_VALUE_ACCESSOR, MINT_INPUT_NUMBER_CONTROL_VALUE_ACCESSOR, MINT_INPUT_PHONE_CONTROL_VALUE_ACCESSOR, MINT_INPUT_TEXT_CONTROL_VALUE_ACCESSOR, MINT_MESSAGE_APP_TAG_KEY, MINT_MESSAGE_ENV_TAG_KEY, MINT_NOTES_CONTROL_VALUE_ACCESSOR, MINT_NULL, MINT_PLAIN_TEXT_CONTROL_VALUE_ACCESSOR, MINT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR, MINT_ROUTE_PATH_PARAMS_KEY, MINT_SELECT_CONTROL_VALUE_ACCESSOR, MINT_SELECT_TIMEZONE_CONTROL_VALUE_ACCESSOR, MINT_SYSTEM_ACCOUNT_SLUG, MINT_SYSTEM_ACCOUNT_UID, MINT_SYSTEM_APP_SLUG, MINT_SYSTEM_APP_UID, MINT_SYSTEM_USER_UID, MINT_SYSTEM_USER_USERNAME, MINT_TOGGLE_CONTROL_VALUE_ACCESSOR, MintAccessAction, MintAccessEffect, MintAccessOperator, MintAccessPrivModel, MintAccessPrivService, MintAccessRole, MintAccessRoleModel, MintAccessRoleParentModel, MintAccessRolePrivModel, MintAccessRoleService, MintAccountModel, MintAccountService, MintAccountStatus, MintAccountType, MintAclAccessChecker, MintAclDirective, MintAclService, MintAddressModel, MintAddressOwnership, MintAddressService, MintAddressType, MintAddressUse, MintAdminGuard, MintAnalytics, MintAnalyticsContactUsEvent, MintAnalyticsEvent, MintAnalyticsGoogle, MintAnalyticsLoginEvent, MintAnalyticsLogoutEvent, MintAnalyticsMixpanel, MintAnalyticsPageViewEvent, MintAnalyticsPasswordEvent, MintAnalyticsPurchaseEvent, MintAnalyticsScreenViewEvent, MintAnalyticsSignupEvent, MintApiEventModel, MintApiEventService, MintApiLogModel, MintApiLogService, MintApiModel, MintApiService, MintApiVersionModel, MintApiVersionService, MintApiVersionStatus, MintAppClientModel, MintAppClientService, MintAppClientStatus, MintAppContext, MintAppMigrationModel, MintAppModel, MintAppService, MintAppSettingModel, MintAppSettingService, MintAppStatus, MintAppType, MintAppVersion, MintArrayWrapper, MintAuthChannel, MintAuthCodeModel, MintAuthCodeService, MintAuthCodeVerificationDto, MintAuthErrorType, MintAuthException, MintAuthInterceptor, MintAuthLogModel, MintAuthLogService, MintAuthLoginCredentialsDto, MintAuthPasscodeUpdateDto, MintAuthPasscodeVerificationDto, MintAuthPasswordResetChangeDto, MintAuthPasswordResetDto, MintAuthPasswordStatus, MintAuthPasswordUpdateDto, MintAuthResource, MintAuthService, MintAuthSessionCreateDto, MintAuthSsoDto, MintAuthSsoProvider, MintAuthStatus, MintAuthTokenModel, MintAuthTokenRefreshDto, MintAuthTokenService, MintAuthTokenStatus, MintAuthTokenType, MintAuthType, MintAutoFieldComponent, MintAutoFieldModule, MintAutoFormComponent, MintAutoFormModule, MintAzureLoginCacheLocation, MintAzureLoginPrompt, MintAzureLoginProtocolMode, MintAzureLoginProvider, MintBase64Util, MintBaseService, MintBatchResultModel, MintCacheException, MintCacheService, MintCacheStats, MintCacheStatsData, MintCacheStorage, MintCamelizer, MintCampaignAnalyticsModel, MintCampaignAnalyticsService, MintCampaignChannelModel, MintCampaignChannelService, MintCampaignChannelStrategy, MintCampaignChannelType, MintCampaignLeadModel, MintCampaignLeadService, MintCampaignModel, MintCampaignPartnerModel, MintCampaignPartnerService, MintCampaignReplyTemplateModel, MintCampaignReplyTemplateService, MintCampaignReplyType, MintCampaignResponseModel, MintCampaignResponseService, MintCampaignSegmentModel, MintCampaignSegmentService, MintCampaignService, MintCampaignTargetModel, MintCampaignTargetService, MintCampaignTargetType, MintCapitalizePipe, MintCartItemModel, MintCartItemService, MintCartModel, MintCartPromoModel, MintCartPromoService, MintCartService, MintCartStatus, MintCartWithItemsDto, MintCheckboxGroup, MintCheckboxGroupComponent, MintCheckboxGroupModule, MintClassUtil, MintCommonModule, MintConfigService, MintContactModel, MintContactRelationship, MintContactService, MintContactSource, MintContactType, MintCoordinates, MintCoreModule, MintCoreResource, MintCountry, MintCountryService, MintCountryToCodePipe, MintCountryToNamePipe, MintCreateAppClientDto, MintCryptoUtil, MintCsvExporter, MintCsvService, MintCurrencyModel, MintCurrencyPipe, MintCurrencyService, MintCurrencyUtil, MintDataTable, MintDataTableComponent, MintDataTableModule, MintDate, MintDateComponent, MintDateISOFormatRegex, MintDateModule, MintDateRange, MintDateRangeComponent, MintDateRangeModule, MintDateUtcPipe, MintDateUtil, MintDateValidator, MintDebouncer, MintDeepMerge, MintDeviceCapability, MintDeviceFingerprint, MintDeviceModel, MintDeviceMotion, MintDeviceNetwork, MintDeviceNetworkType, MintDeviceOS, MintDevicePingModel, MintDeviceScanRecord, MintDeviceService, MintDeviceStatus, MintDeviceType, MintESignatureModel, MintEmailMaskPipe, MintEmailType, MintEmailValidator, MintEntityMeta, MintEntityMetaCache, MintEntityStatus, MintEntityUpdate, MintEnumUtil, MintEnv, MintError, MintExecutionRequest, MintExecutionRequestModel, MintExecutionRequestService, MintExecutionResponseModel, MintExecutionResponseService, MintFileMeta, MintFileModel, MintFileStatus, MintFileType, MintFormCardComponent, MintFormCardModule, MintFormComponent, MintFormController, MintFormField, MintFormFieldAutocomplete, MintFormFieldComponent, MintFormModule, MintFormService, MintFormUtil, MintFormValidationTrigger, MintGeoModule, MintGeocoderService, MintHelpdeskMessageModel, MintHelpdeskMessageService, MintHttpException, MintHttpParamsInterceptor, MintHttpRequestHeaderName, MintHttpService, MintImage, MintImageChannel, MintImageColorSpace, MintImageOrientation, MintInputAddress, MintInputAddressComponent, MintInputAddressModalComponent, MintInputAddressModule, MintInputAfter, MintInputBefore, MintInputDate, MintInputDateComponent, MintInputDateModule, MintInputLayout, MintInputLayoutClassNames, MintInputNumber, MintInputNumberComponent, MintInputNumberModule, MintInputPhone, MintInputPhoneComponent, MintInputPhoneModule, MintInputText, MintInputTextComponent, MintInputTextModule, MintInvitationChannel, MintInvitationEventType, MintInvitationModel, MintInvitationService, MintInvitationStatus, MintInvitationType, MintInvoiceModel, MintInvoiceNote, MintInvoiceNoteVisibility, MintInvoicePaymentModel, MintInvoicePaymentService, MintInvoiceService, MintInvoiceStatus, MintJep, MintJepCache, MintJsonUtil, MintLandingPageModel, MintLandingPageTemplateModel, MintListUtil, MintLogLevel, MintLogger, MintMathUtil, MintMediaModel, MintMediaService, MintMediaTypeUtil, MintMediaUrlPipe, MintMediaUtil, MintMemoryCacheStorage, MintMenuItem, MintMessageAddressDeliverability, MintMessageAddressModel, MintMessageAddressRisk, MintMessageAddressService, MintMessageCampaignModel, MintMessageCampaignService, MintMessageCampaignStatus, MintMessageContentModel, MintMessageContentService, MintMessageEventModel, MintMessageEventService, MintMessageEventType, MintMessageListAddressModel, MintMessageListAddressService, MintMessageListModel, MintMessageListService, MintMessageModel, MintMessageProvider, MintMessageService, MintMessageStatus, MintMessageTemplateModel, MintMessageTemplateService, MintMessageToType, MintMessageType, MintMobileNumberValidator, MintModel, MintNotes, MintNotesComponent, MintNotesModule, MintNumberFormatPipe, MintNumberValidator, MintObjectAccess, MintObjectOwnership, MintObjectUtil, MintOperatorUtil, MintPasswordValidator, MintPaymentAccountCardBrand, MintPaymentAccountModel, MintPaymentAccountSaveCardDto, MintPaymentAccountService, MintPaymentAccountType, MintPaymentMethod, MintPaymentModel, MintPaymentProcessor, MintPaymentProcessorModel, MintPaymentProcessorService, MintPaymentService, MintPaymentStatus, MintPaymentType, MintPeriod, MintPhoneFormatPipe, MintPhoneNumberService, MintPhoneType, MintPipesModule, MintPlaceModel, MintPlaceService, MintPlainText, MintPlainTextComponent, MintPlainTextModule, MintPluralPipe, MintPolicy, MintPolicyConsentModel, MintPolicyConsentStatus, MintPolicyModel, MintPolicyService, MintPolygon, MintPosition, MintPositionModel, MintPositionSource, MintProductModel, MintProductService, MintProductSkuModel, MintProductSkuService, MintProductTaxonomyModel, MintProductTaxonomyProductModel, MintProductTaxonomyProductService, MintProductTaxonomyService, MintProfileEyeColor, MintProfileGender, MintProfileMaritalStatus, MintProfilePresence, MintProfileRace, MintProfileVisibility, MintPromoCodeModel, MintPromoCodeService, MintPromoModel, MintPromoProductModel, MintPromoProductService, MintPromoService, MintPromoTaxonomyModel, MintPromoTaxonomyService, MintProperty, MintPropertyNameCase, MintQueryAggregate, MintQueryCondition, MintQueryExpression, MintQueryField, MintQueryFilter, MintQueryOperator, MintQueryOptions, MintQuerySort, MintQuerySortOrder, MintQueryUtil, MintRadioGroup, MintRadioGroupComponent, MintRadioGroupModule, MintRedirectComponent, MintRedirectModule, MintRegistrationDto, MintRegistrationModel, MintRegistrationService, MintRegistrationType, MintResource, MintResultSet, MintRoleProvider, MintRoleService, MintRoundPipe, MintRoutePathParamsService, MintSafeHtmlPipe, MintSafeResourceUrlPipe, MintSafeUrlPipe, MintSelect, MintSelectComponent, MintSelectModule, MintSelectTimeZoneComponent, MintService, MintSession, MintSessionScope, MintSessionService, MintSessionToken, MintSsnPipe, MintSsnValidator, MintSsoUserModel, MintStorageService, MintStorageType, MintStringUtil, MintSubscriptionModel, MintSubscriptionService, MintSystemUtil, MintTag, MintTemplateParamType, MintTimingPipe, MintToggle, MintToggleComponent, MintToggleModule, MintTypeUtil, MintUidUtil, MintUpload, MintUploadComponent, MintUploadModule, MintUrlUtil, MintUserAccountModel, MintUserAccountService, MintUserAddressModel, MintUserAddressService, MintUserAuthStatus, MintUserDeviceModel, MintUserDynamicSettings, MintUserEmailModel, MintUserEmailService, MintUserEmailUpdateDto, MintUserEmailVerifiedDto, MintUserGuard, MintUserLockedStatusDto, MintUserMfaDto, MintUserMobileNumberVerifiedDto, MintUserMobileUpdateDto, MintUserModel, MintUserPriv, MintUserPrivModel, MintUserProfileModel, MintUserRoleModel, MintUserRoleService, MintUserService, MintUserSettingModel, MintUserSettingService, MintUserSignatureModel, MintUserSignatureSource, MintUserSignatureType, MintUserStatus, MintUserType, MintUsernameValidator, MintValidationException, MintValidatorService, MintVerificationStatus, MintViewService, MintWebhookClientModel, MintWebhookClientService, MintWebhookClientStatus, MintWebhookEventModel, MintWebhookEventService, MintWebhookEventStatus, MintWebhookLogModel, MintWebhookLogService, MintWebhookModel, MintWebhookPayload, MintWebhookService, MintWebhookStatus, MintWebhookSubscriptionModel, MintWebhookSubscriptionService, ModulePreloadingStrategyService, appendUrlParam, cacheServiceFactory, configServiceFactory, countries, countryGroups, countryList, hasValue, isClass, isEmpty, isFunction, isJsonQueryOperator, isMintError, isMintResultSet, isMintTag, isModel, isNullish, isNumber, isObject, isPromise, isQueryCondition, isQueryExpression, isQueryFilter, isQueryFilterType, isString, isSymbol, isUndefined, isValidNumberValue, mintApplyDecorators, mintBase64ToBlob, mintBigIntModelTransformer, mintBigNumberModelTransformer, mintBlobToBase64, mintCountryCodePhoneMap, mintCountryMap, mintCssToString, mintDownloadBlob, mintDownloadData, mintEventSrcContainsClassName, mintFloatModelTransformer, mintIntegerModelTransformer, mintNormalizeUrl, mintParseUrl, mintPixelToValue, mintTag, mintTagModelTransformer, mintUrlEquals, serializeQueryParams, socialAuthServiceConfig, stateCodeFormOptions, throwIfAlreadyLoaded, toJSON };
